import React, { Component, lazy, Suspense } from 'react';
import '../../css/Influencer.css';
import '../SelfServe/InfluencerStepper.css';
import Cookies from 'universal-cookie';
import { Helmet } from 'react-helmet'
import "typeface-roboto";
import update_filter_state from '../common/common/update_filter_state';
import "../../../node_modules/video-react/dist/video-react.css";
import '../../css/InfluencerUpload.css'
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import { decode } from 'html-entities';
import get_and_post_data_skeleton from '../common/common/get_and_post_data_skeleton';
import { withRouter } from '../common/common/withRouter';
import make_block_content_info from '../common/common/make_block_content_info';
import bookmark_button_click from '../common/common/bookmark_button_click';
import like_button_click from '../common/common/like_button_click';
import OpenSubscribePopup from '../common/common/OpenSubscribePopup';
import CloseSubscribePopup from '../common/common/CloseSubscribePopup';
import checkout_button from '../common/common/checkout_button';
import CloseSubscribePopupInfo from '../common/common/CloseSubscribePopupInfo';
import UpgradeSubInfoPopup from '../common/common/UpgradeSubInfoPopup';
import UpgradeSubscription from '../common/common/UpgradeSubscription';
import DowngradeSubscription from '../common/common/DowngradeSubscription';
import DowngradeSubInfoPopup from '../common/common/DowngradeSubInfoPopup';
import UpgradeProcessPost from '../common/common/UpgradeProcessPost';
import DowngradeProcessPost from '../common/common/DowngradeProcessPost';
import getSubpopupInfo from '../common/common/getSubpopupInfo';
import postSubpopupInfo from '../common/common/postSubpopupInfo';
import getGeoInfo from '../common/common/getGeoInfo';
import make_multi_content_grid_div from '../common/common/make_multi_content_grid_div';
import make_single_influencer_row from '../common/common/make_single_influencer_row';
import OpenWaitingListPopup from '../common/common/OpenWaitingListPopup';
import CloseWaitingListPopup from '../common/common/CloseWaitingListPopup';
import { styled } from '@mui/material/styles';
import { Grid } from "@mui/material";
import Paper from '@mui/material/Paper';
import theme from '../../theme';
import PaidDMsExplainer from "./PaidDms/PaidDMsExplainer";
import DMsCheckout from './PaidDms/DMsCheckout';
import TippingCheckout from './Tipping/TippingCheckout';
import BuyNowCheckout from './BuyNowPosts/BuyNowCheckout';
import NewBannerModal from '../Influencer/InfluencerSubComponents/NewBannerModal';
import { clarity } from 'react-microsoft-clarity';
import PagePortal from '../Influencer/PagePortal';
import WaitlistStepOne from '../../media/site_media/dashboard/splashscreens/waitlist-step-one.webp';
import WaitlistStepTwo from '../../media/site_media/dashboard/splashscreens/waitlist-step-two.webp';
import WaitlistStepThree from '../../media/site_media/dashboard/splashscreens/waitlist-step-three.webp';
import EditCollections from './Collections/EditCollections';
import BuyCollectionCheckout from './Collections/BuyCollectionCheckout';
import ErrorCheckoutModal from '../Elements/ErrorCheckoutModal';
import { IoClose } from "react-icons/io5";
import { Typography } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material';

import CreateCollection from './Collections/CreateCollection';
import { resizeImageFromFile } from '../common/resizeImage';
import BioImage from '../../media/site_media/dashboard/base.webp'
import EditDesignImage from '../../media/site_media/dashboard/edit_design.webp'
import { TbLayoutGrid, TbPalette, TbPackageExport, TbDeviceDesktopShare, TbAlertTriangle} from "react-icons/tb";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
// import DashboardOnboarding from './DashboardOnboarding';
import {
   Button,
   Box,
   Modal,
} from "@mui/material";
import axios from "axios";
import uploadInfluencerBanner from "../Content/content_upload_type/common/uploadInfluencerBanner";
import uploadInfluencerHeader from "../Content/content_upload_type/common/uploadInfluencerHeader";
import { logApiRequest, logNavigation } from "../common/mixpanelInterface";
import { gtag } from "ga-gtag";
import CircularProgress from "@mui/material/CircularProgress";
import { PopupModal } from 'react-calendly';
import BottomTab from '../Navigation/BottomTab';
import ViewSelector from '../Elements/ViewSelector';
import MobilePreview from '../common/layouts/MobilePreview';
import HorizontalTabs from '../common/common/HorizontalTabs';
import PlatformTabs from '../common/common/PlatformTabs';
import AvatarEditorCreatorView from '../Settings_Profile/AvatarEditorCreatorView';
import AppContext from '../../context/AppContext';
import DesktopHeaderCreator from '../common/DesktopHeaderCreator';
const TopNavBar = lazy(() => import('../nav_bars/TopNavBar'));
const ContentNewLives = lazy(() => import("../Content/ContentNewLives"));
const ShareModal = lazy(() => import('../Elements/ShareModal'));
const WaitingListModal = lazy(() => import('./WaitingListModal'));
const Navbar = lazy(() => import("../Navigation/Navbar"));
const MobileNavbar = lazy(() => import("../Navigation/MobileNavbar"));
const SnackbarAlert = lazy(() => import('../common/SnackbarAlert'));
const SnackbarSavedContent = lazy(() => import('../Elements/SnackbarSavedContent'));
const SnackbarRemoveSave = lazy(() => import("../Elements/SnackbarRemoveSave"));
const RatingsModal = lazy(() => import('../Content/ContentSubComponents/RatingsModal'));
const SnackbarPublishError = lazy(() => import('../Elements/SnackbarPublishError'));
const InfluencerEditChangesBanner = lazy(() => import("./InfluencerEditChangesBanner"));
const WaitingListBanner = lazy(() => import('./WaitingListBanner'));
const NonCreatorReferralBanner = lazy(() => import('./NonCreatorReferralBanner'));
const DynamicOnboardingBar = lazy(() => import('./DynamicOnboardingBar'));
const MobileUnsubscribedButton = lazy(() => import('./InfluencerSubComponents/MobileUnsubscribedButton'));
const InfluencerBannerMain = lazy(() => import("./InfluencerSubComponents/InfluencerBannerMain"));
const InfluencerBannerMainCreatorView = lazy(() => import("./InfluencerSubComponents/InfluencerBannerMainCreatorView"));
const DashboardOnboarding = lazy(() => import('./DashboardOnboarding'));
const InfluencerTabsBar = lazy(() => import('./InfluencerSubComponents/InfluencerTabsBar'));
const InfluencerContent = lazy(() => import("./InfluencerSubComponents/InfluencerContent"));
const PoweredByFitWith = lazy(() => import('../Elements/PoweredByWithMe'));
const SubscribePopupInfo = lazy(() => import('../Home/SubscribeInfoPopup'));
const SubscribePopup = lazy(() => import("../Home/SubscribePopup"));
const UploadProgress = lazy(() => import('../common/common/UploadProgress'));
const TextEditorModal = lazy(() => import('../common/TextEditorModal'));
const DashboardUploads = lazy(() => import("./DashboardUploads"));
const DashboardComponent = lazy(() => import('./DashboardComponent'));
const PricingModal = lazy(() => import("../SelfServe/PricingModal"));
const CheckoutPopup = lazy(() => import("../common/CheckoutPopup"));
const TermsModal = lazy(() => import('../legal/TermsModal'));
const DashboardMenu = lazy(() => import("../Navigation/DashboardMenu"));
const CustomCreatorLogoModal = lazy(() => import('../Influencer/CustomCreatorLogoModal'));
const CreatorMenu = lazy(() => import("../Navigation/CreatorMenu"));
const SplashScreenModal = lazy(() => import("./Dashboard/SplashScreen"))
const IPhone16Frame = lazy(() => import("./Frames/IPhone16Frame"))
const Platform = lazy(() => import('./MyPlatform/Tabs/Platform'))
const InfluencerAddProduct = lazy(() => import('./InfluencerSubComponents/InfluencerAddProduct'))
const InfluencerCreationFlow = lazy(() => import('./InfluencerSubComponents/InfluencerCreationFlow'))
const sort_options = [
   'latest',
   'saved',
   'trending',
   'shuffle',
   'most views',
   'most likes',
   'purchased'
]

const InitialDashboardModal = lazy(() => import("../Elements/InitialDashboardModal"))
const GetStartedModal = lazy(() => import('./Dashboard/GetStartedModal'))

const HiddenTabModal = lazy(() => import("../Elements/HiddenTabModal"))
const TabInfoModal = lazy(() => import("../Elements/TabInfoModal"))

const PublishedCongratsModal = lazy(() => import("../Elements/PublishedCongratsModal"))
const ExampleCreatorPopup = lazy(() => import('../SelfServe/ExampleCreatorPopup'))
const INTERCOM_APP_ID = 'lfsiny3p';
const CLARITY_ID = 'mtgn4awbao';
const paths = require('../../paths.json');
const cookies = new Cookies();
const isMobile = window.innerWidth < 600

const modalStyle = {
   display: 'flex',
   height: 'auto',
   // bgcolor: 'rgba(0,0,0,1)',
   minHeight: '100vh',
   minWidth: '100vw',
   overflowY: 'hidden',
   outline: 'none',
   zIndex: '9999',
};

const mobileTheme = createTheme({
   breakpoints: {
      values: {
         xs: 350,
         sm: 350,
         md: 350,
         lg: 350,
         xl: 350,
         xxl: 350,
      },
   },
});

const Item = styled(Paper)(({ theme }) => ({
   padding: theme.spacing(1),
   textAlign: 'left',
   boxShadow: "none",

}));

const activeProductTestData = [
   {
     subscriptions: [
       {
         active: true,
         tiers: [
           { name: 'Basic', monthlyPrice: 10, annualPrice: null, monthlyActive: true, annualActive: false, subscribers: 100, contentCount: 50 },
           { name: 'Premium', monthlyPrice: 20, annualPrice: null, monthlyActive: false, annualActive: true, subscribers: 50, contentCount: 100 },
           { name: 'Annual', monthlyPrice: null, annualPrice: 200, monthlyActive: true, annualActive: false, subscribers: 20, contentCount: 200 }
         ],
         collectionTotal: 3
       }
     ],
     courses: [
       {
         total: 5,
         active: true,
         list: [
           { name: 'Course 1', contentNo: 10, image: 'https://images.unsplash.com/photo-1506748686214-e9df14d4d9d0', price: 100 },
           { name: 'Course 2', contentNo: 20, image: '', price: 200 },
           { name: 'Course 3', contentNo: 15, image: '', price: 150 },
           { name: 'Course 4', contentNo: 25, image: 'https://images.unsplash.com/photo-1498050108023-c5249f4df085', price: 250 },
           { name: 'Course 5', contentNo: 30, image: 'https://images.unsplash.com/photo-1498050108023-c5249f4df085', price: 300 }
         ]
       }
     ],
     digitalproducts: [
       {
         digitalproductCount: 7,
         active: true,
         products: [
           { id: 30, name: 'E-book', price: 20, content: 'E-book content', image: '' },
           { id: 31, name: 'Template', price: 25, content: 'Template content', image: 'https://images.unsplash.com/photo-1506748686214-e9df14d4d9d0' },
           { id: 32, name: 'Guide', price: 30, content: 'Guide content', image: '' },
           { id: 33, name: 'Checklist', price: 10, content: 'Checklist content',  image: '' },
           { id: 34, name: 'Workbook', price: 20, content: 'Workbook content', image: 'https://images.unsplash.com/photo-1498050108023-c5249f4df085' },
           { id: 35, name: 'Toolkit', price: 50, content: 'Toolkit content', image: 'https://images.unsplash.com/photo-1498050108023-c5249f4df085' },
           { id: 36, name: 'Planner', price: 40, content: 'Planner content', image: 'https://images.unsplash.com/photo-1506748686214-e9df14d4d9d0' }
         ]
       }
     ],
     community: { active: true },
     messages: { active: true, count: 50 },
     oneOnOneCoaching: { active: true, clients: 5 }
   }
 ]

function isNumericString(value) {
   return /^-?\d+(\.\d+)?$/.test(value);
}


class Influencer extends Component {
   static contextType = AppContext;
   constructor(props) {
      super(props);
      this.textEditorRef = React.createRef();
      this.survey_ref = React.createRef();

      const storedMorePages = localStorage.getItem('morePages');
      const initialMorePages = storedMorePages ? JSON.parse(storedMorePages) : [{
         promo_codes: true,
         referrals: true,
         branding: true,
         examples: true,
      }];
      this.state = {
         dashboard: false,
         creator_preview: false,
         activeTab: 'Platform',
         current_user: null,
         dashboardMenuFixed: false,
         CreatorMenuFixed: false,
         is_me: null,
         //snack bar
         snackbarOpen: false,
         submitMsg: '',
         // waiting list
         isWaitingList: true,
         mobileCTABannerClicked: false,
         // top nav bar
         influencer_bool: "",
         influencer_launched: "",
         current_user_icon: "",
         // user logged in testing
         user_logged_in: false,
         // left nav bar
         recommended_influencers: [],
         user_subscriptions: [],
         n_user_subscriptions: 0,
         pricingModal: false,
         // filter bar stuff
         categories: [],
         // sort and filter
         sort_filter_category: cookies.get('sort_filter_influencer_category'),
         sort_filter_tier: cookies.get('sort_filter_influencer_tier'),
         sort_filter_time: cookies.get('sort_filter_influencer_time'),
         sort_filter_sort: cookies.get('sort_filter_influencer_sort'),
         sort_filter_other: cookies.get('sort_filter_influencer_other'),
         sort_filter_content: cookies.get('sort_filter_influencer_content'),
         // influencer stuff
         influencer_name: (this.props.params.influencer_name) ? this.props.params.influencer_name : this.props.influencer_name,
         initial_content_id: (this.props.params.content_id) ? this.props.params.content_id : null,
         influencer_info: {
            discord_access: null,
            influencer_active_in_community: null,
         },
         sub_type: [],
         influencer_n_subscribers: [],
         influencer_show_icon_image: true,
         // inf scroll
         inf_scroll_loading: false,
         page_position: 0,
         update_inf_scroll: true,
         content_list_length: 0,
         // Popup Selected States
         subscribe_popup_open: false,
         subscribe_popup_initial_selected_tier: '',
         subscribe_popup_initial_selected_tier_backup: '',
         waiting_list_popup_open: false,
         subscribe_popup_icon_image: "",
         subscribe_popup_influencer: "",
         subscribe_popup_influencer_name: "",
         subscribe_popup_current_tier: "",
         subscribe_popup_async_tier_access: false,
         async_apply: false,
         subscribe_popup_minimum_tier: "",
         subscribe_popup_bronze_price: 0,
         subscribe_popup_silver_price: 0,
         subscribe_popup_gold_price: 0,
         subscribe_popup_free_perks_text: [],
         subscribe_popup_bronze_perks_text: [],
         subscribe_popup_silver_perks_text: [],
         subscribe_popup_gold_perks_text: [],
         // subscribe_popup_current_free_trial: '',
         subscribe_popup_free_active: false,
         subscribe_popup_bronze_active: false,
         subscribe_popup_silver_active: false,
         subscribe_popup_gold_active: false,
         free_trial_eligible: false,
         subscribe_popup_free_name: '',
         subscribe_popup_bronze_name: '',
         subscribe_popup_silver_name: '',
         subscribe_popup_gold_name: '',
         subscribe_popup_current_free_trial: '',
         subscribe_popup_current_duration: "",
         subscribe_popup_bronze_annual_price: 0,
         subscribe_popup_silver_annual_price: 0,
         subscribe_popup_gold_annual_price: 0,
         subscribe_popup_bronze_show_annual_reduction: false,
         subscribe_popup_silver_show_annual_reduction: false,
         subscribe_popup_gold_show_annual_reduction: false,
         subscribe_popup_bronze_monthly_active: null,
         subscribe_popup_silver_monthly_active: false,
         subscribe_popup_gold_monthly_active: false,
         subscribe_popup_bronze_annual_active: false,
         subscribe_popup_silver_annual_active: false,
         subscribe_popup_gold_annual_active: false,
         subscribe_popup_async_price: 0,
         subscribe_popup_async_active: false,
         subscribe_popup_async_name: '',
         subscribe_popup_async_annual_price: 0,
         subscribe_popup_async_show_annual_reduction: false,
         subscribe_popup_async_monthly_active: false,
         subscribe_popup_async_annual_active: false,
         subscribe_popup_async_annual_duration: 1,
         subscribe_popup_async_annual_duration_type: 'yearly',
         subscribe_popup_async_annual_rebill: true,
         subscribe_popup_async_tier_hidden: false,
         subscribe_popup_async_tier_apply: false,
         subscribe_popup_trial_length: 7,
         subscribe_popup_single_tier: false,
         // subscribe popup info
         current_tier: '',
         subscription_popup_info_page_type: '',
         subscription_popup_info_renewal_date: '',
         subscription_popup_info_open: false,
         subscription_popup_info_text_1: '',
         subscription_popup_info_text_2: '',
         subscription_popup_info_button_text: '',
         subscription_popup_silver_access: '',
         subscription_popup_gold_access: '',
         subscription_popup_info_button_click_process: () => {
         },
         CloseSubscribePopupInfoFunc: this.CloseSubscribePopupInfo,
         password_edit_visible: false,
         isLargeDevice: false,
         isSmallDevice: false,
         deviceWidth: '',
         n_page_views: 0,
         // editing mode
         edit_mode: false,
         banner_file: undefined,
         header_file: undefined,
         // get current country for currency
         countryName: '',
         currency: 'GBP',
         // banner upload
         isUploading: false,
         uploadComplete: false,
         uploadError: false,
         uploadErrorMsg: '',
         uploadPercent: 0,
         uploadMessage: '',
         uploadStep: '',
         fileSize: 0,
         uploadSpeeds: [],
         uploadStartTime: null,
         timeRemaining: null,
         controller: null,
         timeoutTimer: 0,
         prevPercent: 0,
         //
         subpopup_info_selected_duration: '',
         influencer_rating_average: 5,
         influencer_rating_count: 0,
         rating_color: '#fff',
         influencer_user_rating: 5,
         waiting_list: false,
         // discord status
         discord_active: null,
         // is_me
         // discord_access: false,   this.state.influencer_info.discord_access
         user_discord_setup: null,
         show_discord_popup: true,
         shown_discord_popup_recently: true,

         user_email: '',
         intercom_verify_key: '',
         // terms and conditions
         termsConditionsModal: false,
         terms_tab: 'subscriber',
         // influencer bio varaibles
         influencerBioLength: 0,
         editedBio: false,
         profile_tab_index: 'content',
         calendly_modal: false,
         demo_modal: false,
         full_service_application_modal: false,
         show_save_changes_bar: true,
         //
         alteredBio: '',
         alteredDisplayName: '',
         post_id: null,

         influencerDisplayName: '',
         influencerDescription: '',
         influencerIcon: '',
         influencerBanner: '',
         influencerVideo: '',

         // After changes | pre submit
         showChangesBanner: false,

         influencerDisplayNameUpdated: null,
         influencerDescriptionUpdated: null,
         influencerIconUpdated: '',
         influencerIconUpdatedLoading: false,
         influencerBannerUpdated: '',
         influencerBannerUpdatedFile: '',
         influencerVideoUpdated: '',
         influencerVideoUpdatedFile: '',
         placeholderImage: '',


         isVideoButtonHovered: false,
         isBannerButtonHovered: false,
         customiseMode: true,
         isBannerModalOpen: false,

         community_is_active: false,
         async_is_active: false,
         new_creator_modal: false,
         hidden_tab_modal: false,
         hidden_tab_type: '',

         tab_info_modal: false,
         tab_info_modal_type: '',
         tabState: false,
         // content upload vars
         categories_filter: [],
         content_types: [],
         tierTypes: [],
         courseNames: [],
         courseCounts: [],
         open_content_upload: false,
         content_type: '',

         hasAsyncMembers: false,


         // dashboard data
         expanded: 'panel1',
         expandedDashboard: 'dashboard',
         isSwitchOn: false,
         profileLiveLoading: false,
         copyButtonClicked: false,
         progressCount: 0,
         intercomLoc: null,
         publishedCongratsModal: false,

         // varaibles highlighting what's been done already
         firstName: '',
         watchedSalesVideo: undefined,
         setupProfile: false,
         sharedWaitingList: '',
         oneWaitingList: false,
         uploadedContent: false,
         uploadedPlaylistContent: false,
         updatedPerks: false,
         setupStripe: false,
         stripeStatus: '',
         missingProfiles: null,
         missingText: '',
         tierText: '',
         stripeRedirectLink: '',
         tierChangeOptions: '',
         shareWaitingListError: '',
         joinReasonAdded: false,
         profileVideoAdded: false,
         showContentConfetti: false,

         // what this modals
         openProfileWhatsThis: false,
         openOfferingWhatsThis: false,
         openWaitingListWhatsThis: false,
         openCallWhatsThis: false,
         openContentWhatsThis: false,
         openStripeWhatsThis: false,
         openUrlWhatsThis: false,
         openEditUrl: false,
         editedUsername: '',
         editUrlErrorMsg: '',
         openRefCalcWhatsThis: false,

         tiersModal: false,
         publishModal: false,
         waitingListCount: '',
         collectionsCount: '',
         activeTierCount: '',

         snackbar: false,
         snackbarAutoHide: 4000,
         snackbarSeverity: 'error',
         errorMsg: '',

         publishSnackbar: false,
         publishSnackbarAutoHide: 4000,
         publishSnackbarSeverity: 'error',
         publishErrorMsg: '',
         publishActionText: '',
         publishActionProcess: {},
         openOffering: false,
         open_icon_image_edit: false,

         confettiModal: false,
         whatsThisModal: false,
         checkListModal: false,

         collapse_dashboard: false,
         loading_dashboard_data: false,
         refreshing_content_data: false,
         previewInitialLoading: true,
         isMobile: window.innerWidth <= 900,
         revertImage: false,
         bannerChangesMade: false,
         videoRemoved: false,
         content_count: 0,
         // View type
         view_type: 'creator',
         customCreatorLogoModalOpen: false,
         uploadingCustomCreatorLogo: false,

         // snackbar
         errorMsgUpload: '',
         snackbarOpenUpload: false,
         snackbarSeverityUpload: 'success',

         snackbarSaveText: '',

         snackbarSaved: false,
         snackbarRemoveSaved: false,

         selected_tab: 'all',
         category_menu_open: false,
         category_filter: 'all',
         content_filter: 'all',
         tier_filter: -1,
         sort_menu_open: false,
         content_menu_open: false,
         collections_menu_open: false,
         tier_menu_open: false,
         sort_filter: 'latest',
         collection_filter: 0,
         anchorEl: null,
         collectionsMobileAnchorEl: null,
         collectionsMobileOpen: false,
         selected_collection_index: 2,
         // new var to track collection view
         single_view_collection: '',
         trialLength: '',
         creator_tabs: [/* 'dashboard',  */'membership'],
         // creator_tabs: ['dashboard'],


         // insights
         n_views_this_week: '',
         n_views_increase: '',
         n_subs_this_week: '',
         n_subs_increase: '',
         n_subs_this_week_members: '',
         n_subs_increase_members: '',
         n_subs_this_week_async: '',
         n_subs_increase_async: '',
         n_single_content_this_week: '',
         n_single_content_increase: '',
         n_paid_dms_this_week: '',
         n_paid_dms_increase: '',
         n_tips_this_week: '',
         n_tips_increase: '',
         this_month_income: '',
         last_month_income: '',
         // demo date
         n_collection_purchases_this_week: '',
         n_collection_purchases_increase: '',

         // content
         // old to be deleted
         influencer_content: null,
         influencer_featured_content: [],
         influencer_latest_content: [],
         influencer_course_content: [],
         influencer_library_content: [],
         prev_bookmark_content_id: '',
         prev_bookmark_state: false,
         prev_saved_tab: '',
         influencer_content_contains_buy_now: false,

         // new
         influencer_content_list: null,
         collections_count: 0,
         collection_names: [],
         collection_data: [],
         scheduled_count: 0,
         live_count: 0,
         all_count: 0,
         saved_count: 0,
         force_content_rerender: false,
         force_navbar_rerender: false,
         open_example_creators: false,
         getStartedModalOpen: false,
         collectionTitleHovered: false,
         hoveredIndex: null,

         // search
         searchBarFocus: false,
         contentIsLoading: null,
         mobileSearchOpen: false,

         // share
         shareText: 'Copy',
         socialModalOpen: false,

         // 2nd checkout popup
         open_checkout_modal: false,
         checkout_selected_duration: 'monthly',
         promo_code: null,
         checkout_percent_off: 0,
         edited_promo_code: '',
         promo_error: '',

         // content modal
         contentModalOpen: false,
         content_loading: false,
         currentContentID: null,

         // create initial content info
         content_info: {
            file: '',
            name: '',
            current_tier: '',
            tier: '',
            id: '',
            influencer: '',
            influencer_name: '',
            content_type: '',
            category: '',
            icon_image_file: '',
            is_me: '',
            thumbnail: '',
            content_like: '',
            is_favourite: '',
            description: '',
            n_likes: '',
            added: '',
         },

         // new combined ratings modal
         ratingsModal: false,
         force_initial_loaded: false,
         view_id: '',

         subpopup_tier_overwrite: null,
         subpopup_tier_async_overwrite: null,
         current_page: 'creator',
         selectedMemberTabOverwrite: null,

         // test vars
         logoSquareFile: '',
         logoRectangleFile: '',
         logoSquareFileNew: '',
         logoRectangleFileNew: '',
         // Temporary placeholder var thats displayed pre-save
         currentLogoFile: null,
         mainLogoFile: null,
         had_demo: false,
         content_settings: 'default',

         //   Paid DMs
         paidDMsExplainerModal: false,
         paidDMsPreviouslyActive: false,
         paidDMsOfferingActive: false,
         paidDMsPriceCheckout: '',
         paidDMsPriceCheckoutStr: '',
         paidDMsOfferingPriceMinimum: 299,
         paidDMsCheckoutModal: false,
         paidDMsUserEnteredPrice: 0,
         DMsCreatorCustomMessage: "Let's connect! Ask me anything and I'll get your questions solved ASAP. If you need more clarity, I will always extend the chat.",
         currencyIcon: '',
         currencyIconPost: '',
         paidDMs_show: false,
         paidDMs_has_messages: false,
         max_message_length: 1000,

         // Tipping
         tippingCheckoutOpen: false,
         tippingPriceCheckout: '',
         tippingPriceCheckoutStr: '',
         tippingPriceMinimum: 299,

         // each content type buynow
         buyNowImageActive: false,
         buyNowVideoActive: false,
         buyNowGuideActive: false,
         buyNowAudioActive: false,
         buyNowTextActive: false,
         buyNowLiveActive: false,


         // buy now
         buyNowActive: false,
         buyNowCheckoutOpen: false,
         buyNowPriceCheckout: 299,
         buyNowPriceCheckoutStr: '2.99',
         buyNowThumbnailUrl: '',
         buyNowTitle: '',
         buyNowContentType: '',
         buyNowContentId: '',

         // edit collections
         editCollectionBuyNowActive: false,
         editCollectionOpen: false,
         editCollectionId: '',
         editCollectionTitle: '',
         editCollectionPrice: 0,
         editCollectionPriceStr: '',
         editCollectionThumbnail: '',
         editCollectionLocked: false,


         // buy collections
         buyCollectionActive: false,
         buyCollectionCheckoutOpen: false,
         buyCollectionPriceCheckout: 299,
         buyCollectionPriceCheckoutStr: '2.99',
         buyCollectionThumbnailUrl: '',
         buyCollectionTitle: '',
         buyCollectionId: null,

         // Calendly modals
         calendly_creator_menu_url: '',
         calendly_creator_menu_open: false,

         // paid dms
         dm_active: false,
         // new checkout payment info
         connected_stripe_account_id: '',
         initialSubscribePopupDuration: 'monthly',
         usernameSnackbar: false,

         updatedDisplayName: '',
         selected_page_view: 'dashboard',
         last_5_categories: [],
         last_5_course_names: [],
         isFixed: true,
         isTabsFixed: false,
         open_messages: false,
         open_coaching: false,
         open_collection: false,
         page_n: 1,
         loading_page_change: false,

         // Waitlist Breakdown
         waitlistSignups: 0,
         pageViews: 0,
         predictedMemberships: 0,
         predictedFirstMonthIncome: 0,
         showWaitlistPredictions: true,
         // Splash screens
         waitlistSplashScreenOpen: false,
         buyNowCheckoutTitle: '',
         buyNowContentType: '',
         buyNowCheckoutThumbnail: '',
         buyNowCheckoutPrice: 0,
         buyNowCheckoutContentId: '',
         // checkout error screen
         openCheckoutError: false,
         confirmationSnackbarOpen: false,

         // Create collection
         newPlaylistModal: false,
         newCollectionShowMinBuyNowPriceError: false,
         minBuyNowPriceError: 'Please enter a price greater than ',
         newCourseName: '',
         minBuyNowPrice: 100,
         newCoursePriceActive: false,
         newCoursePriceStr: '2.99',
         newCoursePrice: 299,

         // Page portal
         activeProductData: [],
         isAnyModalOpen: false,
         morePages: initialMorePages,
         incomeData: {},
         subscriptionSubTab: '',

         stripe_customer_id2: '',
         // home, add_product, creation_flow
         my_platform_page: 'home',
         product_type: '',
         editingCourse: false,
         activeTabs:[
            {subscriptions: false},
            {courses: false},
            {collections: false},
            {digital_products: false},
            {community: false},
            {async: false},
            {paid_dms: false},
         ],
         digitalProducts: [],
         isCollectionContentReorder: false,
         collectionContentReorderData: [],
         // creator state
         late_payment: false,
         n_subs: 0,
         creator_tier: 0,
      }

      this.tabsBarRef = React.createRef();
      this.resetTabsRef = React.createRef();

      this.handleBeforeUnload = this.handleBeforeUnload.bind(this);
      this.CloseSubscribePopup = this.CloseSubscribePopup.bind(this);
      this.CloseWaitingListPopup = this.CloseWaitingListPopup.bind(this);
      this.OpenSubscribePopup = this.OpenSubscribePopup.bind(this);
      this.OpenWaitingListPopup = this.OpenWaitingListPopup.bind(this);
      this.UpgradeSubInfoPopup = this.UpgradeSubInfoPopup.bind(this);
      this.DowngradeSubInfoPopup = this.DowngradeSubInfoPopup.bind(this);
      this.CloseSubscribePopupInfo = this.CloseSubscribePopupInfo.bind(this);
      this.DowngradeProcessPost = this.DowngradeProcessPost.bind(this);
      this.ToggleEdit = this.ToggleEdit.bind(this);
      this.OnInfluencerEditChange = this.OnInfluencerEditChange.bind(this);
      this.get_and_post_data_skeleton = this.get_and_post_data_skeleton.bind(this);
      this.like_button_click = this.like_button_click.bind(this);
      this.like_button_click_post = this.like_button_click_post.bind(this);
      this.bookmark_button_click_post = this.bookmark_button_click_post.bind(this);
      this.update_filter_state = this.update_filter_state.bind(this);
      this.DowngradeSubscription = this.DowngradeSubscription.bind(this);
      this.UpgradeSubscription = this.UpgradeSubscription.bind(this);
      this.UpdateSubpopupInfoPageType = this.UpdateSubpopupInfoPageType.bind(this);
      this.updatePredicate = this.updatePredicate.bind(this);
      this.onVideoChange = this.onVideoChange.bind(this)
      this.onBannerChange = this.onBannerChange.bind(this)
      this.metricLoadStart = performance.now();
      this.getSubpopupInfo = this.getSubpopupInfo.bind(this);
      this.postSubpopupInfo = this.postSubpopupInfo.bind(this);
      this.getGeoInfo = this.getGeoInfo.bind(this);
      this.bookmark_button_click = this.bookmark_button_click.bind(this);
      this.uploadInfluencerHeader = this.uploadInfluencerHeader.bind(this);
      this.uploadInfluencerBanner = this.uploadInfluencerBanner.bind(this);
      this.update_ratings = this.update_ratings.bind(this);
      this.preUploadTimeoutSetup = this.preUploadTimeoutSetup.bind(this);
      this.setCalendlyModal = this.setCalendlyModal.bind(this);
      this.saveBannerChanges = this.saveBannerChanges.bind(this);
      this.makeInfluencerLive = this.makeInfluencerLive.bind(this);
      this.submitUsernameUpdate = this.submitUsernameUpdate.bind(this);
      this.switch_onChange_handle = this.switch_onChange_handle.bind(this);
      this.newContentSubmit = this.newContentSubmit.bind(this);
      this.newOfferingSubmit = this.newOfferingSubmit.bind(this);
      this.UpdateIconImagePush = this.UpdateIconImagePush.bind(this);
      this.setRevertImageFalse = this.setRevertImageFalse.bind(this);
      this.updateViewType = this.updateViewType.bind(this);
      this.setTrialLength = this.setTrialLength.bind(this);
      this.setContentPost = this.setContentPost.bind(this);
      this.updateSubscriptionIntent = this.updateSubscriptionIntent.bind(this);
      this.goToCheckout = this.goToCheckout.bind(this);
      this.setState = this.setState.bind(this);
      this.undoSave = this.undoSave.bind(this);
      this.postSaveRestore = this.postSaveRestore.bind(this);
      this.postSaveRestoreSubPosts = this.postSaveRestoreSubPosts.bind(this);
      this.postSaveRestorePaidPosts = this.postSaveRestorePaidPosts.bind(this);
      this.handleObserver = this.handleObserver.bind(this);
      this.openSearchContent = this.openSearchContent.bind(this);
      this.openSearchContentCollection = this.openSearchContentCollection.bind(this);
      this.handleCloseTiers = this.handleCloseTiers.bind(this);
      this.updateCommunityActive = this.updateCommunityActive.bind(this);
      this.openDMCheckout = this.openDMCheckout.bind(this);
      this.openTipCheckout = this.openTipCheckout.bind(this);
      this.updateHasMessage = this.updateHasMessage.bind(this);
      this.setMaxMessageLength = this.setMaxMessageLength.bind(this);
      this.freeSubSubscribe = this.freeSubSubscribe.bind(this);
      this.pinned_post_process = this.pinned_post_process.bind(this);
      this.setCommentCount = this.setCommentCount.bind(this);
      this.openAsyncApply = this.openAsyncApply.bind(this);
      this.revertUserIcon = this.revertUserIcon.bind(this);
      this.setPageN = this.setPageN.bind(this);
      this.setNewCourseName = this.setNewCourseName.bind(this);
      this.addNewPlaylist = this.addNewPlaylist.bind(this);
      this.updateCollectionOrder = this.updateCollectionOrder.bind(this);
      this.checkModalStatus = this.checkModalStatus.bind(this);
      // this.loadInitialInfluencerData = this.loadInitialInfluencerData.bind(this);
      this.handleTabNavigation = this.handleTabNavigation.bind(this);
      this.saveNewCollectionContentOrder = this.saveNewCollectionContentOrder.bind(this);
      // this.loadInfluencerContentData = this.loadInfluencerContentData.bind(this);
   }



   checkModalStatus = () => {
      const modalStates = [
         this.state.customCreatorLogoModalOpen,
         this.state.publishedCongratsModal,
         this.state.new_creator_modal,
         this.state.hidden_tab_modal,
         this.state.tab_info_modal,
         this.state.editCollectionOpen,
         this.state.isBannerModalOpen,
         this.state.getStartedModalOpen,
         this.state.open_example_creators,
         this.state.open_content_upload,
         this.state.edit_mode,
         this.state.newPlaylistModal,
      ];

      const anyModalOpen = modalStates.some(state => state === true);

      if (this.state.isAnyModalOpen !== anyModalOpen) {
         this.setState({ isAnyModalOpen: anyModalOpen });
      }
   }



   
   updateCollectionOrder(new_order, func_to_call) {
      const form_data = new FormData();
      form_data.append('new_order', new_order)
      axios({
         method: 'post',
         url: paths.BACKEND_URL + "api/update_collection_order/",
         data: form_data,
         headers: {
            'Content-type': 'application/json',
         },
         withCredentials: true
      }).then(res => {
         if ('error' in res.data) {
            // raise an error on a snack bar here
         } else {
            // reload the collections tab
            if (this.state.selected_tab === 'sub_collections'){
               this.handleProfileTabChange('', 'sub_collections');
            } else if (this.state.selected_tab === 'paid_collections'){
               this.handleProfileTabChange('', 'paid_collections');                     
            }
            // this.newContentSubmit();
            func_to_call();
         }
      }
      )
   }

   setPageN(page_n) {
      this.setState({
         page_n: page_n,
         loading_page_change: true,
         update_inf_scroll: true,
      })
      const form_data = new FormData();
      form_data.append('influencer_str', this.state.influencer_info.influencer)
      form_data.append('category', this.state.category_filter)
      form_data.append('content_type', this.state.content_filter)
      form_data.append('start_index', this.state.page_position)
      form_data.append('sort', this.state.sort_filter === 'saved' ? 'latest' : this.state.sort_filter === 'purchased' ? 'latest' : this.state.sort_filter === 'saved_sub_posts' ? 'latest' : this.state.sort_filter === 'saved_paid_posts' ? 'latest' : this.state.sort_filter)
      form_data.append('tab', this.state.selected_tab === 'sub_posts' && this.state.sort_filter === 'saved_sub_posts' ? 'saved_sub_posts' : this.state.selected_tab === 'paid_posts' && this.state.sort_filter === 'saved_paid_posts' ? 'saved_paid_posts' : this.state.selected_tab === 'all' && this.state.sort_filter === 'saved' ? 'saved' :  this.state.sort_filter === 'purchased' ? 'purchased' : this.state.selected_tab)
      form_data.append('collection', this.state.single_view_collection === '' ? '' : this.state.single_view_collection)
      form_data.append('post_id', this.state.initial_content_id)
      form_data.append('page_n', page_n)
      form_data.append('currency', this.state.currency)
      form_data.append('tier', this.state.selected_tab === 'sub_posts' ? this.state.tier_filter: this.state.selected_tab === 'all' ? this.state.tier_filter: -1)
      axios({
         method: 'post',
         url: paths.BACKEND_URL + "api/influencer_content_data_tab_change_v7",
         headers: {
            'Content-type': 'application/json',
         },
         data: form_data,
         withCredentials: true
      }).then(res => {
         let new_influencer_content_list = [...res.data.content_list]
         if ((this.state.dashboard === true) && (this.state.view_type === 'user')) {
            if (!((this.state.single_view_collection === '') && (this.state.selected_tab === 'sub_collections' || this.state.selected_tab === 'paid_collections' || this.state.selected_tab === 'collections'))) {
               res.data.content_list.map((influencer_content_split, index) => {
                  new_influencer_content_list[index]['current_tier'] = -1
               })
            } else {
               // res.data.content_list.map((influencer_content_split, index) => {
               //    influencer_content_split.data.map(
               //       (influencer_content_split_inner, index2) => {
               //          new_influencer_content_list[index]['data'][index2]['current_tier'] = -1
               //       }
               //    )
               // })
            }
            this.setState({ subpopup_tier_overwrite: -1 })
            this.setState({ subpopup_tier_async_overwrite: false })
         }
         else if ((this.state.dashboard === true) && (this.state.view_type === 'user-subscribed')) {
            let sub_tier = 0
            let sub_async_tier = false
            if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_silver_active === true) & (this.state.subscribe_popup_gold_active === true) & (this.state.subscribe_popup_async_active === true)) {
               sub_tier = 2
               sub_async_tier = true
            } else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_silver_active) & (this.state.subscribe_popup_gold_active)) {
               sub_tier = 2
               sub_async_tier = false
            } else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_silver_active) & (this.state.subscribe_popup_async_active)) {
               sub_tier = 2
               sub_async_tier = true
            } else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_gold_active) & (this.state.subscribe_popup_async_active)) {
               sub_tier = 3
               sub_async_tier = true
            } else if ((this.state.subscribe_popup_silver_active === true) & (this.state.subscribe_popup_gold_active) & (this.state.subscribe_popup_async_active)) {
               sub_tier = 3
               sub_async_tier = true
            }
            else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_silver_active)) {
               sub_tier = 1
               sub_async_tier = false
            }
            else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_gold_active)) {
               sub_tier = 1
               sub_async_tier = false
            }
            else if ((this.state.subscribe_popup_silver_active === true) & (this.state.subscribe_popup_gold_active)) {
               sub_tier = 2
               sub_async_tier = false
            }
            else if ((this.state.subscribe_popup_silver_active === true) & (this.state.subscribe_popup_async_active)) {
               sub_tier = 2
               sub_async_tier = true
            }
            else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_async_active)) {
               sub_tier = 1
               sub_async_tier = true
            }
            else if ((this.state.subscribe_popup_gold_active === true) & (this.state.subscribe_popup_async_active)) {
               sub_tier = 3
               sub_async_tier = true
            }
            else if ((this.state.subscribe_popup_bronze_active === true)) {
               sub_tier = 1
               sub_async_tier = false
            }
            else if ((this.state.subscribe_popup_silver_active === true)) {
               sub_tier = 2
               sub_async_tier = false
            }
            else if ((this.state.subscribe_popup_gold_active === true)) {
               sub_tier = 3
               sub_async_tier = false
            }
            else if ((this.state.subscribe_popup_async_active === true)) {
               sub_tier = -1
               sub_async_tier = true
            }
            if (!((this.state.single_view_collection === '') && (this.state.selected_tab === 'sub_collections' || this.state.selected_tab === 'paid_collections' || this.state.selected_tab === 'collections'))) {
               res.data.content_list.map((influencer_content_split, index) => {
                  new_influencer_content_list[index]['current_tier'] = sub_tier
               })
            } else {
               // res.data.content_list.map((influencer_content_split, index) => {
               //    influencer_content_split.data.map(
               //       (influencer_content_split_inner, index2) => {
               //          new_influencer_content_list[index]['data'][index2]['current_tier'] = sub_tier
               //       }
               //    )
               // })
            }
            this.setState({ subpopup_tier_overwrite: sub_tier })
            this.setState({ subpopup_tier_async_overwrite: false })
         }
         this.setState(
            {
               refreshing_content_data: false,
               influencer_content_list: new_influencer_content_list,
               contentIsLoading: false,
               inf_scroll_loading: false,
               page_position: new_influencer_content_list.length,
               loading_page_change: false,
            }
         )
         if (new_influencer_content_list.length === 0) {
            this.setState({ update_inf_scroll: false })
         }
         if (new_influencer_content_list.length >= (this.state.content_list_length - ((page_n - 1) * 20))) {
            this.setState({ update_inf_scroll: false })
         }
      })
   }

   handleSingleViewCollection = (collection_id) => {
      this.setState({ single_view_collection: collection_id })
   }



   setCommentCount(content_id, new_count) {
      let idx = this.state.influencer_content_list.findIndex(({ id }) => String(id) === String(content_id));
      let content_copy = [...this.state.influencer_content_list];
      let content_copy_item = { ...content_copy[idx] };
      content_copy_item.n_comments = new_count;
      content_copy[idx] = content_copy_item;
      this.setState({
         influencer_content_list: content_copy,
      })
   }


   pinned_post_process(new_state, content_id) {
      const form_data = new FormData();
      form_data.append('new_state', new_state);
      form_data.append('content_id', content_id);
      axios(
         {
            method: 'post',
            url: paths.BACKEND_URL + 'api/influencer/set_pinned_content',
            headers: {
               'Content-type': 'application/json',
            },
            data: form_data,
            withCredentials: true
         }
      ).then(
         res => {
            if (!res.data.error) {
               // reload the current tab
               if ((this.state.selected_tab === 'sub_collections') || (this.state.selected_tab === 'sub_posts')){
                  this.handleProfileTabChange('', 'sub_posts');
               } else if (this.state.selected_tab === 'paid_posts'){
                  this.handleProfileTabChange('', 'paid_posts');                     
               }
            }
         }
      )
   }

   freeSubSubscribe() {
      if (this.state.current_user.toLowerCase() === this.state.influencer_info['influencer'].toLowerCase()) {
      } else {
         if ((this.state.current_user === null) || (this.state.current_user === '')) {
            window.location.assign('/register?mode=free_sub&post_url=' + this.state.influencer_info.influencer)
         } else {
            const form_data = new FormData();
            form_data.append('influencer_str', this.state.influencer_info.influencer)
            axios(
               {
                  method: 'post',
                  url: paths.BACKEND_URL + 'api/influencer/add_free_membership',
                  headers: {
                     'Content-type': 'application/json',
                  },
                  data: form_data,
                  withCredentials: true
               }
            ).then(
               res => {
                  if (!res.data.error) {
                     window.location.assign('/' + this.state.influencer_info.influencer + '?open_sub=true')
                  } else {
                  }
               }
            )
         }
      }
   }

   fetchActiveProductData = async (currency) => {
      try {
         const form_data = new FormData();
         form_data.append('influencer_str', this.props.influencer_username);
         form_data.append('currency', currency)

         const response = await axios({
             method: 'post',
             url: paths.BACKEND_URL + "api/get_active_influencer_products",
             data: form_data,
             headers: {
                 'Content-type': 'application/json',
             },
             withCredentials: true,
         });
         

         if (response.data.error) {
             this.setState({
                 loading: false,
                 error: response.data.error
             });
             return;
         }
               
         this.setState({
            activeProductData: response.data
         });

     } catch (error) {
         // console.error('Error fetching customer data:', error);
         this.setState({
             loading: false,
             error: 'Failed to load customer data'
         });
     }
   }

   handleConfirmationSnackbarClose() {
      this.setState({ confirmationSnackbarOpen: false })
   }

   handleConfirmationSnackbarOpen = () => {
      this.setState({ confirmationSnackbarOpen: true })
   }

   setMaxMessageLength(value) { this.setState({ max_message_length: value }) }

   updateHasMessage() {
      this.setState({ paidDMs_has_messages: false })
   }


   reorderCategories(items) {
      const foodItems = items.filter(item => item.vertical === "food");
      const mealPlanItem = foodItems.find(item => item.category === "meal plan");
      const otherFoodItems = foodItems.filter(item => item.category !== "meal plan");
      const reorderedFoodItems = mealPlanItem ? [mealPlanItem, ...otherFoodItems] : otherFoodItems;
      const otherItems = items.filter(item => item.vertical !== "food");
      return [...reorderedFoodItems, ...otherItems];
   };



   resetBuyNow() {
      this.setState({
         buyNowActive: false,
         buyNowImageActive: false,
         buyNowVideoActive: false,
         buyNowAudioActive: false,
         buyNowGuideActive: false,
         buyNowTextActive: false,
         buyNowLiveActive: false,
         buyNowCheckoutOpen: false,
         buyNowPriceCheckout: this.state.currency === 'SEK' ? 1500 : 299,
         buyNowPriceCheckoutStr: this.state.currency === 'SEK' ? '15' : '2.99',
      })
   }

   openDMCheckout(currency = null, creator = null) {

      let data = new FormData();
      if (currency) {
         data.append('currency', currency)
      } else {
         data.append('currency', this.state.currency)
         currency = this.state.currency
      }
      if (creator) {
         data.append('influencer', creator)
      } else {
         data.append('influencer', this.state.influencer_info.influencer)
      }

      axios(
         {
            method: 'post',
            url: paths.BACKEND_URL + 'api/influencer/load_dm_minimum_price',
            headers: {
               'Content-type': 'application/json',
            },
            data: data,
            withCredentials: true
         }
      ).then(
         res => {

            if (res.data.error) {
               if (res.data.error === 'non_connect') {
                  this.setState({
                     openCheckoutError: true,
                  })
               }
            } else {
               this.setState(
                  {
                     paidDMsOfferingPriceMinimum: res.data.minimum_price,
                     paidDMsCheckoutModal: true,
                     paidDMsExplainerModal: false,
                  },
               )
               if (currency == 'GBP') {
                  this.setState(
                     {
                        currencyIcon: '£',
                        currencyIconPost: '',
                     }
                  )
               } else if (currency == 'EUR') {
                  this.setState(
                     {
                        currencyIcon: '€',
                        currencyIconPost: '',
                     }
                  )
               } else if (currency == 'USD') {
                  this.setState(
                     {
                        currencyIcon: '$',
                        currencyIconPost: '',
                     }
                  )
               } else if (currency == 'SEK') {
                  this.setState(
                     {
                        currencyIcon: '',
                        currencyIconPost: ' kr',
                     }
                  )
               } else if (currency == 'AUD') {
                  this.setState(
                     {
                        currencyIcon: 'AU$',
                        currencyIconPost: '',
                     }
                  )
               } else if (currency == 'CAD') {
                  this.setState(
                     {
                        currencyIcon: 'CA$',
                        currencyIconPost: '',
                     }
                  )
               } else if (currency == 'NZD') {
                  this.setState(
                     {
                        currencyIcon: 'NZ$',
                        currencyIconPost: '',
                     }
                  )
               }
            }
         }
      )
   }

   openTipCheckout(currency = null, creator = null) {
      let data = new FormData();
      if (currency) {
         data.append('currency', currency)
      } else {
         data.append('currency', this.state.currency)
         currency = this.state.currency
      }
      if (creator) {
         data.append('influencer', creator)
      } else {
         data.append('influencer', this.state.influencer_info.influencer)
      }
      axios(
         {
            method: 'post',
            url: paths.BACKEND_URL + 'api/influencer/load_tip_minimum_price',
            headers: {
               'Content-type': 'application/json',
            },
            data: data,
            withCredentials: true
         }
      ).then(
         res => {
            if (res.data.error) {
               if (res.data.error === 'non_connect') {
                  this.setState({
                     openCheckoutError: true,
                  })
               }
            } else {
               this.setState(
                  {
                     tippingPriceMinimum: res.data.minimum_price,
                     tippingCheckoutOpen: true,
                  },
               )
               if (currency == 'GBP') {
                  this.setState(
                     {
                        currencyIcon: '£',
                        currencyIconPost: '',
                     }
                  )
               } else if (currency == 'EUR') {
                  this.setState(
                     {
                        currencyIcon: '€',
                        currencyIconPost: '',
                     }
                  )
               } else if (currency == 'USD') {
                  this.setState(
                     {
                        currencyIcon: '$',
                        currencyIconPost: '',
                     }
                  )
               } else if (currency == 'SEK') {
                  this.setState(
                     {
                        currencyIcon: '',
                        currencyIconPost: ' kr',
                     }
                  )
               } else if (currency == 'AUD') {
                  this.setState(
                     {
                        currencyIcon: 'AU$',
                        currencyIconPost: '',
                     }
                  )
               } else if (currency == 'CAD') {
                  this.setState(
                     {
                        currencyIcon: 'CA$',
                        currencyIconPost: '',
                     }
                  )
               } else if (currency == 'NZD') {
                  this.setState(
                     {
                        currencyIcon: 'NZ$',
                        currencyIconPost: '',
                     }
                  )
               }
            }
         }
      )
   }


   openBuyNowCheckout = (currency = null, thumbnail, title, contentType, content_id) => {
      let data = new FormData();

      if (currency) {
         data.append('currency', currency)
      } else {
         data.append('currency', this.state.currency)
         currency = this.state.currency
      }
      data.append('content_id', content_id)
      axios(
         {
            method: 'post',
            url: paths.BACKEND_URL + 'api/content/load_single_content_price',
            headers: {
               'Content-type': 'application/json',
            },
            data: data,
            withCredentials: true
         }
      ).then(
         res => {
            if (res.data.error) {
               if (res.data.error === 'non_connect') {
                  this.setState({
                     openCheckoutError: true,
                  })
               }
            } else {
               this.setState(
                  {
                     buyNowCheckoutOpen: true,
                     buyNowCheckoutTitle: res.data.title,
                     buyNowCheckoutThumbnail: res.data.thumbnail_url,
                     buyNowContentType: contentType,
                     buyNowCheckoutPrice: res.data.content_price,
                     buyNowCheckoutContentId: content_id,
                  },
               )
               if (currency == 'GBP') {
                  this.setState(
                     {
                        currencyIcon: '£',
                        currencyIconPost: '',
                     }
                  )
               } else if (currency == 'EUR') {
                  this.setState(
                     {
                        currencyIcon: '€',
                        currencyIconPost: '',
                     }
                  )
               } else if (currency == 'USD') {
                  this.setState(
                     {
                        currencyIcon: '$',
                        currencyIconPost: '',
                     }
                  )
               } else if (currency == 'SEK') {
                  this.setState(
                     {
                        currencyIcon: '',
                        currencyIconPost: ' kr',
                     }
                  )
               } else if (currency == 'AUD') {
                  this.setState(
                     {
                        currencyIcon: 'AU$',
                        currencyIconPost: '',
                     }
                  )
               } else if (currency == 'CAD') {
                  this.setState(
                     {
                        currencyIcon: 'CA$',
                        currencyIconPost: '',
                     }
                  )
               } else if (currency == 'NZD') {
                  this.setState(
                     {
                        currencyIcon: 'NZ$',
                        currencyIconPost: '',
                     }
                  )
               }
            }
         }
      )
   }

   openBuyCollectionCheckout = (currency = null, collection_id) => {
      let data = new FormData();
      if (currency) {
         data.append('currency', currency)
      } else {
         data.append('currency', this.state.currency)
         currency = this.state.currency
      }
      data.append('collection_id', collection_id)
      axios(
         {
            method: 'post',
            url: paths.BACKEND_URL + 'api/content/load_collection_price',
            headers: {
               'Content-type': 'application/json',
            },
            data: data,
            withCredentials: true
         }
      ).then(
         res => {
            if (res.data.error) {
               if (res.data.error === 'non_connect') {
                  this.setState({
                     openCheckoutError: true,
                  })
               }
            } else {

               this.setState(
                  {
                     buyCollectionCheckoutOpen: true,
                     // buyCollectionThumbnailUrl: thumbnail,
                     buyCollectionTitle: res.data.title,
                     buyCollectionPriceCheckout: res.data.collection_price,
                     buyCollectionId: collection_id,
                  },
               )
               if (currency == 'GBP') {
                  this.setState(
                     {
                        currencyIcon: '£',
                        currencyIconPost: '',
                     }
                  )
               } else if (currency == 'EUR') {
                  this.setState(
                     {
                        currencyIcon: '€',
                        currencyIconPost: '',
                     }
                  )
               } else if (currency == 'USD') {
                  this.setState(
                     {
                        currencyIcon: '$',
                        currencyIconPost: '',
                     }
                  )
               } else if (currency == 'SEK') {
                  this.setState(
                     {
                        currencyIcon: '',
                        currencyIconPost: ' kr',
                     }
                  )
               } else if (currency == 'AUD') {
                  this.setState(
                     {
                        currencyIcon: 'AU$',
                        currencyIconPost: '',
                     }
                  )
               } else if (currency == 'CAD') {
                  this.setState(
                     {
                        currencyIcon: 'CA$',
                        currencyIconPost: '',
                     }
                  )
               } else if (currency == 'NZD') {
                  this.setState(
                     {
                        currencyIcon: 'NZ$',
                        currencyIconPost: '',
                     }
                  )
               }
            }
         }
      )
   }

   // new_value input must be a bool (true/false)
   updateCommunityActive(new_value) {
      // update the tiers perk status
      let data = new FormData();
      data.append('new_value', String(new_value))
      axios(
         {
            method: 'post',
            url: paths.BACKEND_URL + 'api/influencer/dashboard_update_community_active',
            headers: {
               'Content-type': 'application/json',
            },
            data: data,
            withCredentials: true
         }
      ).then(
         res => {
            const { snackConfig, setSnackConfig } = this.context;
            if (!res.data.access_denied) {
               // this.loadInitialInfluencerData();
               if (res.data.new_value === 'true') {
                  this.setState({
                     community_is_active: true,
                     contentIsLoading: true,
                     selected_tab: "",
                     loading_dashboard_data: false,
                     my_platform_page: 'creation_flow',
                     updatedPerks: res.data.updated_tier_perks,
                  })
                  this.props.navigate('?page=community')
               } else {
                  this.setState({ community_is_active: false, updatedPerks: res.data.updated_tier_perks});
                  this.handleTabNavigation('platform')
               }
               setSnackConfig({
                  open: true,
                  message: res.data.new_value === 'true' ? 'Community Added To Products' : 'Community Removed From Products',
               })
            }
         }
      )
   }

   handleCloseTiers() {
      // update the tiers perk status
      axios(
         {
            method: 'get',
            url: paths.BACKEND_URL + 'api/influencer/onboarding_dashboard_tiers_update',
            headers: {
               'Content-type': 'application/json',
            },
            withCredentials: true
         }
      ).then(
         res => {
            if (!res.data.access_denied) {
               if (!this.state.influencer_launched) {
                  let pipedrive_data = new FormData();
                  pipedrive_data.append('case', 'tier_perks')
                  axios({
                     method: 'post',
                     url: paths.BACKEND_URL + 'api/influencer/update_pipdedrive_onboarding_deals',
                     data: pipedrive_data,
                     headers: {
                        'Content-type': 'application/json',
                     },
                     withCredentials: true
                  })
               }
               this.setState(
                  {
                     tierChangeOptions: res.data.tier_change_options,
                     updatedPerks: res.data.updated_tier_perks,
                  }
               );
               let display_name_added = true
               let bio_added = true
               let handle_added = false
               let profile_picture_added = true
               let profile_banner_added = true
               if (this.state.missingProfiles.includes('Display Name')) {
                  display_name_added = false
               }
               if (this.state.missingProfiles.includes('Short Bio')) {
                  bio_added = false
               }
               if (this.state.missingProfiles.includes('profile photo')) {
                  profile_picture_added = false
               }
               if (this.state.missingProfiles.includes('header photo')) {
                  profile_banner_added = false
               }
               window.Intercom('shutdown');
               window.Intercom('boot', {
                  app_id: INTERCOM_APP_ID,
                  api_base: "https://api-iam.intercom.io",
                  name: this.state.current_user,
                  email: this.state.user_email,
                  user_hash: this.state.intercom_verify_key,
                  avatar: {
                     "type": "avatar",
                     "image_url": `${paths.BACKEND_URL}api/user/icon`,
                  },
                  "is_influencer": true,
                  "is_logged_in": true,
                  'is_influencer_launched': this.state.influencer_launched,
                  "onboarding_watched_intro_video": this.state.watchedSalesVideo,
                  "onboarding_reason_given": this.state.joinReasonAdded,
                  "onboarding_display_name_added": display_name_added,
                  "onboarding_bio_added": bio_added,
                  "onboarding_handle_added": handle_added,
                  "onboarding_profile_picture_added": profile_picture_added,
                  "onboarding_profile_banner_added": profile_banner_added,
                  "onboarding_profile_video_added": this.state.profileVideoAdded,
                  "onboarding_content_uploaded": this.state.content_count >= 1 ? true : false,
                  "onboarding_playlist_content_uploaded": this.state.uploadedPlaylistContent,
                  "onboarding_waiting_list_shared": this.state.sharedWaitingList,
                  "onboarding_atleast_one_waiting_list": this.state.oneWaitingList,
                  "onboarding_tier_perks_updated": res.data.updated_tier_perks,
                  "onboarding_stripe_connected": this.state.setupStripe,
                  "onboarding_been_to_dashboard": true,
                  hide_default_launcher: window.innerWidth < 600 ? true : false,
               });
               this.newOfferingSubmit();
            } else {
               window.location.assign('/become-a-creator/register');
            }
         }
      )
      this.setState({ tiersModal: false });
   }


   openSearchContent = (content_id) => {
      this.setState({
         initial_content_id: content_id,
      })
      this.handleProfileTabChange(
         {},
         this.state.selected_tab,
         null,
         null,
         true,
         content_id,
      )
   }

   openSearchContentCollection = (collection_name) => {
      let index = ''
      for (let i = 0; i < this.state.collection_names.length; i++) {
         if (collection_name === this.state.collection_names[i]) {
            index = i
            break;
         }
      }
      this.setState({ selected_tab: 'sub_collections' });
      this.handleCollectionTabChange({}, collection_name, 'sub_collections', true);
   }


   handleObserver = () => {
      if (this.state.inf_scroll_loading === false) {
         this.setState({ inf_scroll_loading: true })
         const form_data = new FormData();
         form_data.append('influencer_str', this.state.influencer_info.influencer)
         form_data.append('category', this.state.category_filter)
         form_data.append('content_type', this.state.content_filter)
         form_data.append('start_index', this.state.page_position)
         form_data.append('sort', this.state.sort_filter === 'saved' ? 'latest' : this.state.sort_filter === 'purchased' ? 'latest' : this.state.sort_filter === 'saved_sub_posts' ? 'latest' : this.state.sort_filter === 'saved_paid_posts' ? 'latest' : this.state.sort_filter)
         form_data.append('tab', this.state.selected_tab === 'sub_posts' && this.state.sort_filter === 'saved_sub_posts' ? 'saved_sub_posts' : this.state.selected_tab === 'paid_posts' && this.state.sort_filter === 'saved_paid_posts' ? 'saved_paid_posts' : this.state.selected_tab === 'all' && this.state.sort_filter === 'saved' ? 'saved' :  this.state.sort_filter === 'purchased' ? 'purchased' : this.state.selected_tab)
         form_data.append('collection', this.state.single_view_collection)
         form_data.append('post_id', this.state.initial_content_id)
         form_data.append('page_n', this.state.page_n)
         form_data.append('currency', this.state.currency)
         form_data.append('tier', this.state.tier_filter)
         axios({
            method: 'post',
            url: paths.BACKEND_URL + "api/influencer_content_data_inf_scroll_v5",
            headers: {
               'Content-type': 'application/json',
            },
            data: form_data,
            withCredentials: true
         }).then(res => {
            let new_influencer_content_list = [...res.data.content_list]
            if ((this.state.dashboard === true) && (this.state.view_type === 'user')) {
               if (!((this.state.single_view_collection === '') && (this.state.selected_tab === 'sub_collections' || this.state.selected_tab === 'paid_collections' || this.state.selected_tab === 'collections'))) {
                  res.data.content_list.map((influencer_content_split, index) => {
                     new_influencer_content_list[index]['current_tier'] = -1
                  })
               } else {
                  // res.data.content_list.map((influencer_content_split, index) => {
                  //    influencer_content_split.data.map(
                  //       (influencer_content_split_inner, index2) => {
                  //          new_influencer_content_list[index]['data'][index2]['current_tier'] = -1
                  //       }
                  //    )
                  // })
               }
               this.setState({ subpopup_tier_overwrite: -1 })
               this.setState({ subpopup_tier_async_overwrite: false })
            }
            else if ((this.state.dashboard === true) && (this.state.view_type === 'user-subscribed')) {
               let sub_tier = 0
               let sub_async_tier = false
               if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_silver_active === true) & (this.state.subscribe_popup_gold_active === true) & (this.state.subscribe_popup_async_active === true)) {
                  sub_tier = 2
                  sub_async_tier = true
               } else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_silver_active) & (this.state.subscribe_popup_gold_active)) {
                  sub_tier = 2
                  sub_async_tier = false
               } else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_silver_active) & (this.state.subscribe_popup_async_active)) {
                  sub_tier = 2
                  sub_async_tier = true
               } else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_gold_active) & (this.state.subscribe_popup_async_active)) {
                  sub_tier = 3
                  sub_async_tier = true
               } else if ((this.state.subscribe_popup_silver_active === true) & (this.state.subscribe_popup_gold_active) & (this.state.subscribe_popup_async_active)) {
                  sub_tier = 3
                  sub_async_tier = true
               }
               else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_silver_active)) {
                  sub_tier = 1
                  sub_async_tier = false
               }
               else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_gold_active)) {
                  sub_tier = 1
                  sub_async_tier = false
               }
               else if ((this.state.subscribe_popup_silver_active === true) & (this.state.subscribe_popup_gold_active)) {
                  sub_tier = 2
                  sub_async_tier = false
               }
               else if ((this.state.subscribe_popup_silver_active === true) & (this.state.subscribe_popup_async_active)) {
                  sub_tier = 2
                  sub_async_tier = true
               }
               else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_async_active)) {
                  sub_tier = 1
                  sub_async_tier = true
               }
               else if ((this.state.subscribe_popup_gold_active === true) & (this.state.subscribe_popup_async_active)) {
                  sub_tier = 3
                  sub_async_tier = true
               }
               else if ((this.state.subscribe_popup_bronze_active === true)) {
                  sub_tier = 1
                  sub_async_tier = false
               }
               else if ((this.state.subscribe_popup_silver_active === true)) {
                  sub_tier = 2
                  sub_async_tier = false
               }
               else if ((this.state.subscribe_popup_gold_active === true)) {
                  sub_tier = 3
                  sub_async_tier = false
               }
               else if ((this.state.subscribe_popup_async_active === true)) {
                  sub_tier = -1
                  sub_async_tier = true
               }
               if (!((this.state.single_view_collection === '') && (this.state.selected_tab === 'sub_collections' || this.state.selected_tab === 'paid_collections' || this.state.selected_tab === 'collections'))) {
                  res.data.content_list.map((influencer_content_split, index) => {
                     new_influencer_content_list[index]['current_tier'] = sub_tier
                  })
               } else {
                  // res.data.content_list.map((influencer_content_split, index) => {
                  //    influencer_content_split.data.map(
                  //       (influencer_content_split_inner, index2) => {
                  //          new_influencer_content_list[index]['data'][index2]['current_tier'] = sub_tier
                  //       }
                  //    )
                  // })
               }
               this.setState({ subpopup_tier_overwrite: sub_tier })
               this.setState({ subpopup_tier_async_overwrite: false })
            }
            this.setState(
               {
                  refreshing_content_data: false,
                  influencer_content_list: [...this.state.influencer_content_list, ...new_influencer_content_list],
                  contentIsLoading: false,
                  inf_scroll_loading: false,
                  page_position: this.state.page_position + new_influencer_content_list.length
               }
            )
            if (new_influencer_content_list.length === 0) {
               this.setState({ update_inf_scroll: false })
            }
            if ((this.state.page_position + new_influencer_content_list.length >= this.state.content_list_length) || (this.state.page_position + new_influencer_content_list.length >= 20)) {
               this.setState({ update_inf_scroll: false })
            }
         })
         this.setState({ inf_scroll_loading: false })
      }
   }

   undoSave = () => {
      this.setState({
         refreshing_content_data: true,
      })
      if ((this.state.prev_bookmark_state === false) && (this.state.prev_saved_tab === 'saved')) {
         this.bookmark_button_click(
            this.state.prev_bookmark_content_id,
            this.state.prev_bookmark_state === false,
            this.get_and_post_data_skeleton,
            this.postSaveRestore,
         )
      } else if ((this.state.prev_bookmark_state === false) && (this.state.prev_saved_tab === 'saved_sub_posts')) {
         this.bookmark_button_click(
            this.state.prev_bookmark_content_id,
            this.state.prev_bookmark_state === false,
            this.get_and_post_data_skeleton,
            this.postSaveRestoreSubPosts,
         )
      } else if ((this.state.prev_bookmark_state === false) && (this.state.prev_saved_tab === 'saved_paid_posts')) {
         this.bookmark_button_click(
            this.state.prev_bookmark_content_id,
            this.state.prev_bookmark_state === false,
            this.get_and_post_data_skeleton,
            this.postSaveRestorePaidPosts,
         )
      } else {
         this.bookmark_button_click(
            this.state.prev_bookmark_content_id,
            this.state.prev_bookmark_state === false,
            this.get_and_post_data_skeleton,
            this.bookmark_button_click_post,
         )
      }
   }

   postSaveRestore = (res) => {
      this.setState(
         {
            refreshing_content_data: true,
            influencer_content_list: [],
            inf_scroll_loading: true,
         }
      )
      const form_data = new FormData();
      form_data.append('influencer_str', this.state.influencer_info.influencer)
      form_data.append('category', this.state.category_filter)
      form_data.append('sort', this.state.sort_filter === 'saved' ? 'latest' : this.state.sort_filter === 'purchased' ? 'latest' : this.state.sort_filter)
      form_data.append('content_type', this.state.content_filter)
      form_data.append('tab', 'saved')
      form_data.append('collection', this.state.single_view_collection === '' ? '' : this.state.collection_names[this.state.single_view_collection])
      form_data.append('post_id', this.state.initial_content_id)
      form_data.append('page_n', this.state.page_n)
      form_data.append('currency', this.state.currency)
      form_data.append('tier', this.state.tier_filter)
      axios({
         method: 'post',
         url: paths.BACKEND_URL + "api/influencer_content_data_latest_v7",
         headers: {
            'Content-type': 'application/json',
         },
         data: form_data,
         withCredentials: true
      }).then(res => {
         let new_influencer_content_list = [...res.data.content_list]
         if ((this.state.dashboard === true) && (this.state.view_type === 'user')) {
            if (!((this.state.single_view_collection === '') && (this.state.selected_tab === 'sub_collections' || this.state.selected_tab === 'paid_collections' || this.state.selected_tab === 'collections'))) {
               res.data.content_list.map((influencer_content_split, index) => {
                  new_influencer_content_list[index]['current_tier'] = -1
               })
            } else {
               // res.data.content_list.map((influencer_content_split, index) => {
               //    influencer_content_split.data.map(
               //       (influencer_content_split_inner, index2) => {
               //          new_influencer_content_list[index]['data'][index2]['current_tier'] = -1
               //       }
               //    )
               // })
            }
            this.setState({ subpopup_tier_overwrite: -1 })
            this.setState({ subpopup_tier_async_overwrite: false })
         }
         else if ((this.state.dashboard === true) && (this.state.view_type === 'user-subscribed')) {
            let sub_tier = 0
            let sub_async_tier = false
            if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_silver_active === true) & (this.state.subscribe_popup_gold_active === true) & (this.state.subscribe_popup_async_active === true)) {
               sub_tier = 2
               sub_async_tier = true
            } else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_silver_active) & (this.state.subscribe_popup_gold_active)) {
               sub_tier = 2
               sub_async_tier = false
            } else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_silver_active) & (this.state.subscribe_popup_async_active)) {
               sub_tier = 2
               sub_async_tier = true
            } else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_gold_active) & (this.state.subscribe_popup_async_active)) {
               sub_tier = 3
               sub_async_tier = true
            } else if ((this.state.subscribe_popup_silver_active === true) & (this.state.subscribe_popup_gold_active) & (this.state.subscribe_popup_async_active)) {
               sub_tier = 3
               sub_async_tier = true
            }
            else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_silver_active)) {
               sub_tier = 1
               sub_async_tier = false
            }
            else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_gold_active)) {
               sub_tier = 1
               sub_async_tier = false
            }
            else if ((this.state.subscribe_popup_silver_active === true) & (this.state.subscribe_popup_gold_active)) {
               sub_tier = 2
               sub_async_tier = false
            }
            else if ((this.state.subscribe_popup_silver_active === true) & (this.state.subscribe_popup_async_active)) {
               sub_tier = 2
               sub_async_tier = true
            }
            else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_async_active)) {
               sub_tier = 1
               sub_async_tier = true
            }
            else if ((this.state.subscribe_popup_gold_active === true) & (this.state.subscribe_popup_async_active)) {
               sub_tier = 3
               sub_async_tier = true
            }
            else if ((this.state.subscribe_popup_bronze_active === true)) {
               sub_tier = 1
               sub_async_tier = false
            }
            else if ((this.state.subscribe_popup_silver_active === true)) {
               sub_tier = 2
               sub_async_tier = false
            }
            else if ((this.state.subscribe_popup_gold_active === true)) {
               sub_tier = 3
               sub_async_tier = false
            }
            else if ((this.state.subscribe_popup_async_active === true)) {
               sub_tier = -1
               sub_async_tier = true
            }
            if (!((this.state.single_view_collection === '') && (this.state.selected_tab === 'sub_collections' || this.state.selected_tab === 'paid_collections' || this.state.selected_tab === 'collections'))) {
               res.data.content_list.map((influencer_content_split, index) => {
                  new_influencer_content_list[index]['current_tier'] = sub_tier
               })
            } else {
               // res.data.content_list.map((influencer_content_split, index) => {
               //    influencer_content_split.data.map(
               //       (influencer_content_split_inner, index2) => {
               //          new_influencer_content_list[index]['data'][index2]['current_tier'] = sub_tier
               //       }
               //    )
               // })
            }
            this.setState({ subpopup_tier_overwrite: sub_tier })
            this.setState({ subpopup_tier_async_overwrite: false })
         }
         this.setState(
            {
               refreshing_content_data: false,
               content_count: res.data.content_count,
               influencer_content_list: new_influencer_content_list,
               // live_count: res.data.live_count,
               // scheduled_count: res.data.scheduled_count,
               collections_count: res.data.collections_count,
               all_count: res.data.all_count,
               saved_count: res.data.saved_count,
               content_types: res.data.content_types,
               categories_filter: res.data.categories_filter,
               selected_tab: this.state.is_me === true ? 'sub_posts' : 'all',
               prev_bookmark_state: this.state.prev_bookmark_state === false,
               inf_scroll_loading: false,
               collection_names: res.data.collection_names,
            }
         )
      })
   }

   postSaveRestoreSubPosts = (res) => {
      this.setState(
         {
            refreshing_content_data: true,
            influencer_content_list: [],
            inf_scroll_loading: true,
         }
      )
      const form_data = new FormData();
      form_data.append('influencer_str', this.state.influencer_info.influencer)
      form_data.append('category', this.state.category_filter)
      form_data.append('sort', this.state.sort_filter === 'saved_sub_posts' ? 'latest' : this.state.sort_filter === 'purchased' ? 'latest' : this.state.sort_filter)
      form_data.append('content_type', this.state.content_filter)
      form_data.append('tab', 'saved_sub_posts')
      form_data.append('collection', this.state.single_view_collection === '' ? '' : this.state.collection_names[this.state.single_view_collection])
      form_data.append('post_id', this.state.initial_content_id)
      form_data.append('page_n', this.state.page_n)
      form_data.append('currency', this.state.currency)
      form_data.append('tier', this.state.tier_filter)
      axios({
         method: 'post',
         url: paths.BACKEND_URL + "api/influencer_content_data_latest_v7",
         headers: {
            'Content-type': 'application/json',
         },
         data: form_data,
         withCredentials: true
      }).then(res => {
         let new_influencer_content_list = [...res.data.content_list]
         if ((this.state.dashboard === true) && (this.state.view_type === 'user')) {
            if (!((this.state.single_view_collection === '') && (this.state.selected_tab === 'sub_collections' || this.state.selected_tab === 'paid_collections' || this.state.selected_tab === 'collections'))) {
               res.data.content_list.map((influencer_content_split, index) => {
                  new_influencer_content_list[index]['current_tier'] = -1
               })
            } else {
               // res.data.content_list.map((influencer_content_split, index) => {
               //    influencer_content_split.data.map(
               //       (influencer_content_split_inner, index2) => {
               //          new_influencer_content_list[index]['data'][index2]['current_tier'] = -1
               //       }
               //    )
               // })
            }
            this.setState({ subpopup_tier_overwrite: -1 })
            this.setState({ subpopup_tier_async_overwrite: false })
         }
         else if ((this.state.dashboard === true) && (this.state.view_type === 'user-subscribed')) {
            let sub_tier = 0
            let sub_async_tier = false
            if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_silver_active === true) & (this.state.subscribe_popup_gold_active === true) & (this.state.subscribe_popup_async_active === true)) {
               sub_tier = 2
               sub_async_tier = true
            } else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_silver_active) & (this.state.subscribe_popup_gold_active)) {
               sub_tier = 2
               sub_async_tier = false
            } else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_silver_active) & (this.state.subscribe_popup_async_active)) {
               sub_tier = 2
               sub_async_tier = true
            } else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_gold_active) & (this.state.subscribe_popup_async_active)) {
               sub_tier = 3
               sub_async_tier = true
            } else if ((this.state.subscribe_popup_silver_active === true) & (this.state.subscribe_popup_gold_active) & (this.state.subscribe_popup_async_active)) {
               sub_tier = 3
               sub_async_tier = true
            }
            else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_silver_active)) {
               sub_tier = 1
               sub_async_tier = false
            }
            else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_gold_active)) {
               sub_tier = 1
               sub_async_tier = false
            }
            else if ((this.state.subscribe_popup_silver_active === true) & (this.state.subscribe_popup_gold_active)) {
               sub_tier = 2
               sub_async_tier = false
            }
            else if ((this.state.subscribe_popup_silver_active === true) & (this.state.subscribe_popup_async_active)) {
               sub_tier = 2
               sub_async_tier = true
            }
            else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_async_active)) {
               sub_tier = 1
               sub_async_tier = true
            }
            else if ((this.state.subscribe_popup_gold_active === true) & (this.state.subscribe_popup_async_active)) {
               sub_tier = 3
               sub_async_tier = true
            }
            else if ((this.state.subscribe_popup_bronze_active === true)) {
               sub_tier = 1
               sub_async_tier = false
            }
            else if ((this.state.subscribe_popup_silver_active === true)) {
               sub_tier = 2
               sub_async_tier = false
            }
            else if ((this.state.subscribe_popup_gold_active === true)) {
               sub_tier = 3
               sub_async_tier = false
            }
            else if ((this.state.subscribe_popup_async_active === true)) {
               sub_tier = -1
               sub_async_tier = true
            }
            if (!((this.state.single_view_collection === '') && (this.state.selected_tab === 'sub_collections' || this.state.selected_tab === 'paid_collections' || this.state.selected_tab === 'collections'))) {
               res.data.content_list.map((influencer_content_split, index) => {
                  new_influencer_content_list[index]['current_tier'] = sub_tier
               })
            } else {
               // res.data.content_list.map((influencer_content_split, index) => {
               //    influencer_content_split.data.map(
               //       (influencer_content_split_inner, index2) => {
               //          new_influencer_content_list[index]['data'][index2]['current_tier'] = sub_tier
               //       }
               //    )
               // })
            }
            this.setState({ subpopup_tier_overwrite: sub_tier })
            this.setState({ subpopup_tier_async_overwrite: false })
         }
         this.setState(
            {
               refreshing_content_data: false,
               content_count: res.data.content_count,
               influencer_content_list: new_influencer_content_list,
               // live_count: res.data.live_count,
               // scheduled_count: res.data.scheduled_count,
               collections_count: res.data.collections_count,
               all_count: res.data.all_count,
               saved_count: res.data.saved_count,
               content_types: res.data.content_types,
               categories_filter: res.data.categories_filter,
               selected_tab: 'sub_posts',
               prev_bookmark_state: this.state.prev_bookmark_state === false,
               inf_scroll_loading: false,
               collection_names: res.data.collection_names,
            }
         )
      })
   }

   postSaveRestorePaidPosts = (res) => {
      this.setState(
         {
            refreshing_content_data: true,
            influencer_content_list: [],
            inf_scroll_loading: true,
         }
      )
      const form_data = new FormData();
      form_data.append('influencer_str', this.state.influencer_info.influencer)
      form_data.append('category', this.state.category_filter)
      form_data.append('sort', this.state.sort_filter === 'saved_paid_posts' ? 'latest' : this.state.sort_filter === 'purchased' ? 'latest' : this.state.sort_filter)
      form_data.append('content_type', this.state.content_filter)
      form_data.append('tab', 'saved_paid_posts')
      form_data.append('collection', this.state.single_view_collection === '' ? '' : this.state.collection_names[this.state.single_view_collection])
      form_data.append('post_id', this.state.initial_content_id)
      form_data.append('page_n', this.state.page_n)
      form_data.append('currency', this.state.currency)
      form_data.append('tier', this.state.tier_filter)
      axios({
         method: 'post',
         url: paths.BACKEND_URL + "api/influencer_content_data_latest_v7",
         headers: {
            'Content-type': 'application/json',
         },
         data: form_data,
         withCredentials: true
      }).then(res => {
         let new_influencer_content_list = [...res.data.content_list]
         if ((this.state.dashboard === true) && (this.state.view_type === 'user')) {
            if (!((this.state.single_view_collection === '') && (this.state.selected_tab === 'sub_collections' || this.state.selected_tab === 'paid_collections' || this.state.selected_tab === 'collections'))) {
               res.data.content_list.map((influencer_content_split, index) => {
                  new_influencer_content_list[index]['current_tier'] = -1
               })
            } else {
               // res.data.content_list.map((influencer_content_split, index) => {
               //    influencer_content_split.data.map(
               //       (influencer_content_split_inner, index2) => {
               //          new_influencer_content_list[index]['data'][index2]['current_tier'] = -1
               //       }
               //    )
               // })
            }
            this.setState({ subpopup_tier_overwrite: -1 })
            this.setState({ subpopup_tier_async_overwrite: false })
         }
         else if ((this.state.dashboard === true) && (this.state.view_type === 'user-subscribed')) {
            let sub_tier = 0
            let sub_async_tier = false
            if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_silver_active === true) & (this.state.subscribe_popup_gold_active === true) & (this.state.subscribe_popup_async_active === true)) {
               sub_tier = 2
               sub_async_tier = true
            } else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_silver_active) & (this.state.subscribe_popup_gold_active)) {
               sub_tier = 2
               sub_async_tier = false
            } else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_silver_active) & (this.state.subscribe_popup_async_active)) {
               sub_tier = 2
               sub_async_tier = true
            } else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_gold_active) & (this.state.subscribe_popup_async_active)) {
               sub_tier = 3
               sub_async_tier = true
            } else if ((this.state.subscribe_popup_silver_active === true) & (this.state.subscribe_popup_gold_active) & (this.state.subscribe_popup_async_active)) {
               sub_tier = 3
               sub_async_tier = true
            }
            else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_silver_active)) {
               sub_tier = 1
               sub_async_tier = false
            }
            else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_gold_active)) {
               sub_tier = 1
               sub_async_tier = false
            }
            else if ((this.state.subscribe_popup_silver_active === true) & (this.state.subscribe_popup_gold_active)) {
               sub_tier = 2
               sub_async_tier = false
            }
            else if ((this.state.subscribe_popup_silver_active === true) & (this.state.subscribe_popup_async_active)) {
               sub_tier = 2
               sub_async_tier = true
            }
            else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_async_active)) {
               sub_tier = 1
               sub_async_tier = true
            }
            else if ((this.state.subscribe_popup_gold_active === true) & (this.state.subscribe_popup_async_active)) {
               sub_tier = 3
               sub_async_tier = true
            }
            else if ((this.state.subscribe_popup_bronze_active === true)) {
               sub_tier = 1
               sub_async_tier = false
            }
            else if ((this.state.subscribe_popup_silver_active === true)) {
               sub_tier = 2
               sub_async_tier = false
            }
            else if ((this.state.subscribe_popup_gold_active === true)) {
               sub_tier = 3
               sub_async_tier = false
            }
            else if ((this.state.subscribe_popup_async_active === true)) {
               sub_tier = -1
               sub_async_tier = true
            }
            if (!((this.state.single_view_collection === '') && (this.state.selected_tab === 'sub_collections' || this.state.selected_tab === 'paid_collections' || this.state.selected_tab === 'collections'))) {
               res.data.content_list.map((influencer_content_split, index) => {
                  new_influencer_content_list[index]['current_tier'] = sub_tier
               })
            } else {
               // res.data.content_list.map((influencer_content_split, index) => {
               //    influencer_content_split.data.map(
               //       (influencer_content_split_inner, index2) => {
               //          new_influencer_content_list[index]['data'][index2]['current_tier'] = sub_tier
               //       }
               //    )
               // })
            }
            this.setState({ subpopup_tier_overwrite: sub_tier })
            this.setState({ subpopup_tier_async_overwrite: false })
         }
         this.setState(
            {
               refreshing_content_data: false,
               content_count: res.data.content_count,
               influencer_content_list: new_influencer_content_list,
               // live_count: res.data.live_count,
               // scheduled_count: res.data.scheduled_count,
               collections_count: res.data.collections_count,
               all_count: res.data.all_count,
               saved_count: res.data.saved_count,
               content_types: res.data.content_types,
               categories_filter: res.data.categories_filter,
               selected_tab: 'paid_posts',
               prev_bookmark_state: this.state.prev_bookmark_state === false,
               inf_scroll_loading: false,
               collection_names: res.data.collection_names,
            }
         )
      })
   }

   goToCheckout = (tier, duration, promo_code = null, influencer_name = null) => {
      // get the payment intent info
      const form_data = new FormData();
      if (influencer_name !== null) {
         form_data.append('influencer', influencer_name)
      } else {
         form_data.append('influencer', this.state.subscribe_popup_influencer)
      }
      form_data.append('currency', this.state.currency)
      form_data.append('duration', duration)
      form_data.append('tier', tier)
      if (promo_code !== null) {
         form_data.append('promo_code', promo_code)
      } else {
         form_data.append('promo_code', this.state.promo_code)
      }
      if (this.state.free_trial_eligible === true) {
         form_data.append('trial_length', this.state.subscribe_popup_trial_length)
      } else {
         form_data.append('trial_length', 0)
      }
      axios({
         method: 'post',
         url: paths.BACKEND_URL + "api/checkout/get_new_payment_intent",
         data: form_data,
         headers: {
            'Content-type': 'application/json',
         },
         withCredentials: true
      }).then(res => {
         if (res.data.error) {
            if (res.data.error === 'non_connect') {
               this.setState({
                  subscribe_popup_open: false,
                  openCheckoutError: true,
               })
            } else {
               if (promo_code) {
                  window.location.assign(`/login?post_url=${influencer_name}&mode=paid_sub&id=${tier}&duration=${duration}&promo_code=${promo_code}`)
               } else {
                  window.location.assign(`/login?post_url=${influencer_name}&mode=paid_sub&id=${tier}&duration=${duration}`)
               }
            }
         } else {
            this.setState(
               {
                  subscribe_popup_open: false,
                  open_checkout_modal: true,
                  checkout_selected_duration: duration,
                  subscribe_popup_initial_selected_tier: tier,
                  subscribe_popup_initial_selected_tier_backup: tier,
                  checkout_percent_off: res.data.coupon_percent_off,
                  edited_promo_code: res.data.coupon_percent_off > 0 ? res.data.promo_code : '',
                  promo_code: res.data.promo_code,
                  promo_error: res.data.promo_error,
                  subscribe_popup_influencer_name: res.data.influencer_name,
               }
            )
            if (influencer_name !== null) {
               this.setState(
                  {
                     subscribe_popup_influencer: influencer_name
                  }
               )
            }
         }
      })
   }

   launchCopySnackbar = () => {
      this.setState({
         confirmationSnackbarOpen: true,
         confirmationSnackbarMessage: 'Copied to clipboard!',
         confirmationSnackbarSeverity: 'success',
      })
   }

   openAsyncApply = () => {
      // get the payment intent info
      const form_data = new FormData();
      form_data.append('influencer', this.state.subscribe_popup_influencer)
      // add some form of loader
      axios({
         method: 'post',
         url: paths.BACKEND_URL + "api/influencer/open_apply_async",
         data: form_data,
         headers: {
            'Content-type': 'application/json',
         },
         withCredentials: true
      }).then(res => {
         if (!res.data.error) {
            this.setState(
               {
                  subscribe_popup_open: false,
                  subscribe_popup_influencer_name: res.data.influencer_name,
               }
            )
            // reload this page
            window.location.assign(`/${this.state.subscribe_popup_influencer}?open_coaching=true`);
         } else {
            window.location.assign(`/login?post_url=${this.state.subscribe_popup_influencer}`)
         }
      })
   }


   handleOpenCollections = (title, id, price, locked, thumbnail) => {
      this.setState({ editCollectionOpen: true, editCollectionId: id, editCollectionTitle: title, editCollectionPrice: price, editCollectionBuyNowActive: locked, editCollectionThumbnail: thumbnail });
   }

   handleCloseEditCollection = () => {
      this.setState({ editCollectionOpen: false });
   }


   updateSubscriptionIntent = (duration, promo_code) => {
      // get the payment intent info
      const form_data = new FormData();
      form_data.append('influencer', this.state.subscribe_popup_influencer)
      form_data.append('currency', this.state.currency)
      form_data.append('duration', duration)
      form_data.append('tier', this.state.subscribe_popup_initial_selected_tier)
      form_data.append('promo_code', promo_code)
      if (this.state.free_trial_eligible === true) {
         form_data.append('trial_length', this.state.subscribe_popup_trial_length)
      } else {
         form_data.append('trial_length', 0)
      }
      axios({
         method: 'post',
         url: paths.BACKEND_URL + "api/checkout/update_payment_intent",
         data: form_data,
         headers: {
            'Content-type': 'application/json',
         },
         withCredentials: true
      }).then(res => {
         if (!res.data.error) {
            this.setState(
               {
                  checkout_selected_duration: duration,
                  promo_error: res.data.promo_error,
                  checkout_percent_off: res.data.coupon_percent_off,
                  edited_promo_code: res.data.coupon_percent_off > 0 ? res.data.promo_code : '',
                  promo_code: res.data.promo_code,
               }
            )
         }
      })
   }
   // content processing functions

   // initial load
   setContentPost = (res) => {
      if (res.data.content_list) {
         this.setState({
            content_count: res.data.content_count,
            influencer_content_list: res.data.content_list,
            collections_count: res.data.collections_count,
            // live_count: res.data.live_count,
            // scheduled_count: res.data.scheduled_count,
            all_count: res.data.all_count,
            saved_count: res.data.saved_count,
            content_types: res.data.content_types,
            categories_filter: res.data.categories_filter,
            inf_scroll_loading: false,
            page_position: res.data.content_list.length,
            content_list_length: res.data.content_list_length,
            collection_names: res.data.collection_names,
            // collection_data: res.data.collection_data,
            contentIsLoading: false,
         })

         if (res.data.content_list.length >= res.data.content_list_length) {
            this.setState({ update_inf_scroll: false })
         }
         if (res.data.content_list.length === 0) {
            this.setState({ update_inf_scroll: false })
         }
         const searchParams = new URLSearchParams(window.location.search);

         const collection_id = searchParams.get('id')


         let username = ''
         if (this.props.influencer_name) {
            username = this.props.influencer_name
         } else {
            username = this.props.params.influencer_name
         }
         if (this.state.initial_content_id) {
            setTimeout(() => {
               this.handleProfileTabChange({}, 'all', null, username, true)
            }, 200);
         } else if (String(searchParams.get("open_community")) === 'true') {
            this.setState({
               selected_tab: 'community',
            })
         } else if (String(searchParams.get("open_collection")) === 'true') {
            this.setState({
               open_collection: true,
            })
            && searchParams.get('id')
            if (this.state.initial_content_id) {
               setTimeout(() => {
                  this.handleProfileTabChange({}, 'collections', null, '', true)
               }, 200);
            } else {
               setTimeout(() => {
                  this.handleProfileTabChange({}, 'collections', null, '', false)
               }, 200);
            }
         } else if (String(searchParams.get("upload_content")) === 'true') {
            this.setState({
               open_content_upload: true,
               content_type: 0,
            })
         }
         else if (String(searchParams.get("open_coaching")) === 'true') {
            // scroll to async_post_input
            this.setState({
               open_coaching: true,
            })
            setTimeout(() => {
               this.handleProfileTabChange({}, 'async', null, '', true)
            }, 200);
         } else if (String(searchParams.get("open_messages")) === 'true') {
            this.setState({
               open_messages: true,
            })
            setTimeout(() => {
               this.handleProfileTabChange({}, 'paidDMs', null, null, true)
            }, 200);
            // } else if (this.props.params.influencer_name === res.data.current_user || username.toLowerCase() === res.data.current_user) {
            //    this.setState({
            //       selected_tab: 'dashboard',
            //    })
         } else if (String(searchParams.get("open_example_creators")) === 'true') {
            this.setState({ open_example_creators: true })
         } else {
            // if (res.data.live_count > 0){
            //    this.setState({
            //       selected_tab: 'live now',
            //    })
            // }
            if (this.props.params.influencer_name === res.data.current_user) {
               // this.setState({
               //    selected_tab: 'dashboard',
               // })
            }
            else if (res.data.dm_tab) {
               this.setState({
                  selected_tab: 'paidDMs',
               })
            }
            else {
               // if (res.data.collections_count > 0) {
               //    this.setState({
               //       selected_tab: 'collections',
               //    })
               // } else {
               // if (res.data.async_tier_access) {
               //    if (this.state.selected_tab !== 'async'){
               //       if (!this.state.influencer_info.influencer) {
               //          // Fix for tablet sometimes not loading due to state not being set yet
               //          setTimeout(() => {
               //             this.handleProfileTabChange({}, 'async', null, username)
               //          }, 200);
               //       } else {
               //          this.handleProfileTabChange({},'async')
               //       }
               //    }
               // } 
               // else 
               if (!this.state.influencer_info.influencer) {
                  // Fix for tablet sometimes not loading due to state not being set yet
                  setTimeout(() => {
                     this.handleProfileTabChange({}, 'all', null, username)
                  }, 200);
               }
               else {
                  this.handleProfileTabChange({}, 'all')
               }
               // }
            }

         }
      }
      this.setState({
         inf_scroll_loading: false,
      })
   }

   handleSocialModalClose = () => {
      this.setState({ socialModalOpen: false });
   };

   handleCollectionTitleMouseEnter = (index) => {
      this.setState({ collectionTitleHovered: true, hoveredIndex: index });
   }

   handleCollectionTitleMouseLeave = () => {
      this.setState({ collectionTitleHovered: false, hoveredIndex: null });
   }


   handleCreateContent = () => {
      this.setState({ new_creator_modal: false });
      this.props.navigate('?page=platform#add_digital_content');
      gtag('event', 'new_creator_get_started_sell_content', { 'event_category': 'Onboarding Event', 'event_label': 'New Creator Get Started Sell Content' });
   }

   handleCreateCollection = () => {
      this.setState({ new_creator_modal: false });
      this.props.navigate('?page=platform#add_collection');
      gtag('event', 'new_creator_get_started_collections', { 'event_category': 'Onboarding Event', 'event_label': 'New Creator Get Started Collections' });
   }

   handleCreateMembership = () => {
      this.setState({ new_creator_modal: false });
      this.props.navigate('?page=platform#add_memberships');
      gtag('event', 'new_creator_get_started_membership', { 'event_category': 'Onboarding Event', 'event_label': 'New Creator Get Started Membership' });
   }

   handleCreateAsync = () => {
      this.setState({ new_creator_modal: false });
      this.props.navigate('?page=platform#add_coaching');
      gtag('event', 'new_creator_get_started_coaching', { 'event_category': 'Onboarding Event', 'event_label': 'New Creator Get Started Coaching' });
   }

   handleCreateCommunity = () => {
      this.setState({ new_creator_modal: false });
      this.props.navigate('?page=platform#add_community');
      gtag('event', 'new_creator_get_started_community', { 'event_category': 'Onboarding Event', 'event_label': 'New Creator Get Started Community' });
   }

   handleCloseCheckoutError = () => {
      this.setState({ openCheckoutError: false })
   }


   // tab change
   handleProfileTabChange = (event, newTab, sort_filter_overwrite = null, creator_overwrite = null, scroll_to_post = null, post_id = null) => {
      if (this.state.tiersModal === true) {
         this.setState({ tiersModal: false });
      }
      if (!scroll_to_post) {
         this.setState({
            selectedMemberTabOverwrite: null,
            post_id: null,
            open_messages: false,
            open_coaching: false,
            open_collection: false,
         })
      }
      if ((newTab !== 'community') && (newTab !== 'async') && (newTab !== 'paidDMs') && (newTab !== 'dashboard') && (newTab !== 'membership')) {
         this.setState({ contentIsLoading: true, selected_tab: newTab, inf_scroll_loading: true })
         let index = null
         if ((newTab === 'sub_collections' || newTab === 'paid_collections' || newTab === 'collections') && (post_id)) {
            index = this.state.collection_data.findIndex(item => item.course_name.toLowerCase() === post_id.replace('%20', ' ').toLowerCase());
            this.setState({ single_view_collection: this.state.collection_data[index]?.course_name, collection_filter: this.state.collection_data[index]?.course_name })
         }
         const form_data = new FormData();
         if (newTab === 'sub_posts'){
            form_data.append('category', 'all')
            form_data.append('content_type', 'all')
            form_data.append('sort', 'latest')
            form_data.append('tab', newTab)
            this.setState({
               category_filter: 'all',
               content_filter: 'all',
               sort_filter: 'latest',
               tier_filter: -1,
            })
         } else if (newTab === 'paid_posts'){
            form_data.append('category', 'all')
            form_data.append('content_type', 'all')
            form_data.append('sort', 'latest')
            form_data.append('tab', newTab)
            this.setState({
               category_filter: 'all',
               content_filter: 'all',
               sort_filter: 'latest',
               tier_filter: -1,
            })
         } else {
            form_data.append('category', this.state.category_filter)
            form_data.append('content_type', this.state.content_filter)
            form_data.append('sort', sort_filter_overwrite === 'saved' ? 'latest' : this.state.sort_filter === 'saved' ? 'latest' : sort_filter_overwrite === 'purchased' ? 'latest' : this.state.sort_filter === 'purchased' ? 'latest' : this.state.sort_filter)
            form_data.append('tab', (newTab === 'all' && (sort_filter_overwrite === 'saved' || this.state.sort_filter === 'saved'))  ? 'saved' :  (newTab === 'all') && (sort_filter_overwrite === 'purchased' || this.state.sort_filter === 'purchased') ? 'purchased' : newTab)
         }
         form_data.append('influencer_str', creator_overwrite ? creator_overwrite : this.state.influencer_info.influencer)
         form_data.append('collection', this.state.collection_data?.length > 0 && index >= 0 ? this.state.collection_data[index]?.course_name : this.state.collection_data?.length > 0 && this.state.single_view_collection?.length > 0 ? this.state.single_view_collection : '')
         form_data.append('post_id', newTab === 'sub_collections' || newTab === 'paid_collections' || newTab === 'collections' ? 'null' : post_id ? post_id : this.state.initial_content_id)
         form_data.append('page_n', 1)
         form_data.append('currency', this.state.currency)
         form_data.append('tier', newTab === 'sub_posts' ? -1: newTab === 'all' ? this.state.tier_filter: -1)
         axios({
            method: 'post',
            url: paths.BACKEND_URL + "api/influencer_content_data_tab_change_v7",
            headers: {
               'Content-type': 'application/json',
            },
            data: form_data,
            withCredentials: true
         }).then(res => {
            let new_influencer_content_list = [...res.data.content_list]

            if (this.state.selected_tab === 'sub_collections' || this.state.selected_tab === 'paid_collections' || this.state.selected_tab === 'collections') {
               this.setState({ collection_data: res.data.collection_data })
            }
            if ((this.state.dashboard === true) && (this.state.view_type === 'user')) {
               if (!((this.state.single_view_collection === '') && (this.state.selected_tab === 'sub_collections' || this.state.selected_tab === 'paid_collections' || this.state.selected_tab === 'collections'))) {
                  res.data.content_list.map((influencer_content_split, index) => {
                     new_influencer_content_list[index]['current_tier'] = -1
                  })
               } else {
                  // res.data.content_list.map((influencer_content_split, index) => {
                  //    influencer_content_split.data.map(
                  //       (influencer_content_split_inner, index2) => {
                  //          new_influencer_content_list[index]['data'][index2]['current_tier'] = -1
                  //       }
                  //    )
                  // })
               }
               this.setState({ subpopup_tier_overwrite: -1 })
               this.setState({ subpopup_tier_async_overwrite: false })
            }
            else if ((this.state.dashboard === true) && (this.state.view_type === 'user-subscribed')) {
               let sub_tier = 0
               let sub_async_tier = false
               if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_silver_active === true) & (this.state.subscribe_popup_gold_active === true) & (this.state.subscribe_popup_async_active === true)) {
                  sub_tier = 2
                  sub_async_tier = true
               } else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_silver_active) & (this.state.subscribe_popup_gold_active)) {
                  sub_tier = 2
                  sub_async_tier = false
               } else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_silver_active) & (this.state.subscribe_popup_async_active)) {
                  sub_tier = 2
                  sub_async_tier = true
               } else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_gold_active) & (this.state.subscribe_popup_async_active)) {
                  sub_tier = 3
                  sub_async_tier = true
               } else if ((this.state.subscribe_popup_silver_active === true) & (this.state.subscribe_popup_gold_active) & (this.state.subscribe_popup_async_active)) {
                  sub_tier = 3
                  sub_async_tier = true
               }
               else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_silver_active)) {
                  sub_tier = 1
                  sub_async_tier = false
               }
               else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_gold_active)) {
                  sub_tier = 1
                  sub_async_tier = false
               }
               else if ((this.state.subscribe_popup_silver_active === true) & (this.state.subscribe_popup_gold_active)) {
                  sub_tier = 2
                  sub_async_tier = false
               }
               else if ((this.state.subscribe_popup_silver_active === true) & (this.state.subscribe_popup_async_active)) {
                  sub_tier = 2
                  sub_async_tier = true
               }
               else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_async_active)) {
                  sub_tier = 1
                  sub_async_tier = true
               }
               else if ((this.state.subscribe_popup_gold_active === true) & (this.state.subscribe_popup_async_active)) {
                  sub_tier = 3
                  sub_async_tier = true
               }
               else if ((this.state.subscribe_popup_bronze_active === true)) {
                  sub_tier = 1
                  sub_async_tier = false
               }
               else if ((this.state.subscribe_popup_silver_active === true)) {
                  sub_tier = 2
                  sub_async_tier = false
               }
               else if ((this.state.subscribe_popup_gold_active === true)) {
                  sub_tier = 3
                  sub_async_tier = false
               }
               else if ((this.state.subscribe_popup_async_active === true)) {
                  sub_tier = -1
                  sub_async_tier = true
               }
               if (!((this.state.single_view_collection === '') && (this.state.selected_tab === 'sub_collections' || this.state.selected_tab === 'paid_collections' || this.state.selected_tab === 'collections'))) {
                  res.data.content_list.map((influencer_content_split, index) => {
                     new_influencer_content_list[index]['current_tier'] = sub_tier
                  })
               } else {
                  // res.data.content_list.map((influencer_content_split, index) => {
                  //    influencer_content_split.data.map(
                  //       (influencer_content_split_inner, index2) => {
                  //          new_influencer_content_list[index]['data'][index2]['current_tier'] = sub_tier
                  //       }
                  //    )
                  // })
               }
               this.setState({ subpopup_tier_overwrite: sub_tier })
               this.setState({ subpopup_tier_async_overwrite: false })
            }
            this.setState(
               {
                  refreshing_content_data: false,
                  influencer_content_list: new_influencer_content_list,
                  contentIsLoading: false,
                  inf_scroll_loading: false,
                  content_list_length: res.data.content_list_length,
                  page_position: new_influencer_content_list.length,
                  page_n: 1,
                  content_types: res.data.content_types,
                  categories_filter: res.data.categories_filter,
               }
            )
            const searchParams = new URLSearchParams(window.location.search);
            if ((newTab === 'paid_collections') && searchParams.get("open_collection") && searchParams.get('id') && this.state.open_collection){
               let collection_id = ''
               if (isNumericString(searchParams.get("id"))) {
                  let index = res.data.collection_data.findIndex(item => String(item.id) === String(searchParams.get("id")));
                  collection_id = res.data.collection_data[index]['course_name']
               } else {
                  collection_id = searchParams.get("id")
               }
               this.setState({open_collection: false})
               setTimeout(() => {
                  this.handleProfileTabChange({}, 'paid_collections', null, '', true, collection_id)
               }, 200);
            }
            if ((newTab === 'sub_collections') && searchParams.get("open_collection") && searchParams.get('id') && this.state.open_collection){
               let collection_id = ''
               if (isNumericString(searchParams.get("id"))) {
                  let index = res.data.collection_data.findIndex(item => String(item.id) === String(searchParams.get("id")));
                  collection_id = res.data.collection_data[index]['course_name']
               } else {
                  collection_id = searchParams.get("id")
               }
               this.setState({open_collection: false})
               setTimeout(() => {
                  this.handleProfileTabChange({}, 'sub_collections', null, '', true, collection_id)
               }, 200);
            }
            if ((newTab === 'collections') && searchParams.get("open_collection") && searchParams.get('id') && this.state.open_collection){
               let collection_id = ''
               if (isNumericString(searchParams.get("id"))) {
                  let index = res.data.collection_data.findIndex(item => String(item.id) === String(searchParams.get("id")));
                  collection_id = res.data.collection_data[index]['course_name']
               } else {
                  collection_id = searchParams.get("id")
               }
               this.setState({open_collection: false})
               setTimeout(() => {
                  this.handleProfileTabChange({}, 'collections', null, '', true, collection_id)
               }, 200);
            }
            if (new_influencer_content_list.length >= res.data.content_list_length) {
               this.setState({
                  update_inf_scroll: false,
               })
            } else {
               this.setState({
                  update_inf_scroll: true,
               })
            }
         })
      } else {
         this.setState({
            selected_tab: newTab,
            inf_scroll_loading: false,
         })    
         if (newTab === 'dashboard'){
            this.setState({influencer_content_list: []})
         }
      }

      if (newTab === 'community') {
         this.setState({ mobileCTABannerClicked: true })
         gtag('event', 'community_page_view', {
            'event_category': 'Event',
            'event_label': 'Community Page View'
         });
      }
      if (scroll_to_post === true) {
         if (newTab === 'all' || newTab === 'sub_posts' || newTab === 'paid_posts') {
            setTimeout(() => {
               const section = document.getElementById('post' + String(post_id ? post_id : this.state.initial_content_id));
               try {
                  section.scrollIntoView({ behavior: 'smooth', block: 'center' });
               } catch (error) {
               }
            }, 1000)
         } else if (newTab === 'sub_collections' || newTab === 'paid_collections' || newTab === 'collections') {
            setTimeout(() => {
               const section = document.getElementById('content_container');
               try {
                  section.scrollIntoView({ behavior: 'smooth', block: 'start' });
               } catch (error) {
               }
            }, 1000)
         }
      }
   }

   handleCollectionTabChange = (event, new_collection_name, selected_tab, scroll_to_top = null) => {
      if (new_collection_name !== null) {
         this.setState({
            inf_scroll_loading: true,
            contentIsLoading: true,
            influencer_content_list: [],
         })
         const form_data = new FormData();
         form_data.append('influencer_str', this.state.influencer_info.influencer)
         form_data.append('category', this.state.category_filter)
         form_data.append('content_type', this.state.content_filter)
         form_data.append('sort', this.state.sort_filter)
         form_data.append('tab', this.state.is_me === false ? 'collections': this.props.current_page_view === 'subscriptions' ? 'sub_collections' : 'paid_collections')
         form_data.append('collection', new_collection_name)
         form_data.append('post_id', this.state.initial_content_id)
         form_data.append('page_n', 1)
         form_data.append('currency', this.state.currency)
         form_data.append('tier', this.state.selected_tab === 'sub_posts' ? this.state.tier_filter: this.state.selected_tab === 'all' ? this.state.tier_filter: -1)
         axios({
            method: 'post',
            url: paths.BACKEND_URL + "api/influencer_content_data_tab_change_v7",
            headers: {
               'Content-type': 'application/json',
            },
            data: form_data,
            withCredentials: true
         }).then(res => {
            let new_influencer_content_list = [...res.data.content_list]
            if ((this.state.dashboard === true) && (this.state.view_type === 'user')) {
               if (new_collection_name !== '') {
                  res.data.content_list.map((influencer_content_split, index) => {
                     new_influencer_content_list[index]['current_tier'] = -1
                  })
               } else {
                  res.data.content_list.map((influencer_content_split, index) => {
                     influencer_content_split.data.map(
                        (influencer_content_split_inner, index2) => {
                           new_influencer_content_list[index]['data'][index2]['current_tier'] = -1
                        }
                     )
                  })
               }
               this.setState({ subpopup_tier_overwrite: -1 })
               this.setState({ subpopup_tier_async_overwrite: false })
            }
            else if ((this.state.dashboard === true) && (this.state.view_type === 'user-subscribed')) {
               let sub_tier = 0
               let sub_async_tier = false
               if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_silver_active === true) & (this.state.subscribe_popup_gold_active === true) & (this.state.subscribe_popup_async_active === true)) {
                  sub_tier = 2
                  sub_async_tier = true
               } else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_silver_active) & (this.state.subscribe_popup_gold_active)) {
                  sub_tier = 2
                  sub_async_tier = false
               } else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_silver_active) & (this.state.subscribe_popup_async_active)) {
                  sub_tier = 2
                  sub_async_tier = true
               } else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_gold_active) & (this.state.subscribe_popup_async_active)) {
                  sub_tier = 3
                  sub_async_tier = true
               } else if ((this.state.subscribe_popup_silver_active === true) & (this.state.subscribe_popup_gold_active) & (this.state.subscribe_popup_async_active)) {
                  sub_tier = 3
                  sub_async_tier = true
               }
               else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_silver_active)) {
                  sub_tier = 1
                  sub_async_tier = false
               }
               else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_gold_active)) {
                  sub_tier = 1
                  sub_async_tier = false
               }
               else if ((this.state.subscribe_popup_silver_active === true) & (this.state.subscribe_popup_gold_active)) {
                  sub_tier = 2
                  sub_async_tier = false
               }
               else if ((this.state.subscribe_popup_silver_active === true) & (this.state.subscribe_popup_async_active)) {
                  sub_tier = 2
                  sub_async_tier = true
               }
               else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_async_active)) {
                  sub_tier = 1
                  sub_async_tier = true
               }
               else if ((this.state.subscribe_popup_gold_active === true) & (this.state.subscribe_popup_async_active)) {
                  sub_tier = 3
                  sub_async_tier = true
               }
               else if ((this.state.subscribe_popup_bronze_active === true)) {
                  sub_tier = 1
                  sub_async_tier = false
               }
               else if ((this.state.subscribe_popup_silver_active === true)) {
                  sub_tier = 2
                  sub_async_tier = false
               }
               else if ((this.state.subscribe_popup_gold_active === true)) {
                  sub_tier = 3
                  sub_async_tier = false
               }
               else if ((this.state.subscribe_popup_async_active === true)) {
                  sub_tier = -1
                  sub_async_tier = true
               }
               if (new_collection_name !== '') {
                  res.data.content_list.map((influencer_content_split, index) => {
                     new_influencer_content_list[index]['current_tier'] = sub_tier
                  })
               } else {
                  res.data.content_list.map((influencer_content_split, index) => {
                     influencer_content_split.data.map(
                        (influencer_content_split_inner, index2) => {
                           new_influencer_content_list[index]['data'][index2]['current_tier'] = sub_tier
                        }
                     )
                  })
               }
               this.setState({ subpopup_tier_overwrite: sub_tier })
               this.setState({ subpopup_tier_async_overwrite: false })
            }
            this.setState(
               {
                  refreshing_content_data: false,
                  influencer_content_list: new_influencer_content_list,
                  contentIsLoading: false,
                  inf_scroll_loading: false,
                  content_list_length: res.data.content_list_length,
                  page_position: new_influencer_content_list.length,
                  page_n: 1,
                  collection_data: res.data.collection_data,
               }
            )
            if (new_collection_name === '') {
               this.setState({
                  single_view_collection: '',
                  collection_filter: '',
               })
            } else {
               this.setState({
                  single_view_collection: new_collection_name,
                  collection_filter: new_collection_name,
               })
            }
            if (new_influencer_content_list.length >= res.data.content_list_length) {
               this.setState({
                  update_inf_scroll: false,
               })
            } else {
               this.setState({
                  update_inf_scroll: true,
               })
            }
         })
         if (scroll_to_top) {
            setTimeout(() => {
               const section = document.getElementById('content_container');
               try {
                  section.scrollIntoView({ behavior: 'smooth', block: 'start' });
               } catch (error) {
               }
            }, 1000)
         }
      }
   }

   setTrialLength = (value) => {
      this.setState({ trialLength: value })
   }

   handleCopyClick = () => {
      navigator.clipboard.writeText(window.location.origin + `/${this.state.influencer_info['influencer']}`)
         .then(() => {
            this.setState({
               shareText: 'Copied',
               errorMsgUpload: 'Copied to clipboard',
               snackbarOpenUpload: true,
               snackbarSeverityUpload: 'success',
            })
         })
         .catch((error) => {
            // console.error('Failed to copy link:', error);
         });
   };

   handleSuccessfulCustomLogo = () => {
      this.setState({
         // shareText: 'Copied',
         errorMsgUpload: 'Platform Logo Updated',
         snackbarOpenUpload: true,
         snackbarSeverityUpload: 'success',
      })
   }

   updateViewType = (event) => {
      this.setState({ view_type: event.target.value, loading_dashboard_data: true, single_view_collection: '' })
      if (event.target.value === 'user') {
         let new_influencer_info = this.state.influencer_info
         new_influencer_info.current_tier = -1
         new_influencer_info.waiting_list = false
         let new_influencer_content_list = Array.isArray(this.state.influencer_content_list) ?
            [...this.state.influencer_content_list].map((content) => ({...content, current_tier: -1})) : [];
         if (!((this.state.selected_collection_index === '') && (this.state.selected_tab === 'sub_collections' || this.state.selected_tab === 'paid_collections' || this.state.selected_tab === 'collections'))) {
            if (Array.isArray(this.state.influencer_content_list)) {
               this.state.influencer_content_list.forEach((influencer_content_split, index) => {
                  if (new_influencer_content_list[index]) {
                     new_influencer_content_list[index]['current_tier'] = -1;
                  }
               });
            }
         } else {
            if (Array.isArray(this.state.influencer_content_list)) {
               this.state.influencer_content_list.forEach((influencer_content_split, index) => {
                  if (influencer_content_split && Array.isArray(influencer_content_split.data)) {
                     influencer_content_split.data.forEach((influencer_content_split_inner, index2) => {
                        if (new_influencer_content_list[index] &&
                           new_influencer_content_list[index]['data'] &&
                           new_influencer_content_list[index]['data'][index2]) {
                           new_influencer_content_list[index]['data'][index2]['current_tier'] = -1;
                        }
                     });
                  }
               });
            }
         }
         this.setState({ subpopup_tier_overwrite: -1 })
         this.setState({ subpopup_tier_async_overwrite: false })
         this.setState({
            influencer_info: new_influencer_info,
            is_me: false,
            influencer_content_list: new_influencer_content_list,
            waiting_list: false,
         })
         if (this.state.selected_tab === 'async' || this.state.selected_tab === 'paidDMs' || this.state.selected_tab === 'dashboard' || this.state.selected_tab === 'membership') {
            this.handleProfileTabChange('', 'all');
         }
      } else if (event.target.value === 'user-subscribed') {
         // determine the tier to set it too
         let sub_tier = 0
         let sub_async_tier = false
         if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_silver_active === true) & (this.state.subscribe_popup_gold_active === true) & (this.state.subscribe_popup_async_active === true)) {
            sub_tier = 2
            sub_async_tier = false
         } else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_silver_active) & (this.state.subscribe_popup_gold_active)) {
            sub_tier = 2
            sub_async_tier = false
         } else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_silver_active) & (this.state.subscribe_popup_async_active)) {
            sub_tier = 2
            sub_async_tier = false
         } else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_gold_active) & (this.state.subscribe_popup_async_active)) {
            sub_tier = 3
            sub_async_tier = false
         } else if ((this.state.subscribe_popup_silver_active === true) & (this.state.subscribe_popup_gold_active) & (this.state.subscribe_popup_async_active)) {
            sub_tier = 3
            sub_async_tier = false
         }
         else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_silver_active)) {
            sub_tier = 1
            sub_async_tier = false
         }
         else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_gold_active)) {
            sub_tier = 1
            sub_async_tier = false
         }
         else if ((this.state.subscribe_popup_silver_active === true) & (this.state.subscribe_popup_gold_active)) {
            sub_tier = 2
            sub_async_tier = false
         }
         else if ((this.state.subscribe_popup_silver_active === true) & (this.state.subscribe_popup_async_active)) {
            sub_tier = 2
            sub_async_tier = false
         }
         else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_async_active)) {
            sub_tier = 1
            sub_async_tier = false
         }
         else if ((this.state.subscribe_popup_gold_active === true) & (this.state.subscribe_popup_async_active)) {
            sub_tier = 3
            sub_async_tier = false
         }
         else if ((this.state.subscribe_popup_bronze_active === true)) {
            sub_tier = 1
            sub_async_tier = false
         }
         else if ((this.state.subscribe_popup_silver_active === true)) {
            sub_tier = 2
            sub_async_tier = false
         }
         else if ((this.state.subscribe_popup_gold_active === true)) {
            sub_tier = 3
            sub_async_tier = false
         }
         else if ((this.state.subscribe_popup_async_active === true)) {
            sub_tier = -1
            sub_async_tier = false
         }
         let new_influencer_info = this.state.influencer_info
         new_influencer_info.current_tier = sub_tier
         new_influencer_info.waiting_list = false
         let new_influencer_content_list = Array.isArray(this.state.influencer_content_list) ?
            [...this.state.influencer_content_list] : [];

         if (!((this.state.selected_collection_index === '') && (this.state.selected_tab === 'sub_collections' || this.state.selected_tab === 'paid_collections' || this.state.selected_tab === 'collections'))) {
            if (Array.isArray(this.state.influencer_content_list)) {
               this.state.influencer_content_list.forEach((influencer_content_split, index) => {
                  if (new_influencer_content_list[index]) {
                     new_influencer_content_list[index]['current_tier'] = sub_tier;
                  }
               });
            }
         } else {
            if (Array.isArray(this.state.influencer_content_list)) {
               this.state.influencer_content_list.forEach((influencer_content_split, index) => {
                  if (influencer_content_split && Array.isArray(influencer_content_split.data)) {
                     influencer_content_split.data.forEach((influencer_content_split_inner, index2) => {
                        if (new_influencer_content_list[index] &&
                           new_influencer_content_list[index]['data'] &&
                           new_influencer_content_list[index]['data'][index2]) {
                           new_influencer_content_list[index]['data'][index2]['current_tier'] = sub_tier;
                        }
                     });
                  }
               });
            }
         }

         this.setState({ subpopup_tier_overwrite: sub_tier })
         this.setState({ subpopup_tier_async_overwrite: false })
         this.setState({
            influencer_info: new_influencer_info,
            is_me: false,
            influencer_content_list: new_influencer_content_list,
            waiting_list: false,
         })
         if (sub_async_tier === false) {
            if (this.state.selected_tab === 'async' || this.state.selected_tab === 'paidDMs' || this.state.selected_tab === 'dashboard' || this.state.selected_tab === 'membership') {
               this.handleProfileTabChange('', 'all');
            }
         }
      } else if (event.target.value === 'creator') {
         let new_influencer_info = this.state.influencer_info
         new_influencer_info.current_tier = 3
         new_influencer_info.waiting_list = false
         let new_influencer_content_list = Array.isArray(this.state.influencer_content_list) ?
            [...this.state.influencer_content_list] : [];

         if (!((this.state.selected_collection_index === '') && (this.state.selected_tab === 'sub_collections' || this.state.selected_tab === 'paid_collections' || this.state.selected_tab === 'collections'))) {
            if (Array.isArray(this.state.influencer_content_list)) {
               this.state.influencer_content_list.forEach((influencer_content_split, index) => {
                  if (new_influencer_content_list[index]) {
                     new_influencer_content_list[index]['current_tier'] = 3;
                  }
               });
            }
         } else {
            if (Array.isArray(this.state.influencer_content_list)) {
               this.state.influencer_content_list.forEach((influencer_content_split, index) => {
                  if (influencer_content_split && Array.isArray(influencer_content_split.data)) {
                     influencer_content_split.data.forEach((influencer_content_split_inner, index2) => {
                        if (new_influencer_content_list[index] &&
                           new_influencer_content_list[index]['data'] &&
                           new_influencer_content_list[index]['data'][index2]) {
                           new_influencer_content_list[index]['data'][index2]['current_tier'] = 3;
                        }
                     });
                  }
               });
            }
         }

         this.setState({ subpopup_tier_overwrite: null })
         this.setState({ subpopup_tier_async_overwrite: null })
         if (this.state.open_collection) {
            const searchParams = new URLSearchParams(window.location.search);
            let collection_id;
            if (isNumericString(searchParams.get("id"))) {
               let index = this.state.collection_data.findIndex(item => String(item.id) === String(searchParams.get("id")));
               collection_id = this.state.collection_data[index]['course_name']
            } else {
               collection_id = searchParams.get("id")
            }
            this.handleProfileTabChange({}, 'collections', null, null, true, collection_id)
         } else {
            this.setState({ selected_tab: 'all' })
         }
         this.setState({
            influencer_info: new_influencer_info,
            is_me: true,
            influencer_content_list: new_influencer_content_list,
            waiting_list: false,
         })
      } else if (event.target.value === 'user-waitlist') {
         let new_influencer_info = this.state.influencer_info
         new_influencer_info.current_tier = -1
         new_influencer_info.waiting_list = true
         let new_influencer_content_list = Array.isArray(this.state.influencer_content_list) ?
            [...this.state.influencer_content_list] : [];

         if (!((this.state.selected_collection_index === '') && (this.state.selected_tab === 'sub_collections' || this.state.selected_tab === 'paid_collections' || this.state.selected_tab === 'collections'))) {
            if (Array.isArray(this.state.influencer_content_list)) {
               this.state.influencer_content_list.forEach((influencer_content_split, index) => {
                  if (new_influencer_content_list[index]) {
                     new_influencer_content_list[index]['current_tier'] = -1;
                  }
               });
            }
         } else {
            if (Array.isArray(this.state.influencer_content_list)) {
               this.state.influencer_content_list.forEach((influencer_content_split, index) => {
                  if (influencer_content_split && Array.isArray(influencer_content_split.data)) {
                     influencer_content_split.data.forEach((influencer_content_split_inner, index2) => {
                        if (new_influencer_content_list[index] &&
                           new_influencer_content_list[index]['data'] &&
                           new_influencer_content_list[index]['data'][index2]) {
                           new_influencer_content_list[index]['data'][index2]['current_tier'] = -1;
                        }
                     });
                  }
               });
            }
         }

         this.setState({ subpopup_tier_overwrite: -1 })
         this.setState({ subpopup_tier_async_overwrite: false })
         this.setState({
            influencer_info: new_influencer_info,
            is_me: false,
            influencer_content_list: new_influencer_content_list,
            waiting_list: true,
         })
      }
   }

   handlePricingModalOpen = () => {
      window.open('https://withme-pricing.vercel.app/', 'blank')
   }

   UpdateIconImagePush = (event, imageBase64) => {
      event.preventDefault();
      this.setState({ influencerIconUpdated: imageBase64, influencerIconUpdatedLoading: true })
   }

   setRevertImageFalse = () => {
      this.setState({ revertImage: false })
   }


   revertUserIcon = () => {
      this.setState({
         // this.state.influencer_info['icon_image_path']
         influencerIconUpdated: '', influencerIconUpdatedLoading: false
      })
   }


   newContentSubmit = async (collection_overwrite = null) => {
      this.setState(
         {
            refreshing_content_data: true,
            influencer_content_list: [],
            inf_scroll_loading: true,
         }
      )
      if (this.props.current_page_view === 'platform'){
         this.fetchActiveProductData(this.state.currency);
         this.props.navigate('?page=digital_products')
      } else {
         const tab = this.state.selected_tab === 'membership' ? 'sub_posts' : this.state.selected_tab;
         
         const form_data = new FormData();
         form_data.append("influencer_str", this.state.influencer_info.influencer);
         form_data.append("category", this.state.category_filter);
         form_data.append("sort", this.state.sort_filter);
         form_data.append("content_type", this.state.content_filter);
         form_data.append("tab", tab);
         form_data.append(
            "collection",
            collection_overwrite
            ? collection_overwrite
            : this.state.single_view_collection === "" ? "" : this.state.single_view_collection
         );
         form_data.append("post_id", this.state.initial_content_id);
         form_data.append("page_n", 1);
         form_data.append("currency", this.state.currency);
         form_data.append('tier', this.state.tier_filter)
         axios({
            method: "post",
            url: paths.BACKEND_URL + "api/influencer_content_data_latest_v7",
            headers: {
            "Content-type": "application/json",
            },
            data: form_data,
            withCredentials: true,
         }).then((res) => {
            let new_influencer_content_list = [...res.data.content_list];
            if (this.state.dashboard === true && this.state.view_type === "user") {
            if (!(this.state.single_view_collection === "" && this.state.selected_tab === "collections")) {
               res.data.content_list.map((influencer_content_split, index) => {
                  new_influencer_content_list[index]["current_tier"] = -1;
               });
            } else {
               // res.data.content_list.map((influencer_content_split, index) => {
               //    influencer_content_split.data.map(
               //       (influencer_content_split_inner, index2) => {
               //          new_influencer_content_list[index]['data'][index2]['current_tier'] = -1
               //       }
               //    )
               // })
            }
            this.setState({ subpopup_tier_overwrite: -1 });
            this.setState({ subpopup_tier_async_overwrite: false });
            } else if (this.state.dashboard === true && this.state.view_type === "user-subscribed") {
            let sub_tier = 0;
            let sub_async_tier = false;
            if (
               (this.state.subscribe_popup_bronze_active === true) &
               (this.state.subscribe_popup_silver_active === true) &
               (this.state.subscribe_popup_gold_active === true) &
               (this.state.subscribe_popup_async_active === true)
            ) {
               sub_tier = 2;
               sub_async_tier = true;
            } else if (
               (this.state.subscribe_popup_bronze_active === true) &
               this.state.subscribe_popup_silver_active &
               this.state.subscribe_popup_gold_active
            ) {
               sub_tier = 2;
               sub_async_tier = false;
            } else if (
               (this.state.subscribe_popup_bronze_active === true) &
               this.state.subscribe_popup_silver_active &
               this.state.subscribe_popup_async_active
            ) {
               sub_tier = 2;
               sub_async_tier = true;
            } else if (
               (this.state.subscribe_popup_bronze_active === true) &
               this.state.subscribe_popup_gold_active &
               this.state.subscribe_popup_async_active
            ) {
               sub_tier = 3;
               sub_async_tier = true;
            } else if (
               (this.state.subscribe_popup_silver_active === true) &
               this.state.subscribe_popup_gold_active &
               this.state.subscribe_popup_async_active
            ) {
               sub_tier = 3;
               sub_async_tier = true;
            } else if ((this.state.subscribe_popup_bronze_active === true) & this.state.subscribe_popup_silver_active) {
               sub_tier = 1;
               sub_async_tier = false;
            } else if ((this.state.subscribe_popup_bronze_active === true) & this.state.subscribe_popup_gold_active) {
               sub_tier = 1;
               sub_async_tier = false;
            } else if ((this.state.subscribe_popup_silver_active === true) & this.state.subscribe_popup_gold_active) {
               sub_tier = 2;
               sub_async_tier = false;
            } else if ((this.state.subscribe_popup_silver_active === true) & this.state.subscribe_popup_async_active) {
               sub_tier = 2;
               sub_async_tier = true;
            } else if ((this.state.subscribe_popup_bronze_active === true) & this.state.subscribe_popup_async_active) {
               sub_tier = 1;
               sub_async_tier = true;
            } else if ((this.state.subscribe_popup_gold_active === true) & this.state.subscribe_popup_async_active) {
               sub_tier = 3;
               sub_async_tier = true;
            } else if (this.state.subscribe_popup_bronze_active === true) {
               sub_tier = 1;
               sub_async_tier = false;
            } else if (this.state.subscribe_popup_silver_active === true) {
               sub_tier = 2;
               sub_async_tier = false;
            } else if (this.state.subscribe_popup_gold_active === true) {
               sub_tier = 3;
               sub_async_tier = false;
            } else if (this.state.subscribe_popup_async_active === true) {
               sub_tier = -1;
               sub_async_tier = true;
            }
            if (!(this.state.single_view_collection === "" && this.state.selected_tab === "collections")) {
               res.data.content_list.map((influencer_content_split, index) => {
                  new_influencer_content_list[index]["current_tier"] = sub_tier;
               });
            } else {
               // res.data.content_list.map((influencer_content_split, index) => {
               //    influencer_content_split.data.map(
               //       (influencer_content_split_inner, index2) => {
               //          new_influencer_content_list[index]['data'][index2]['current_tier'] = sub_tier
               //       }
               //    )
               // })
            }
            this.setState({ subpopup_tier_overwrite: sub_tier });
            this.setState({ subpopup_tier_async_overwrite: false });
            }
            this.setState({
            refreshing_content_data: false,
            content_count: res.data.content_count,
            influencer_content_list: new_influencer_content_list,
            // live_count: res.data.live_count,
            // scheduled_count: res.data.scheduled_count,
            collections_count: res.data.collections_count,
            all_count: res.data.all_count,
            saved_count: res.data.saved_count,
            content_types: res.data.content_types,
            categories_filter: res.data.categories_filter,
            inf_scroll_loading: false,
            content_list_length: res.data.content_list_length,
            page_position: new_influencer_content_list.length,
            collection_names: res.data.collection_names,
            collection_data: res.data.collection_data,
            page_n: 1,
            updatedPerks: res.data.updated_tier_perks,
            });
            if (collection_overwrite) {
            this.setState({
               single_view_collection: res.data.collection_names.indexOf(collection_overwrite),
               collection_filter: res.data.collection_names.indexOf(collection_overwrite),
            });
            }
            if (new_influencer_content_list.length >= res.data.content_list_length) {
            this.setState({
               update_inf_scroll: false,
            });
            } else {
            this.setState({
               update_inf_scroll: true,
            });
            }

            this.setState({
            creator_tabs: [/* 'dashboard',  */ "membership"],
            });

            axios({
            method: "get",
            url: paths.BACKEND_URL + "api/influencer/get_course_name_possibilities_v2/" + this.state.currency,
            headers: {
               "Content-type": "application/json",
            },
            withCredentials: true,
            }).then((res) => {
            this.setState({
               courseNames: res.data.course_name_possibilites,
               last_5_categories: res.data.last_5_categories,
               last_5_course_names: res.data.last_5_course_names,
            });
            let playlist_content_uploaded = false;
            if (String(res.data.collection_content_uploaded).toLowerCase() === "true") {
               this.setState({
                  uploadedPlaylistContent: true,
                  uploadedContent: res.data.content_count >= 6 ? true : false,
               });
               playlist_content_uploaded = true;
            } else {
               this.setState({
                  uploadedPlaylistContent: false,
                  uploadedContent: false,
               });
            }

            // cycle through the content and check for a playlist
            window.Intercom("shutdown");
            window.Intercom("boot", {
               hide_default_launcher: true,
               app_id: INTERCOM_APP_ID,
               api_base: "https://api-iam.intercom.io",
               name: this.state.current_user,
               email: this.state.user_email,
               user_hash: this.state.intercom_verify_key,
               is_influencer: true,
               is_logged_in: true,
               onboarding_content_uploaded: true,
               onboarding_playlist_content_uploaded: playlist_content_uploaded,
            });
            // check the existing selected courses
            });
         })
      }
   }

   newOfferingSubmit = () => {
      const form_data = new FormData();
      form_data.append('influencer', this.state.influencer_name)
      form_data.append('currency', this.state.currency)
      axios({
         method: 'post',
         url: paths.BACKEND_URL + "api/subpopup_info/",
         data: form_data,
         headers: {
            'Content-type': 'application/json',
         },
         withCredentials: true
      }).then(res => {
         this.setState(
            {
               subscribe_popup_current_free_trial: res.data.subpopup_info.current_free_trial,
               free_trial_eligible: res.data.subpopup_info.free_trial_eligible,
               subscribe_popup_bronze_price: res.data.subpopup_info.bronze_price,
               subscribe_popup_silver_price: res.data.subpopup_info.silver_price,
               subscribe_popup_gold_price: res.data.subpopup_info.gold_price,
               subscribe_popup_free_perks_text: res.data.subpopup_info.free_perks_text,
               subscribe_popup_bronze_perks_text: res.data.subpopup_info.bronze_perks_text,
               subscribe_popup_silver_perks_text: res.data.subpopup_info.silver_perks_text,
               subscribe_popup_gold_perks_text: res.data.subpopup_info.gold_perks_text,
               subscribe_popup_free_active: res.data.subpopup_info.free_active,
               subscribe_popup_bronze_active: res.data.subpopup_info.bronze_active,
               subscribe_popup_silver_active: res.data.subpopup_info.silver_active,
               subscribe_popup_gold_active: res.data.subpopup_info.gold_active,
               subscribe_popup_free_name: res.data.subpopup_info.free_name,
               subscribe_popup_bronze_name: res.data.subpopup_info.bronze_name,
               subscribe_popup_silver_name: res.data.subpopup_info.silver_name,
               subscribe_popup_gold_name: res.data.subpopup_info.gold_name,
               subscribe_popup_current_duration: res.data.subpopup_info.current_duration,
               subscribe_popup_bronze_annual_price: res.data.subpopup_info.bronze_annual_price,
               subscribe_popup_silver_annual_price: res.data.subpopup_info.silver_annual_price,
               subscribe_popup_gold_annual_price: res.data.subpopup_info.gold_annual_price,
               subscribe_popup_bronze_show_annual_reduction: res.data.subpopup_info.bronze_show_annual_reduction,
               subscribe_popup_silver_show_annual_reduction: res.data.subpopup_info.silver_show_annual_reduction,
               subscribe_popup_gold_show_annual_reduction: res.data.subpopup_info.gold_show_annual_reduction,
               subscribe_popup_bronze_monthly_active: res.data.subpopup_info.bronze_monthly_active,
               subscribe_popup_silver_monthly_active: res.data.subpopup_info.silver_monthly_active,
               subscribe_popup_gold_monthly_active: res.data.subpopup_info.gold_monthly_active,
               subscribe_popup_bronze_annual_active: res.data.subpopup_info.bronze_annual_active,
               subscribe_popup_silver_annual_active: res.data.subpopup_info.silver_annual_active,
               subscribe_popup_gold_annual_active: res.data.subpopup_info.gold_annual_active,
               subscribe_popup_trial_length: res.data.subpopup_info.trial_length,
               subscribe_popup_influencer: res.data.subpopup_info.username,
               influencer_name: res.data.subpopup_info.username,
               subscribe_popup_async_price: res.data.subpopup_info.async_price,
               subscribe_popup_async_perks_text: res.data.subpopup_info.async_perks_text,
               subscribe_popup_async_active: res.data.subpopup_info.async_active,
               subscribe_popup_async_name: res.data.subpopup_info.async_name,
               subscribe_popup_async_annual_price: res.data.subpopup_info.async_annual_price,
               subscribe_popup_async_show_annual_reduction: res.data.subpopup_info.async_show_annual_reduction,
               subscribe_popup_async_monthly_active: res.data.subpopup_info.async_monthly_active,
               subscribe_popup_async_annual_active: res.data.subpopup_info.async_annual_active,
               subscribe_popup_current_tier: res.data.subpopup_info.current_tier,
               subscribe_popup_async_tier_access: res.data.subpopup_info.async_tier_access,
               subscribe_popup_async_annual_duration: res.data.subpopup_info.async_annual_duration,
               subscribe_popup_async_annual_duration_type: res.data.subpopup_info.async_annual_duration_type,
               subscribe_popup_async_annual_rebill: res.data.subpopup_info.async_annual_rebill,
               subscription_popup_silver_access: res.data.subpopup_info.silver_access,
               subscription_popup_gold_access: res.data.subpopup_info.gold_access,
               subscribe_popup_async_tier_hidden: res.data.subpopup_info.async_tier_hidden,
               subscribe_popup_async_tier_apply: res.data.subpopup_info.async_tier_apply,
            }
         )
         let new_tier_types = []
         if (res.data.subpopup_info.bronze_active === true) {
            new_tier_types.push(res.data.subpopup_info.bronze_name)
         }
         if (res.data.subpopup_info.silver_active === true) {
            new_tier_types.push(res.data.subpopup_info.silver_name)
         }
         if (res.data.subpopup_info.gold_active === true) {
            new_tier_types.push(res.data.subpopup_info.gold_name)
         }
         // if (res.data.subpopup_info.async_active === true){
         //    new_tier_types.push(res.data.subpopup_info.async_name)
         // }
         this.setState({
            tierTypes: new_tier_types,
         })
      })
   }

   // New functions
   handleDisplayNameChange = (event) => {
      this.setState({ influencerDisplayNameUpdated: event.target.value })
   }

   // Descripton
   handleDescriptionChange = (event) => {
      this.setState({ influencerDescriptionUpdated: event.target.value })
   }

   // Icon
   handleIconChange = (event) => {
      this.setState({ influencerIconUpdated: event.target.value, influencerIconUpdatedLoading: true })
   }


   //handle cureent banner
   setCurrentBanner = (event) => {
      this.setState({
         influencerBanner: event,
      })
   }

   //handle cureent banner
   setCurrentVideo = (event) => {
      this.setState({
         influencerVideo: event,
      })
   }

   // Set banner
   handleSetBannerChange = (event) => {
      const file = event.target.files[0];
      const imageUrl = URL.createObjectURL(file);
      this.setState({
         influencerBannerUpdated: imageUrl,
         influencerBannerUpdatedFile: file
      })
   };

   handlePresetBannerChange = async (imageUrl) => {
      try {
         // Fetch the image from the URL
         const response = await fetch(imageUrl);
         const blob = await response.blob();
         // create file from the blog
         const file = new File([blob], "presetImage.jpg", { type: "image/jpeg" });
         this.setState({
            influencerBannerUpdated: imageUrl,
            influencerBannerUpdatedFile: file
         });
      } catch (error) {
         //   console.error('Error fetching and processing the image:', error);
      }
   };




   // Set welcome video
   handleSetVideoChange = (event) => {
      const file = event.target.files[0];
      const videoUrl = URL.createObjectURL(file);
      this.setState({
         influencerVideoUpdated: videoUrl,
         influencerVideoUpdatedFile: file
      })
   };


   handleRemoveVideo = () => {
      this.setState({
         influencerVideo: '',
         videoRemoved: true,
         influencerVideoUpdated: '',
         influencerVideoUpdatedFile: '',
      })
   }

   handleCustomiseMode = (currentMode) => {
      this.setState({
         customiseMode: !currentMode
      })
   }

   handleCancelCustomise = () => {
      this.setState({ customiseMode: false })
   }


   bannerChangesMadeCheck = (event) => {
      this.setState({
         bannerChangesMade: event
      })
   }


   clearSquareLogo = () => {
      this.setState({
         logoSquareFileNew: '',
         currentLogoFile: '',
         // logoSquareFile: ''
      });
   };

   clearRectangleLogo = () => {
      this.setState({
         logoRectangleFileNew: '',
         currentLogoFile: '',
         // logoRectangleFile: ''
      });
   };


   rerenderClearedNavbar = () => {
      this.setState({
         currentLogoFile: null,
         logoRectangleFileNew: '',
         logoRectangleFile: '',
         logoSquareFileNew: '',
         logoSquareFile: ''
      })
      this.forceUpdate();
   }


   // saveChanges = () => {
   //    // determine how many things need updating
   //    // steps to update
   //    console.log(this.state.influencerDisplayNameUpdated,
   //       this.state.influencerDescriptionUpdated,
   //       this.state.influencerIconUpdated,
   //       this.state.influencerBannerUpdated,
   //       this.state.influencerVideoUpdated,)
   //
   //    this.saveBannerChanges(
   //       this.state.influencerDisplayNameUpdated,
   //       this.state.influencerDescriptionUpdated,
   //       this.state.influencerIconUpdated,
   //       this.state.influencerBannerUpdated,
   //       this.state.influencerVideoUpdated,
   //       // influencerDisplayNameUpdated,
   //       // influencerDescriptionUpdated,
   //       // influencerIconUpdated,
   //       // influencerBannerUpdatedFile,
   //       // influencerVideoUpdatedFile,
   //       () => {
   //
   //          this.setState({
   //             influencerDisplayNameUpdated: '',
   //             influencerDescriptionUpdated: '',
   //             influencerIconUpdated: '',
   //             influencerBannerUpdated: '',
   //             influencerVideoUpdated: '',
   //          })
   //
   //          // setInfluencerBanner(influencerBannerUpdated);
   //          // setInfluencerVideo(influencerVideoUpdated);
   //          // // revert the updated values
   //          // setInfluencerDisplayNameUpdated('');
   //          // setInfluencerDescriptionUpdated('');
   //          // setInfluencerBannerUpdated('');
   //          // setInfluencerBannerUpdatedFile('');
   //          // setInfluencerIconUpdated('');
   //          // setInfluencerVideoUpdated('');
   //          // setInfluencerVideoUpdatedFile('');
   //       }
   //    );
   // }


   // allow for hover effects to preview what element is edited
   handleBannerButtonHovered = () => { this.setState({ isBannerButtonHovered: true }) }
   handleBannerButtonHoveredExit = () => { this.setState({ isBannerButtonHovered: false }) }
   handleVideoButtonHovered = () => { this.setState({ isVideoButtonHovered: true }) }
   handleVideoButtonHoveredExit = () => { this.setState({ isVideoButtonHovered: false }) }


   update_discord_popup_seen() {
      const form_data = new FormData()
      form_data.append('influencer', this.state.influencer_name)
      axios({
         method: 'post',
         url: paths.BACKEND_URL + 'api/influencer/update_seen_discord_popup',
         data: form_data,
         headers: {
            'Content-type': 'application/json',
         },
         withCredentials: true
      }).then(
         (res) => {
            if (!res.data.access_denied) {
               if (!res.data.error) {
                  this.setState({ show_discord_popup: false });
                  // close the popup
               } else {
                  // display that there's been an error and try again
                  this.setState({ show_discord_popup: false });
               }
            } else {
               // display that there's been an error and try again
               this.setState({ show_discord_popup: false });
            }
         }
      )
   }

   setCalendlyModal(value) {
      this.setState({ calendly_modal: value })
   }

   setDemoModal(value) {
      this.setState({ demo_modal: value })
   }

   setFullServiceApplicationModal(value) {
      this.setState({ full_service_application_modal: value })
   }


   handleOpenHiddenTabModal = () => {
      this.setState({
         hidden_tab_modal: true,
         // hidden_tab_type: type
      })
   }

   handleCloseHiddenTabModal = () => {
      this.setState({
         hidden_tab_modal: false,
         // hidden_tab_type: ''
      })
   }

   handleOpenInfoTabModal = (type, tabState) => {
      this.setState({
         tab_info_modal: true,
         tab_info_modal_type: type,
         tabState: true,
      })
   }

   handleCloseInfoTabModal = () => {
      this.setState({
         tab_info_modal: false,
         tab_info_modal_type: '',
         tabState: false,
      })
   }


   handleCloseNewCreatorModal = () => {
      // update url
      window.history.pushState(null, "dashboard", window.location.href.replace('&new_creator=true', ''))
      this.setState({
         // logoRectangleFileNew: this.state.logoRectangleFile,
         // logoSquareFileNew: this.state.logoSquareFile,
         new_creator_modal: false,
      })
      this.forceUpdate();
   }

   handleClosePublishedCongratsModal = () => {
      window.history.pushState(null, "dashboard", window.location.href.replace('?published=true', ''))
      this.setState({
         publishedCongratsModal: false,
      })
   }

   update_ratings(res) {
      if (res.data.success) {
         this.setState({
            influencer_rating_count: res.data.influencer_rating_count,
            influencer_rating_average: res.data.influencer_rating_average,
         })
      }
   }

   UpdateSubpopupInfoPageType(page_type) {
      this.setState({
         subscription_popup_info_page_type: page_type,
      })
   }

   onVideoChange(file) {
      this.setState({ header_file: file })
   }

   onBannerChange(file) {
      this.setState({ banner_file: file })
   }

   // handleTabChange(event, newValue) {
   //    this.setState({selected_tab: newValue, mobile_content: null});
   // }


   like_button_click_post(res) {
      // if the like value is below 1000 (i.e., all numbers) it is updated
      // to reflect the change
      // the color of the button is updated for all values
      if (res.data.login_required) {
         window.location.assign('/register?post_url=' + res.data.influencer + '/' + res.data.content_id + '&mode=like&id=' + res.data.content_id)
      } else {
         const content_list_copy = this.state.influencer_content_list;
         if (this.state.single_view_collection === '' && (this.state.selected_tab === 'sub_collections' || this.state.selected_tab === 'paid_collections' || this.state.selected_tab === 'collections')) {
            for (let i = 0; i < this.state.influencer_content_list.length; i++) {
               const contentIndex = content_list_copy[i]['data'].findIndex(content => content.id == res.data.content_id);
               if (contentIndex !== -1) {
                  if (res.data.liked) {
                     content_list_copy[i]['data'][contentIndex].content_like = true
                     content_list_copy[i]['data'][contentIndex].n_likes = content_list_copy[i]['data'][contentIndex].n_likes + 1
                  } else {
                     content_list_copy[i]['data'][contentIndex].content_like = false
                     content_list_copy[i]['data'][contentIndex].n_likes = content_list_copy[i]['data'][contentIndex].n_likes - 1
                  }
                  this.setState({ influencer_content_list: content_list_copy })
               }
            }
         } else {
            const contentIndex = content_list_copy.findIndex(content => content.id == res.data.content_id);
            if (contentIndex !== -1) {
               if (res.data.liked) {
                  content_list_copy[contentIndex].content_like = true
                  content_list_copy[contentIndex].n_likes = content_list_copy[contentIndex].n_likes + 1
               } else {
                  content_list_copy[contentIndex].content_like = false
                  content_list_copy[contentIndex].n_likes = content_list_copy[contentIndex].n_likes - 1
               }
               this.setState({ influencer_content_list: content_list_copy })
            }
         }
         if (this.state.content_info.content_like !== '') {
            const content_info_copy = this.state.content_info;
            if (res.data.liked) {
               content_info_copy.content_like = true
               content_info_copy.n_likes = content_info_copy.n_likes + 1
            } else {
               content_info_copy.content_like = false
               content_info_copy.n_likes = content_info_copy.n_likes - 1
            }
            this.setState({ content_info: content_info_copy })
         }
      }
   }

   bookmark_button_click_post(res) {
      if (res.data.login_required) {
         window.location.assign('/register?post_url=' + res.data.influencer + '/' + res.data.content_id + '&mode=fav&id=' + res.data.content_id)
      } else if (res.data.is_favourite !== undefined) {
         const content_list_copy = this.state.influencer_content_list;
         if ((this.state.single_view_collection === '') && (this.state.selected_tab === 'sub_collections' || this.state.selected_tab === 'paid_collections' || this.state.selected_tab === 'collections')) {
            for (let i = 0; i < this.state.influencer_content_list.length; i++) {
               const contentIndex = content_list_copy[i]['data'].findIndex(content => content.id == res.data.content_id);
               if (contentIndex !== -1) {
                  if ((content_list_copy[i]['data'][contentIndex]) && (content_list_copy[i]['data'][contentIndex].is_favourite !== res.data.is_favourite)) {
                     if (this.state.is_me === true) {
                        if (!((this.state.selected_tab === 'sub_posts') && (this.state.sort_filter === 'saved_sub_posts'))) {
                           content_list_copy[i]['data'][contentIndex].is_favourite = res.data.is_favourite;
                           if (res.data.is_favourite === true) {
                              this.setState({
                                 saved_count: this.state.saved_count + 1,
                                 prev_bookmark_content_id: res.data.content_id,
                                 prev_bookmark_state: res.data.is_favourite,
                                 prev_saved_tab: (this.state.selected_tab === 'sub_posts') && (this.state.sort_filter === 'saved_sub_posts') ? 'saved_sub_posts' : (this.state.selected_tab === 'sub_posts') && (this.state.sort_filter === 'purchased') ? 'purchased' : this.state.selected_tab,
                              })
                           } else {
                              this.setState({
                                 saved_count: this.state.saved_count - 1,
                                 prev_bookmark_content_id: res.data.content_id,
                                 prev_bookmark_state: res.data.is_favourite,
                                 prev_saved_tab: (this.state.selected_tab === 'sub_posts') && (this.state.sort_filter === 'saved_sub_posts') ? 'saved_sub_posts' : (this.state.selected_tab === 'sub_posts') && (this.state.sort_filter === 'purchased') ? 'purchased' : this.state.selected_tab,
                              })
                           }
                        } else {
                           content_list_copy[i]['data'].splice(contentIndex, 1);
                           this.setState({
                              saved_count: this.state.saved_count - 1,
                              prev_bookmark_content_id: res.data.content_id,
                              prev_bookmark_state: res.data.is_favourite,
                              prev_saved_tab: (this.state.selected_tab === 'sub_posts') && (this.state.sort_filter === 'saved_sub_posts') ? 'saved_sub_posts' : (this.state.selected_tab === 'sub_posts') && (this.state.sort_filter === 'purchased') ? 'purchased' : this.state.selected_tab,
                           })
                        }
                     } else {
                        if (!((this.state.selected_tab === 'all') && (this.state.sort_filter === 'saved'))) {
                           content_list_copy[i]['data'][contentIndex].is_favourite = res.data.is_favourite;
                           if (res.data.is_favourite === true) {
                              this.setState({
                                 saved_count: this.state.saved_count + 1,
                                 prev_bookmark_content_id: res.data.content_id,
                                 prev_bookmark_state: res.data.is_favourite,
                                 prev_saved_tab: (this.state.selected_tab === 'all') && (this.state.sort_filter === 'saved') ? 'saved' : (this.state.selected_tab === 'all') && (this.state.sort_filter === 'purchased') ? 'purchased' : this.state.selected_tab,
                              })
                           } else {
                              this.setState({
                                 saved_count: this.state.saved_count - 1,
                                 prev_bookmark_content_id: res.data.content_id,
                                 prev_bookmark_state: res.data.is_favourite,
                                 prev_saved_tab: (this.state.selected_tab === 'all') && (this.state.sort_filter === 'saved') ? 'saved' : (this.state.selected_tab === 'all') && (this.state.sort_filter === 'purchased') ? 'purchased' : this.state.selected_tab,
                              })
                           }
                        } else {
                           content_list_copy[i]['data'].splice(contentIndex, 1);
                           this.setState({
                              saved_count: this.state.saved_count - 1,
                              prev_bookmark_content_id: res.data.content_id,
                              prev_bookmark_state: res.data.is_favourite,
                              prev_saved_tab: (this.state.selected_tab === 'all') && (this.state.sort_filter === 'saved') ? 'saved' : (this.state.selected_tab === 'all') && (this.state.sort_filter === 'purchased') ? 'purchased' : this.state.selected_tab,
                           })
                        }
                     }
                     this.setState({ influencer_content_list: content_list_copy, force_content_rerender: this.state.force_content_rerender === false, refreshing_content_data: false, });
                  }
               }
            }
         } else {
            const contentIndex = content_list_copy.findIndex(content => content.id == res.data.content_id);
            if (contentIndex !== -1) {
               if ((content_list_copy[contentIndex]) && (content_list_copy[contentIndex].is_favourite !== res.data.is_favourite)) {
                  if (this.state.is_me === true){
                     if (!((this.state.selected_tab === 'sub_posts') && (this.state.sort_filter === 'saved_sub_posts'))) {
                        content_list_copy[contentIndex].is_favourite = res.data.is_favourite;
                        if (res.data.is_favourite === true) {
                           this.setState({
                              saved_count: this.state.saved_count + 1,
                              prev_bookmark_content_id: res.data.content_id,
                              prev_bookmark_state: res.data.is_favourite,
                              prev_saved_tab: (this.state.selected_tab === 'sub_posts') && (this.state.sort_filter === 'saved_sub_posts') ? 'saved_sub_posts' : (this.state.selected_tab === 'sub_posts') && (this.state.sort_filter === 'purchased') ? 'purchased' : this.state.selected_tab,
                           })
                        } else {
                           this.setState({
                              saved_count: this.state.saved_count - 1,
                              prev_bookmark_content_id: res.data.content_id,
                              prev_bookmark_state: res.data.is_favourite,
                              prev_saved_tab: (this.state.selected_tab === 'sub_posts') && (this.state.sort_filter === 'saved_sub_posts') ? 'saved_sub_posts' : (this.state.selected_tab === 'sub_posts') && (this.state.sort_filter === 'purchased') ? 'purchased' : this.state.selected_tab,
                           })
                        }
                     } else {
                        content_list_copy.splice(contentIndex, 1);
                        this.setState({
                           saved_count: this.state.saved_count - 1,
                           prev_bookmark_content_id: res.data.content_id,
                           prev_bookmark_state: res.data.is_favourite,
                           influencer_content_list: content_list_copy,
                           prev_saved_tab: (this.state.selected_tab === 'sub_posts') && (this.state.sort_filter === 'saved_sub_posts') ? 'saved_sub_posts' : (this.state.selected_tab === 'sub_posts') && (this.state.sort_filter === 'purchased') ? 'purchased' : this.state.selected_tab,
                           force_content_rerender: this.state.force_content_rerender === false,
                        })
                     }
                  } else {
                     if (!((this.state.selected_tab === 'all') && (this.state.sort_filter === 'saved'))) {
                        content_list_copy[contentIndex].is_favourite = res.data.is_favourite;
                        if (res.data.is_favourite === true) {
                           this.setState({
                              saved_count: this.state.saved_count + 1,
                              prev_bookmark_content_id: res.data.content_id,
                              prev_bookmark_state: res.data.is_favourite,
                              prev_saved_tab: (this.state.selected_tab === 'all') && (this.state.sort_filter === 'saved') ? 'saved' : (this.state.selected_tab === 'all') && (this.state.sort_filter === 'purchased') ? 'purchased' : this.state.selected_tab,
                           })
                        } else {
                           this.setState({
                              saved_count: this.state.saved_count - 1,
                              prev_bookmark_content_id: res.data.content_id,
                              prev_bookmark_state: res.data.is_favourite,
                              prev_saved_tab: (this.state.selected_tab === 'all') && (this.state.sort_filter === 'saved') ? 'saved' : (this.state.selected_tab === 'all') && (this.state.sort_filter === 'purchased') ? 'purchased' : this.state.selected_tab,
                           })
                        }
                     } else {
                        content_list_copy.splice(contentIndex, 1);
                        this.setState({
                           saved_count: this.state.saved_count - 1,
                           prev_bookmark_content_id: res.data.content_id,
                           prev_bookmark_state: res.data.is_favourite,
                           influencer_content_list: content_list_copy,
                           prev_saved_tab: (this.state.selected_tab === 'all') && (this.state.sort_filter === 'saved') ? 'saved' : (this.state.selected_tab === 'all') && (this.state.sort_filter === 'purchased') ? 'purchased' : this.state.selected_tab,
                           force_content_rerender: this.state.force_content_rerender === false,
                        })
                     }
                  }
                  this.setState({
                     influencer_content_list: content_list_copy,
                     force_content_rerender: this.state.force_content_rerender === false,
                     refreshing_content_data: false
                  });
               }
            }
         }
         if (this.state.content_info.is_favourite !== '') {
            const content_info_copy = this.state.content_info;
            content_info_copy.is_favourite = res.data.is_favourite
            this.setState({ content_info: content_info_copy })
         }
      }
   }

   DowngradeProcessPost(res) {
      //  close the popups
      this.setState(
         {
            subscription_popup_info_open: false,
            subscription_popup_info_text_1: "",
            subscription_popup_info_text_2: "",
            subscription_popup_info_button_text: "",
            subscription_popup_info_button_click_process: "",
            subscribe_popup_open: false,
            waiting_list_popup_open: false,
            // subscribe_popup_icon_image: "",
            // subscribe_popup_influencer: "",
            // subscribe_popup_influencer_name: "",
            // subscribe_popup_current_tier: "",
            // subscribe_popup_minimum_tier: "",
            // subscribe_popup_bronze_price: "",
            // subscribe_popup_silver_price: "",
            // subscribe_popup_gold_price: "",
         }
      )
   }

   UpgradeProcessPost(res) {
      //  close the popups
      window.location.assign('/influencers/' + res.data.influencer)
   }
   // make influencer live
   makeInfluencerLive() {
      this.setState({ profileLiveLoading: true })
      axios(
         {
            method: 'get',
            url: paths.BACKEND_URL + 'api/influencer/onboarding_dashboard_make_influencer_live',
            headers: {
               'Content-type': 'application/json',
            },
            withCredentials: true
         }
      ).then(
         res => {
            if (!res.data.access_denied) {
               if (res.data.success === 'true') {
                  if (!this.state.influencer_launched) {
                     let pipedrive_data = new FormData();
                     pipedrive_data.append('case', 'launched')
                     axios({
                        method: 'post',
                        url: paths.BACKEND_URL + 'api/influencer/update_pipdedrive_onboarding_deals',
                        data: pipedrive_data,
                        headers: {
                           'Content-type': 'application/json',
                        },
                        withCredentials: true
                     }).then(() => {
                        this.setState({ isSwitchOn: !this.state.isSwitchOn })
                        window.location.assign('/' + this.state.influencer_name + '?published=true');
                        this.setState({ profileLiveLoading: false })
                     })
                  } else {
                     this.setState({ isSwitchOn: !this.state.isSwitchOn })
                     window.location.assign('/' + this.state.influencer_name + '?published=true');
                     this.setState({ profileLiveLoading: false })
                  }
               } else {
                  this.setState(
                     {
                        profileLiveLoading: false,
                        // publishErrorMsg: res.data.error,
                        snackbar: true,
                        errorMsg: res.data.error,
                     }
                  )
               }
            }
         }
      )
   }
   submitUsernameUpdate() {
      let special_char_regex = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
      // check the username
      if (this.state.editedUsername.length > 60 || this.state.editedUsername.length < 4) {
         this.setState({ editUrlErrorMsg: "Username must be between 4 and 60 characters" })
      } else if (this.state.editedUsername.indexOf(' ') >= 0) {
         this.setState({ editUrlErrorMsg: "No spaces allowed in username" })
      } else if (special_char_regex.test(this.state.editedUsername)) {
         this.setState({ editUrlErrorMsg: "No special characters allowed in username" })
      } else {
         this.setState({ editUrlErrorMsg: "" })
         // update the username
         const form_data = new FormData()
         form_data.append('username', this.state.editedUsername)
         axios(
            {
               method: 'post',
               url: paths.BACKEND_URL + 'api/influencer/update_username',
               data: form_data,
               headers: {
                  'Content-type': 'application/json',
               },
               withCredentials: true
            }
         ).then(
            res => {
               if (!res.data.access_denied) {
                  if (res.data.success) {
                     if (!this.state.influencer_launched) {
                        let pipedrive_data = new FormData();
                        pipedrive_data.append('case', 'username')
                        axios({
                           method: 'post',
                           url: paths.BACKEND_URL + 'api/influencer/update_pipdedrive_onboarding_deals',
                           data: pipedrive_data,
                           headers: {
                              'Content-type': 'application/json',
                           },
                           withCredentials: true
                        })
                     }
                     window.location.assign('/' + this.state.editedUsername + "?updated-username=true");
                     //    this.setState({
                     //       snackbar: true
                     // })
                     // this.setState(
                     //    {
                     //       current_user: this.state.editedUsername,
                     //       openEditUrl: false,
                     //    }
                     // )
                  } else {
                     if (res.data.error === 'username already taken') {
                        this.setState({ editUrlErrorMsg: 'Username already taken. Please choose a different one.' })
                     } else {
                        this.setState({ editUrlErrorMsg: 'Error please try again.' })
                     }
                  }
               } else {
                  this.setState({ editUrlErrorMsg: 'Error please try again.' })
               }
            }
         )
      }
   }


   switch_onChange_handle() {
      if (this.state.setupProfile === false) {
         if (this.state.influencer_info['description'] === '') {
            this.setState(
               {
                  // publishErrorMsg: res.data.error,
                  publishSnackbar: true,
                  publishErrorMsg: 'Maximise your launch! Update your profile description before publishing 🚀',
                  publishActionText: 'Add profile description',
                  publishActionProcess: () => {
                     if (window.innerWidth >= 900) {
                        this.setState({ publishSnackbar: false })
                        window.location.assign(window.location.href.split('#')[0] + '#banner_desktop')
                        setTimeout(() => {
                           this.setState({ edit_mode: true })
                        }
                           , 1000);
                        // set focus
                     } else {
                        this.setState({ publishSnackbar: false })
                        window.location.assign(window.location.href.split('#')[0] + '#banner_mobile')
                        setTimeout(() => {
                           this.setState({ customiseMode: true });
                           this.setState({ edit_mode: true });
                        }
                           , 1000);
                        // set focus
                     }
                  }
               }
            )
         } else if (this.state.missingProfiles.includes('profile photo')) {
            this.setState(
               {
                  // publishErrorMsg: res.data.error,
                  publishSnackbar: true,
                  publishErrorMsg: 'Maximise your launch! Update your profile image before publishing 🚀',
                  publishActionText: 'Add profile image',
                  publishActionProcess: () => {
                     if (window.innerWidth >= 900) {
                        this.setState({ publishSnackbar: false })
                        window.location.assign(window.location.href.split('#')[0] + '#banner_desktop');
                        setTimeout(() => {
                           this.setState({ open_icon_image_edit: true })
                        }, 1000);
                        // set focus
                     } else {
                        this.setState({ publishSnackbar: false })
                        window.location.assign(window.location.href.split('#')[0] + '#banner_mobile');
                        setTimeout(() => {
                           this.setState({ customiseMode: true });
                           this.setState({ open_icon_image_edit: true })
                        }, 1000);
                        // set focus
                     }
                  }
               }
            )
         } else {
            this.setState(
               {
                  // publishErrorMsg: res.data.error,
                  publishSnackbar: true,
                  publishErrorMsg: 'Maximise your launch! Update your banner image before publishing 🚀',
                  publishActionText: 'Add banner image',
                  publishActionProcess: () => {
                     if (window.innerWidth >= 900) {
                        this.setState({ publishSnackbar: false })
                        window.location.assign(window.location.href.split('#')[0] + '#banner_desktop')
                        // props.checklistBannerUpload();
                        setTimeout(() => {
                           const input = document.getElementById('banner_image_upload_desktop');
                           input.click();
                        }
                           , 1000);
                     } else {
                        this.setState({ publishSnackbar: false })
                        window.location.assign(window.location.href.split('#')[0] + '#banner_mobile');
                        this.setState({ customiseMode: true });
                        // set focus
                        setTimeout(() => {
                           const input = document.getElementById('banner_image_upload_mobile');
                           input.click();
                        }
                           , 1000);
                     }
                  }
               }
            )
         }
      } else if (this.state.updatedPerks === false) {
         this.setState(
            {
               // publishErrorMsg: res.data.error,
               publishSnackbar: true,
               publishErrorMsg: 'Maximise your launch! Create an offering before publishing 🚀',
               publishActionText: 'Add pricing tier',
               publishActionProcess: () => {
                  if (window.innerWidth >= 900) {
                     this.setState({ publishSnackbar: false })
                     this.handleProfileTabChange('', 'membership');
                  } else {
                     this.setState({ publishSnackbar: false })
                     this.handleProfileTabChange('', 'membership');
                  }
               }
            }
         )
      }
      else {
         axios(
            {
               method: 'get',
               url: paths.BACKEND_URL + 'api/influencer/onboarding_dashboard_check_influencer_live',
               headers: {
                  'Content-type': 'application/json',
               },
               withCredentials: true
            }
         ).then(
            res => {
               if (!res.data.access_denied) {
                  if (res.data.success === 'true') {
                     this.setState(
                        {
                           waitingListCount: res.data.number_waiting_list,
                           activeTierCount: res.data.number_of_active_tiers,
                           collectionsCount: res.data.number_of_collections,
                           publishModal: true,
                           // publishedCongratsModal: true
                        }
                     )
                     // window.location.assign('/'+ this.state.current_user +'?published=true')
                  } else {
                     this.setState(
                        {
                           // publishErrorMsg: res.data.error,
                           snackbar: true,
                           errorMsg: 'Must add benefits to your offering before you can launch!',
                        }
                     )
                  }
               }
            }
         )
      }
   };




   // add the imported change functions
   componentDidMount() {

      const { current_page_view } = this.props;
      const searchParams = new URLSearchParams(window.location.search);
      current_page_view && (document.title = (current_page_view.charAt(0).toUpperCase() + current_page_view.slice(1)).replace('_', ' ') + ' - WithMe');
      window.addEventListener('beforeunload', this.handleBeforeUnload);
      window.addEventListener("scroll", this.handleScroll);
      window.addEventListener("resize", this.handleWindowResize);
      // dashboard initial
      let currency = this.getGeoInfo(true);
      let waiting_list = searchParams.get("waiting_list");
      const form_data = new FormData();
      form_data.append('influencer', this.props.influencer_name ? this.props.influencer_name : this.props.params.influencer_name)
      form_data.append('currency', currency)
      let updated_username = searchParams.get('updated-username')
      if (this.props.influencer_name){
         window.history.pushState(null, this.props.influencer_name, "/"+this.props.influencer_name)
      }

      axios({
         method: 'post',
         url: paths.BACKEND_URL + "api/influencer/onboarding_dashboard_initial_data_new_v2",
         data: form_data,
         headers: {
            'Content-type': 'application/json',
         },
         withCredentials: true
      }).then( res => {
         let new_creator = searchParams.get("new_creator")
         let published = searchParams.get("published")
         let promo_code = searchParams.get('promo_code')
         let content_id = searchParams.get('id')
         let creator_preview = Boolean(searchParams.get('creator_preview'));
         let isSubscribed = Boolean(searchParams.get('isSubscribed'));
         this.setState({ creator_preview: creator_preview });

         if (promo_code === null){
            promo_code = ''
         }

         // load the additional data for dashboard
         window.Intercom('shutdown');
         this.setState(
            {
               dashboard: res.data.is_me,
               promo_code: promo_code,
               subscribe_popup_current_free_trial: res.data.influencer_info_first.current_free_trial, // both
               free_trial_eligible: res.data.influencer_info_first.free_trial_eligible, // both
               subscribe_popup_bronze_price: res.data.influencer_info_first.bronze_price, // both
               subscribe_popup_silver_price: res.data.influencer_info_first.silver_price, // both
               subscribe_popup_gold_price: res.data.influencer_info_first.gold_price, // both
               subscribe_popup_free_perks_text: res.data.influencer_info_first.free_perks_text, // both
               subscribe_popup_bronze_perks_text: res.data.influencer_info_first.bronze_perks_text, // both
               subscribe_popup_silver_perks_text: res.data.influencer_info_first.silver_perks_text, // both
               subscribe_popup_gold_perks_text: res.data.influencer_info_first.gold_perks_text, // both
               subscribe_popup_free_active: res.data.influencer_info_first.free_active, // both
               subscribe_popup_bronze_active: res.data.influencer_info_first.bronze_active, // both
               subscribe_popup_silver_active: res.data.influencer_info_first.silver_active, // both
               subscribe_popup_gold_active: res.data.influencer_info_first.gold_active, // both
               subscribe_popup_free_name: res.data.influencer_info_first.free_name, // both
               subscribe_popup_bronze_name: res.data.influencer_info_first.bronze_name, // both
               subscribe_popup_silver_name: res.data.influencer_info_first.silver_name, // both
               subscribe_popup_gold_name: res.data.influencer_info_first.gold_name, // both
               subscribe_popup_current_duration: res.data.influencer_info_first.current_duration, // both
               subscribe_popup_bronze_annual_price: res.data.influencer_info_first.bronze_annual_price, // both
               subscribe_popup_silver_annual_price: res.data.influencer_info_first.silver_annual_price, // both
               subscribe_popup_gold_annual_price: res.data.influencer_info_first.gold_annual_price, // both
               subscribe_popup_bronze_show_annual_reduction: res.data.influencer_info_first.bronze_show_annual_reduction, // both
               subscribe_popup_silver_show_annual_reduction: res.data.influencer_info_first.silver_show_annual_reduction, // both
               subscribe_popup_gold_show_annual_reduction: res.data.influencer_info_first.gold_show_annual_reduction, // both
               subscribe_popup_bronze_monthly_active: res.data.influencer_info_first.bronze_monthly_active, // both
               subscribe_popup_silver_monthly_active: res.data.influencer_info_first.silver_monthly_active, // both
               subscribe_popup_gold_monthly_active: res.data.influencer_info_first.gold_monthly_active, // both
               subscribe_popup_bronze_annual_active: res.data.influencer_info_first.bronze_annual_active, // both
               subscribe_popup_silver_annual_active: res.data.influencer_info_first.silver_annual_active, // both
               subscribe_popup_gold_annual_active: res.data.influencer_info_first.gold_annual_active, // both
               subscribe_popup_trial_length: res.data.influencer_info_first.trial_length, // both
               subscribe_popup_influencer: res.data.influencer_info_first.username, //both
               influencer_info: res.data.influencer_info, // both
               sub_type: res.data.sub_type, // both
               user_email: res.data.influencer_info_first.email, // both
               categories: res.data.categories, // both
               current_user: res.data.current_user, // both
               current_user_icon: res.data.current_user_icon, // both
               hidden_influencer: res.data.hidden_influencer, // both
               influencer_bool: res.data.influencer_bool, // both
               influencer_launched: res.data.influencer_launched, // both
               influencer_rating_average: res.data.influencer_rating_average, // both
               influencer_rating_count: res.data.influencer_rating_count, // both
               is_me: res.data.is_me, // both
               n_user_subscriptions: res.data.n_user_subscriptions, // both
               recommended_influencers: res.data.recommended_influencers, // both
               intercom_verify_key: res.data.user_key, // both
               user_subscriptions: res.data.user_subscriptions, // both
               display_name: res.data.display_name, // both
               subscribe_popup_async_price: res.data.influencer_info_first.async_price, // both
               subscribe_popup_async_perks_text: res.data.influencer_info_first.async_perks_text, // both
               subscribe_popup_async_active: res.data.influencer_info_first.async_active, // both
               subscribe_popup_async_name: res.data.influencer_info_first.async_name, // both
               subscribe_popup_async_annual_price: res.data.influencer_info_first.async_annual_price, // both
               subscribe_popup_async_show_annual_reduction: res.data.influencer_info_first.async_show_annual_reduction, // both
               subscribe_popup_async_monthly_active: res.data.influencer_info_first.async_monthly_active, // both
               subscribe_popup_async_annual_active: res.data.influencer_info_first.async_annual_active, // both
               subscribe_popup_async_tier_access: res.data.influencer_info.async_tier_access,
               logoSquareFile: res.data.influencer_info_first.square_logo ? res.data.influencer_info_first.square_logo : '',
               logoRectangleFile: res.data.influencer_info_first.rectangle_logo ? res.data.influencer_info_first.rectangle_logo : '',
               logoSquareFileNew: res.data.influencer_info_first.square_logo ? res.data.influencer_info_first.square_logo : '',
               logoRectangleFileNew: res.data.influencer_info_first.rectangle_logo ? res.data.influencer_info_first.rectangle_logo : '',
               subscribe_popup_async_annual_duration: res.data.influencer_info_first.async_annual_duration,
               subscribe_popup_async_annual_duration_type: res.data.influencer_info_first.async_annual_duration_type,
               subscribe_popup_async_annual_rebill: res.data.influencer_info_first.async_annual_rebill,
               subscribe_popup_async_tier_hidden: res.data.influencer_info_first.async_tier_hidden,
               subscribe_popup_async_tier_apply: res.data.influencer_info_first.async_tier_apply,
               community_is_active: res.data.influencer_info_first.community_tab_active,
               subscription_popup_silver_access: res.data.silver_access,
               subscription_popup_gold_access: res.data.gold_access,
               dm_active: res.data.dm_active,
               paidDMs_show: res.data.influencer_info_first.show_dm,
               paidDMs_has_messages: res.data.has_messages,
               async_apply: res.data.influencer_info.async_apply,
               connected_stripe_account_id: res.data.influencer_info.stripe_connected_account_id,
               stripe_customer_id2: res.data.stripe_customer_id2,
            }
         )
         if (res.data.is_me === true) {
            this.getAsyncStatus(res.data.influencer_info.influencer, res.data.current_user)
         }
         if (updated_username === 'true') {
            
            this.setState({
               usernameSnackbar: true,

            })
         }

         // Clarity tracking info
         clarity.init(CLARITY_ID);
         clarity.identify(res.data.current_user, { username: res.data.current_user, displayName: res.data.display_name, email: res.data.influencer_info_first.email });
         // Cookie consent
         clarity.consent();
         clarity.setTag('isCreator', res.data.is_me);

         if (res.data.is_me === true){
            this.setState({
               categories_filter: res.data.categories_filter,
               courseNames: res.data.course_name_possibilites,
               last_5_course_names: res.data.last_5_course_names,
               tierTypes: res.data.influencer_info_first.tierTypes,
               had_demo: res.data.influencer_info_first.had_demo,
               first_name: res.data.first_name,
               updatedPerks: res.data.updated_tier_perks,
               watched_sales_video: res.data.intro_video_watched,
               setupProfile: res.data.profile_complete,
               joinReasonAdded: res.data.join_reason_added,
               uploadedContent: ((res.data.content_count >= 6) & (res.data.uploaded_playlist_content === true))? true : false,
               uploadedPlaylistContent: res.data.uploaded_playlist_content,
               sharedWaitingList: res.data.shared_waiting_list,
               oneWaitingList: res.data.one_waiting_list,
               missingProfiles: res.data.missing_profile_parts,
               setupStripe: res.data.stripe_connected,
               stripeStatus: res.data.stripe_status,
               stripeRedirectLink: res.data.stripe_login_link,
               tierChangeOptions: res.data.tier_change_options,
               showContentConfetti: res.data.show_content_confetti,
               confettiModal: res.data.show_content_confetti,
               profileVideoAdded: res.data.profile_video_added,
               tier_change_options: res.data.tier_change_options,
               influencer_name: res.data.current_user,
               editedUsername: res.data.current_user,
               discord_active: res.data.discord_active,
               header_file: res.data.header_file,
               header_video: res.data.header_video,
               icon_image: res.data.icon_image, 
               content_count: res.data.content_count,
               is_me: res.data.is_me,
               last_5_categories: res.data.last_5_categories,
               late_payment: res.data.late_payment,
               n_subs: res.data.n_subs,
               creator_tier: res.data.creator_tier,
            })

            let display_name_added = true
            let bio_added = true
            let handle_added = false
            let profile_picture_added = true
            let profile_banner_added = true
            if (res.data.missing_profile_parts.includes('Display Name')){
               display_name_added = false
            }
            if (res.data.missing_profile_parts.includes('Short Bio')){
               bio_added = false
            }
            if (res.data.missing_profile_parts.includes('profile photo')){
               profile_picture_added = false
            }
            if (res.data.missing_profile_parts.includes('header photo')){
               profile_banner_added = false
            }
            window.Intercom('boot', {
               app_id: INTERCOM_APP_ID,
               api_base: "https://api-iam.intercom.io",
               name: res.data.current_user,
               email: res.data.influencer_info_first.email,
               user_hash: res.data.user_key,
               avatar: {
                  "type": "avatar",
                  "image_url" : `${paths.BACKEND_URL}api/user/icon`,
               },
               "is_influencer": true,
               "is_logged_in": true,
               "pre_influencer": false,
               'is_influencer_launched': res.data.influencer_launched,
               "onboarding_watched_intro_video": res.data.intro_video_watched,
               "onboarding_reason_given": res.data.join_reason_added,
               "onboarding_display_name_added": display_name_added,
               "onboarding_bio_added": bio_added,
               "onboarding_handle_added": handle_added,
               "onboarding_profile_picture_added": profile_picture_added,
               "onboarding_profile_banner_added": profile_banner_added,
               "onboarding_profile_video_added": res.data.profile_video_added,
               "onboarding_content_uploaded": res.data.uploaded_content,
               "onboarding_playlist_content_uploaded": res.data.uploaded_playlist_content,
               "onboarding_waiting_list_shared": res.data.shared_waiting_list,
               "onboarding_atleast_one_waiting_list": res.data.one_waiting_list,
               "onboarding_tier_perks_updated": res.data.updated_tier_perks,
               "onboarding_stripe_connected": res.data.connected_stripe,
               "onboarding_been_to_dashboard": true,
               "onboarding_first_name": res.data.first_name,
               "had_demo": res.data.influencer_info_first.had_demo,
               hide_default_launcher: window.innerWidth < 600 ? true : false,
            });
            if (new_creator === 'true'){
               this.setState({
                  new_creator_modal: true,
               })
            }

            if (published === 'true'){
               this.setState({
                  publishedCongratsModal: true,
               })
            }
            if (res.data.influencer_launched){
               this.get_and_post_data_skeleton(
                  paths.BACKEND_URL + "api/influencer/onboarding_dashboard_insights_data/"+currency,
                  'get',
               )
               
            } else {
               this.get_and_post_data_skeleton(
                  paths.BACKEND_URL + "api/influencer/onboarding_dashboard_insights_data_waitlist/"+currency,
                  'get',
               )             
            }
         }
         // Get income data to setup the Payout page
         let influencer_name = ''
         if (this.props.influencer_name){
            influencer_name = this.props.influencer_name
         } else {
            influencer_name = this.props.params.influencer_name
         }
         if (res.data.is_me) {
            const income_form_data = new FormData();
            income_form_data.append('currency', currency)
            this.get_and_post_data_skeleton(
               paths.BACKEND_URL + "api/settings_page_income_page_info",
               'post',
               false,
               income_form_data,
               (res) => { 
                  this.setState({incomeData: res.data})
               }
            )
   

            // Set selected_tab from URL page parameter if it exists
            // if (window.location.href.includes('subscriptions') && this.state.is_me === true) {
            //    this.setState({ selected_tab: 'all' });
            // } else if (window.location.href.includes('digital_products') && this.state.is_me === true) {
            //    this.setState({ selected_tab: 'paid_posts' });
            // }
            this.fetchActiveProductData(this.state.currency);
            // Trigger tab actions on mount if conditions are met
            if (String(searchParams.get("open_community")) === 'true') {
               if (searchParams.get("post_id")){
                  this.setState({post_id: searchParams.get('post_id')})
                  this.props.navigate('?page=community&open_community=true&post_id='+searchParams.get("post_id"))
               } else {
                  this.props.navigate('?page=community&open_community=true')
               }
               this.handleTabNavigation('community', influencer_name, res.data.influencer_info);
            } else if (String(searchParams.get("open_messages")) === 'true') {
               let coaching_member = searchParams.get("coaching_member");
               let post_id = searchParams.get("post_id")
               if (coaching_member){
                  this.setState({selectedMemberTabOverwrite: coaching_member})
                  if (post_id){
                     this.setState({post_id: post_id})
                     this.props.navigate('?page=messages&open_messages=true&coaching_member='+coaching_member+'&post_id='+post_id)
                  } else {
                     this.props.navigate('?page=messages&open_messages=true&coaching_member='+coaching_member)
                  }
               } else {
                  this.props.navigate('?page=messages&open_messages=true')
               }
               this.handleTabNavigation('messages', influencer_name, res.data.influencer_info, true);
            } else if (String(searchParams.get("open_coaching")) === 'true') {
               let coaching_member = searchParams.get("coaching_member");
               let post_id = searchParams.get("post_id")
               if (coaching_member){
                  this.setState({selectedMemberTabOverwrite: searchParams.get("coaching_member")})
                  if (post_id){
                     this.setState({post_id: searchParams.get("post_id")})
                     this.props.navigate('?page=1v1coaching&open_coaching=true&coaching_member='+coaching_member+'&post_id='+post_id)
                  } else {
                     this.props.navigate('?page=1v1coaching&open_coaching=true&coaching_member='+coaching_member)
                  }
               } else {
                  this.props.navigate('?page=1v1coaching&open_coaching=true')
               }
               this.handleTabNavigation('1v1coaching', influencer_name, res.data.influencer_info, true);
            } else if (this.state.initial_content_id) {
               // determine type of content
               const form_data = new FormData();
               form_data.append('content_id', this.state.initial_content_id)
               axios(
                  {
                     method: 'POST',
                     url: paths.BACKEND_URL + "api/content/determine_sub_content_type",
                     data: form_data,
                     headers: {
                        'Content-type': 'application/json',
                     },
                     withCredentials: true
                  })
                  .then(res => {
                     if (res.data.content_type === 'sub'){
                        this.props.navigate('?page=subscriptions')
                        this.handleTabNavigation('subscriptions', influencer_name, res.data.influencer_info);
                     } else if (res.data.content_type === 'paid'){
                        this.props.navigate('?page=digital_products')
                        this.handleTabNavigation('digital_products', influencer_name, res.data.influencer_info);
                     } else {
                        this.setState({open_collection: true})
                        this.props.navigate('?page=courses&open_collection=true&id='+res.data.content_type)
                        this.handleTabNavigation('courses', influencer_name, res.data.influencer_info, true, res.data.content_type);                     
                     }
                  }
               )
            } else if (String(searchParams.get("open_collection")) === 'true') {
                  let id = searchParams.get("id")
                  // determine type of content
                  if (id){
                     const form_data = new FormData();
                     form_data.append('collection_id', id)
                     axios(
                        {
                           method: 'POST',
                           url: paths.BACKEND_URL + "api/content/determine_collection_type",
                           data: form_data,
                           headers: {
                              'Content-type': 'application/json',
                           },
                           withCredentials: true
                        })
                        .then(res => {
                           if (res.data.collection_type === 'paid'){
                              this.props.navigate('?page=courses&open_collection=true&id='+id)
                              this.setState({open_collection: true})
                              this.handleTabNavigation('courses', influencer_name, res.data.influencer_info, true, id);
                           } else {
                              this.setState({open_collection: true})
                              this.props.navigate('?page=subscriptions&open_collection=true&id='+id)
                              this.handleTabNavigation('subscriptions', influencer_name, res.data.influencer_info, true, id, 'collection');                     
                           }
                        }
                     )
                  }
            } else if (!this.props.creator_preview && !this.props.isSubscribed && res.data.is_me) {
               if (this.props.current_page_view) {
                  if (String(searchParams.get("open_help")) === 'true'){
                     this.props.navigate('?page='+this.props.current_page_view+'&open_help=true')
                  } else {
                     this.props.navigate('?page='+this.props.current_page_view)
                  }
                  this.handleTabNavigation(this.props.current_page_view, influencer_name, res.data.influencer_info);
               } else {
                  if (String(searchParams.get("open_help")) === 'true'){
                     if (this.state.deviceWidth >= 1280){
                        this.props.navigate('?page=home&open_help=true')
                     } else {
                        this.props.navigate('?page=platform&open_help=true')
                     }
                  } else {
                     this.props.navigate('?page=home')                     
                  }
                  this.handleTabNavigation('home');
               }
            }
         }
         let open_sub = searchParams.get("open_sub");
         let tier = searchParams.get("tier");
         let single_tier = searchParams.get("single_tier");
         let open_sub_bool = true
         let initialSubscribePopupDuration = String(searchParams.get('duration'));
         // add duration type if not null
         if (String(open_sub) === 'true'){
            this.setState({
               subscribe_popup_icon_image: res.data.influencer_info.icon_image,
               subscribe_popup_influencer: res.data.influencer_info.influencer,
               subscribe_popup_influencer_name: res.data.influencer_info.influencer_name,
               subscribe_popup_current_tier: res.data.influencer_info.current_tier,
               subscribe_popup_async_tier_access: res.data.influencer_info.async_tier_access,
               subscribe_popup_minimum_tier: '',
               initialSubscribePopupDuration: initialSubscribePopupDuration,
            })
            if (tier){
               if (
                  (
                     (tier === '1') 
                     && (res.data.influencer_info_first.bronze_active === true)
                  ) || (
                     (tier === '2') 
                     && (res.data.influencer_info_first.silver_active === true)
                  ) || (
                     (tier === '3') 
                     && (res.data.influencer_info_first.gold_active === true)
                  ) || (
                     (tier === '4') 
                     && (res.data.influencer_info_first.async_active === true)
                     && (res.data.influencer_info_first.async_tier_hidden === false)
                  ) || (
                     (tier === '4') 
                     && (res.data.influencer_info_first.async_active === true)
                     && (res.data.influencer_info_first.async_tier_hidden === true)
                     && (String(single_tier) === 'true')
                  )
               ){
                  this.setState({subscribe_popup_initial_selected_tier: Number(tier)})
                  if (
                     (tier === '4') 
                     && (res.data.influencer_info_first.async_active === true)
                     && (res.data.influencer_info_first.async_tier_hidden === true)
                     && (String(single_tier) === 'true')
                  ) {
                     this.setState({subscribe_popup_async_tier_hidden: false})
                  }
               } else {
                  window.location.assign('/'+res.data.influencer_info.influencer)
                  open_sub_bool = false
               }
            }
            if (String(single_tier) === 'true'){
               this.setState({subscribe_popup_single_tier: true})
            }
            if (open_sub_bool === true){
               this.setState({subscribe_popup_open: true})
            }
         }
         let open_checkout = searchParams.get('open_checkout')
         if (open_checkout === 'true'){
            let tier_num = Number(searchParams.get('tier'))
            let duration = String(searchParams.get('duration'))
            if (
               (
                  (tier_num === 1) 
                  && (res.data.influencer_info_first.bronze_active === true)
               ) || (
                  (tier_num === 2) 
                  && (res.data.influencer_info_first.silver_active === true)
               ) || (
                  (tier_num === 3) 
                  && (res.data.influencer_info_first.gold_active === true)
               ) || (
                  (tier_num === 4) 
                  && (res.data.influencer_info_first.async_active === true)
               )
            ){
               if (tier_num === 1){
                  if ((duration === 'monthly') && (res.data.influencer_info_first.bronze_monthly_active === false)){
                     duration = 'yearly'
                  } else if ((duration === 'yearly') && (res.data.influencer_info_first.bronze_annual_active === false)){
                     duration = 'monthly'
                  } else if (duration === 'null'){
                     if (res.data.influencer_info_first.bronze_annual_active === true){
                        duration = 'yearly'
                     } else {
                        duration = 'monthly'
                     }
                  }
               } else if (tier_num === 2){
                  if ((duration === 'monthly') && (res.data.influencer_info_first.silver_monthly_active === false)){
                     duration = 'yearly'
                  } else if ((duration === 'yearly') && (res.data.influencer_info_first.silver_annual_active === false)){
                     duration = 'monthly'
                  } else if (duration === 'null'){
                     if (res.data.influencer_info_first.silver_annual_active === true){
                        duration = 'yearly'
                     } else {
                        duration = 'monthly'
                     }
                  }
               } else if (tier_num === 3){
                  if ((duration === 'monthly') && (res.data.influencer_info_first.gold_monthly_active === false)){
                     duration = 'yearly'
                  } else if ((duration === 'yearly') && (res.data.influencer_info_first.gold_annual_active === false)){
                     duration = 'monthly'
                  } else if (duration === 'null'){
                     if (res.data.influencer_info_first.gold_annual_active === true){
                        duration = 'yearly'
                     } else {
                        duration = 'monthly'
                     }
                  }
               } else if (tier_num === 4){
                  if ((duration === 'monthly') && (res.data.influencer_info_first.async_monthly_active === false)){
                     duration = 'yearly'
                  } else if ((duration === 'yearly') && (res.data.influencer_info_first.async_annual_active === false)){
                     duration = 'monthly'
                  } else if (duration === 'null'){
                     if (res.data.influencer_info_first.async_annual_active === true){
                        duration = 'yearly'
                     } else {
                        duration = 'monthly'
                     }
                  }
               }
               this.goToCheckout(tier_num, duration, promo_code, res.data.influencer_info.influencer)
            } else {
               window.location.assign('/'+res.data.influencer_info.influencer)
            }
         }
         let open_message_checkout = searchParams.get('open_message_checkout')
         if (open_message_checkout === 'true'){
            if (res.data.current_user === '') {
               window.location.assign('/login?post_url='+res.data.influencer_info.influencer+'&mode=dm')
            } else if (res.data.has_messages){
               this.handleProfileTabChange({}, 'paidDMs', null, null, true)
            } else {
               this.openDMCheckout(currency, res.data.influencer_info.influencer);
            }
         }
         let open_tip_checkout = searchParams.get('open_tip_checkout')
         let open_buy_now_checkout = searchParams.get('open_buy_now_checkout')
         let open_buy_collection_checkout = searchParams.get('open_buy_collection_checkout')
         if (open_tip_checkout === 'true'){
            if (res.data.current_user === '') {
               window.location.assign('/login?post_url='+res.data.influencer_info.influencer+'&mode=tip')
            } else {
               this.openTipCheckout(currency, res.data.influencer_info.influencer);
            }
         } else if (open_buy_now_checkout === 'true'){
            this.openBuyNowCheckout(currency, this.state.buyNowThumbnailUrl, this.state.buyNowTitle, this.state.buyNowContentType, content_id);
         } else if (open_buy_collection_checkout === 'true'){
            this.openBuyCollectionCheckout(currency, searchParams.get('id'));
         }
         window.addEventListener("resize", this.updatePredicate);
         this.updatePredicate();
         this.get_and_post_data_skeleton(
            paths.BACKEND_URL + "api/influencer/get_page_views/" + influencer_name,
            'get',
         )
         if (!res.data.is_me){
   
            if (String(waiting_list) !== 'true'){
               let open_community = searchParams.get("open_community");
               let open_coaching = searchParams.get("open_coaching");
               let open_messages = searchParams.get("open_messages");
               let open_collection = searchParams.get("open_collection");
               let coaching_member = searchParams.get("coaching_member");
               this.setState({post_id: searchParams.get('post_id')})
               if (String(open_community) === 'true'){
                  this.setState({selected_tab: 'community'})
               }
               if (String(open_messages) === 'true'){
                  this.setState({
                     open_messages: true,
                  })
                  setTimeout(() => {
                     this.handleProfileTabChange({}, 'paidDMs', null, null, true)
                  }, 200);
                  if (coaching_member != undefined){
                     this.setState({selectedMemberTabOverwrite: coaching_member})
                  }
               }
               if (String(open_coaching) === 'true'){
                  this.setState({
                     open_coaching: true,
                  })
                  this.setState({selected_tab: 'dashboard'})
                  if (coaching_member != undefined){
                     this.setState({selectedMemberTabOverwrite: coaching_member})
                  }
               }
               if (String(open_collection) === 'true'){
                  this.setState({
                     selected_tab: 'collections',
                     open_collection: true,
                     selected_page_view: searchParams.get('id'),
                  })
               }
               this.setState({inf_scroll_loading: true})
               const form_data = new FormData();
               form_data.append('influencer_str', influencer_name)
               form_data.append('category', 'all')
               form_data.append('sort', 'latest')
               form_data.append('content_type', 'all')
               form_data.append('tab', String(open_collection) === 'true' ? 'collections': String(open_community) === 'true' ? 'community': String(open_coaching) === 'true' ? 'async' : String(open_messages) === 'true' ? 'paidDMs' : '')
               form_data.append('collection', '')
               form_data.append('post_id', this.state.initial_content_id)
               form_data.append('page_n', this.state.page_n)
               form_data.append('currency', this.state.currency)
               form_data.append('tier', this.state.tier_filter)
               this.get_and_post_data_skeleton(
                  paths.BACKEND_URL + "api/influencer_content_data_latest_v7",
                  'post',
                  false,
                  form_data,
                  this.setContentPost,
               )
            }
            const time = performance.now() - this.metricLoadStart;
   
            const memberData = new FormData()
            if (this.state.selectedMemberTabOverwrite !== null){
               memberData.append('member', this.state.selectedMemberTabOverwrite)
            }
   
            logNavigation(time);
         }
      })
      // this.get_and_post_data_skeleton(
      //    paths.BACKEND_URL + "api/influencer_page_initial_data/" + this.props.params.influencer_name+'/'+waiting_list,
      //    'get',
      //    false,
      //    {},
      //    null,
      //    false,
      //    false,
      //    null,
      //    true,
      // )

   }

   componentWillUnmount() {
      window.removeEventListener('beforeunload', this.handleBeforeUnload);
      window.removeEventListener("scroll", this.handleScroll);
      window.removeEventListener("resize", this.handleWindowResize);
   }


   handleWindowResize = () => {
      this.setState({ isMobile: window.innerWidth <= 900 });
      if (window.innerWidth > 900) {
         this.setState({
            customiseMode: false
         })
      }
   };


   handleBeforeUnload(event) {
      const {
         influencerDisplayNameUpdated,
         influencerDescriptionUpdated,
         influencerIconUpdated,
         influencerBannerUpdated,
         influencerVideoUpdated,
      } = this.state;
      if (
         influencerDisplayNameUpdated !== null ||
         influencerDescriptionUpdated !== null ||
         influencerIconUpdated !== '' ||
         influencerBannerUpdated !== '' ||
         influencerVideoUpdated !== ''
      ) {
         const warningMessage = 'You have unsaved changes. Are you sure you want to leave?';
         event.returnValue = warningMessage;
         return warningMessage;
      }
      return null;
   }


   // Saved to saved section
   handleSavedContent = () => {
      if (this.state.current_user !== '') {
         this.setState({
            refreshing_content_data: true,
            snackbarSaveText: 'This post has been added to your saved section',
            snackbarRemoveSaved: false,
            snackbarSaved: true,
         })
      }
   }

   // Removed from saved section
   handleRemoveSavedContent = () => {
      if (this.state.current_user !== '') {
         this.setState({
            refreshing_content_data: true,
            snackbarSaveText: 'This post has been removed from your saved section',
            snackbarSaved: false,
            snackbarRemoveSaved: true
         })
      }
   }



   getAsyncStatus = (influencerName, currentUser) => {
      const memberData = new FormData()
      memberData.append('post_id', null);
      if (this.state.selectedMemberTabOverwrite !== null) {
         memberData.append('member', this.state.selectedMemberTabOverwrite)
      }
      axios(
         {
            method: 'POST',
            url: paths.BACKEND_URL + "api/influencer/async/initial_load_v2/" + influencerName + '/' + currentUser,
            data: memberData,
            headers: {
               'Content-type': 'application/json',
            },
            withCredentials: true
         })
         .then(
            res => {
               if (res.data.tier_4_members.length === 0) {
                  this.setState({hasAsyncMembers: false})
               } else {
                  this.setState({hasAsyncMembers: true})
               }
            })
         .catch(error => {
         })
   }


   handleContentModalOpen = (id) => {
      let content_info = ''
      if (this.state.single_view_collection === '' && (this.state.selected_tab === 'sub_collections' || this.state.selected_tab === 'paid_collections' || this.state.selected_tab === 'collections')) {
         for (let i = 0; i < this.state.influencer_content_list.length; i++) {
            const contentIndex = this.state.influencer_content_list[i]['data'].findIndex(content => content.id == id);
            if (contentIndex !== -1) {
               content_info = this.state.influencer_content_list[i]['data'][contentIndex]
               break
            }
         }
      } else {
         const contentIndex = this.state.influencer_content_list.findIndex(content => content.id == id);
         if (contentIndex !== -1) {
            content_info = this.state.influencer_content_list[contentIndex]
         }
      }
      let new_content_info = {
         file: '',
         name: content_info.name,
         current_tier: '',
         tier: content_info.tier,
         id: content_info.id,
         influencer: this.state.influencer_info.influencer,
         influencer_name: this.state.influencer_info.influencer_name,
         content_type: content_info.content_type,
         category: content_info.category,
         text: content_info.text,
         icon_image_file: content_info.icon_image_file,
         thumbnail: content_info.thumbnail,
         is_me: this.state.is_me,
         content_like: content_info.content_like,
         is_favourite: content_info.is_favourite,
         n_likes: content_info.n_likes,
         description: content_info.description,
         added: content_info.added,
      }
      this.setState({
         content_info: new_content_info,
         contentModalOpen: true,
         content_loading: true,
      })
   }
   handleContentModalClose = () => {
      this.setState({
         content_info: {
            file: '',
            name: '',
            current_tier: '',
            tier: '',
            id: '',
            influencer: '',
            influencer_name: '',
            content_type: '',
            category: '',
            text: '',
            icon_image_file: '',
            is_me: '',
            thumbnail: '',
            content_like: '',
            is_favourite: '',
            description: '',
            n_likes: '',
            added: '',
         },
         contentModalOpen: false,
      })
      window.history.pushState(null, '/' + this.state.influencer_info.influencer, '/' + this.state.influencer_info.influencer);
   }


   updatePredicate() {
      // Pause desktop banner video on mobile resize
      if (window.innerWidth < 900 && document.querySelector('.desktop_banner_video')) {
         document.querySelector('.desktop_banner_video').querySelector('video').pause()
      }
      // Pauses videos on mobile resize
      // else if (!window.innerWidth < 900) {
      //    let videos = document.querySelectorAll('video')
      //    for (let i=0; i<videos.length; i++) {
      //       videos[i].pause()
      //    }
      // }
      this.setState({ isExtraSmallDevice: window.innerWidth < 600 });
      this.setState({ isSmallDevice: ((window.innerWidth >= 600) && (window.innerWidth < 900)) });
      // this.setState({ isMediumDevice: window.innerWidth > 600 });
      this.setState({ isMediumDevice: ((window.innerWidth >= 900) && (window.innerWidth < 1280)) });
      this.setState({ isLargeDevice: window.innerWidth >= 1280 && (window.innerWidth < 1536) });
      this.setState({ isXLargeDevice: window.innerWidth >= 1536 })
      this.setState({
         deviceWidth: window.innerWidth
      })
   }

   preUploadTimeoutSetup() {
      this.setState({ controller: new AbortController() })
      // setup timeout check
      this.setState({ timeoutTimer: Date.now() / 1000 }, () => {
         const timeOutInterval = setInterval(() => {
            if (Date.now() / 1000 - this.state.timeoutTimer >= 60) {
               // Timed out
               if (this.state.uploadPercent < 0 && this.state.uploadPercent !== 100) {
                  // If uploading to s3, abort the upload
                  this.state.controller.abort()
               }
               this.setState({
                  isUploading: false,
                  fileSize: 0,
                  uploadError: true,
                  snackbarAutoHide: 6000
               })
               clearInterval(timeOutInterval)
            } else if (!this.state.isUploading) {
               // Upload finished or error occurred
               clearInterval(timeOutInterval)
            } else if (this.state.prevPercent !== this.state.uploadPercent) {
               // Reset timer
               this.setState({ timeoutTimer: Date.now() / 1000 })
               // Update prevPercent
               this.setState({ prevPercent: this.state.uploadPercent })
            }
         }, 1000);
      })
   }


   handleCustomCreatorLogoModalOpen = () => {

      this.setState({
         logoSquareFileNew: this.state.currentLogoFile !== null ? this.state.logoSquareFile : '',
         logoRectangleFileNew: this.state.currentLogoFile !== null ? this.state.logoRectangleFile : '',
         currentLogoFile: '',
         // currentLogoFile: (this.state.logoSquareFile === '' && this.state.logoRectangleFile === '') ?
         //    null : (window.innerWidth < 1280 ? this.state.logoSquareFile :
         //       (this.state.logoRectangleFile !== '' ? this.state.logoRectangleFile : this.state.logoSquareFile)),
         customCreatorLogoModalOpen: true,
      })
   }

   handleCustomCreatorLogoModalClose = () => {
      this.setState({
         currentLogoFile: null,
         customCreatorLogoModalOpen: false,
         // logoSquareFileNew: this.state.logoSquareFile,
         // logoRectangleFileNew: this.state.logoRectangleFile,
      })
   }


   saveChanges = () => {
      // determine how many things need updating
      if (((this.state.influencerIconUpdated.split(/%..|./).length - 1) / 1e+6) < 4) {
         this.saveBannerChanges(
            this.state.influencerDisplayNameUpdated,
            this.state.influencerDescriptionUpdated,
            this.state.influencerIconUpdated,
            this.state.influencerIconUpdatedLoading,
            this.state.influencerBannerUpdatedFile,
            this.state.influencerVideoUpdatedFile,
            this.state.videoRemoved,
            () => {
               if (this.state.influencerBannerUpdated !== '') {
                  this.setState({
                     influencerBanner: this.state.influencerBannerUpdated,
                  })
               }
               if (this.state.influencerVideoUpdated !== '') {
                  this.setState({
                     influencerVideo: this.state.influencerVideoUpdated,
                  })
               }
               this.setState({
                  influencerDisplayNameUpdated: null,
                  influencerDescriptionUpdated: null,
                  // influencerIconUpdated: '',
                  influencerIconUpdatedLoading: false,
                  // influencerBannerUpdated: '',
                  influencerVideoUpdated: '',
                  influencerBannerUpdatedFile: '',
                  influencerVideoUpdatedFile: '',
               })
               // this.loadInitialInfluencerData();
            }
         );
      } else {
         this.setState({
            snackbar: true,
            errorMsg: 'Profile image must be smaller than 4MB after processing.',
         })
      }
   }


   async saveBannerChanges(
      influencerDisplayNameUpdated,
      influencerDescriptionUpdated,
      influencerIconUpdated,
      influencerIconUpdatedLoading,
      influencerBannerUpdatedFile,
      influencerVideoUpdatedFile,
      videoRemoved,
      updateFunction,
   ) {

      let steps_to_update = []
      let steps_to_take = 0
      if (influencerDisplayNameUpdated !== null) {
         steps_to_update.push('display_name')
         steps_to_take += 1
      }
      if (influencerDescriptionUpdated !== null) {
         steps_to_update.push('description')
         steps_to_take += 1
      }
      if (influencerIconUpdatedLoading) {
         steps_to_update.push('icon_image')
         steps_to_take += 1
      }
      if (influencerBannerUpdatedFile !== '') {
         steps_to_update.push('banner_image')
         steps_to_take += 3
      }
      if (influencerVideoUpdatedFile !== '') {
         steps_to_update.push('banner_video')
         steps_to_take += 3
      }
      if ((videoRemoved === true) & (influencerVideoUpdatedFile === '')) {
         steps_to_update.push('banner_video_removal')
         steps_to_take += 1
      }
      let current_step = 1
      this.setState({ uploadPercent: 0, uploadComplete: false, timeRemaining: null, uploadError: false })
      // Mutes banner video so no sound is playing while user is locked out of interacting
      try {
         const bannerVideo = document.querySelector('video')
         bannerVideo.muted = true
      } catch (error) {
      }
      // update the display name
      if (steps_to_update.includes('display_name')) {
         this.setState({
            isUploading: true,
            uploadPercent: 0,
            uploadMessage: 'Updating display name...',
            uploadStep: 'Step ' + current_step + ' of ' + String(steps_to_take),
            fileSize: 0,
            uploadStartTime: null,
         })
         const data = new FormData()
         data.append('display_name', decode(influencerDisplayNameUpdated))
         await axios({
            method: 'post',
            url: paths.BACKEND_URL + 'api/influencer/update_display_name',
            data: data,
            headers: {
               'Content-type': 'application/json',
            },
            withCredentials: true
         })
         this.setState({
            isUploading: true,
            uploadPercent: 100,
            uploadMessage: 'Updating display name...',
            uploadStep: 'Step ' + current_step + ' of ' + String(steps_to_take),
            fileSize: 0,
            uploadStartTime: null,
         })
         current_step += 1
      }
      // update the description
      if (steps_to_update.includes('description')) {
         this.setState({
            isUploading: true,
            uploadPercent: 0,
            uploadMessage: 'Updating description...',
            uploadStep: 'Step ' + current_step + ' of ' + String(steps_to_take),
            fileSize: 0,
            uploadStartTime: null,
         })
         const data = new FormData()
         data.append('description', decode(influencerDescriptionUpdated))
         await axios({
            method: 'post',
            url: paths.BACKEND_URL + 'api/influencer/edit',
            data: data,
            headers: {
               'Content-type': 'application/json',
            },
            withCredentials: true
         });
         this.setState({
            isUploading: true,
            uploadPercent: 100,
            uploadMessage: 'Updating description...',
            uploadStep: 'Step ' + current_step + ' of ' + String(steps_to_take),
            fileSize: 0,
            uploadStartTime: null,
         })
         current_step += 1;
         let index = this.state.missingProfiles.indexOf('Short Bio')
         if (index > -1) {
            let new_missing_profiles = [...this.state.missingProfiles]
            new_missing_profiles.splice(index, 1)
            this.setState({
               missingProfiles: new_missing_profiles
            })
            if (new_missing_profiles.length === 0) {
               this.setState({ setupProfile: true })
            }
         }
      }


      // icon image
      if (steps_to_update.includes('icon_image')) {
         this.setState({
            isUploading: true,
            uploadPercent: 0,
            uploadMessage: 'Uploading icon image...',
            uploadStep: 'Step ' + current_step + ' of ' + String(steps_to_take),
            fileSize: 0,
            uploadStartTime: null,
         })
         const form_data = new FormData();
         form_data.append('icon_image', influencerIconUpdated);
         const response = await axios({
            method: 'post',
            url: paths.BACKEND_URL + 'api/settings_post_processing/',
            data: form_data,
            withCredentials: true,
            maxContentLength: 100000000,
            maxBodyLength: 1000000000,
         });
         this.setState({
            isUploading: true,
            uploadPercent: 100,
            uploadMessage: 'Uploading icon image...',
            uploadStep: 'Step ' + current_step + ' of ' + String(steps_to_take),
            fileSize: 0,
            uploadStartTime: null,
            current_user_icon: response.data.current_user_icon,
         })
         current_step += 1;
         let index = this.state.missingProfiles.indexOf('profile photo')
         if (index > -1) {
            let new_missing_profiles = [...this.state.missingProfiles]
            new_missing_profiles.splice(index, 1)
            this.setState({
               missingProfiles: new_missing_profiles
            })
            if (new_missing_profiles.length === 0) {
               this.setState({ setupProfile: true })
            }
         }
      }
      // banner image
      if (steps_to_update.includes('banner_image')) {
         this.setState({
            isUploading: true,
            uploadPercent: 0,
            uploadMessage: 'Preparing banner image...',
            uploadStep: 'Step ' + current_step + ' of ' + String(steps_to_take),
            fileSize: 0,
            uploadStartTime: null,
         })
         this.preUploadTimeoutSetup()
         const form_data = new FormData();
         form_data.append('content_type', influencerBannerUpdatedFile.type)
         form_data.append('file_size', influencerBannerUpdatedFile.size)
         this.state.timeRemainingInterval && clearInterval(this.state.timeRemainingInterval)
         this.setState({ timeRemainingInterval: null })
         try {
            const response = await axios({
               method: 'post',
               url: paths.BACKEND_URL + 'api/influencer/edit/banner',
               data: form_data,
               withCredentials: true
            });
            current_step += 1;
            this.setState({
               uploadPercent: 0,
               uploadMessage: 'Uploading banner image...',
               uploadStep: 'Step ' + current_step + ' of ' + String(steps_to_take),
            })
            const r =
               await axios.put(response.data.upload_uri, influencerBannerUpdatedFile, {
                  headers: {
                     'Content-Type': influencerBannerUpdatedFile.type
                  },
                  signal: this.state.controller.signal,
                  onUploadProgress: progressEvent => {
                     if (this.state.fileSize === 0) {
                        this.setState({ uploadStartTime: Date.now() })
                        this.setState({ fileSize: progressEvent.total }, () => {
                           const networkCheck = setInterval(() => {
                              !this.state.timeRemainingInterval && this.setState({ timeRemainingInterval: networkCheck })
                              this.setState({
                                 uploadSpeeds: [...this.state.uploadSpeeds,
                                 (this.state.uploadPercent * this.state.fileSize) / (100 * (Date.now() - this.state.uploadStartTime))
                                 ]
                              }, () => {
                                 if (this.state.uploadSpeeds.length >= 3 && this.state.uploadPercent !== 100) {
                                    const speedsArr = [...this.state.uploadSpeeds]
                                    const uploadSpeedAvg = speedsArr.reduce((a, b) => a + b, 0) / speedsArr.length
                                    const remainingBytes = this.state.fileSize * (1 - this.state.uploadPercent / 100)
                                    const secondsRemaining = 0.001 * remainingBytes / uploadSpeedAvg
                                    this.setState({ timeRemaining: Math.round(secondsRemaining) })
                                 }
                              })
                              if (this.state.uploadPercent === 100) {
                                 clearInterval(networkCheck)
                              }
                           }, 500)
                        })
                     }
                     let uploadString = ''
                     if (progressEvent.total >= 1048576) {
                        const uploadMB = Math.round(progressEvent.loaded / 1048576)
                        const totalSizeMB = Math.round(progressEvent.total / 1048576)
                        uploadString = `${uploadMB}MB of ${totalSizeMB}MB`
                     }
                     else if (progressEvent.total >= 1024) {
                        const uploadKB = Math.round(progressEvent.loaded / 1024)
                        const totalSizeKB = Math.round(progressEvent.total / 1024)
                        uploadString = `${uploadKB}KB of ${totalSizeKB}KB`
                     }
                     else {
                        const uploadBytes = Math.round(progressEvent.loaded)
                        const totalSizeBytes = Math.round(progressEvent.total)
                        uploadString = `${uploadBytes}Bytes of ${totalSizeBytes}Bytes`
                     }
                     if (Math.round(this.state.uploadPercent) === 100) {
                        return
                     }
                     this.setState({ uploadPercent: (progressEvent.loaded / progressEvent.total) * 100, uploadMessage: `Uploading image...(${uploadString})` })
                  }
               })
            current_step += 1;
            this.setState({
               uploadPercent: 100,
               uploadMessage: 'Processing image...',
               uploadStep: 'Step ' + current_step + ' of ' + String(steps_to_take),
               timeRemaining: 0,
            })
            const response2 = await axios({
               method: 'get',
               url: response.data.completed_uri,
               withCredentials: true
            });
            this.setState({
               uploadPercent: 100,
               uploadMessage: 'Finished',
               isUploading: false,
               fileSize: 0,
               uploadStartTime: null,
               banner_file: null
            })
            current_step += 1;
         }
         catch (err) {
            this.setState({
               isUploading: false,
               fileSize: 0,
               uploadError: true,
               snackbarAutoHide: 6000,

            })
            this.state.timeRemainingInterval && clearInterval(this.state.timeRemainingInterval)
            this.setState({ timeRemainingInterval: null })
            const error = err.response.data.error
            if (error === 'Invalid Type') {
               this.setState({
                  snackbarOpenUpload: true,
                  snackbarSeverityUpload: 'error',
                  errorMsgUpload: 'Invalid file type for image. Please upload an image with one of the following file types: jpeg, png, webpg ',
                  uploadErrorMsg: 'Invalid file type for image. Please upload an image with one of the following file types: jpeg, png, webpg ',

               })
            }
            else {
               this.setState({
                  snackbarOpenUpload: true,
                  snackbarSeverityUpload: 'error',
                  errorMsgUpload: 'Oops. There was an error while uploading. Retry and if the error persists refresh the page and try again.',
                  uploadErrorMsg: 'Oops. There was an error while uploading. Retry and if the error persists refresh the page and try again.',

               })
            }
            throw new Error('Server error')
         }
         let index = this.state.missingProfiles.indexOf('header photo')
         if (index > -1) {
            let new_missing_profiles = [...this.state.missingProfiles]
            new_missing_profiles.splice(index, 1)
            this.setState({
               missingProfiles: new_missing_profiles
            })
            if (new_missing_profiles.length === 0) {
               this.setState({ setupProfile: true })
            }
         }
      }
      // banner video
      if (steps_to_update.includes('banner_video')) {
         this.setState({
            isUploading: true,
            uploadPercent: 0,
            uploadMessage: 'Preparing banner video...',
            uploadStep: 'Step ' + current_step + ' of ' + String(steps_to_take),
            fileSize: 0,
            uploadStartTime: null,

         })
         this.preUploadTimeoutSetup();
         const form_data = new FormData();
         form_data.append('content_type', influencerVideoUpdatedFile.type)
         form_data.append('file_size', influencerVideoUpdatedFile.size)
         const file = influencerVideoUpdatedFile
         let multipartUpload = false
         multipartUpload = !(window.location.host.includes('localhost')) && file.size > 100 * Math.pow(1024, 2) // 100MB
         if (multipartUpload) {
            form_data.append('upload_type', 'multipart')
         }
         else {
            form_data.append('upload_type', 'single')
         }
         // Setup for Multipart uploads
         let uploadId = ''
         let presignedUrls = []
         let fileKey = ''
         const partSize = 10 * 1024 * 1024; // 10MB part size
         const parts = Math.ceil(file.size / partSize);
         let partsProgress = new Array(parts).fill(0)
         let etags = new Array(parts)
         form_data.append('num_parts', parts)
         this.state.timeRemainingInterval && clearInterval(this.state.timeRemainingInterval)
         this.setState({ timeRemainingInterval: null, timeRemaining: null })
         this.state.progressInterval && clearInterval(this.state.progressInterval)
         const outer = this
         async function abortMultipartUpload(initial) {
            try {
               if (initial) {
                  outer.state.progressInterval && clearInterval(outer.state.progressInterval)
                  outer.setState({
                     snackbarOpenUpload: true,
                     snackbarSeverityUpload: 'error',
                     errorMsgUpload: 'Oops. There was an error while uploading. Retry and if the error persists refresh the page and try again.',
                     uploadErrorMsg: 'Oops. There was an error while uploading. Retry and if the error persists refresh the page and try again.',
                  })
                  outer.state.controller.abort()
               }
               let fd = new FormData()
               fd.append('key', fileKey)
               fd.append('uploadId', uploadId)
               const res2 = await axios({
                  method: 'post',
                  url: paths.BACKEND_URL + 'api/abort_multipart_upload/',
                  data: fd,
                  withCredentials: true
               });
            }
            catch {
               setTimeout(() => {
                  abortMultipartUpload(false)
               }, 2000);
            }
         }
         async function uploadPart(partNumber, partSize) {
            const start = partNumber * partSize;
            const end = Math.min(start + partSize, file.size);
            const chunk = file.slice(start, end);
            const url = presignedUrls[partNumber];
            const chunkSize = end - start;
            const maxRetries = 5;

            for (let retry = 0; retry < maxRetries; retry++) {
               try {
                  const r = await axios.put(url, chunk, {
                     headers: {
                        'Content-Type': file.type,
                     },
                     onUploadProgress: progressEvent => {
                        partsProgress[partNumber] = (progressEvent.loaded / progressEvent.total) * chunkSize;
                     },
                     signal: outer.state.controller.signal
                  });

                  const etag = r.headers.etag;
                  etags[partNumber] = etag;
                  break; // Successful upload, exit the loop
               } catch (error) {
                  if (retry >= maxRetries - 1) {
                     // Handle the failure, log, or take further action as needed
                     return Promise.reject(`Max retries reached for chunk ${partNumber + 1}`)
                  }
                  else {
                     // Wait for a moment before retrying
                     await new Promise(resolve => setTimeout(resolve, 1000));
                  }
               }
            }
         }
         try {
            const response = await axios({
               method: 'post',
               url: paths.BACKEND_URL + 'api/influencer/edit/intro',
               data: form_data,
               withCredentials: true,
            });
            current_step += 1;
            this.setState({
               uploadPercent: 0,
               uploadMessage: 'Uploading banner video...',
               uploadStep: 'Step ' + current_step + ' of ' + String(steps_to_take),
            })
            multipartUpload = response.data.multipart
            if (multipartUpload) {
               presignedUrls = response.data.urls
               uploadId = response.data.uploadId
               fileKey = response.data.fileKey
               const uploadPromises = [];
               for (let i = 0; i < parts; i++) {
                  uploadPromises.push(uploadPart(i, partSize));
               }
               const progressInterval = setInterval(() => {
                  const progress = partsProgress.reduce((a, b) => a + b, 0)
                  const percent = 100 * progress / parts
                  if (this.state.fileSize === 0) {
                     // Only runs once
                     this.setState({
                        uploadSpeeds: [],
                        progressInterval: progressInterval,
                        uploadStartTime: Date.now(), timeOutTime: Date.now(),
                        timeRemaining: null
                     })
                     this.setState({ fileSize: file.size }, () => {
                        const networkCheck = setInterval(() => {
                           !this.state.timeRemainingInterval && this.setState({ timeRemainingInterval: networkCheck })
                           this.setState({
                              uploadSpeeds: [...this.state.uploadSpeeds,
                              (this.state.uploadPercent * this.state.fileSize) / (100 * (Date.now() - this.state.uploadStartTime))
                              ]
                           }, () => {
                              if (this.state.uploadSpeeds.length >= 3 && this.state.uploadPercent !== 100) {
                                 const speedsArr = [...this.state.uploadSpeeds]
                                 const uploadSpeedAvg = speedsArr.reduce((a, b) => a + b, 0) / speedsArr.length
                                 const remainingBytes = this.state.fileSize * (1 - this.state.uploadPercent / 100)
                                 const secondsRemaining = 0.001 * remainingBytes / uploadSpeedAvg
                                 this.setState({ timeRemaining: Math.round(secondsRemaining) })
                              }
                           })
                           if (this.state.uploadPercent === 100) {
                              clearInterval(networkCheck)
                           }
                        }, 500)
                     })
                  }

                  let uploadString = ''
                  if (file.size >= 1048576) {
                     const uploadMB = Math.round(progress / 1048576)
                     const totalSizeMB = Math.round(file.size / 1048576)
                     uploadString = `${uploadMB}MB of ${totalSizeMB}MB`
                  }
                  else if (file.size >= 1024) {
                     const uploadKB = Math.round(progress / 1024)
                     const totalSizeKB = Math.round(file.size / 1024)
                     uploadString = `${uploadKB}KB of ${totalSizeKB}KB`
                  }
                  else {
                     const uploadBytes = Math.round(progress)
                     const totalSizeBytes = Math.round(file.size)
                     uploadString = `${uploadBytes}Bytes of ${totalSizeBytes}Bytes`
                  }
                  this.setState({
                     uploadPercent: (progress / file.size) * 100,
                     uploadMessage: `Uploading...(${uploadString})`,
                  })
                  if (percent === 100) {
                     clearInterval(progressInterval)
                  }
               }, 300);

               // Upload parts in parallel
               await Promise.all(uploadPromises);

               clearInterval(progressInterval)
               const partsInfo = etags.map(({ ETag }, i) => ({
                  ETag: etags[i],
                  PartNumber: i + 1,
               }))
               let data = new FormData()
               data.append('key', fileKey)
               data.append('uploadId', uploadId)
               data.append('partsInfo', partsInfo)
               data.append('etags', etags)
               const res2 = await axios({
                  method: 'post',
                  url: paths.BACKEND_URL + 'api/complete_multipart_upload/',
                  data: data,
                  withCredentials: true
               });
            }
            else {
               const r =
                  await axios.put(response.data.upload_uri, influencerVideoUpdatedFile, {
                     headers: {
                        'Content-Type': influencerVideoUpdatedFile.type
                     },
                     signal: this.state.controller.signal,
                     onUploadProgress: progressEvent => {
                        if (this.state.fileSize === 0) {
                           this.setState({ uploadSpeeds: [] })
                           this.setState({ uploadStartTime: Date.now() })
                           this.setState({ timeRemaining: null })
                           this.setState({ fileSize: progressEvent.total }, () => {
                              const networkCheck = setInterval(() => {
                                 !this.state.timeRemainingInterval && this.setState({ timeRemainingInterval: networkCheck })
                                 this.setState({
                                    uploadSpeeds: [...this.state.uploadSpeeds,
                                    (this.state.uploadPercent * this.state.fileSize) / (100 * (Date.now() - this.state.uploadStartTime))
                                    ]
                                 }, () => {
                                    if (this.state.uploadSpeeds.length >= 3 && this.state.uploadPercent !== 100) {
                                       const speedsArr = [...this.state.uploadSpeeds]
                                       const uploadSpeedAvg = speedsArr.reduce((a, b) => a + b, 0) / speedsArr.length
                                       const remainingBytes = this.state.fileSize * (1 - this.state.uploadPercent / 100)
                                       const secondsRemaining = 0.001 * remainingBytes / uploadSpeedAvg
                                       this.setState({ timeRemaining: Math.round(secondsRemaining) })
                                    }
                                 })
                                 if (this.state.uploadPercent === 100) {
                                    clearInterval(networkCheck)
                                 }
                              }, 500)
                           })
                        }
                        let uploadString = ''
                        if (progressEvent.total >= 1048576) {
                           const uploadMB = Math.round(progressEvent.loaded / 1048576)
                           const totalSizeMB = Math.round(progressEvent.total / 1048576)
                           uploadString = `${uploadMB}MB of ${totalSizeMB}MB`
                        }
                        else if (progressEvent.total >= 1024) {
                           const uploadKB = Math.round(progressEvent.loaded / 1024)
                           const totalSizeKB = Math.round(progressEvent.total / 1024)
                           uploadString = `${uploadKB}KB of ${totalSizeKB}KB`
                        }
                        else {
                           const uploadBytes = Math.round(progressEvent.loaded)
                           const totalSizeBytes = Math.round(progressEvent.total)
                           uploadString = `${uploadBytes}Bytes of ${totalSizeBytes}Bytes`
                        }
                        if (Math.round(this.state.uploadPercent) === 100) {
                           return
                        }
                        this.setState({ uploadPercent: (progressEvent.loaded / progressEvent.total) * 100, uploadMessage: `Uploading video...(${uploadString})` })
                     }
                  })
            }

            current_step += 1;
            this.setState({
               uploadPercent: 100,
               uploadMessage: 'Processing banner video...',
               uploadStep: 'Step ' + current_step + ' of ' + String(steps_to_take),
               timeRemaining: 0
            })
            const response2 = await axios({
               method: 'get',
               url: response.data.completed_uri,
               withCredentials: true
            });
            // 1. Make a shallow copy of the items
            let influencer_info = this.state.influencer_info;
            // 3. Replace the property you're intested in
            influencer_info['intro_video_path'] = response2.data.file_name
            // 5. Set the state to our new copy
            this.setState({ influencer_info: influencer_info });
            this.setState({
               uploadPercent: 100,
               uploadMessage: 'Video uploaded',
               isUploading: false,
               fileSize: 0,
               uploadStartTime: null,
               header_file: null,
            })
            current_step += 1;
         }


         catch (err) {
            this.setState({
               isUploading: false,
               fileSize: 0,
               uploadError: true,
               snackbarAutoHide: 6000
            })
            if (multipartUpload) {
               this.state.progressInterval && clearInterval(this.state.progressInterval)
               abortMultipartUpload(true)
            }
            this.state.timeRemainingInterval && clearInterval(this.state.timeRemainingInterval)
            this.setState({ timeRemainingInterval: null })
            const error = err.response?.data?.error
            if (error === 'Invalid Type') {
               this.setState({
                  snackbarOpenUpload: true,
                  snackbarSeverityUpload: 'error',
                  errorMsgUpload: 'Invalid file type for video. Please upload a video with one of the following file types: mp4, mov ',
                  uploadErrorMsg: 'Invalid file type for video. Please upload a video with one of the following file types: mp4, mov ',
               })
            }
            else {
               this.setState({
                  snackbarOpenUpload: true,
                  snackbarSeverityUpload: 'error',
                  errorMsgUpload: 'Oops. There was an error while uploading. Retry and if the error persists refresh the page and try again.',
                  uploadErrorMsg: 'Oops. There was an error while uploading. Retry and if the error persists refresh the page and try again.',
               })
            }
            throw new Error('Server error')
         }
      }
      if (steps_to_update.includes('banner_video_removal')) {
         this.setState({
            isUploading: true,
            uploadPercent: 0,
            uploadMessage: 'Removing intro video...',
            uploadStep: 'Step ' + current_step + ' of ' + String(steps_to_take),
            fileSize: 0,
            uploadStartTime: null,
         })
         axios(
            {
               method: 'get',
               url: paths.BACKEND_URL + 'api/influencer/set_intro_video_to_none',
               headers: {
                  'Content-type': 'application/json',
               },
               withCredentials: true
            }
         )
         this.setState({
            isUploading: false,
            uploadPercent: 100,
            uploadMessage: 'Removing video...',
            uploadStep: 'Step ' + current_step + ' of ' + String(steps_to_take),
            fileSize: 0,
            uploadStartTime: null,
         })
         current_step += 1;
      }
      this.setState({
         uploadComplete: true,
         isUploading: false,
         uploadPercent: 0,
         uploadMessage: 'Updating description...',
         uploadStep: 'Step ' + current_step + ' of ' + String(steps_to_take),
         fileSize: 0,
         uploadStartTime: null,

      })
      if ((influencerDisplayNameUpdated !== null) || (influencerDescriptionUpdated !== null)) {
         let new_influencer_info = { ...this.state.influencer_info };
         if (influencerDisplayNameUpdated !== null) {
            new_influencer_info['influencer_name'] = influencerDisplayNameUpdated
         }
         if (influencerDescriptionUpdated !== null) {
            new_influencer_info['description'] = influencerDescriptionUpdated
         }
         this.setState({ influencer_info: new_influencer_info })
      }
      // update intercom
      if (influencerDisplayNameUpdated !== null) {
         window.Intercom('boot', {
            app_id: INTERCOM_APP_ID,
            api_base: "https://api-iam.intercom.io",
            name: this.state.current_user,
            email: this.state.user_email,
            user_hash: this.state.intercom_verify_key,
            "is_influencer": true,
            "is_logged_in": true,
            "onboarding_display_name_added": true,
         });
      }
      if (influencerDescriptionUpdated !== null) {
         window.Intercom('boot', {
            app_id: INTERCOM_APP_ID,
            api_base: "https://api-iam.intercom.io",
            name: this.state.current_user,
            email: this.state.user_email,
            user_hash: this.state.intercom_verify_key,
            "is_influencer": true,
            "is_logged_in": true,
            "onboarding_bio_added": true,
         });
      }
      if (influencerIconUpdated !== '') {
         window.Intercom('boot', {
            app_id: INTERCOM_APP_ID,
            api_base: "https://api-iam.intercom.io",
            name: this.state.current_user,
            email: this.state.user_email,
            user_hash: this.state.intercom_verify_key,
            "is_influencer": true,
            "is_logged_in": true,
            "onboarding_profile_picture_added": true,
         });
      }
      if (influencerBannerUpdatedFile !== '') {
         window.Intercom('boot', {
            app_id: INTERCOM_APP_ID,
            api_base: "https://api-iam.intercom.io",
            name: this.state.current_user,
            email: this.state.user_email,
            user_hash: this.state.intercom_verify_key,
            "is_influencer": true,
            "is_logged_in": true,
            "onboarding_profile_banner_added": true,
         });
      }
      if (influencerVideoUpdatedFile !== '') {
         window.Intercom('boot', {
            app_id: INTERCOM_APP_ID,
            api_base: "https://api-iam.intercom.io",
            name: this.state.current_user,
            email: this.state.user_email,
            user_hash: this.state.intercom_verify_key,
            "is_influencer": true,
            "is_logged_in": true,
            "onboarding_profile_video_added": true,
         });
      }
      if (!this.state.influencer_launched) {
         let pipedrive_data = new FormData();
         pipedrive_data.append('case', 'banner')
         axios({
            method: 'post',
            url: paths.BACKEND_URL + 'api/influencer/update_pipdedrive_onboarding_deals',
            data: pipedrive_data,
            headers: {
               'Content-type': 'application/json',
            },
            withCredentials: true
         })
      }
      updateFunction();
      this.setState({
         snackbarOpenUpload: true,
         snackbarSeverityUpload: 'success',
         errorMsgUpload: 'Profile Updated Successfully',
      })

   }

   handleMobileSearchOpen = () => {
      this.setState({ mobileSearchOpen: true })
   }

   handleMobileSearchClose = () => {
      this.setState({ mobileSearchOpen: false })
   }




   //   TODO CREATE FUNCTION FOR WAITLIST IF MEMBERSHIP + CONTENT CHECKED OFF
   handleOpenSplashScreen = () => {
      this.setState({
         waitlistSplashScreenOpen: true
      })
   }


   handleCloseSplashScreen = () => {
      const url = new URL(window.location.href);
      // Send data to backend that it's been seen
      this.setState({
         waitlistSplashScreenOpen: false
      })

      if (url.searchParams.has('new_membership')) {
         url.searchParams.delete('new_membership');
         window.history.pushState({}, '', url);
      }
   }





   async ToggleEdit() {
      const updatePercent = (percent) => {
         this.setState({ uploadPercent: percent })
      }
      this.setState({ uploadPercent: 0, uploadComplete: false, timeRemaining: null, uploadError: false })
      // check description lengths
      new Promise((resolve, reject) => {
         const data = new FormData()
         data.append('description', decode(this.state.influencer_info.description))
         const startTime1 = performance.now();
         axios({
            method: 'post',
            url: paths.BACKEND_URL + 'api/influencer/edit',
            data: data,
            headers: {
               'Content-type': 'application/json',
            },
            // onUploadProgress(progressEvent) {
            //    const { loaded, total } = progressEvent;
            //    console.log(progressEvent)
            //    let percent = Math.floor((loaded * 100) / total);
            //    updatePercent(percent)
            //  },
            withCredentials: true
         }).finally(() => {
            logApiRequest(paths.BACKEND_URL + 'api/influencer/edit', performance.now() - startTime1)
         })
      });

      const doubleUpload = this.state.header_file && this.state.banner_file ? true : false
      const upload = this.state.header_file || this.state.banner_file ? true : false
      if (this.state.header_file) {
         this.preUploadTimeoutSetup()
         // Mutes banner video so no sound is playing while user is locked out of interacting
         const bannerVideo = document.querySelector('video')
         bannerVideo.muted = true
         this.setState({
            isUploading: true,
            uploadPercent: 0,
            uploadMessage: 'Preparing video...',
            uploadStep: doubleUpload ? 'Step 1 of 6:' : 'Step 1 of 3:',
            fileSize: 0,
            uploadStartTime: null,
         })
         await this.uploadInfluencerHeader(this.state.header_file, 'influencer_banner_video', doubleUpload)
      } else if (this.state.header_file === '') {
         this.setState({
            isUploading: true,
            uploadPercent: 0,
            uploadMessage: 'Removing video...',
            uploadStep: doubleUpload ? 'Step 1 of 4:' : 'Step 1 of 1:',
            fileSize: 0,
            uploadStartTime: null,
         })
         axios(
            {
               method: 'get',
               url: paths.BACKEND_URL + 'api/influencer/set_intro_video_to_none',
               headers: {
                  'Content-type': 'application/json',
               },
               withCredentials: true
            }
         )
         this.setState({
            isUploading: false,
            uploadPercent: 0,
            uploadMessage: 'Removing video...',
            uploadStep: doubleUpload ? 'Step 1 of 4:' : 'Step 1 of 1:',
            fileSize: 0,
            uploadStartTime: null,
         })
      }
      if (this.state.banner_file) {
         this.preUploadTimeoutSetup()
         // Mutes banner video so no sound is playing while user is locked out of interacting
         try {
            const bannerVideo = document.querySelector('video')
            bannerVideo.muted = true
         } catch (error) {

         }
         this.setState({
            isUploading: true,
            uploadPercent: 0,
            uploadMessage: 'Preparing image...',
            uploadStep: doubleUpload ? 'Step 4 of 6:' : 'Step 1 of 3',
            fileSize: 0,
            uploadStartTime: null,
         })
         await this.uploadInfluencerBanner(this.state.banner_file, 'influencer_banner_image', doubleUpload)
      }
      upload && this.setState({ uploadComplete: true })
   }

   OnInfluencerEditChange(evt, property_name) {
      if (this.state.influencer_info.hasOwnProperty(property_name)) {
         const update = this.state.influencer_info;
         update[property_name] = decode(evt);
         this.setState(update);
      }
   }


   openExampleCreatorsPopup = () => {
      this.setState({ open_example_creators: true })
   }

   openGetStartedModal = () => {
      this.setState({ getStartedModalOpen: true })
   }

   handleClearNewIcon = () => {
      this.setState({ influencerIconUpdated: '', influencerIconUpdatedLoading: false })
   }

   revertChanges = () => {
      // Logic to handle reverting changes
      // this.handleClearNewIcon()
      // e.g., resetting state or fetching original data

      this.setState({
         influencerDisplayNameUpdated: null,
         influencerDescriptionUpdated: null,
         influencerIconUpdated: '',
         influencerIconUpdatedLoading: false,
         influencerBannerUpdated: '',
         influencerVideoUpdated: '',
         revertImage: true,
         influencerVideo: this.state.influencer_info['intro_video_path'],
      });

   };

   get_and_post_data_skeleton = get_and_post_data_skeleton
   make_block_content_info = make_block_content_info
   make_single_influencer_row = make_single_influencer_row
   make_multi_content_grid_div = make_multi_content_grid_div
   like_button_click = like_button_click
   CloseSubscribePopup = CloseSubscribePopup
   CloseWaitingListPopup = CloseWaitingListPopup
   OpenSubscribePopup = OpenSubscribePopup
   OpenWaitingListPopup = OpenWaitingListPopup
   checkout_button = checkout_button
   bookmark_button_click = bookmark_button_click
   DowngradeSubInfoPopup = DowngradeSubInfoPopup
   UpgradeSubInfoPopup = UpgradeSubInfoPopup
   UpgradeSubscription = UpgradeSubscription
   DowngradeSubscription = DowngradeSubscription
   CloseSubscribePopupInfo = CloseSubscribePopupInfo
   DowngradeProcessPost = DowngradeProcessPost
   UpgradeProcessPost = UpgradeProcessPost
   update_filter_state = update_filter_state
   getSubpopupInfo = getSubpopupInfo
   postSubpopupInfo = postSubpopupInfo
   getGeoInfo = getGeoInfo
   uploadInfluencerHeader = uploadInfluencerHeader
   uploadInfluencerBanner = uploadInfluencerBanner




   // function to scroll to the top of influencertabsbar
   scrollToTopOfTabs = () => {
      if (this.tabsBarRef.current) {
         const topPosition = this.tabsBarRef.current.getBoundingClientRect().top + window.scrollY;
         window.scrollTo({ top: topPosition, behavior: 'smooth' });
      }
   }


   discordConnected = () => {
      const form_data = new FormData()
      form_data.append('influencer', this.state.influencer_name)
      axios({
         method: 'post',
         url: paths.BACKEND_URL + 'api/influencer/update_seen_discord_popup',
         data: form_data,
         headers: {
            'Content-type': 'application/json',
         },
         withCredentials: true
      });
      this.setState({ show_discord_popup: false });
      window.open('https://discord.com/channels/@me')
   }

   // Discord Not Connected -> Sign up
   discordNotConnected = () => {
      const form_data = new FormData()
      form_data.append('influencer', this.state.influencer_name)
      axios({
         method: 'post',
         url: paths.BACKEND_URL + 'api/influencer/update_seen_discord_popup',
         data: form_data,
         headers: {
            'Content-type': 'application/json',
         },
         withCredentials: true
      });
      this.setState({ show_discord_popup: false });
      window.open(`${paths.BACKEND_URL}oauth/login/discord`)
   }




   setNewPlaylistModal = (value) => {
      this.setState({ newPlaylistModal: value })
   }

   setNewCourseName = (value) => {
      this.setState({ newCourseName: value })
   }

   setNewCoursePriceActive = (value) => {
      this.setState({ newCoursePriceActive: value })
   }

   setNewCoursePriceStr = (value) => {
      this.setState({ newCoursePriceStr: value })
   }

   setNewCoursePrice = (value) => {
      this.setState({ newCoursePrice: value })
   }

   setNewCollectionShowMinBuyNowPriceError = (value) => {
      this.setState({ newCollectionShowMinBuyNowPriceError: value })
   }


   async addNewPlaylist(imageFile) {
      const data = new FormData();
      data.append('playlist_name', this.state.newCourseName);
      data.append('currency', this.state.currency);
      if (this.state.newCoursePriceActive) {
         data.append('price', this.state.newCoursePrice);
      }
      if (imageFile) {
         let thumbnail_base64 = ''
         thumbnail_base64 = await resizeImageFromFile(imageFile, 1920);
         data.append('thumbnail', thumbnail_base64)
      }
      axios({
         method: 'post',
         url: paths.BACKEND_URL + 'api/influencer/onboarding_new_playlist',
         data: data,
         headers: {
            'Content-type': 'application/json',
         },
         withCredentials: true
      }).then(
         res => {
            if (!res.data.access_denied) {

               if (!res.data.error) {
                  this.setState({
                     courseNames: res.data.course_name_possibilites,
                     single_view_collection: this.state.newCourseName,
                     newCourseName: '',
                     newPlaylistModal: false,
                     newCoursePrice: 299,
                     newCoursePriceStr: '2.99',
                     newCoursePriceActive: false,
                     mediaSettingsModal: true,
                     snackbar: true,
                     snackbarAutoHide: 4000,

                     snackbarSeverity: 'success',
                     errorMsg: `${this.props.current_page_view === 'platform' ? 'Course' : 'Collection'} Created Successfully`
                     //  Upload content to see this ${this.props.current_page_view === 'platform' ? 'course' : 'collection'} in your ${this.props.current_page_view === 'platform' ? 'course' : 'collection'} tab.`,

                  });
                  this.setNewPlaylistModal(false)
                  if (this.state.selected_tab === 'sub_collections'){
                     this.handleProfileTabChange('', 'sub_collections');
                  } else if (this.state.selected_tab === 'paid_collections'){
                     this.handleProfileTabChange('', 'paid_collections');                     
                  } else if (this.props.current_page_view === 'platform'){
                     this.fetchActiveProductData(this.state.currency);
                     this.props.navigate('?page=courses');
                     this.handleTabNavigation('courses');
                  }

               } else {
                  if (res.data.error === 'course name exists') {
                     this.setState({ snackbar: true });
                     this.setState({ errorMsg: 'Course name already exists!' });
                     this.setState({ snackbarAutoHide: 4000 });
                     this.setState({ snackbarSeverity: 'error' });
                     // setNewPlaylistLoading(false)
                  } else {
                     this.setState({ snackbar: true });
                     this.setState({ errorMsg: 'Error, please try again.' });
                     this.setState({ snackbarAutoHide: 4000 });
                     this.setState({ snackbarSeverity: 'error' });
                     // setNewPlaylistLoading(false)
                  }
               }
            } else {
               this.setState({
                  newCourseName: '',
                  snackbar: true,
                  snackbarAutoHide: 4000,
                  snackbarSeverity: 'error',
                  errorMsg: 'Error saving collection name, please try again.',
               })
            }
         }
      )
   }

   handleScroll = () => {


      // WAITLIST
      if (this.state.waiting_list || (this.state.is_me === false && this.state.view_type === 'waiting_list')) {
         if (this.state.selected_tab !== 'sub_collections' && this.state.selected_tab !== 'paid_collections' && this.state.selected_tab !== 'collections' && this.state.selected_tab !== 'community') {
            this.setState({ showBottomJoinBanner: true });
         }
      }
      // NON MEMBER
      else if (this.state.selected_tab === 'all' && this.state.is_me === false) {
         const element = document.getElementById("show-unsubscribe-banner");
         if (element) {
            const elementRect = element.getBoundingClientRect();
            if (elementRect.top <= 0 && !this.state.showBottomJoinBanner) {
               if (this.state.selected_tab !== 'sub_collections' && this.state.selected_tab !== 'paid_collections' && this.state.selected_tab !== 'collections' && this.state.selected_tab !== 'community') {
                  this.setState({ showBottomJoinBanner: true });
               }
            } else if (this.state.showBottomJoinBanner && elementRect.top > 0) {
               this.setState({ showBottomJoinBanner: false });
            }
         }
      } else {
         if (window.scrollY >= 400 && !this.state.showBottomJoinBanner) {
            if (this.state.selected_tab !== 'sub_collections' && this.state.selected_tab !== 'paid_collections' && this.state.selected_tab !== 'collections' && this.state.selected_tab !== 'community') {
               this.setState({ showBottomJoinBanner: true });
            }
         } else if (window.scrollY < 400 && this.state.showBottomJoinBanner) {
            this.setState({ showBottomJoinBanner: false });
         }
      }
   };


   handleOpenCreatorCalendly = (url) => {
      this.setState({
         calendly_creator_menu_url: url,
         calendly_creator_menu_open: true,
      })
   }

   handleCloseCreatorCalendly = () => {
      this.setState({
         calendly_creator_menu_url: '',
         calendly_creator_menu_open: false,
      })
   }

   // loadInfluencerContentData = (influencer_name_overwrite=null, influencer_info_overwrite=null, is_me = true) => new Promise((resolve, reject) => {
   //       const form_data = new FormData();
   //       form_data.append('influencer_str', influencer_name_overwrite ? influencer_name_overwrite : this.state.influencer_info.influencer)
   //       form_data.append('category', 'all')
   //       form_data.append('sort', 'latest')
   //       form_data.append('content_type', 'all')
   //       form_data.append('tab', 'all')
   //       form_data.append('collection', this.state.single_view_collection === '' ? '' : this.state.collection_names[this.state.single_view_collection])
   //       form_data.append('post_id', this.state.initial_content_id)
   //       form_data.append('page_n', this.state.page_n)
   //       form_data.append('currency', this.state.currency)
   //       axios({
   //          method: 'post',
   //          url: paths.BACKEND_URL + "api/influencer_content_data_latest_v7",
   //          headers: {
   //             'Content-type': 'application/json',
   //          },
   //          data: form_data,
   //          withCredentials: true
   //       }).then(res => {
   //          let new_influencer_content_list = [...res.data.content_list]
   //          let sub_tier = 0
   //          let sub_async_tier = false
   //          if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_silver_active === true) & (this.state.subscribe_popup_gold_active === true) & (this.state.subscribe_popup_async_active === true)) {
   //             sub_tier = 2
   //             sub_async_tier = true
   //          } else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_silver_active) & (this.state.subscribe_popup_gold_active)) {
   //             sub_tier = 2
   //             sub_async_tier = false
   //          } else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_silver_active) & (this.state.subscribe_popup_async_active)) {
   //             sub_tier = 2
   //             sub_async_tier = true
   //          } else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_gold_active) & (this.state.subscribe_popup_async_active)) {
   //             sub_tier = 3
   //             sub_async_tier = true
   //          } else if ((this.state.subscribe_popup_silver_active === true) & (this.state.subscribe_popup_gold_active) & (this.state.subscribe_popup_async_active)) {
   //             sub_tier = 3
   //             sub_async_tier = true
   //          }
   //          else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_silver_active)) {
   //             sub_tier = 1
   //             sub_async_tier = false
   //          }
   //          else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_gold_active)) {
   //             sub_tier = 1
   //             sub_async_tier = false
   //          }
   //          else if ((this.state.subscribe_popup_silver_active === true) & (this.state.subscribe_popup_gold_active)) {
   //             sub_tier = 2
   //             sub_async_tier = false
   //          }
   //          else if ((this.state.subscribe_popup_silver_active === true) & (this.state.subscribe_popup_async_active)) {
   //             sub_tier = 2
   //             sub_async_tier = true
   //          }
   //          else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_async_active)) {
   //             sub_tier = 1
   //             sub_async_tier = true
   //          }
   //          else if ((this.state.subscribe_popup_gold_active === true) & (this.state.subscribe_popup_async_active)) {
   //             sub_tier = 3
   //             sub_async_tier = true
   //          }
   //          else if ((this.state.subscribe_popup_bronze_active === true)) {
   //             sub_tier = 1
   //             sub_async_tier = false
   //          }
   //          else if ((this.state.subscribe_popup_silver_active === true)) {
   //             sub_tier = 2
   //             sub_async_tier = false
   //          }
   //          else if ((this.state.subscribe_popup_gold_active === true)) {
   //             sub_tier = 3
   //             sub_async_tier = false
   //          }
   //          else if ((this.state.subscribe_popup_async_active === true)) {
   //             sub_tier = -1
   //             sub_async_tier = true
   //          }
   //          if (!((this.state.single_view_collection === '') && (this.state.selected_tab === 'sub_collections' || this.state.selected_tab === 'paid_collections' || this.state.selected_tab === 'collections'))) {
   //             res.data.content_list.map((influencer_content_split, index) => {
   //                new_influencer_content_list[index]['current_tier'] = sub_tier
   //             })
   //          } else {
   //             // res.data.content_list.map((influencer_content_split, index) => {
   //             //    influencer_content_split.data.map(
   //             //       (influencer_content_split_inner, index2) => {
   //             //          new_influencer_content_list[index]['data'][index2]['current_tier'] = sub_tier
   //             //       }
   //             //    )
   //             // })
   //          }
   //          this.setState({ subpopup_tier_overwrite: sub_tier })
   //          this.setState({ subpopup_tier_async_overwrite: false })
   //          let new_influencer_info
   //          if (!influencer_info_overwrite){
   //             new_influencer_info = {...this.state.influencer_info}
   //          } else {
   //             new_influencer_info = {...influencer_info_overwrite}
   //          }
   //          new_influencer_info.current_tier = sub_tier
   //          new_influencer_info.waiting_list = false
   //          this.setState(
   //             {
   //                refreshing_content_data: false,
   //                content_count: res.data.content_count,
   //                influencer_content_list: new_influencer_content_list,
   //                collections_count: res.data.collections_count,
   //                all_count: res.data.all_count,
   //                content_types: res.data.content_types,
   //                categories_filter: res.data.categories_filter,
   //                selected_tab: 'all',
   //                prev_bookmark_state: this.state.prev_bookmark_state === false,
   //                inf_scroll_loading: false,
   //                collection_names: res.data.collection_names,
   //                influencer_info: new_influencer_info,
   //                waiting_list: false,
   //                is_me: is_me,
   //                page_position: res.data.content_list.length,
   //                content_list_length: res.data.content_list_length,
   //                contentIsLoading: false,
   //                previewInitialLoading: false,
   //             }
   //          )
   //          if (new_influencer_content_list.length >= res.data.content_list_length) {
   //             this.setState({
   //                update_inf_scroll: false,
   //             })
   //          } else {
   //             this.setState({
   //                update_inf_scroll: true,
   //             })
   //          }
   //          resolve()
   //       }).catch(() => {
   //          reject()
   //       })
   // })

   handleTabNavigation(page, influencer_name_overwrite=null, influencer_info_overwrite=null, scroll_to_post=null, post_id=null, type=null) {
      const { view_type } = this.state;
      // remove loadInfluencerContentData
      const { updateViewType, handleProfileTabChange, setState,  } = this;
      const { navigate, current_page_view } = this.props;

      window.scrollTo({top: 0, behavior: 'instant'} )

      const tabString = String(page);
      if (page) {
         document.title = `${(tabString.charAt(0).toUpperCase() + tabString.slice(1)).replace('_', ' ')} - WithMe`;
      }

      const tabActions = {
         'home': () => {
            if (view_type !== 'creator'){
               updateViewType({ target: { value: 'creator' } });
            }
            setState({
               loading_dashboard_data: false,
               my_platform_page: 'creator_home'
            });
            handleProfileTabChange({}, 'dashboard');
         },
         'platform': () => {
            if (view_type !== 'creator'){
               updateViewType({ target: { value: 'creator' } });
            }
            setState({
               loading_dashboard_data: false,
               my_platform_page: this.props.hash.startsWith('#add_') ? 'add_product' : 'home',
               selected_tab: '',
               influencer_content_list: [],
            });  
            // loadInfluencerContentData(influencer_name_overwrite, influencer_info_overwrite).then(() => {
            //   handleProfileTabChange({}, "all", null, influencer_name_overwrite);
            // });          
            if (!influencer_name_overwrite){
               this.fetchActiveProductData(this.state.currency);
            }
         },
         'preview': () => {
            setState({
               loading_dashboard_data: false,
               my_platform_page: 'home'
            });
            this.setState(
               {
                  refreshing_content_data: true,
                  influencer_content_list: [],
                  inf_scroll_loading: true,
                  view_type: 'user-subscribed',
                  isWaitingList: false,
                  selected_tab: 'all',
                  previewInitialLoading: true,
                  sort_filter: 'latest',
                  category_filter: 'all',
                  content_filter: 'all',
                  tier_filter: -1,
               }
            )
            const form_data = new FormData();
            form_data.append('influencer_str', influencer_name_overwrite ? influencer_name_overwrite : this.state.influencer_info.influencer)
            form_data.append('category', 'all')
            form_data.append('sort', 'latest')
            form_data.append('content_type', 'all')
            form_data.append('tab', 'all')
            form_data.append('collection', this.state.single_view_collection === '' ? '' : this.state.collection_names[this.state.single_view_collection])
            form_data.append('post_id', this.state.initial_content_id)
            form_data.append('page_n', this.state.page_n)
            form_data.append('currency', this.state.currency)
            form_data.append('tier', this.state.tier_filter)
            axios({
               method: 'post',
               url: paths.BACKEND_URL + "api/influencer_content_data_latest_v7",
               headers: {
                  'Content-type': 'application/json',
               },
               data: form_data,
               withCredentials: true
            }).then(res => {
               let new_influencer_content_list = [...res.data.content_list]
               let sub_tier = 0
               let sub_async_tier = false
               if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_silver_active === true) & (this.state.subscribe_popup_gold_active === true) & (this.state.subscribe_popup_async_active === true)) {
                  sub_tier = 2
                  sub_async_tier = true
               } else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_silver_active) & (this.state.subscribe_popup_gold_active)) {
                  sub_tier = 2
                  sub_async_tier = false
               } else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_silver_active) & (this.state.subscribe_popup_async_active)) {
                  sub_tier = 2
                  sub_async_tier = true
               } else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_gold_active) & (this.state.subscribe_popup_async_active)) {
                  sub_tier = 3
                  sub_async_tier = true
               } else if ((this.state.subscribe_popup_silver_active === true) & (this.state.subscribe_popup_gold_active) & (this.state.subscribe_popup_async_active)) {
                  sub_tier = 3
                  sub_async_tier = true
               }
               else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_silver_active)) {
                  sub_tier = 1
                  sub_async_tier = false
               }
               else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_gold_active)) {
                  sub_tier = 1
                  sub_async_tier = false
               }
               else if ((this.state.subscribe_popup_silver_active === true) & (this.state.subscribe_popup_gold_active)) {
                  sub_tier = 2
                  sub_async_tier = false
               }
               else if ((this.state.subscribe_popup_silver_active === true) & (this.state.subscribe_popup_async_active)) {
                  sub_tier = 2
                  sub_async_tier = true
               }
               else if ((this.state.subscribe_popup_bronze_active === true) & (this.state.subscribe_popup_async_active)) {
                  sub_tier = 1
                  sub_async_tier = true
               }
               else if ((this.state.subscribe_popup_gold_active === true) & (this.state.subscribe_popup_async_active)) {
                  sub_tier = 3
                  sub_async_tier = true
               }
               else if ((this.state.subscribe_popup_bronze_active === true)) {
                  sub_tier = 1
                  sub_async_tier = false
               }
               else if ((this.state.subscribe_popup_silver_active === true)) {
                  sub_tier = 2
                  sub_async_tier = false
               }
               else if ((this.state.subscribe_popup_gold_active === true)) {
                  sub_tier = 3
                  sub_async_tier = false
               }
               else if ((this.state.subscribe_popup_async_active === true)) {
                  sub_tier = -1
                  sub_async_tier = true
               }
               if (!((this.state.single_view_collection === '') && (this.state.selected_tab === 'sub_collections' || this.state.selected_tab === 'paid_collections' || this.state.selected_tab === 'collections'))) {
                  res.data.content_list.map((influencer_content_split, index) => {
                     new_influencer_content_list[index]['current_tier'] = sub_tier
                  })
               } else {
                  // res.data.content_list.map((influencer_content_split, index) => {
                  //    influencer_content_split.data.map(
                  //       (influencer_content_split_inner, index2) => {
                  //          new_influencer_content_list[index]['data'][index2]['current_tier'] = sub_tier
                  //       }
                  //    )
                  // })
               }
               this.setState({ subpopup_tier_overwrite: sub_tier })
               this.setState({ subpopup_tier_async_overwrite: false })
               let new_influencer_info
               if (!influencer_info_overwrite){
                  new_influencer_info = {...this.state.influencer_info}
               } else {
                  new_influencer_info = {...influencer_info_overwrite}
               }
               new_influencer_info.current_tier = sub_tier
               new_influencer_info.waiting_list = false
               this.setState(
                  {
                     refreshing_content_data: false,
                     content_count: res.data.content_count,
                     influencer_content_list: new_influencer_content_list,
                     // live_count: res.data.live_count,
                     // scheduled_count: res.data.scheduled_count,
                     collections_count: res.data.collections_count,
                     all_count: res.data.all_count,
                     // saved_count: res.data.saved_count,
                     content_types: res.data.content_types,
                     categories_filter: res.data.categories_filter,
                     selected_tab: 'all',
                     prev_bookmark_state: this.state.prev_bookmark_state === false,
                     inf_scroll_loading: false,
                     collection_names: res.data.collection_names,
                     influencer_info: new_influencer_info,
                     waiting_list: false,
                     is_me: false,
                     page_position: res.data.content_list.length,
                     content_list_length: res.data.content_list_length,
                     // collection_data: res.data.collection_data,
                     contentIsLoading: false,
                     previewInitialLoading: false,
                  }
               )
               if (new_influencer_content_list.length >= res.data.content_list_length) {
                  this.setState({
                     update_inf_scroll: false,
                  })
               } else {
                  this.setState({
                     update_inf_scroll: true,
                  })
               }
            })
         },
         'subscriptions': () => {

            // dispatch(setSubscriptionSubTab('all'));
            if (view_type !== 'creator') updateViewType({ target: { value: 'creator' } });
            setState({
               loading_dashboard_data: false,
               my_platform_page: 'creation_flow',
               collection_data: []
            });
            if (type === 'collection'){
               handleProfileTabChange({}, 'sub_collections', null, influencer_name_overwrite ? influencer_name_overwrite : null, scroll_to_post, post_id);
            } else {
               handleProfileTabChange({}, 'sub_posts', null, influencer_name_overwrite ? influencer_name_overwrite : null, scroll_to_post, post_id);
            }
         },
         'digital_products': () => {
            if (view_type !== 'creator') updateViewType({ target: { value: 'creator' } });
            setState({
               loading_dashboard_data: false,
               my_platform_page: 'creation_flow'
            });
            handleProfileTabChange({}, 'paid_posts', null, influencer_name_overwrite ? influencer_name_overwrite : null);
         },
         'courses': () => {
            if (view_type !== 'creator') updateViewType({ target: { value: 'creator' } });
            setState({
               loading_dashboard_data: false,
               my_platform_page: 'creation_flow',
               collection_data: []
            });
            handleProfileTabChange({}, 'paid_collections', null, influencer_name_overwrite ? influencer_name_overwrite : null, scroll_to_post, post_id);
         },
         '1v1coaching': () => {
            if (view_type !== 'creator') updateViewType({ target: { value: 'creator' } });
            setState({
               loading_dashboard_data: false,
               my_platform_page: 'creation_flow',
               influencer_content_list: []
            });
            handleProfileTabChange({}, 'async', null, null, scroll_to_post);
         },
         'community': () => {
            if (view_type !== 'creator') updateViewType({ target: { value: 'creator' } });
            setState({
               loading_dashboard_data: false,
               my_platform_page: 'creation_flow',
               influencer_content_list: []
            });
            handleProfileTabChange({}, 'community', null, '', true);
         },
         'messages': () => {
            if (view_type !== 'creator') updateViewType({ target: { value: 'creator' } });
            setState({
               loading_dashboard_data: false,
               my_platform_page: 'creation_flow',
               influencer_content_list: []
            });
            handleProfileTabChange({}, 'paidDMs', null, null, scroll_to_post);
         },
         'payouts': () => { },
         'insights': () => { },
         'customers': () => { },
         'promo_codes': () => { },
         'branding': () => { },
         'examples': () => { },
         'referrals': () => { },
         'more': () => { }
      };

      if (tabActions[page]) {
         setState({
            single_view_collection: '',
            my_platform_page: 'home'
         })
         tabActions[page]();
      }
   }

   saveNewCollectionContentOrder() {
      const { collectionContentReorderData } = this.state;
      const collection_id = this.state.collection_data?.find(collection => collection.course_name === this.state.single_view_collection)?.id;
      const data = new FormData();
      data.append('collection_id', collection_id);
      data.append('new_order', collectionContentReorderData);
      axios({
         method: 'post',
         url: paths.BACKEND_URL + 'api/update_collection_content_order/',
         data: data,
         headers: { 'Content-type': 'application/json' },
         withCredentials: true
      }).then((response) => {
         if (!response.data.error) {            
            this.setState({ isCollectionContentReorder: false, collectionContentReorderData: [] })
            this.handleCollectionTabChange({}, this.state.single_view_collection)
         }
      })
   }  


   componentDidUpdate(prevProps, prevState) {
      
      const searchParams = new URLSearchParams(window.location.search);
      const creator_preview = Boolean(searchParams.get('creator_preview'));
      const isSubscribed = Boolean(searchParams.get('isSubscribed'));
      const mobile_preview = Boolean(searchParams.get('mobile_preview'));
      const { edit_mode, my_platform_page } = this.state;
      const { current_page_view } = this.props;
      const { current_page_view: prev_page_view } = prevProps;

      // Focus text editor when entering edit mode
      if (!prevState.edit_mode && edit_mode && this.textEditorRef.current) {
         this.textEditorRef.current.focus();
      }
      if (
         current_page_view &&
         prev_page_view !== current_page_view &&
         !creator_preview &&
         !isSubscribed &&
         !mobile_preview
      ) {
         this.handleTabNavigation(current_page_view); // Sync only
      } 

      // Check modal status changes
      const modalStates = [
         'customCreatorLogoModalOpen',
         'publishedCongratsModal',
         'new_creator_modal',
         'hidden_tab_modal',
         'tab_info_modal',
         'editCollectionOpen',
         'isBannerModalOpen',
         'getStartedModalOpen',
         'open_content_upload',
         'open_example_creators',
         'edit_mode',
         'newPlaylistModal'
      ];

      const hasModalChanged = modalStates.some(state => prevState[state] !== this.state[state]);
      if (hasModalChanged) {
         this.checkModalStatus();
      }

      if (
         // check if Avatar is updated
         (prevState.influencerIconUpdated !== this.state.influencerIconUpdated)
         // check if Banner is updated
         || (prevState.influencerBannerUpdated !== this.state.influencerBannerUpdated)
         // check if Discription is updated
         || ((prevState.influencerDescriptionUpdated === null && this.state.influencerDescriptionUpdated !== null) || (prevState.influencerDescriptionUpdated !== this.state.influencerDescriptionUpdated))
      ) {
         this.saveChanges();
      }
   }


   componentWillUnmount() {
      window.removeEventListener('beforeunload', this.handleBeforeUnload);
      window.removeEventListener("scroll", this.handleScroll);
      window.removeEventListener("resize", this.handleWindowResize);
   }



   render() {
      const {
         influencerDisplayNameUpdated,
         influencerDescriptionUpdated,
         influencerIconUpdated,
         influencerBannerUpdated,
         influencerVideoUpdated,
         videoRemoved,
         influencer_info,
         bannerChangesMade,
         view_type,
         influencer_launched,
         progressCount,
         setupStripe,
         deviceWidth,
         current_user,
         updatedPerks,
         creator_preview,
         incomeData,
         subscriptionSubTab
      } = this.state;
      const { dashboard, navigate, location, params, current_page_view } = this.props;

      const mobile_preview = Boolean(this.props.searchParams.get('mobile_preview'));

      const isMobile = deviceWidth < 1280;

      const shouldShowEditChangesBanner =
         influencerDisplayNameUpdated !== null ||
         // influencerDescriptionUpdated !== null ||
         // influencerIconUpdated !== '' ||
         // influencerBannerUpdated !== '' ||
         influencerVideoUpdated !== '' ||
         videoRemoved;
      const sectionHeader = {
         color: 'var(--brand-color)',
         fontSize: '16px',
         textTransform: 'uppercase',
         fontWeight: '800',
      }

      const mainHeader = {
         color: '#222222',
         fontSize: window.innerWidth < 600 ? '28px' : '36px',
         textTransform: 'uppercase',
         fontWeight: '600',
         margin: '0px',
         maxWidth: '900px',
         textAlign: 'center',
         marginBottom: '20px',
      }

      const mainDescription = {
         color: '#6E89AF',
         fontSize: window.innerWidth < 600 ? '14px' : '16px',
         fontWeight: '400',
         margin: '0px 0px',
         maxWidth: '900px',
         textAlign: 'center',
         marginBottom: '20px',
         lineHeight: '1.5',
      }

      const { isFixed } = this.state;
      const { showBottomJoinBanner } = this.state;

      const leftBarStyle = {
         backgroundColor: "#fff",
         position: isFixed ? "fixed" : "relative",
         borderRight: '1px solid #F1F1F8',
         left: "0px",
         top: '0px',
         width: "100%",
         height: "130vh",
      };

      let video_height = '22.5vw'
      let title_font_size = 'calc(25px + 2vw)'
      if ((this.state.isLargeDevice) || (this.state.isXLargeDevice)) {
         if ((this.state.current_user === '') && (this.state.waiting_list === false)) {
            video_height = '16.875vw'
            title_font_size = 'calc(16px + 2vw)'
         } else {
            video_height = '22.5vw'
            title_font_size = 'calc(16px + 2vw)'
         }
      } else {
         video_height = '22.5vw'
         title_font_size = 'calc(16px + 2vw)'
      }

      if ((this.state.influencer_bool === true) && (this.state.influencer_info.influencer_active_in_community !== null) && (this.state.influencer_name.toLowerCase() === this.state.current_user.toLowerCase())) {
         if (true) {
            window.Intercom('boot', {
               app_id: INTERCOM_APP_ID,
               api_base: "https://api-iam.intercom.io",
               name: this.state.current_user,
               email: this.state.user_email,
               user_hash: this.state.intercom_verify_key,
               "is_influencer": this.state.influencer_bool,
               "is_logged_in": (this.state.current_user !== ''),
               'is_influencer_launched': this.state.influencer_launched,
               "active_on_community_last_7_days": this.state.influencer_info.influencer_active_in_community,
               avatar: {
                  "type": "avatar",
                  "image_url": this.state.current_user_icon,
               }
            });
         }
         const searchParams = new URLSearchParams(window.location.search);
         let open_help = searchParams.get("open_help")
         if (open_help === 'true') {
            window.Intercom('show')
         }
      } else {
         if (this.state.current_user === '') {
            window.Intercom('boot', {
               hide_default_launcher: true,
               app_id: INTERCOM_APP_ID,
               api_base: "https://api-iam.intercom.io",
            });
         } else {
            window.Intercom('boot', {
               hide_default_launcher: true,
               app_id: INTERCOM_APP_ID,
               api_base: "https://api-iam.intercom.io",
               name: this.state.current_user,
               email: this.state.user_email,
               user_hash: this.state.intercom_verify_key,
               "is_logged_in": true,
            });
         }
         const searchParams = new URLSearchParams(window.location.search);
         let open_help = searchParams.get("open_help")
         if (open_help === 'true') {
            window.Intercom('show')
         }
      }

      const isVideoPlaying = video => !!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2);
      if (document.getElementById('banner_video') != null) {
         document.getElementById('banner_video').onplay = () => {
            this.setState({ influencer_show_icon_image: false })
         }
      }
      if (document.getElementById('banner_video') != null) {
         document.getElementById('banner_video').onpause = () => {
            this.setState({ influencer_show_icon_image: true })
         }
      }
      let main_div = ""
      let swiper_data = ""
      let bannerMain = ""

      const tabsData = [
         { label: "Platform", icon: <TbLayoutGrid /> },
         { label: "Landing Pages", icon: <TbDeviceDesktopShare /> },
         { label: "Edit Design", icon: <TbPalette /> },
      ];

      if (this.state.my_platform_page === 'home' && this.state.view_type === 'creator') {
         bannerMain = (
            <Box
               sx={{
                  width: '100%',
                  maxWidth: '100vw',
                  zIndex: '999',
                  display: 'flex',
                  boxSizing: 'border-box',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '20px',
                  minWidth: '300px',
                  p: { xs: current_page_view === 'platform' && this.state.is_me === true ? '0px' : '0px', lg: '0px' },
                  marginTop: current_page_view === 'platform' ? '0px' : '60px',
                  alignItems: 'flex-start'
               }}
            >
               {current_page_view === 'platform' && this.state.is_me &&
                  <>
                     {/* <HorizontalTabs tabs={tabsData} activeTab={this.state.activeTab} onTabChange={(tab) => this.setState({ activeTab: tab })} /> */}
                     
                     <PlatformTabs tabs={tabsData} activeTab={this.state.activeTab} onTabChange={(tab) => this.setState({ activeTab: tab })} />
                  </>}



               <Item id={'banner_desktop'} xs={12} sx={{
                  backgroundColor: 'white',
                  display: 'flex',
                  flexGrow: 1,
             
                  left: '0px',
                  margin: '0px auto',
                  overflow: 'hidden',
                  width: '100%',
                  border: "none",
                  padding: '0px',
                  boxShadow: "none",
                  outline: "none",
                  borderRadius: this.state.view_type === 'creator' && this.state.is_me === true ? '8px' : '0px',
                  marginTop: this.state.deviceWidth < 1280 && this.state.dashboard === true && this.state.view_type === 'creator' && (this.state.influencer_launched === false || this.state.bannerChangesMade === false) && !shouldShowEditChangesBanner ? { xs: '0px', lg: '60px' } : '',
                  flexDirection: 'column',
                  justifyContent: 'center',
               }}>
                  {this.state.view_type === 'creator' && this.state.is_me === true ? (
                     <></>
                  ) : (
                     <Suspense fallback={<></>}>
                        <InfluencerBannerMain
                           open_icon_image_edit={this.state.open_icon_image_edit}
                           view_type={this.state.view_type}
                           influencer_info={this.state.influencer_info}
                           is_me={this.state.is_me}
                           edit_mode={this.state.edit_mode}
                           ToggleEdit={this.ToggleEdit}
                           influencerBannerImage={this.state.banner_file}
                           setState={this.setState}
                           OnInfluencerEditChange={this.OnInfluencerEditChange}
                           influencerBioLength={this.state.influencerBioLength}
                           editedBio={this.state.editedBio}
                           OpenSubscribePopup={this.OpenSubscribePopup}
                           OpenWaitingListPopup={this.OpenWaitingListPopup}
                           CloseSubscribePopup={this.CloseSubscribePopup}
                           CloseWaitingListPopup={this.CloseWaitingListPopup}
                           influencer_n_subscribers={this.state.influencer_n_subscribers}
                           influencer_show_icon_image={this.state.influencer_show_icon_image}
                           current_user={this.state.current_user}
                           isLargeDevice={this.state.isLargeDevice}
                           isXLargeDevice={this.state.isXLargeDevice}
                           bannerImage={this.state.bannerImage}
                           headerVideo={this.state.headerVideo}
                           onVideoChange={this.onVideoChange}
                           onBannerChange={this.onBannerChange}
                           freeSubSubscribe={this.freeSubSubscribe}
                           n_page_views={this.state.n_page_views}
                           currency={this.state.currency}
                           influencer_rating_average={this.state.influencer_rating_average}
                           influencer_rating_count={this.state.influencer_rating_count}
                           rating_color={this.state.rating_color}
                           influencer_user_rating={this.state.influencer_user_rating}
                           data_func={this.get_and_post_data_skeleton}
                           update_ratings={this.update_ratings}
                           waiting_list={this.state.influencer_info['waiting_list']}
                           banner_file_path={this.state.influencer_info['banner_file_path']}
                           influencer={this.state.influencer_name}
                           trial_length={this.state.subscribe_popup_trial_length}
                           discordActive={this.state.discord_active}
                           userDiscordSetup={this.state.user_discord_setup}
                           async_active={this.state.subscribe_popup_async_active}
                           discordAccess={this.state.influencer_info.discord_access}
                           uploadComplete={this.state.uploadComplete}
                           content_count={this.state.content_count}
                           alteredBio={this.state.alteredBio}
                           alteredDisplayName={this.state.alteredDisplayName}
                           influencerDisplayName={this.state.influencer_info['influencer_name'] ? this.state.influencer_info['influencer_name'] : this.state.influencer_info['influencer']}
                           influencerDescription={this.state.influencer_info['description']}
                           influencerBanner={this.state.influencerBanner}
                           influencerVideo={this.state.influencerVideo}
                           influencerIcon={this.state.influencer_info['icon_image_path']}
                           influencerDisplayNameUpdated={this.state.influencerDisplayNameUpdated}
                           influencerDescriptionUpdated={this.state.influencerDescriptionUpdated}
                           influencerIconUpdated={this.state.influencerIconUpdated}
                           influencerBannerUpdated={this.state.influencerBannerUpdated}
                           influencerBannerUpdatedFile={this.state.influencerBannerUpdatedFile}
                           influencerVideoUpdated={this.state.influencerVideoUpdated}
                           influencerVideoUpdatedFile={this.state.influencerVideoUpdatedFile}
                           handleIconChange={this.handleIconChange}
                           setCurrentBanner={this.setCurrentBanner}
                           setCurrentVideo={this.setCurrentVideo}
                           handleSetBannerChange={this.handleSetBannerChange}
                           handleClearNewIcon={this.handleClearNewIcon}
                           handleSetVideoChange={this.handleSetVideoChange}
                           handleRemoveVideo={this.handleRemoveVideo}
                           UpdateIconImagePush={this.UpdateIconImagePush}
                           bannerChangesMade={this.state.bannerChangesMade}
                           bannerChangesMadeCheck={this.bannerChangesMadeCheck}
                           setRevertImageFalse={this.setRevertImageFalse}
                           revertImage={this.state.revertImage}
                           videoRemoved={this.state.videoRemoved}
                           deviceWidth={this.state.deviceWidth}
                           free_trial_eligible={this.state.free_trial_eligible}
                           ratingsModel={this.state.ratingsModal}
                           subpopup_tier_async_overwrite={this.state.subpopup_tier_async_overwrite}
                           paidDMsExplainerModal={this.state.paidDMsExplainerModal}
                           openCheckout={this.openDMCheckout}
                           dm_active={this.state.dm_active}
                           async_tier_access={this.state.subpopup_tier_async_overwrite !== null ? this.state.subpopup_tier_async_overwrite : this.state.subscribe_popup_async_tier_access}
                           subscribe_popup_async_active={this.state.subscribe_popup_async_active}
                           handleProfileTabChange={this.handleProfileTabChange}
                           paidDMs_show={this.state.paidDMs_show}
                           paidDMs_has_message={this.state.paidDMs_has_messages}
                           windowWidth={window.innerWidth}
                           isDashboard={this.props.dashboard}
                           showChangesBanner={true}
                           saveChanges={this.saveChanges}
                           revertChanges={this.revertChanges}
                           isPublished={this.state.influencer_info['waiting_list']}
                           isMessagesActive={true}
                           free_active={this.state.influencer_info['free_active']}
                           bronze_active={this.state.subscribe_popup_bronze_active}
                           silver_active={this.state.subscribe_popup_silver_active}
                           gold_active={this.state.subscribe_popup_gold_active}
                           subscribe_popup_async_tier_apply={this.state.subscribe_popup_async_tier_apply}
                           subscribe_popup_bronze_monthly_active={this.state.subscribe_popup_bronze_monthly_active}
                           subscribe_popup_silver_monthly_active={this.state.subscribe_popup_silver_monthly_active}
                           subscribe_popup_gold_monthly_active={this.state.subscribe_popup_gold_monthly_active}
                           subscribe_popup_bronze_annual_active={this.state.subscribe_popup_bronze_annual_active}
                           subscribe_popup_silver_annual_active={this.state.subscribe_popup_silver_annual_active}
                           subscribe_popup_gold_annual_active={this.state.subscribe_popup_gold_annual_active}
                           current_tier={this.state.influencer_info['current_tier']}
                           influencer_bool={this.state.influencer_bool}
                           hidden_influencer={this.state.hidden_influencer}
                           n_user_subscriptions={this.state.n_user_subscriptions}
                           user_subscriptions={this.state.user_subscriptions}
                           recommended_influencers={this.state.recommended_influencers}
                           mobile_content={this.state.mobile_content}
                           influencer_id={this.state.influencer_info['id']}
                           customiseMode={this.state.customiseMode}
                           handleCustomiseMode={this.handleCustomiseMode}
                           handleCancelCustomise={this.handleCancelCustomise}
                           dashboard={this.state.dashboard}
                           waiting_list_influencer={this.state.waiting_list_influencer}
                           current_user_state={this.state.current_user}
                           current_user_icon={this.state.current_user_icon}
                           top_bar_text={this.state.influencer_name}
                           subs_user_menu={true}
                           show_search={true}
                           display_name={this.state.display_name}
                           influencer_page={true}
                           mobileSearchOpen={this.state.mobileSearchOpen}
                           handleMobileSearchClose={this.handleMobileSearchClose}
                           handleMobileSearchOpen={this.handleMobileSearchOpen}
                           onWaitingList={this.state.isWaitingList}
                           revertUserIcon={this.revertUserIcon}
                           setCalendlyModal={this.setCalendlyModal}
                        />
                     </Suspense>
                  )}
               </Item>

               {current_page_view === 'platform' && this.state.is_me &&


                  <div style={{ padding: window.innerWidth < 1280 ? '0px 20px' : '0px', width: '100%', boxSizing: 'border-box' }}>
                     
                     {this.state.activeTab === 'Platform' ?
                        <Platform
                           handleTabNavigation={this.handleTabNavigation}
                           activeProductTestData={activeProductTestData}
                           activeProductData={this.state.activeProductData}
                           // loadInitialInfluencerData={this.loadInitialInfluencerData}
                           // activeTabs={}
                           updateCommunityActive={this.updateCommunityActive}
                           editingCourse={this.state.editingCourse}
                           setState={this.setState}
                           handleCloseTiers={this.handleCloseTiers}
                           selectedMemberTabOverwrite={this.state.selectedMemberTabOverwrite}
                           selected_tab={this.state.selected_tab}
                           my_platform_page={this.state.my_platform_page}
                           influencer_icon={this.state.influencer_info['icon_image_path']}
                           dashboard={this.state.dashboard}
                           isPublished={this.state.influencer_launched}
                           view_type={this.state.view_type}
                           contentIsLoading={this.state.contentIsLoading}
                           current_user={this.state.current_user}
                           current_user_icon={this.state.current_user_icon}
                           is_me={this.state.is_me}
                           influencer={this.state.influencer_name}
                           influencer_info={this.state.influencer_info}
                           currency={this.state.currency}
                           current_tier={this.state.subscribe_popup_current_tier}
                           post_id={this.state.post_id}
                           // buy collections
                           single_view_collection={this.state.single_view_collection}
                           sort_filter={this.state.sort_filter}
                           collection_filter={this.state.collection_filter}
                           category_filter={this.state.category_filter}
                           content_filter={this.state.content_filter}
                           influencer_content_list={this.state.influencer_content_list}
                           isExtraSmallDevice={this.state.isExtraSmallDevice}
                           collectionTitleHovered={this.state.collectionTitleHovered}
                           hoveredIndex={this.state.hoveredIndex}
                           OpenSubscribePopup={this.OpenSubscribePopup}
                           openBuyNowCheckout={this.openBuyNowCheckout}
                           openBuyCollectionCheckout={this.openBuyCollectionCheckout}
                           buyCollectionId={this.state.buyCollectionId}
                           handleBuyNowCheckoutData={this.handleBuyNowCheckoutData}
                           handleProfileTabChange={this.handleProfileTabChange}
                           OpenWaitingListPopup={this.OpenWaitingListPopup}
                           CloseSubscribePopup={this.CloseSubscribePopup}
                           CloseWaitingListPopup={this.CloseWaitingListPopup}
                           like_button_click_post={this.like_button_click_post}
                           share_button_click={this.share_button_click}
                           bookmark_button_post={this.bookmark_button_click_post}
                           bookmark_button_click={this.bookmark_button_click}
                           pinned_post_process={this.pinned_post_process}
                           like_button_click={this.like_button_click}
                           update_filter_state={this.update_filter_state}
                           get_and_post_data_skeleton={this.get_and_post_data_skeleton}
                           handleCollectionTitleMouseLeave={this.handleCollectionTitleMouseLeave}
                           handleCollectionTitleMouseEnter={this.handleCollectionTitleMouseEnter}
                           isSmallDevice={this.state.isSmallDevice}
                           isMediumDevice={this.state.isMediumDevice}
                           isLargeDevice={this.state.isLargeDevice}
                           isXLargeDevice={this.state.isXLargeDevice}
                           subscribe_popup_bronze_active={this.state.subscribe_popup_bronze_active}
                           subscribe_popup_silver_active={this.state.subscribe_popup_silver_active}
                           subscribe_popup_gold_active={this.state.subscribe_popup_gold_active}
                           subscribe_popup_async_active={this.state.subscribe_popup_async_active}
                           subscribe_popup_bronze_name={this.state.subscribe_popup_bronze_name}
                           subscribe_popup_silver_name={this.state.subscribe_popup_silver_name}
                           subscribe_popup_gold_name={this.state.subscribe_popup_gold_name}
                           subscribe_popup_async_name={this.state.subscribe_popup_async_name}
                           force_content_rerender={this.state.force_content_rerender}
                           handleSavedContent={this.handleSavedContent}
                           handleRemoveSavedContent={this.handleRemoveSavedContent}
                           handleContentModalOpen={this.handleContentModalOpen}
                           handleContentModalClose={this.handleContentModalClose}
                           handleObserver={this.handleObserver}
                           display_name={this.state.display_name}
                           update_inf_scroll={this.state.update_inf_scroll}
                           collection_names={this.state.collection_names}
                           collection_data={this.state.collection_data}
                           width={window.innerWidth}
                           async_tier_access={this.state.subpopup_tier_async_overwrite !== null ? this.state.subpopup_tier_async_overwrite : this.state.subscribe_popup_async_tier_access}
                           // Imports for membership to work inside influencer content sections
                           handleRemoveVideo={this.handleRemoveVideo}
                           windowWidth={this.state.deviceWidth}
                           windowHeight={window.innerHeight}
                           expanded={this.state.expanded}
                           expandedDashboard={this.state.expandedDashboard}
                           updateViewType={this.updateViewType}
                           isSwitchOn={this.state.isSwitchOn}
                           profileLiveLoading={this.state.profileLiveLoading}
                           copyButtonClicked={this.state.copyButtonClicked}
                           progressCount={this.state.progressCount}
                           influencer_bool={this.state.influencer_bool}
                           firstName={this.state.first_name}
                           watchedSalesVideo={this.state.watchedSalesVideo}
                           setupProfile={this.state.setupProfile}
                           sharedWaitingList={this.state.sharedWaitingList}
                           oneWaitingList={this.state.oneWaitingList}
                           uploadedContent={this.state.uploadedContent}
                           uploadedPlaylistContent={this.state.uploadedPlaylistContent}
                           updatedPerks={this.state.updatedPerks}
                           setupStripe={this.state.setupStripe}
                           stripeStatus={this.state.stripeStatus}
                           missingText={this.state.missingText}
                           tierText={this.state.tierText}
                           stripeRedirectLink={this.state.stripeRedirectLink}
                           tierChangeOptions={this.state.tierChangeOptions}
                           shareWaitingListError={this.state.shareWaitingListError}
                           joinReasonAdded={this.state.joinReasonAdded}
                           profileVideoAdded={this.state.profileVideoAdded}
                           showContentConfetti={this.state.showContentConfetti}
                           openProfileWhatsThis={this.state.openProfileWhatsThis}
                           openOfferingWhatsThis={this.state.openOfferingWhatsThis}
                           openWaitingListWhatsThis={this.state.openWaitingListWhatsThis}
                           openCallWhatsThis={this.state.openCallWhatsThis}
                           openContentWhatsThis={this.state.openContentWhatsThis}
                           openStripeWhatsThis={this.state.openStripeWhatsThis}
                           openUrlWhatsThis={this.state.openUrlWhatsThis}
                           openEditUrl={this.state.openEditUrl}
                           editedUsername={this.state.editedUsername}
                           editUrlErrorMsg={this.state.editUrlErrorMsg}
                           openRefCalcWhatsThis={this.state.openRefCalcWhatsThis}
                           tiersModal={this.state.tiersModal}
                           publishModal={this.state.publishModal}
                           contentCount={this.state.content_count}
                           waitingListCount={this.state.waitingListCount}
                           waiting_list_influencer={this.state.influencer_info['waiting_list']}
                           collectionsCount={this.state.collectionsCount}
                           activeTierCount={this.state.activeTierCount}
                           snackbar={this.state.snackbar}
                           snackbarAutoHide={this.state.snackbarAutoHide}
                           snackbarSeverity={this.state.snackbarSeverity}
                           confettiModal={this.state.confettiModal}
                           whatsThisModal={this.state.whatsThisModal}
                           checkListModal={this.state.checkListModal}
                           makeInfluencerLive={this.makeInfluencerLive}
                           influencerUsername={this.state.current_user}
                           influencerIcon={this.state.influencer_info['icon_image_path']}
                           missingProfiles={this.state.missingProfiles}
                           influencerDescription={this.state.influencer_info['description']}
                           influencerEmail={this.state.user_email}
                           influencerBanner={this.state.influencerBanner}
                           influencerVideo={this.state.influencerVideo}
                           influencerIntercomKey={this.state.intercom_verify_key}
                           switch_onChange_handle={this.switch_onChange_handle}
                           submitUsernameUpdate={this.submitUsernameUpdate}
                           setTrialLength={this.setTrialLength}
                           trialLength={this.state.trialLength}
                           n_views_this_week={this.state.n_views_this_week}
                           n_views_increase={this.state.n_views_increase}
                           n_subs_this_week={this.state.n_subs_this_week}
                           n_subs_increase={this.state.n_subs_increase}
                           this_month_income={this.state.this_month_income}
                           last_month_income={this.state.last_month_income}
                           openOffering={this.state.openOffering}
                           community_is_active={this.state.community_is_active}
                           handleOpenHiddenTabModal={this.handleOpenHiddenTabModal}
                           handleOpenInfoTabModal={this.handleOpenInfoTabModal}
                           handleCloseInfoTabModal={this.handleCloseInfoTabModal}
                           dm_active={this.state.dm_active}
                           openDMCheckout={this.openDMCheckout}
                           updateHasMessage={this.updateHasMessage}
                           paidDMs_show={this.state.paidDMs_show}
                           maxMessageLength={this.state.max_message_length}
                           setMaxMessageLength={this.setMaxMessageLength}
                           handleCollectionTabChange={this.handleCollectionTabChange}
                           openTippingCheckout={this.openTipCheckout}
                           setCommentCount={this.setCommentCount}
                           async_apply={this.state.async_apply}
                           goToCheckout={this.goToCheckout}
                           open_messages={this.state.open_messages}
                           open_coaching={this.state.open_coaching}
                           loading_page_change={this.state.loading_page_change}
                           content_list_length={this.state.content_list_length}
                           page_n={this.state.page_n}
                           setPageN={this.setPageN}
                           n_page_views={this.state.n_page_views}
                           buyNowThumbnailUrl={this.state.buyNowThumbnailUrl}
                           buyNowTitle={this.state.buyNowTitle}
                           buyNowContentType={this.state.buyNowContentType}
                           buyNowContentId={this.state.buyNowContentId}
                           setNewPlaylistModal={this.setNewPlaylistModal}
                           handleSingleViewCollection={this.handleSingleViewCollection}
                           handleConfirmationSnackbarOpen={this.handleConfirmationSnackbarOpen}
                           handleOpenCollections={this.handleOpenCollections}
                           collectionsMobileAnchorEl={this.state.collectionsMobileAnchorEl}
                           collectionsMobileOpen={this.state.collectionsMobileOpen}
                           updateCollectionOrder={this.updateCollectionOrder}
                           influencer_username={this.state.influencer_info['influencer']}
                           search_func_collection={this.openSearchContentCollection}
                           product_type={this.state.product_type}
                           creatorBanner={
                              <>
                                 {<Suspense fallback={<></>}>
                                    <Item id={'banner_desktop'} xs={12} sx={{
                                       backgroundColor: 'white',
                                       display: 'flex',
                                       flexGrow: 1,
                                       left: '0px',
                                       margin: '0px auto',
                                       overflow: 'hidden',
                                       width: '100%',
                                       border: "none",
                                       padding: '0px',
                                       boxShadow: "none",
                                       outline: "none",
                                       borderRadius: this.state.view_type === 'creator' && this.state.is_me === true ? '8px' : '0px',
                                       marginTop: this.state.deviceWidth < 1280 && this.state.dashboard === true && this.state.view_type === 'creator' && (this.state.influencer_launched === false || this.state.bannerChangesMade === false) && !shouldShowEditChangesBanner ? { xs: '0px', lg: '60px' } : '',
                                       flexDirection: 'column',
                                       justifyContent: 'center',
                                    }}>
                                       <InfluencerBannerMainCreatorView
                                          open_icon_image_edit={this.state.open_icon_image_edit}
                                          view_type={this.state.view_type}
                                          influencer_info={this.state.influencer_info}
                                          is_me={this.state.is_me}
                                          edit_mode={this.state.edit_mode}
                                          ToggleEdit={this.ToggleEdit}
                                          influencerBannerImage={this.state.banner_file}
                                          setState={this.setState}
                                          OnInfluencerEditChange={this.OnInfluencerEditChange}
                                          influencerBioLength={this.state.influencerBioLength}
                                          editedBio={this.state.editedBio}
                                          OpenSubscribePopup={this.OpenSubscribePopup}
                                          OpenWaitingListPopup={this.OpenWaitingListPopup}
                                          CloseSubscribePopup={this.CloseSubscribePopup}
                                          CloseWaitingListPopup={this.CloseWaitingListPopup}
                                          influencer_n_subscribers={this.state.influencer_n_subscribers}
                                          influencer_show_icon_image={this.state.influencer_show_icon_image}
                                          saveChange={this.saveChanges}
                                          current_user={this.state.current_user}
                                          isLargeDevice={this.state.isLargeDevice}
                                          isXLargeDevice={this.state.isXLargeDevice}
                                          bannerImage={this.state.bannerImage}
                                          headerVideo={this.state.headerVideo}
                                          onVideoChange={this.onVideoChange}
                                          onBannerChange={this.onBannerChange}
                                          freeSubSubscribe={this.freeSubSubscribe}
                                          n_page_views={this.state.n_page_views}
                                          currency={this.state.currency}
                                          influencer_rating_average={this.state.influencer_rating_average}
                                          influencer_rating_count={this.state.influencer_rating_count}
                                          rating_color={this.state.rating_color}
                                          influencer_user_rating={this.state.influencer_user_rating}
                                          data_func={this.get_and_post_data_skeleton}
                                          update_ratings={this.update_ratings}
                                          waiting_list={this.state.influencer_info['waiting_list']}
                                          banner_file_path={this.state.influencer_info['banner_file_path']}
                                          influencer={this.state.influencer_name}
                                          trial_length={this.state.subscribe_popup_trial_length}
                                          discordActive={this.state.discord_active}
                                          userDiscordSetup={this.state.user_discord_setup}
                                          async_active={this.state.subscribe_popup_async_active}
                                          discordAccess={this.state.influencer_info.discord_access}
                                          uploadComplete={this.state.uploadComplete}
                                          content_count={this.state.content_count}
                                          alteredBio={this.state.alteredBio}
                                          alteredDisplayName={this.state.alteredDisplayName}
                                          influencerDisplayName={this.state.influencer_info['influencer_name'] ? this.state.influencer_info['influencer_name'] : this.state.influencer_info['influencer']}
                                          influencerDescription={this.state.influencer_info['description']}
                                          influencerBanner={this.state.influencerBanner}
                                          influencerVideo={this.state.influencerVideo}
                                          influencerIcon={this.state.influencer_info['icon_image_path']}
                                          influencerDisplayNameUpdated={this.state.influencerDisplayNameUpdated}
                                          influencerDescriptionUpdated={this.state.influencerDescriptionUpdated}
                                          influencerIconUpdated={this.state.influencerIconUpdated}
                                          influencerBannerUpdated={this.state.influencerBannerUpdated}
                                          influencerBannerUpdatedFile={this.state.influencerBannerUpdatedFile}
                                          influencerVideoUpdated={this.state.influencerVideoUpdated}
                                          influencerVideoUpdatedFile={this.state.influencerVideoUpdatedFile}
                                          handleIconChange={this.handleIconChange}
                                          setCurrentBanner={this.setCurrentBanner}
                                          setCurrentVideo={this.setCurrentVideo}
                                          handleSetBannerChange={this.handleSetBannerChange}
                                          handleClearNewIcon={this.handleClearNewIcon}
                                          handleSetVideoChange={this.handleSetVideoChange}
                                          handleRemoveVideo={this.handleRemoveVideo}
                                          UpdateIconImagePush={this.UpdateIconImagePush}
                                          bannerChangesMade={this.state.bannerChangesMade}
                                          bannerChangesMadeCheck={this.bannerChangesMadeCheck}
                                          setRevertImageFalse={this.setRevertImageFalse}
                                          revertImage={this.state.revertImage}
                                          videoRemoved={this.state.videoRemoved}
                                          deviceWidth={this.state.deviceWidth}
                                          free_trial_eligible={this.state.free_trial_eligible}
                                          ratingsModel={this.state.ratingsModal}
                                          subpopup_tier_async_overwrite={this.state.subpopup_tier_async_overwrite}
                                          paidDMsExplainerModal={this.state.paidDMsExplainerModal}
                                          openCheckout={this.openDMCheckout}
                                          dm_active={this.state.dm_active}
                                          async_tier_access={this.state.subpopup_tier_async_overwrite !== null ? this.state.subpopup_tier_async_overwrite : this.state.subscribe_popup_async_tier_access}
                                          subscribe_popup_async_active={this.state.subscribe_popup_async_active}
                                          handleProfileTabChange={this.handleProfileTabChange}
                                          paidDMs_show={this.state.paidDMs_show}
                                          paidDMs_has_message={this.state.paidDMs_has_messages}
                                          windowWidth={window.innerWidth}
                                          isDashboard={this.props.dashboard}
                                          showChangesBanner={true}
                                          saveChanges={this.saveChanges}
                                          revertChanges={this.revertChanges}
                                          isPublished={this.state.influencer_info['waiting_list']}
                                          isMessagesActive={true}
                                          free_active={this.state.influencer_info['free_active']}
                                          bronze_active={this.state.subscribe_popup_bronze_active}
                                          silver_active={this.state.subscribe_popup_silver_active}
                                          gold_active={this.state.subscribe_popup_gold_active}
                                          subscribe_popup_async_tier_apply={this.state.subscribe_popup_async_tier_apply}
                                          subscribe_popup_bronze_monthly_active={this.state.subscribe_popup_bronze_monthly_active}
                                          subscribe_popup_silver_monthly_active={this.state.subscribe_popup_silver_monthly_active}
                                          subscribe_popup_gold_monthly_active={this.state.subscribe_popup_gold_monthly_active}
                                          subscribe_popup_bronze_annual_active={this.state.subscribe_popup_bronze_annual_active}
                                          subscribe_popup_silver_annual_active={this.state.subscribe_popup_silver_annual_active}
                                          subscribe_popup_gold_annual_active={this.state.subscribe_popup_gold_annual_active}
                                          current_tier={this.state.influencer_info['current_tier']}
                                          influencer_bool={this.state.influencer_bool}
                                          hidden_influencer={this.state.hidden_influencer}
                                          n_user_subscriptions={this.state.n_user_subscriptions}
                                          user_subscriptions={this.state.user_subscriptions}
                                          recommended_influencers={this.state.recommended_influencers}
                                          mobile_content={this.state.mobile_content}
                                          influencer_id={this.state.influencer_info['id']}
                                          customiseMode={this.state.customiseMode}
                                          handleCustomiseMode={this.handleCustomiseMode}
                                          handleCancelCustomise={this.handleCancelCustomise}
                                          dashboard={this.state.dashboard}
                                          waiting_list_influencer={this.state.waiting_list_influencer}
                                          current_user_state={this.state.current_user}
                                          current_user_icon={this.state.current_user_icon}
                                          top_bar_text={this.state.influencer_name}
                                          subs_user_menu={true}
                                          show_search={true}
                                          display_name={this.state.display_name}
                                          influencer_page={true}
                                          mobileSearchOpen={this.state.mobileSearchOpen}
                                          handleMobileSearchClose={this.handleMobileSearchClose}
                                          handleMobileSearchOpen={this.handleMobileSearchOpen}
                                          onWaitingList={this.state.isWaitingList}
                                          revertUserIcon={this.revertUserIcon}
                                          setCalendlyModal={this.setCalendlyModal}
                                       />
                                    </Item>
                                 </Suspense>}
                              </>
                           }
                           addProductButton={
                              <>
                                 {current_page_view === 'platform' && this.state.is_me &&
                                    <Button
                                       disableElevation
                                       sx={{
                                          backgroundColor: 'var(--brand-color)',
                                          color: 'white',
                                          fontSize: '15px',
                                          fontWeight: 'bold',
                                          width: '100%',
                                          height: '50px',
                                          margin: '0px auto',
                                          borderRadius: '8px',
                                          textTransform: 'none',
                                          ':hover': {
                                             backgroundColor: 'var(--brand-color)',
                                             opacity: '0.95'
                                          }
                                       }}
                                       onClick={() => this.setState({ my_platform_page: 'add_product' })}
                                       variant='contained'
                                    >
                                       Add Product
                                    </Button>
                                 }
                              </>


                           }
                        />
                        :
                        (this.state.activeTab === 'Landing Pages' ?
                           <>
                           <Box
                              sx={{
                                 display: 'flex', 
                                 flexDirection: 'column',
                                 border: '1px solid #E4EBF6',
                                 gap: '20px',
                                 padding: '20px', 
                                 backgroundColor: '#fff',
                                 borderRadius: '12px',
                                 margin: '0 auto',
                              }}
                           >
                              <Box
                                 sx={{
                                    width: '100%',
                                    height: 'auto',
                                    margin: '0 auto'
                                 }}
                              >
                                 <img 
                                    src={BioImage}
                                    style={{
                                       width: '100%',
                                       height: 'auto',
                                       borderRadius: '12px'
                                    }}
                                 />
                              </Box>

                              <Box sx={{flex: 1}}>
                                 <h1 style={{ fontSize: '18px', fontWeight: '600', color: '#222222', margin: '0px 0px 0px 0px', fontFamily: 'var(--main-font-family)' }}>
                                    Get your WithMe Storefront now
                                 </h1>

                                 {/* <p style={{ marginTop: '8px', fontSize: '14px', color: '#6E89AF', marginBottom: '10px', fontWeight: '500', lineHeight: '17px' }}>
                                   Want your own personalized storefront to showcase all your important links in one place? Apply now & we'll notify you with the next steps.
                                 </p> */}
                                   <p style={{ marginTop: '8px', fontSize: '14px', color: '#6E89AF', marginBottom: '10px', fontWeight: '500', lineHeight: '17px' }}>
                                   Create your growth flywheel with your own WithMe storefront.
                                 </p>

                                 <Button
                                    disableElevation
                                    sx={{
                                       backgroundColor: 'var(--brand-color)',
                                       color: 'white', 
                                       fontSize: '15px',
                                       fontWeight: 'bold',
                                       width: '100%',
                                       height: '45px',
                                       borderRadius: '8px',
                                       textTransform: 'none',
                                       mt: 2,
                                       ':hover': {
                                          backgroundColor: 'var(--brand-color)',
                                          opacity: '0.95'
                                       }
                                    }}
                                    onClick={() => window.location.href = 'mailto:mgray@fitwithofficial.com?subject=Application for WithMe Storefront'}
                                    variant='contained'
                                 >
                                    Claim My Storefront
                                 </Button>
                              </Box>
                           </Box>
                           </>
                        :
                        (this.state.activeTab === 'Edit Design') ?
                           <>
                        <Box
                              sx={{
                                 display: 'flex', 
                                 flexDirection: 'column',
                                 border: '1px solid #E4EBF6',
                                 gap: '20px',
                                 padding: '20px', 
                                 backgroundColor: '#fff',
                                 borderRadius: '12px',
                                 margin: '0 auto',
                              }}
                           >
                              <Box
                                 sx={{
                                    width: '100%',
                                    height: 'auto',
                                    margin: '0 auto'
                                 }}
                              >
                                 <img 
                                    src={EditDesignImage}
                                    style={{
                                       width: '100%',
                                       height: 'auto',
                                       borderRadius: '12px'
                                    }}
                                 />
                              </Box>

                              <Box sx={{flex: 1}}>
                                 <h1 style={{ fontSize: '18px', fontWeight: '600', color: '#222222', margin: '0px 0px 0px 0px', fontFamily: 'var(--main-font-family)' }}>
                                    Customization is coming to WithMe
                                 </h1>

                                 {/* <p style={{ marginTop: '8px', fontSize: '14px', color: '#6E89AF', marginBottom: '10px', fontWeight: '500', lineHeight: '17px' }}>
                                   Want your own personalized storefront to showcase all your important links in one place? Apply now & we'll notify you with the next steps.
                                 </p> */}
                                   <p style={{ marginTop: '8px', fontSize: '14px', color: '#6E89AF', marginBottom: '10px', fontWeight: '500', lineHeight: '17px' }}>
                                   Soon you will be able to customize your WithMe platform to your liking. Different fonts, colours, and more.
                                 </p>

                                
                              </Box>
                           </Box>
                           </>
                        :
                           null
                        )
                     }
                  </div>
               }
            </Box>)
      } else {

         bannerMain = (
            <Box
               sx={{
                  width: '100%',
                  zIndex: '999',
                  display: 'flex',
                  flexDirection: 'column',
                  maxWidth: '100vw',
                  justifyContent: 'center',
                  alignItems: 'center',
               }}
            >

               <Item id={'banner_desktop'} xs={12} sx={{
                  backgroundColor: 'white',
                  display: 'flex',
                  flexGrow: 1,
                  left: '0px',
                  maxWidth: '100vw',
                  margin: '0px auto',
                  borderTopLeftRadius: current_page_view === 'preview' || creator_preview ? '0px' : { xs: '0px', md: '12px' },
                  borderTopRightRadius: current_page_view === 'preview' || creator_preview ? '0px' : { xs: '0px', md: '12px' },
                  overflow: 'hidden',
                  width: '100%',
                  padding: '0px',
                  position: 'relative',
                  border: "none",
                  boxShadow: "none",
                  outline: "none",
                  marginTop: this.state.deviceWidth < 1280 && this.state.dashboard === true && this.state.view_type === 'creator' && (this.state.influencer_launched === false || this.state.bannerChangesMade === false) && !shouldShowEditChangesBanner ? '46px' : '',
                  flexDirection: 'column',
                  justifyContent: 'center',
               }}>

                  {(!this.state.previewInitialLoading) && (<Suspense fallback={<></>}>
                     <InfluencerBannerMain
                        open_icon_image_edit={this.state.open_icon_image_edit}
                        view_type={this.state.view_type}
                        influencer_info={this.state.influencer_info}
                        is_me={this.state.is_me}
                        edit_mode={this.state.edit_mode}
                        ToggleEdit={this.ToggleEdit}
                        influencerBannerImage={this.state.banner_file}
                        setState={this.setState}
                        OnInfluencerEditChange={this.OnInfluencerEditChange}
                        influencerBioLength={this.state.influencerBioLength}
                        editedBio={this.state.editedBio}
                        OpenSubscribePopup={this.OpenSubscribePopup}
                        OpenWaitingListPopup={this.OpenWaitingListPopup}
                        CloseSubscribePopup={this.CloseSubscribePopup}
                        CloseWaitingListPopup={this.CloseWaitingListPopup}
                        influencer_n_subscribers={this.state.influencer_n_subscribers}
                        influencer_show_icon_image={this.state.influencer_show_icon_image}
                        current_user={this.state.current_user}
                        isLargeDevice={this.state.isLargeDevice}
                        isXLargeDevice={this.state.isXLargeDevice}
                        bannerImage={this.state.bannerImage}
                        headerVideo={this.state.headerVideo}
                        onVideoChange={this.onVideoChange}
                        onBannerChange={this.onBannerChange}
                        freeSubSubscribe={this.freeSubSubscribe}
                        n_page_views={this.state.n_page_views}
                        currency={this.state.currency}
                        influencer_rating_average={this.state.influencer_rating_average}
                        influencer_rating_count={this.state.influencer_rating_count}
                        rating_color={this.state.rating_color}
                        influencer_user_rating={this.state.influencer_user_rating}
                        data_func={this.get_and_post_data_skeleton}
                        update_ratings={this.update_ratings}
                        waiting_list={this.state.influencer_info['waiting_list']}
                        banner_file_path={this.state.influencer_info['banner_file_path']}
                        influencer={this.state.influencer_name}
                        trial_length={this.state.subscribe_popup_trial_length}
                        discordActive={this.state.discord_active}
                        userDiscordSetup={this.state.user_discord_setup}
                        async_active={this.state.subscribe_popup_async_active}
                        discordAccess={this.state.influencer_info.discord_access}
                        uploadComplete={this.state.uploadComplete}
                        content_count={this.state.content_count}
                        alteredBio={this.state.alteredBio}
                        alteredDisplayName={this.state.alteredDisplayName}
                        influencerDisplayName={this.state.influencer_info['influencer_name'] ? this.state.influencer_info['influencer_name'] : this.state.influencer_info['influencer']}
                        influencerDescription={this.state.influencer_info['description']}
                        influencerBanner={this.state.influencerBanner}
                        influencerVideo={this.state.influencerVideo}
                        influencerIcon={this.state.influencer_info['icon_image_path']}
                        influencerDisplayNameUpdated={this.state.influencerDisplayNameUpdated}
                        influencerDescriptionUpdated={this.state.influencerDescriptionUpdated}
                        influencerIconUpdated={this.state.influencerIconUpdated}
                        influencerBannerUpdated={this.state.influencerBannerUpdated}
                        influencerBannerUpdatedFile={this.state.influencerBannerUpdatedFile}
                        influencerVideoUpdated={this.state.influencerVideoUpdated}
                        influencerVideoUpdatedFile={this.state.influencerVideoUpdatedFile}
                        handleIconChange={this.handleIconChange}
                        setCurrentBanner={this.setCurrentBanner}
                        setCurrentVideo={this.setCurrentVideo}
                        handleSetBannerChange={this.handleSetBannerChange}
                        handleClearNewIcon={this.handleClearNewIcon}
                        handleSetVideoChange={this.handleSetVideoChange}
                        handleRemoveVideo={this.handleRemoveVideo}
                        UpdateIconImagePush={this.UpdateIconImagePush}
                        bannerChangesMade={this.state.bannerChangesMade}
                        bannerChangesMadeCheck={this.bannerChangesMadeCheck}
                        setRevertImageFalse={this.setRevertImageFalse}
                        revertUserIcon={this.revertUserIcon}
                        revertImage={this.state.revertImage}
                        videoRemoved={this.state.videoRemoved}
                        deviceWidth={this.state.deviceWidth}
                        free_trial_eligible={this.state.free_trial_eligible}
                        ratingsModel={this.state.ratingsModal}
                        subpopup_tier_async_overwrite={this.state.subpopup_tier_async_overwrite}
                        paidDMsExplainerModal={this.state.paidDMsExplainerModal}
                        openCheckout={this.openDMCheckout}
                        dm_active={this.state.dm_active}
                        async_tier_access={this.state.subpopup_tier_async_overwrite !== null ? this.state.subpopup_tier_async_overwrite : this.state.subscribe_popup_async_tier_access}
                        subscribe_popup_async_active={this.state.subscribe_popup_async_active}
                        handleProfileTabChange={this.handleProfileTabChange}
                        paidDMs_show={this.state.paidDMs_show}
                        paidDMs_has_message={this.state.paidDMs_has_messages}
                        windowWidth={window.innerWidth}
                        isDashboard={this.props.dashboard}
                        showChangesBanner={true}
                        saveChanges={this.saveChanges}
                        revertChanges={this.revertChanges}
                        isPublished={this.state.influencer_info['waiting_list']}
                        isMessagesActive={true}
                        free_active={this.state.influencer_info['free_active']}
                        bronze_active={this.state.subscribe_popup_bronze_active}
                        silver_active={this.state.subscribe_popup_silver_active}
                        gold_active={this.state.subscribe_popup_gold_active}
                        subscribe_popup_async_tier_apply={this.state.subscribe_popup_async_tier_apply}
                        subscribe_popup_bronze_monthly_active={this.state.subscribe_popup_bronze_monthly_active}
                        subscribe_popup_silver_monthly_active={this.state.subscribe_popup_silver_monthly_active}
                        subscribe_popup_gold_monthly_active={this.state.subscribe_popup_gold_monthly_active}
                        subscribe_popup_bronze_annual_active={this.state.subscribe_popup_bronze_annual_active}
                        subscribe_popup_silver_annual_active={this.state.subscribe_popup_silver_annual_active}
                        subscribe_popup_gold_annual_active={this.state.subscribe_popup_gold_annual_active}
                        isMyPlatform
                        current_tier={this.state.influencer_info['current_tier']}
                        influencer_bool={this.state.influencer_bool}
                        hidden_influencer={this.state.hidden_influencer}
                        n_user_subscriptions={this.state.n_user_subscriptions}
                        user_subscriptions={this.state.user_subscriptions}
                        recommended_influencers={this.state.recommended_influencers}
                        mobile_content={this.state.mobile_content}
                        influencer_id={this.state.influencer_info['id']}
                        setCalendlyModal={this.setCalendlyModal}
                        customiseMode={this.state.customiseMode}
                        handleCustomiseMode={this.handleCustomiseMode}
                        handleCancelCustomise={this.handleCancelCustomise}
                        dashboard={this.state.dashboard}
                        waiting_list_influencer={this.state.waiting_list_influencer}
                        current_user_state={this.state.current_user}
                        current_user_icon={this.state.current_user_icon}
                        top_bar_text={this.state.influencer_name}
                        subs_user_menu={true}
                        show_search={true}
                        display_name={this.state.display_name}
                        influencer_page={true}
                        mobileSearchOpen={this.state.mobileSearchOpen}
                        handleMobileSearchClose={this.handleMobileSearchClose}
                        handleMobileSearchOpen={this.handleMobileSearchOpen}
                        onWaitingList={this.state.isWaitingList}
                     />
                  </Suspense>)}

               </Item>
            </Box>
         )
      }

      if (this.state.influencer_content_list === null && this.state.collection_data.length === 0) {
         swiper_data = ''
      } else if ((this.state.influencer_info['waiting_list'] === true) && (this.state.is_me === false)) {
         swiper_data = ''
      } else {
         if (this.state.influencer_content_list || this.state.collection_data.length > 0) {
            swiper_data =
               <>
                  <Suspense fallback={<></>}>
                     <div ref={this.tabsBarRef}
                        style={{
                           position: 'relative',
                           top: this.state.isTabsFixed ? '0px' : '',
                           margin: this.state.deviceWidth >= 1280 && (this.state.selected_tab === 'sub_collections' || this.state.selected_tab === 'sub_posts' || this.state.selected_tab === 'membership' || this.state.selected_tab === 'paid_posts' || this.state.selected_tab === 'paid_collections' || this.state.selected_tab === 'collections') && current_page_view !== 'preview' && current_page_view !== 'platform' && this.state.is_me ? '40px 40px' : '',
                           boxSizing: 'border-box',
                           zIndex: this.state.isTabsFixed ? '1200' : '900',
                        }}>

                           {(!this.state.is_me || (this.state.is_me && (current_page_view === 'subscriptions' || current_page_view === 'all' || current_page_view === 'sub_posts' || (current_page_view === 'digital_products' || current_page_view === 'paid_posts') || (current_page_view === 'courses' || current_page_view === 'paid_collections') || current_page_view === 'sub_collections' || current_page_view === 'collections')) && (current_page_view !== 'messages' && current_page_view !== 'community' && current_page_view !== 'async')) ?
                           <>
                              <InfluencerTabsBar
                                 creator_preview={creator_preview}
                                 isTabsFixed={this.state.isTabsFixed}
                                 current_page_view={current_page_view}
                                 my_platform_page={this.state.my_platform_page}
                                 windowWidth={this.state.deviceWidth}
                                 setState={this.setState}
                                 contentIsLoading={this.state.contentIsLoading}
                                 current_user={this.state.current_user}
                                 content_length={this.state.influencer_content_list.length}
                                 selected_tab={this.state.selected_tab}
                                 live_count={this.state.live_count}
                                 all_count={this.state.all_count}
                                 saved_count={this.state.saved_count}
                                 collections_count={this.state.collections_count}
                                 scheduled_count={this.state.scheduled_count}
                                 creator_tabs={this.state.creator_tabs}
                                 is_me={this.state.is_me}
                                 confirmationSnackbarOpen={this.state.confirmationSnackbarOpen}
                                 handleConfirmationSnackbarClose={this.handleConfirmationSnackbarClose}
                                 handleConfirmationSnackbarOpen={this.handleConfirmationSnackbarOpen}
                                 single_view_collection={this.state.single_view_collection}
                                 handleOpenCollections={this.handleOpenCollections}
                                 buyCollectionActive={this.state.buyCollectionActive}
                                 buyCollectionCheckoutOpen={this.state.buyCollectionCheckoutOpen}
                                 buyCollectionPriceCheckout={this.state.buyCollectionPriceCheckout}
                                 buyCollectionPriceCheckoutStr={this.state.buyCollectionPriceCheckoutStr}
                                 buyCollectionThumbnailUrl={this.state.buyCollectionThumbnailUrl}
                                 buyCollectionTitle={this.state.buyCollectionTitle}
                                 handleSingleViewCollection={this.handleSingleViewCollection}
                                 influencer_info_influencer={this.state.influencer_info['influencer']}
                                 current_tier={this.state.influencer_info['current_tier']}
                                 influencer_content_list={this.state.influencer_content_list}
                                 category_filter={this.state.category_filter}
                                 content_filter={this.state.content_filter}
                                 sort_filter={this.state.sort_filter}
                                 collection_filter={this.state.collection_filter}
                                 anchorEl={this.state.anchorEl}
                                 collectionsMobileAnchorEl={this.state.collectionsMobileAnchorEl}
                                 collectionsMobileOpen={this.state.collectionsMobileOpen}
                                 category_menu_open={this.state.category_menu_open}
                                 categories={this.state.categories_filter}
                                 content_types={this.state.content_types}
                                 categories_rerender={this.state.categories}
                                 sort_menu_open={this.state.sort_menu_open}
                                 collections_menu_open={this.state.collections_menu_open}
                                 content_menu_open={this.state.content_menu_open}
                                 handleProfileTabChange={this.handleProfileTabChange}
                                 handleCollectionTabChange={this.handleCollectionTabChange}
                                 handleCopyClick={this.handleCopyClick}
                                 sort_options={sort_options}
                                 subscribe_popup_bronze_active={this.state.subscribe_popup_bronze_active}
                                 subscribe_popup_silver_active={this.state.subscribe_popup_silver_active}
                                 subscribe_popup_gold_active={this.state.subscribe_popup_gold_active}
                                 subscribe_popup_async_active={this.state.subscribe_popup_async_active}
                                 dashboard={this.state.dashboard}
                                 view_type={this.state.view_type}
                                 collection_names={this.state.collection_names}
                                 collection_data={this.state.collection_data}
                                 async_tier_access={creator_preview ? this.state.async_is_active : this.state.subpopup_tier_async_overwrite !== null ? this.state.subpopup_tier_async_overwrite : this.state.subscribe_popup_async_tier_access}
                                 handleOpenHiddenTabModal={this.handleOpenHiddenTabModal}
                                 community_is_active={this.state.community_is_active}
                                 handleOpenInfoTabModal={this.handleOpenInfoTabModal}
                                 handleCloseInfoTabModal={this.handleCloseInfoTabModal}
                                 asyncActive={this.state.subscribe_popup_async_active}
                                 hasAsyncMembers={this.state.hasAsyncMembers}
                                 dm_active={this.state.dm_active}
                                 subscription_popup_info_renewal_date={this.state.subscription_popup_info_renewal_date}
                                 open_modal={this.state.subscribe_popup_open}
                                 icon_image={this.state.subscribe_popup_icon_image}
                                 influencer={this.state.influencer_info['influencer']}
                                 influencer_name={this.state.subscribe_popup_influencer_name}
                                 minimum_tier={this.state.subscribe_popup_minimum_tier}
                                 bronze_price={this.state.subscribe_popup_bronze_price}
                                 silver_price={this.state.subscribe_popup_silver_price}
                                 gold_price={this.state.subscribe_popup_gold_price}
                                 bronze_perks_text={this.state.subscribe_popup_bronze_perks_text}
                                 silver_perks_text={this.state.subscribe_popup_silver_perks_text}
                                 gold_perks_text={this.state.subscribe_popup_gold_perks_text}
                                 nextStep={this.goToCheckout}
                                 CloseSubscribePopup={this.CloseSubscribePopup}
                                 UpgradeSubInfoPopup={this.UpgradeSubInfoPopup}
                                 DowngradeSubInfoPopup={this.DowngradeSubInfoPopup}
                                 free_trial_eligible={this.state.free_trial_eligible}
                                 current_free_trial={this.state.subscribe_popup_current_free_trial}
                                 free_active={((this.state.subscribe_popup_single_tier === true) && (this.state.subscribe_popup_initial_selected_tier === 0)) ? true : ((this.state.subscribe_popup_single_tier === true) && (this.state.subscribe_popup_initial_selected_tier !== 0)) ? false : this.state.subscribe_popup_free_active}
                                 bronze_active={((this.state.subscribe_popup_single_tier === true) && (this.state.subscribe_popup_initial_selected_tier === 1)) ? true : ((this.state.subscribe_popup_single_tier === true) && (this.state.subscribe_popup_initial_selected_tier !== 1)) ? false : this.state.subscribe_popup_bronze_active}
                                 silver_active={((this.state.subscribe_popup_single_tier === true) && (this.state.subscribe_popup_initial_selected_tier === 2)) ? true : ((this.state.subscribe_popup_single_tier === true) && (this.state.subscribe_popup_initial_selected_tier !== 2)) ? false : this.state.subscribe_popup_silver_active}
                                 gold_active={((this.state.subscribe_popup_single_tier === true) && (this.state.subscribe_popup_initial_selected_tier === 3)) ? true : ((this.state.subscribe_popup_single_tier === true) && (this.state.subscribe_popup_initial_selected_tier !== 3)) ? false : this.state.subscribe_popup_gold_active}
                                 free_name={this.state.subscribe_popup_free_name}
                                 bronze_name={this.state.subscribe_popup_bronze_name}
                                 silver_name={this.state.subscribe_popup_silver_name}
                                 gold_name={this.state.subscribe_popup_gold_name}
                                 current_duration={this.state.subscribe_popup_current_duration}
                                 currency={this.state.currency}
                                 bronze_annual_price={this.state.subscribe_popup_bronze_annual_price}
                                 silver_annual_price={this.state.subscribe_popup_silver_annual_price}
                                 gold_annual_price={this.state.subscribe_popup_gold_annual_price}
                                 bronze_show_annual_reduction={this.state.subscribe_popup_bronze_show_annual_reduction}
                                 silver_annual_reduction={this.state.subscribe_popup_silver_show_annual_reduction}
                                 gold_annual_reduction={this.state.subscribe_popup_gold_show_annual_reduction}
                                 bronze_monthly_active={this.state.subscribe_popup_bronze_monthly_active}
                                 silver_monthly_active={this.state.subscribe_popup_silver_monthly_active}
                                 gold_monthly_active={this.state.subscribe_popup_gold_monthly_active}
                                 bronze_annual_active={this.state.subscribe_popup_bronze_annual_active}
                                 silver_annual_active={this.state.subscribe_popup_silver_annual_active}
                                 gold_annual_active={this.state.subscribe_popup_gold_annual_active}
                                 trial_length={this.state.subscribe_popup_trial_length}
                                 initial_selected_tier={this.state.subscribe_popup_initial_selected_tier}
                                 influencer_icon={this.state.influencer_info['icon_image_path']}
                                 influencer_banner={this.state.influencerBanner}
                                 promo_code={this.state.promo_code}
                                 async_price={this.state.subscribe_popup_async_price}
                                 async_perks_text={this.state.subscribe_popup_async_perks_text}
                                 async_active={((this.state.subscribe_popup_single_tier === true) && (this.state.subscribe_popup_initial_selected_tier === 4)) ? true : ((this.state.subscribe_popup_single_tier === true) && (this.state.subscribe_popup_initial_selected_tier !== 4)) ? false : this.state.subscribe_popup_async_active}
                                 async_name={this.state.subscribe_popup_async_name}
                                 async_annual_price={this.state.subscribe_popup_async_annual_price}
                                 async_annual_reduction={this.state.subscribe_popup_async_show_annual_reduction}
                                 async_monthly_active={this.state.subscribe_popup_async_monthly_active}
                                 async_annual_active={this.state.subscribe_popup_async_annual_active}
                                 subscribe_popup_single_tier={this.state.subscribe_popup_single_tier}
                                 async_annual_duration={this.state.subscribe_popup_async_annual_duration}
                                 async_annual_duration_type={this.state.subscribe_popup_async_annual_duration_type}
                                 async_annual_rebill={this.state.subscribe_popup_async_annual_rebill}
                                 paidDMs_show={this.state.paidDMs_show}
                                 async_tier_hidden={this.state.subscribe_popup_async_tier_hidden}
                                 async_tier_apply={this.state.subscribe_popup_async_tier_apply}
                                 handleCancelCustomise={this.handleCancelCustomise}
                                 openAsyncApply={this.openAsyncApply}
                                 async_apply={this.state.async_apply}
                                 content_list_length={this.state.content_list_length}
                                 page_n={this.state.page_n}
                                 setPageN={this.setPageN}
                                 update_filter_state={this.update_filter_state}
                                 categories_list={this.state.categories}
                                 current_user_icon={this.state.current_user_icon}
                                 influencer_username={this.state.influencer_info['influencer']}
                                 influencer_display_name={this.state.influencer_info['influencer_name']}
                                 search_func={this.openSearchContent}
                                 search_func_collection={this.openSearchContentCollection}
                                 buyCollectionPrice={((this.state.collection_data.length > 0) && (this.state.single_view_collection !== '')) ? this.state.collection_data[this.state.single_view_collection]?.collection_price : 0}
                                 subscribe_popup_bronze_monthly_active={this.state.subscribe_popup_bronze_monthly_active}
                                 subscribe_popup_silver_monthly_active={this.state.subscribe_popup_silver_monthly_active}
                                 subscribe_popup_gold_monthly_active={this.state.subscribe_popup_gold_monthly_active}
                                 subscribe_popup_bronze_annual_active={this.state.subscribe_popup_bronze_annual_active}
                                 subscribe_popup_silver_annual_active={this.state.subscribe_popup_silver_annual_active}
                                 subscribe_popup_gold_annual_active={this.state.subscribe_popup_gold_annual_active}
                                 updateCollectionOrder={this.updateCollectionOrder}
                                 bannerChangesMadeCheck={this.bannerChangesMadeCheck}
                                 silver_access={this.state.subscription_popup_silver_access}
                                 gold_access={this.state.subscription_popup_gold_access}
                                 isCollectionContentReorder={this.state.isCollectionContentReorder}
                                 saveNewCollectionContentOrder={this.saveNewCollectionContentOrder}
                                 tier_filter={this.state.tier_filter}
                                 tier_menu_open={this.state.tier_menu_open}
                              />
                           </>
                           : 
                           null

                        }

                     </div>
                  </Suspense>
                  <div ref={this.resetTabsRef}></div>




                  {this.state.dashboard === true && this.state.selected_tab === 'dashboard' && this.state.is_me && this.state.my_platform_page !== 'add_product' &&
   <>

                     <Suspense fallback={<></>}><DashboardOnboarding
                        incomeData={this.state.incomeData}
                        handleRemoveVideo={this.handleRemoveVideo}
                        windowWidth={this.state.deviceWidth}
                        windowHeight={window.innerHeight}
                        expanded={this.state.expanded}
                        expandedDashboard={this.state.expandedDashboard}
                        setState={this.setState}
                        selected_tab={this.state.selected_tab}
                        updateViewType={this.updateViewType}
                        isSwitchOn={this.state.isSwitchOn}
                        profileLiveLoading={this.state.profileLiveLoading}
                        copyButtonClicked={this.state.copyButtonClicked}
                        progressCount={this.state.progressCount}
                        firstName={this.state.first_name}
                        watchedSalesVideo={this.state.watchedSalesVideo}
                        setupProfile={this.state.setupProfile}
                        sharedWaitingList={this.state.sharedWaitingList}
                        oneWaitingList={this.state.oneWaitingList}
                        uploadedContent={this.state.uploadedContent}
                        uploadedPlaylistContent={this.state.uploadedPlaylistContent}
                        updatedPerks={this.state.updatedPerks}
                        setupStripe={this.state.setupStripe}
                        stripeStatus={this.state.stripeStatus}
                        missingProfiles={this.state.missingProfiles}
                        missingText={this.state.missingText}
                        tierText={this.state.tierText}
                        stripeRedirectLink={this.state.stripeRedirectLink}
                        tierChangeOptions={this.state.tierChangeOptions}
                        shareWaitingListError={this.state.shareWaitingListError}
                        joinReasonAdded={this.state.joinReasonAdded}
                        profileVideoAdded={this.state.profileVideoAdded}
                  handleCreateContent={this.handleCreateContent}
                  handleCreateCollection={this.handleCreateCollection}
                  handleCreateMembership={this.handleCreateMembership}
                  handleCreateAsync={this.handleCreateAsync}
                  handleCreateCommunity={this.handleCreateCommunity}
                        showContentConfetti={this.state.showContentConfetti}
                        openProfileWhatsThis={this.state.openProfileWhatsThis}
                        openOfferingWhatsThis={this.state.openOfferingWhatsThis}
                        openWaitingListWhatsThis={this.state.openWaitingListWhatsThis}
                        openCallWhatsThis={this.state.openCallWhatsThis}
                        openContentWhatsThis={this.state.openContentWhatsThis}
                        openStripeWhatsThis={this.state.openStripeWhatsThis}
                        openUrlWhatsThis={this.state.openUrlWhatsThis}
                        openEditUrl={this.state.openEditUrl}
                        editedUsername={this.state.editedUsername}
                        editUrlErrorMsg={this.state.editUrlErrorMsg}
                        openRefCalcWhatsThis={this.state.openRefCalcWhatsThis}
                        tiersModal={this.state.tiersModal}
                        publishModal={this.state.publishModal}
                        contentCount={this.state.content_count}
                        waitingListCount={this.state.waitingListCount}
                        collectionsCount={this.state.collectionsCount}
                        activeTierCount={this.state.activeTierCount}
                        snackbar={this.state.snackbar}
                        snackbarAutoHide={this.state.snackbarAutoHide}
                        snackbarSeverity={this.state.snackbarSeverity}
                        confettiModal={this.state.confettiModal}
                        // setConfettiModal={(value) => {this.setState({confettiModal: value});}}
                        whatsThisModal={this.state.whatsThisModal}
                        // setWhatsThisModal={(value) => {this.setState({whatsThisModal: value});}}
                        checkListModal={this.statecheckListModal}
                        handleOpenSplashScreen={this.handleOpenSplashScreen}
                        waitlistSplashScreenOpen={this.state.waitlistSplashScreenOpen}
                        // setCheckListModal={(value) => {this.setState({checkListModal: value});}}
                        makeInfluencerLive={this.makeInfluencerLive}
                        handleProfileTabChange={this.handleProfileTabChange}
                        influencerUsername={this.state.current_user}
                        influencerIcon={this.state.influencer_info['icon_image_path']}
                        influencerDescription={this.state.influencer_info['description']}
                        influencerEmail={this.state.user_email}
                        influencerBanner={this.state.influencerBanner}
                        influencerVideo={this.state.influencerVideo}
                        influencerIntercomKey={this.state.intercom_verify_key}
                        // setCalendlyModal={(value) => {this.setState({calendly_modal: true});}}
                        switch_onChange_handle={this.switch_onChange_handle}
                        // setCalendlyModal={(value) => {this.setState({calendly_modal: true});}}
                        setCalendlyModal={this.setDemoModal}
                        submitUsernameUpdate={this.submitUsernameUpdate}
                        // openUploadPopup={(contentType) => {this.setState({open_content_upload: true, content_type: contentType})}}
                        view_type={this.state.view_type}
                        // changeViewType={(event) => {this.updateViewType(event)}}
                        // setErrorMsg={(value) => {this.setState({errorMsg: value})}}
                        // checklist
                        setTrialLength={this.setTrialLength}
                        trialLength={this.state.trialLength}
                        isPublished={this.state.influencer_launched}
                        // checklistHandleImageIcon={(event) => this.EditIconImageOn(event)}
                        n_views_this_week={this.state.n_views_this_week}
                        n_views_increase={this.state.n_views_increase}
                        n_subs_this_week={this.state.n_subs_this_week}
                        n_subs_increase={this.state.n_subs_increase}
                        n_subs_this_week_members={this.state.n_subs_this_week_members}
                        n_subs_increase_members={this.state.n_subs_increase_members}
                        n_subs_this_week_async={this.state.n_subs_this_week_async}
                        n_subs_increase_async={this.state.n_subs_increase_async}
                        n_single_content_this_week={this.state.n_single_content_this_week}
                        n_single_content_increase={this.state.n_single_content_increase}
                        n_paid_dms_this_week={this.state.n_paid_dms_this_week}
                        n_paid_dms_increase={this.state.n_paid_dms_increase}
                        n_tips_this_week={this.state.n_tips_this_week}
                        n_tips_increase={this.state.n_tips_increase}
                        n_collection_purchases_this_week={this.state.n_collection_purchases_this_week}
                        n_collection_purchases_increase={this.state.n_collection_purchases_increase}
                        this_month_income={this.state.this_month_income}
                        last_month_income={this.state.last_month_income}
                        currency={this.state.currency}
                        currencySymbol={
                           this.state.currency === 'GBP' ? '£' :
                              this.state.currency === 'EUR' ? '€' :
                                 this.state.currency === 'USD' ? '$' :
                                    this.state.currency === 'AUD' ? 'AU$' :
                                       this.state.currency === 'CAD' ? 'CA$' :
                                          this.state.currency === 'SEK' ? '' : ''}
                        currencySymbolPost={this.state.currency === 'SEK' ? ' kr' : ''}
                        openOffering={this.state.openOffering}
                        // Waitlist Breakdown
                        waitlistSignups={this.state.waitlistSignups}
                        pageViews={this.state.n_page_views}
                        predictedMemberships={this.state.predictedMemberships}
                        predictedFirstMonthIncome={this.state.predictedFirstMonthIncome.toFixed(0)}
                        showWaitlistPredictions={this.state.showWaitlistPredictions}
                        newPlaylistModal={this.state.newPlaylistModal}
                        influencerDisplayNameUpdated={this.state.influencerDisplayNameUpdated}
                        influencerDescriptionUpdated={this.state.influencerDescriptionUpdated}
                        influencerIconUpdated={this.state.influencerIconUpdated}
                        influencerBannerUpdatedFile={this.state.influencerBannerUpdatedFile}
                        influencerVideoUpdatedFile={this.state.influencerVideoUpdatedFile}
                        videoRemoved={this.state.videoRemoved}
                        customiseMode={this.state.customiseMode}
                        bannerChangesMadeCheck={this.bannerChangesMadeCheck}
                     />
                     
                     <AvatarEditorCreatorView
                        creatorProfile={true}
                        UpdateIconImagePush={this.UpdateIconImagePush}
                        revertUserIcon={this.revertUserIcon}
                        influencerIconUpdated={this.state.influencerIconUpdated}
                        customiseMode={this.state.customiseMode}
                        is_me={this.state.is_me}
                        url={this.state.influencer_info && this.state.influencer_info.icon_image_path ? 
                             this.state.influencer_info.icon_image_path.replace('/sm/', '/md/') : ''}
                        revertImage={this.state.revertImage}
                        setRevertImageFalse={() => { this.setRevertImageFalse(); }}
                        handleClearNewIcon={this.handleClearNewIcon}
                        setState={this.setState}
                        open_icon_image_edit={this.state.open_icon_image_edit}
                     />
                     </Suspense>
</>

                  }
                  {
                     this.state.my_platform_page === 'creation_flow' && (current_page_view === 'community' || current_page_view === '1v1coaching' || current_page_view === 'messages') &&
                     <Suspense fallback={<></>}>
                        <InfluencerCreationFlow
                        current_page_view={current_page_view}
                        influencer_content_list={this.state.influencer_content_list}
                        handleCloseTiers={this.handleCloseTiers}
                        selectedMemberTabOverwrite={this.state.selectedMemberTabOverwrite}
                        selected_tab={this.state.selected_tab}
                        my_platform_page={this.state.my_platform_page}
                        influencer_icon={this.state.influencer_info['icon_image_path']}
                        dashboard={this.state.dashboard}
                        isPublished={this.state.influencer_launched}
                        view_type={this.state.view_type}
                        contentIsLoading={this.state.contentIsLoading}
                        current_user={this.state.current_user}
                        current_user_icon={this.state.current_user_icon}
                        is_me={this.state.is_me}
                        influencer={this.state.influencer_name}
                        influencer_info={this.state.influencer_info}
                        currency={this.state.currency}
                        current_tier={this.state.subscribe_popup_current_tier}
                        post_id={this.state.post_id}
                        // buy collections
                        single_view_collection={this.state.single_view_collection}
                        sort_filter={this.state.sort_filter}
                        collection_filter={this.state.collection_filter}
                        category_filter={this.state.category_filter}
                        content_filter={this.state.content_filter}
                        isExtraSmallDevice={this.state.isExtraSmallDevice}
                        collectionTitleHovered={this.state.collectionTitleHovered}
                        hoveredIndex={this.state.hoveredIndex}
                        setState={this.setState}
                        OpenSubscribePopup={this.OpenSubscribePopup}
                        openBuyNowCheckout={this.openBuyNowCheckout}
                        openBuyCollectionCheckout={this.openBuyCollectionCheckout}
                        buyCollectionId={this.state.buyCollectionId}
                        handleBuyNowCheckoutData={this.handleBuyNowCheckoutData}
                        handleProfileTabChange={this.handleProfileTabChange}
                        OpenWaitingListPopup={this.OpenWaitingListPopup}
                        CloseSubscribePopup={this.CloseSubscribePopup}
                        CloseWaitingListPopup={this.CloseWaitingListPopup}
                        like_button_click_post={this.like_button_click_post}
                        share_button_click={this.share_button_click}
                        bookmark_button_post={this.bookmark_button_click_post}
                        bookmark_button_click={this.bookmark_button_click}
                        pinned_post_process={this.pinned_post_process}
                        like_button_click={this.like_button_click}
                        update_filter_state={this.update_filter_state}
                        get_and_post_data_skeleton={this.get_and_post_data_skeleton}
                        handleCollectionTitleMouseLeave={this.handleCollectionTitleMouseLeave}
                        handleCollectionTitleMouseEnter={this.handleCollectionTitleMouseEnter}
                        isSmallDevice={this.state.isSmallDevice}
                        isMediumDevice={this.state.isMediumDevice}
                        isLargeDevice={this.state.isLargeDevice}
                        isXLargeDevice={this.state.isXLargeDevice}
                        subscribe_popup_bronze_active={this.state.subscribe_popup_bronze_active}
                        subscribe_popup_silver_active={this.state.subscribe_popup_silver_active}
                        subscribe_popup_gold_active={this.state.subscribe_popup_gold_active}
                        subscribe_popup_async_active={this.state.subscribe_popup_async_active}
                        subscribe_popup_bronze_name={this.state.subscribe_popup_bronze_name}
                        subscribe_popup_silver_name={this.state.subscribe_popup_silver_name}
                        subscribe_popup_gold_name={this.state.subscribe_popup_gold_name}
                        subscribe_popup_async_name={this.state.subscribe_popup_async_name}
                        force_content_rerender={this.state.force_content_rerender}
                        handleSavedContent={this.handleSavedContent}
                        handleRemoveSavedContent={this.handleRemoveSavedContent}
                        handleContentModalOpen={this.handleContentModalOpen}
                        handleContentModalClose={this.handleContentModalClose}
                        handleObserver={this.handleObserver}
                        display_name={this.state.display_name}
                        update_inf_scroll={this.state.update_inf_scroll}
                        collection_names={this.state.collection_names}
                        collection_data={this.state.collection_data}
                        width={window.innerWidth}
                        async_tier_access={this.state.subpopup_tier_async_overwrite !== null ? this.state.subpopup_tier_async_overwrite : this.state.subscribe_popup_async_tier_access}
                        // Imports for membership to work inside influencer content sections
                        handleRemoveVideo={this.handleRemoveVideo}
                        windowWidth={this.state.deviceWidth}
                        windowHeight={window.innerHeight}
                        expanded={this.state.expanded}
                        expandedDashboard={this.state.expandedDashboard}
                        updateViewType={this.updateViewType}
                        isSwitchOn={this.state.isSwitchOn}
                        profileLiveLoading={this.state.profileLiveLoading}
                        copyButtonClicked={this.state.copyButtonClicked}
                        progressCount={this.state.progressCount}
                        influencer_bool={this.state.influencer_bool}
                        firstName={this.state.first_name}
                        watchedSalesVideo={this.state.watchedSalesVideo}
                        setupProfile={this.state.setupProfile}
                        sharedWaitingList={this.state.sharedWaitingList}
                        oneWaitingList={this.state.oneWaitingList}
                        uploadedContent={this.state.uploadedContent}
                        uploadedPlaylistContent={this.state.uploadedPlaylistContent}
                        updatedPerks={this.state.updatedPerks}
                        setupStripe={this.state.setupStripe}
                        stripeStatus={this.state.stripeStatus}
                        missingText={this.state.missingText}
                        tierText={this.state.tierText}
                        stripeRedirectLink={this.state.stripeRedirectLink}
                        tierChangeOptions={this.state.tierChangeOptions}
                        shareWaitingListError={this.state.shareWaitingListError}
                        joinReasonAdded={this.state.joinReasonAdded}
                        profileVideoAdded={this.state.profileVideoAdded}
                        showContentConfetti={this.state.showContentConfetti}
                        openProfileWhatsThis={this.state.openProfileWhatsThis}
                        openOfferingWhatsThis={this.state.openOfferingWhatsThis}
                        openWaitingListWhatsThis={this.state.openWaitingListWhatsThis}
                        openCallWhatsThis={this.state.openCallWhatsThis}
                        openContentWhatsThis={this.state.openContentWhatsThis}
                        openStripeWhatsThis={this.state.openStripeWhatsThis}
                        openUrlWhatsThis={this.state.openUrlWhatsThis}
                        openEditUrl={this.state.openEditUrl}
                        editedUsername={this.state.editedUsername}
                        editUrlErrorMsg={this.state.editUrlErrorMsg}
                        openRefCalcWhatsThis={this.state.openRefCalcWhatsThis}
                        tiersModal={this.state.tiersModal}
                        publishModal={this.state.publishModal}
                        contentCount={this.state.content_count}
                        waitingListCount={this.state.waitingListCount}
                        waiting_list_influencer={this.state.influencer_info['waiting_list']}
                        collectionsCount={this.state.collectionsCount}
                        activeTierCount={this.state.activeTierCount}
                        snackbar={this.state.snackbar}
                        snackbarAutoHide={this.state.snackbarAutoHide}
                        snackbarSeverity={this.state.snackbarSeverity}
                        confettiModal={this.state.confettiModal}
                        whatsThisModal={this.state.whatsThisModal}
                        checkListModal={this.state.checkListModal}
                        makeInfluencerLive={this.makeInfluencerLive}
                        influencerUsername={this.state.current_user}
                        influencerIcon={this.state.influencer_info['icon_image_path']}
                        missingProfiles={this.state.missingProfiles}
                        influencerDescription={this.state.influencer_info['description']}
                        influencerEmail={this.state.user_email}
                        influencerBanner={this.state.influencerBanner}
                        influencerVideo={this.state.influencerVideo}
                        influencerIntercomKey={this.state.intercom_verify_key}
                        switch_onChange_handle={this.switch_onChange_handle}
                        submitUsernameUpdate={this.submitUsernameUpdate}
                        setTrialLength={this.setTrialLength}
                        trialLength={this.state.trialLength}
                        n_views_this_week={this.state.n_views_this_week}
                        n_views_increase={this.state.n_views_increase}
                        n_subs_this_week={this.state.n_subs_this_week}
                        n_subs_increase={this.state.n_subs_increase}
                        this_month_income={this.state.this_month_income}
                        last_month_income={this.state.last_month_income}
                        openOffering={this.state.openOffering}
                        community_is_active={this.state.community_is_active}
                        handleOpenHiddenTabModal={this.handleOpenHiddenTabModal}
                        handleOpenInfoTabModal={this.handleOpenInfoTabModal}
                        handleCloseInfoTabModal={this.handleCloseInfoTabModal}
                        updateCommunityActive={this.updateCommunityActive}
                        dm_active={this.state.dm_active}
                        openDMCheckout={this.openDMCheckout}
                        updateHasMessage={this.updateHasMessage}
                        paidDMs_show={this.state.paidDMs_show}
                        maxMessageLength={this.state.max_message_length}
                        setMaxMessageLength={this.setMaxMessageLength}
                        handleCollectionTabChange={this.handleCollectionTabChange}
                        openTippingCheckout={this.openTipCheckout}
                        setCommentCount={this.setCommentCount}
                        async_apply={this.state.async_apply}
                        goToCheckout={this.goToCheckout}
                        open_messages={this.state.open_messages}
                        open_coaching={this.state.open_coaching}
                        loading_page_change={this.state.loading_page_change}
                        content_list_length={this.state.content_list_length}
                        page_n={this.state.page_n}
                        setPageN={this.setPageN}
                        n_page_views={this.state.n_page_views}
                        buyNowThumbnailUrl={this.state.buyNowThumbnailUrl}
                        buyNowTitle={this.state.buyNowTitle}
                        buyNowContentType={this.state.buyNowContentType}
                        buyNowContentId={this.state.buyNowContentId}
                        setNewPlaylistModal={this.setNewPlaylistModal}
                        handleSingleViewCollection={this.handleSingleViewCollection}
                        handleConfirmationSnackbarOpen={this.handleConfirmationSnackbarOpen}
                        handleOpenCollections={this.handleOpenCollections}
                        collectionsMobileAnchorEl={this.state.collectionsMobileAnchorEl}
                        collectionsMobileOpen={this.state.collectionsMobileOpen}
                        updateCollectionOrder={this.updateCollectionOrder}
                        influencer_username={this.state.influencer_info['influencer']}
                        search_func_collection={this.openSearchContentCollection}
                        product_type={this.state.product_type}
                        digitalProducts={this.state.digitalProducts}
                        />
                        </Suspense>
                     // <Suspense fallback={<></>}><InfluencerContent /></Suspense>
                  }

                  {
                     this.state.my_platform_page === 'add_product' &&
                     <Suspense fallback={<></>}>
                        <InfluencerAddProduct
                        isTabsFixed={this.state.isTabsFixed}
                        setTrialLength={this.setTrialLength}
                        setMaxMessageLength={this.setMaxMessageLength}
                        activeProductData={this.state.activeProductData}
                        my_platform_page={this.state.my_platform_page}
                        width={this.state.deviceWidth}
                        setState={this.setState}
                        contentIsLoading={this.state.contentIsLoading}
                        current_user={this.state.current_user}
                        content_length={this.state.influencer_content_list.length}
                        selected_tab={this.state.selected_tab}
                        live_count={this.state.live_count}
                        all_count={this.state.all_count}
                        saved_count={this.state.saved_count}
                        collections_count={this.state.collections_count}
                        scheduled_count={this.state.scheduled_count}
                        creator_tabs={this.state.creator_tabs}
                        is_me={this.state.is_me}
                        confirmationSnackbarOpen={this.state.confirmationSnackbarOpen}
                        handleConfirmationSnackbarClose={this.handleConfirmationSnackbarClose}
                        handleConfirmationSnackbarOpen={this.handleConfirmationSnackbarOpen}
                        single_view_collection={this.state.single_view_collection}
                        handleOpenCollections={this.handleOpenCollections}
                        buyCollectionActive={this.state.buyCollectionActive}
                        buyCollectionCheckoutOpen={this.state.buyCollectionCheckoutOpen}
                        buyCollectionPriceCheckout={this.state.buyCollectionPriceCheckout}
                        buyCollectionPriceCheckoutStr={this.state.buyCollectionPriceCheckoutStr}
                        buyCollectionThumbnailUrl={this.state.buyCollectionThumbnailUrl}
                        buyCollectionTitle={this.state.buyCollectionTitle}
                        handleSingleViewCollection={this.handleSingleViewCollection}
                        influencer_info_influencer={this.state.influencer_info['influencer']}
                        current_tier={this.state.influencer_info['current_tier']}
                        influencer_content_list={this.state.influencer_content_list}
                        category_filter={this.state.category_filter}
                        content_filter={this.state.content_filter}
                        sort_filter={this.state.sort_filter}
                        collection_filter={this.state.collection_filter}
                        anchorEl={this.state.anchorEl}
                        collectionsMobileAnchorEl={this.state.collectionsMobileAnchorEl}
                        collectionsMobileOpen={this.state.collectionsMobileOpen}
                        category_menu_open={this.state.category_menu_open}
                        categories={this.state.categories_filter}
                        content_types={this.state.content_types}
                        categories_rerender={this.state.categories}
                        sort_menu_open={this.state.sort_menu_open}
                        collections_menu_open={this.state.collections_menu_open}
                        content_menu_open={this.state.content_menu_open}
                        handleProfileTabChange={this.handleProfileTabChange}
                        handleCollectionTabChange={this.handleCollectionTabChange}
                        handleCopyClick={this.handleCopyClick}
                        sort_options={sort_options}
                        subscribe_popup_bronze_active={this.state.subscribe_popup_bronze_active}
                        subscribe_popup_silver_active={this.state.subscribe_popup_silver_active}
                        subscribe_popup_gold_active={this.state.subscribe_popup_gold_active}
                        subscribe_popup_async_active={this.state.subscribe_popup_async_active}
                        dashboard={this.state.dashboard}
                        view_type={this.state.view_type}
                        collection_names={this.state.collection_names}
                        collection_data={this.state.collection_data}
                        async_tier_access={this.state.subpopup_tier_async_overwrite !== null ? this.state.subpopup_tier_async_overwrite : this.state.subscribe_popup_async_tier_access}
                        handleOpenHiddenTabModal={this.handleOpenHiddenTabModal}
                        community_is_active={this.state.community_is_active}
                        handleOpenInfoTabModal={this.handleOpenInfoTabModal}
                        handleCloseInfoTabModal={this.handleCloseInfoTabModal}
                        asyncActive={this.state.subscribe_popup_async_active}
                        hasAsyncMembers={this.state.hasAsyncMembers}
                        dm_active={this.state.dm_active}
                        subscription_popup_info_renewal_date={this.state.subscription_popup_info_renewal_date}
                        open_modal={this.state.subscribe_popup_open}
                        icon_image={this.state.subscribe_popup_icon_image}
                        influencer={this.state.influencer_info['influencer']}
                        influencer_name={this.state.subscribe_popup_influencer_name}
                        minimum_tier={this.state.subscribe_popup_minimum_tier}
                        bronze_price={this.state.subscribe_popup_bronze_price}
                        silver_price={this.state.subscribe_popup_silver_price}
                        gold_price={this.state.subscribe_popup_gold_price}
                        bronze_perks_text={this.state.subscribe_popup_bronze_perks_text}
                        silver_perks_text={this.state.subscribe_popup_silver_perks_text}
                        gold_perks_text={this.state.subscribe_popup_gold_perks_text}
                        nextStep={this.goToCheckout}
                        CloseSubscribePopup={this.CloseSubscribePopup}
                        UpgradeSubInfoPopup={this.UpgradeSubInfoPopup}
                        DowngradeSubInfoPopup={this.DowngradeSubInfoPopup}
                        free_trial_eligible={this.state.free_trial_eligible}
                        current_free_trial={this.state.subscribe_popup_current_free_trial}
                        free_active={((this.state.subscribe_popup_single_tier === true) && (this.state.subscribe_popup_initial_selected_tier === 0)) ? true : ((this.state.subscribe_popup_single_tier === true) && (this.state.subscribe_popup_initial_selected_tier !== 0)) ? false : this.state.subscribe_popup_free_active}
                        bronze_active={((this.state.subscribe_popup_single_tier === true) && (this.state.subscribe_popup_initial_selected_tier === 1)) ? true : ((this.state.subscribe_popup_single_tier === true) && (this.state.subscribe_popup_initial_selected_tier !== 1)) ? false : this.state.subscribe_popup_bronze_active}
                        silver_active={((this.state.subscribe_popup_single_tier === true) && (this.state.subscribe_popup_initial_selected_tier === 2)) ? true : ((this.state.subscribe_popup_single_tier === true) && (this.state.subscribe_popup_initial_selected_tier !== 2)) ? false : this.state.subscribe_popup_silver_active}
                        gold_active={((this.state.subscribe_popup_single_tier === true) && (this.state.subscribe_popup_initial_selected_tier === 3)) ? true : ((this.state.subscribe_popup_single_tier === true) && (this.state.subscribe_popup_initial_selected_tier !== 3)) ? false : this.state.subscribe_popup_gold_active}
                        free_name={this.state.subscribe_popup_free_name}
                        bronze_name={this.state.subscribe_popup_bronze_name}
                        silver_name={this.state.subscribe_popup_silver_name}
                        gold_name={this.state.subscribe_popup_gold_name}
                        current_duration={this.state.subscribe_popup_current_duration}
                        currency={this.state.currency}
                        bronze_annual_price={this.state.subscribe_popup_bronze_annual_price}
                        silver_annual_price={this.state.subscribe_popup_silver_annual_price}
                        gold_annual_price={this.state.subscribe_popup_gold_annual_price}
                        bronze_show_annual_reduction={this.state.subscribe_popup_bronze_show_annual_reduction}
                        silver_annual_reduction={this.state.subscribe_popup_silver_show_annual_reduction}
                        gold_annual_reduction={this.state.subscribe_popup_gold_show_annual_reduction}
                        bronze_monthly_active={this.state.subscribe_popup_bronze_monthly_active}
                        silver_monthly_active={this.state.subscribe_popup_silver_monthly_active}
                        gold_monthly_active={this.state.subscribe_popup_gold_monthly_active}
                        bronze_annual_active={this.state.subscribe_popup_bronze_annual_active}
                        silver_annual_active={this.state.subscribe_popup_silver_annual_active}
                        gold_annual_active={this.state.subscribe_popup_gold_annual_active}
                        trial_length={this.state.subscribe_popup_trial_length}
                        initial_selected_tier={this.state.subscribe_popup_initial_selected_tier}
                        influencer_icon={this.state.influencer_info['icon_image_path']}
                        influencer_banner={this.state.influencerBanner}
                        promo_code={this.state.promo_code}
                        async_price={this.state.subscribe_popup_async_price}
                        async_perks_text={this.state.subscribe_popup_async_perks_text}
                        async_active={((this.state.subscribe_popup_single_tier === true) && (this.state.subscribe_popup_initial_selected_tier === 4)) ? true : ((this.state.subscribe_popup_single_tier === true) && (this.state.subscribe_popup_initial_selected_tier !== 4)) ? false : this.state.subscribe_popup_async_active}
                        async_name={this.state.subscribe_popup_async_name}
                        async_annual_price={this.state.subscribe_popup_async_annual_price}
                        async_annual_reduction={this.state.subscribe_popup_async_show_annual_reduction}
                        async_monthly_active={this.state.subscribe_popup_async_monthly_active}
                        async_annual_active={this.state.subscribe_popup_async_annual_active}
                        subscribe_popup_single_tier={this.state.subscribe_popup_single_tier}
                        async_annual_duration={this.state.subscribe_popup_async_annual_duration}
                        async_annual_duration_type={this.state.subscribe_popup_async_annual_duration_type}
                        async_annual_rebill={this.state.subscribe_popup_async_annual_rebill}
                        paidDMs_show={this.state.paidDMs_show}
                        async_tier_hidden={this.state.subscribe_popup_async_tier_hidden}
                        async_tier_apply={this.state.subscribe_popup_async_tier_apply}
                        handleCancelCustomise={this.handleCancelCustomise}
                        openAsyncApply={this.openAsyncApply}
                        async_apply={this.state.async_apply}
                        content_list_length={this.state.content_list_length}
                        page_n={this.state.page_n}
                        setPageN={this.setPageN}
                        update_filter_state={this.update_filter_state}
                        categories_list={this.state.categories}
                        current_user_icon={this.state.current_user_icon}
                        influencer_username={this.state.influencer_info['influencer']}
                        influencer_display_name={this.state.influencer_info['influencer_name']}
                        search_func={this.openSearchContent}
                        search_func_collection={this.openSearchContentCollection}
                        buyCollectionPrice={((this.state.collection_data.length > 0) && (this.state.single_view_collection !== '')) ? this.state.collection_data[this.state.single_view_collection]?.collection_price : 0}
                        subscribe_popup_bronze_monthly_active={this.state.subscribe_popup_bronze_monthly_active}
                        subscribe_popup_silver_monthly_active={this.state.subscribe_popup_silver_monthly_active}
                        subscribe_popup_gold_monthly_active={this.state.subscribe_popup_gold_monthly_active}
                        subscribe_popup_bronze_annual_active={this.state.subscribe_popup_bronze_annual_active}
                        subscribe_popup_silver_annual_active={this.state.subscribe_popup_silver_annual_active}
                        subscribe_popup_gold_annual_active={this.state.subscribe_popup_gold_annual_active}
                        updateCollectionOrder={this.updateCollectionOrder}
                        product_type={this.state.product_type}
                        handleCloseTiers={this.handleCloseTiers}
                        handleTabNavigation={this.handleTabNavigation}
                        fetchActiveProductData={this.fetchActiveProductData}
                        // loadInitialInfluencerData={this.loadInitialInfluencerData}
                        {...this.props}
                        />
                        
                        </Suspense>
                  }

                  {/* Content Feeds, Subscriptions & Collections, Courses, Digital Products */}
                  {!this.state.is_me || this.state.is_me && (current_page_view === 'subscriptions' || current_page_view === 'courses' || current_page_view === 'digital_products') && (current_page_view !== 'messages' && current_page_view !== 'community' && current_page_view !== 'async') ?
                     
                     <Suspense fallback={<></>}>
                        <InfluencerContent
                        isCollectionContentReorder={this.state.isCollectionContentReorder}
                        handleCloseTiers={this.handleCloseTiers}
                        selectedMemberTabOverwrite={this.state.selectedMemberTabOverwrite}
                        selected_tab={this.state.selected_tab}
                        my_platform_page={this.state.my_platform_page}
                        influencer_icon={this.state.influencer_info['icon_image_path']}
                        dashboard={this.state.dashboard}
                        isPublished={this.state.influencer_launched}
                        view_type={this.state.view_type}
                        contentIsLoading={this.state.contentIsLoading}
                        current_user={this.state.current_user}
                        current_user_icon={this.state.current_user_icon}
                        is_me={this.state.is_me}
                        influencer={this.state.influencer_name}
                        influencer_info={this.state.influencer_info}
                        currency={this.state.currency}
                        current_tier={this.state.subscribe_popup_current_tier}
                        post_id={this.state.post_id}
                        // buy collections
                        single_view_collection={this.state.single_view_collection}
                        sort_filter={this.state.sort_filter}
                        collection_filter={this.state.collection_filter}
                        category_filter={this.state.category_filter}
                        content_filter={this.state.content_filter}
                        influencer_content_list={this.state.influencer_content_list}
                        isExtraSmallDevice={this.state.isExtraSmallDevice}
                        collectionTitleHovered={this.state.collectionTitleHovered}
                        hoveredIndex={this.state.hoveredIndex}
                        setState={this.setState}
                        OpenSubscribePopup={this.OpenSubscribePopup}
                        openBuyNowCheckout={this.openBuyNowCheckout}
                        openBuyCollectionCheckout={this.openBuyCollectionCheckout}
                        buyCollectionId={this.state.buyCollectionId}
                        handleBuyNowCheckoutData={this.handleBuyNowCheckoutData}
                        handleProfileTabChange={this.handleProfileTabChange}
                        OpenWaitingListPopup={this.OpenWaitingListPopup}
                        CloseSubscribePopup={this.CloseSubscribePopup}
                        CloseWaitingListPopup={this.CloseWaitingListPopup}
                        like_button_click_post={this.like_button_click_post}
                        share_button_click={this.share_button_click}
                        bookmark_button_post={this.bookmark_button_click_post}
                        bookmark_button_click={this.bookmark_button_click}
                        pinned_post_process={this.pinned_post_process}
                        like_button_click={this.like_button_click}
                        update_filter_state={this.update_filter_state}
                        get_and_post_data_skeleton={this.get_and_post_data_skeleton}
                        handleCollectionTitleMouseLeave={this.handleCollectionTitleMouseLeave}
                        handleCollectionTitleMouseEnter={this.handleCollectionTitleMouseEnter}
                        isSmallDevice={this.state.isSmallDevice}
                        isMediumDevice={this.state.isMediumDevice}
                        isLargeDevice={this.state.isLargeDevice}
                        isXLargeDevice={this.state.isXLargeDevice}
                        subscribe_popup_bronze_active={this.state.subscribe_popup_bronze_active}
                        subscribe_popup_silver_active={this.state.subscribe_popup_silver_active}
                        subscribe_popup_gold_active={this.state.subscribe_popup_gold_active}
                        subscribe_popup_async_active={this.state.subscribe_popup_async_active}
                        subscribe_popup_bronze_name={this.state.subscribe_popup_bronze_name}
                        subscribe_popup_silver_name={this.state.subscribe_popup_silver_name}
                        subscribe_popup_gold_name={this.state.subscribe_popup_gold_name}
                        subscribe_popup_async_name={this.state.subscribe_popup_async_name}
                        force_content_rerender={this.state.force_content_rerender}
                        handleSavedContent={this.handleSavedContent}
                        handleRemoveSavedContent={this.handleRemoveSavedContent}
                        handleContentModalOpen={this.handleContentModalOpen}
                        handleContentModalClose={this.handleContentModalClose}
                        handleObserver={this.handleObserver}
                        display_name={this.state.display_name}
                        update_inf_scroll={this.state.update_inf_scroll}
                        collection_names={this.state.collection_names}
                        collection_data={this.state.collection_data}
                        // collection_data={[
                        //    { name: 'Demo Collection 1', id: 1, content_count: 10, is_locked: false },
                        //    { name: 'Demo Collection 2', id: 2, content_count: 10, is_locked: true },
                        //    { name: 'Demo Collection 3', id: 3, content_count: 0, is_locked: false }
                        // ]}
                        // collection_names={[
                        //    {name: 'Demo Collection 1', id: 1, content_count: 10, is_locked: false},
                        //    {name: 'Demo Collection 2', id: 2, content_count: 10, is_locked: true}, 
                        //    {name: 'Demo Collection 3', id: 3, content_count: 10, is_locked: false}
                        // ]}
                        // collection_names={['collection 1', 'collection 2', 'collection 3']}
                        width={window.innerWidth}
                        async_tier_access={this.state.subpopup_tier_async_overwrite !== null ? this.state.subpopup_tier_async_overwrite : this.state.subscribe_popup_async_tier_access}
                        // Imports for membership to work inside influencer content sections
                        handleRemoveVideo={this.handleRemoveVideo}
                        windowWidth={this.state.deviceWidth}
                        windowHeight={window.innerHeight}
                        expanded={this.state.expanded}
                        expandedDashboard={this.state.expandedDashboard}
                        updateViewType={this.updateViewType}
                        isSwitchOn={this.state.isSwitchOn}
                        profileLiveLoading={this.state.profileLiveLoading}
                        copyButtonClicked={this.state.copyButtonClicked}
                        progressCount={this.state.progressCount}
                        influencer_bool={this.state.influencer_bool}
                        firstName={this.state.first_name}
                        watchedSalesVideo={this.state.watchedSalesVideo}
                        setupProfile={this.state.setupProfile}
                        sharedWaitingList={this.state.sharedWaitingList}
                        oneWaitingList={this.state.oneWaitingList}
                        uploadedContent={this.state.uploadedContent}
                        uploadedPlaylistContent={this.state.uploadedPlaylistContent}
                        updatedPerks={this.state.updatedPerks}
                        setupStripe={this.state.setupStripe}
                        stripeStatus={this.state.stripeStatus}
                        missingText={this.state.missingText}
                        tierText={this.state.tierText}
                        stripeRedirectLink={this.state.stripeRedirectLink}
                        tierChangeOptions={this.state.tierChangeOptions}
                        shareWaitingListError={this.state.shareWaitingListError}
                        joinReasonAdded={this.state.joinReasonAdded}
                        profileVideoAdded={this.state.profileVideoAdded}
                        showContentConfetti={this.state.showContentConfetti}
                        openProfileWhatsThis={this.state.openProfileWhatsThis}
                        openOfferingWhatsThis={this.state.openOfferingWhatsThis}
                        openWaitingListWhatsThis={this.state.openWaitingListWhatsThis}
                        openCallWhatsThis={this.state.openCallWhatsThis}
                        openContentWhatsThis={this.state.openContentWhatsThis}
                        openStripeWhatsThis={this.state.openStripeWhatsThis}
                        openUrlWhatsThis={this.state.openUrlWhatsThis}
                        openEditUrl={this.state.openEditUrl}
                        editedUsername={this.state.editedUsername}
                        editUrlErrorMsg={this.state.editUrlErrorMsg}
                        openRefCalcWhatsThis={this.state.openRefCalcWhatsThis}
                        tiersModal={this.state.tiersModal}
                        publishModal={this.state.publishModal}
                        contentCount={this.state.content_count}
                        waitingListCount={this.state.waitingListCount}
                        waiting_list_influencer={this.state.influencer_info['waiting_list']}
                        collectionsCount={this.state.collectionsCount}
                        activeTierCount={this.state.activeTierCount}
                        snackbar={this.state.snackbar}
                        snackbarAutoHide={this.state.snackbarAutoHide}
                        snackbarSeverity={this.state.snackbarSeverity}
                        confettiModal={this.state.confettiModal}
                        whatsThisModal={this.state.whatsThisModal}
                        checkListModal={this.state.checkListModal}
                        makeInfluencerLive={this.makeInfluencerLive}
                        influencerUsername={this.state.current_user}
                        influencerIcon={this.state.influencer_info['icon_image_path']}
                        missingProfiles={this.state.missingProfiles}
                        influencerDescription={this.state.influencer_info['description']}
                        influencerEmail={this.state.user_email}
                        influencerBanner={this.state.influencerBanner}
                        influencerVideo={this.state.influencerVideo}
                        influencerIntercomKey={this.state.intercom_verify_key}
                        switch_onChange_handle={this.switch_onChange_handle}
                        submitUsernameUpdate={this.submitUsernameUpdate}
                        setTrialLength={this.setTrialLength}
                        trialLength={this.state.trialLength}
                        n_views_this_week={this.state.n_views_this_week}
                        n_views_increase={this.state.n_views_increase}
                        n_subs_this_week={this.state.n_subs_this_week}
                        n_subs_increase={this.state.n_subs_increase}
                        this_month_income={this.state.this_month_income}
                        last_month_income={this.state.last_month_income}
                        openOffering={this.state.openOffering}
                        community_is_active={this.state.community_is_active}
                        handleOpenHiddenTabModal={this.handleOpenHiddenTabModal}
                        handleOpenInfoTabModal={this.handleOpenInfoTabModal}
                        handleCloseInfoTabModal={this.handleCloseInfoTabModal}
                        updateCommunityActive={this.updateCommunityActive}
                        dm_active={this.state.dm_active}
                        openDMCheckout={this.openDMCheckout}
                        updateHasMessage={this.updateHasMessage}
                        paidDMs_show={this.state.paidDMs_show}
                        maxMessageLength={this.state.max_message_length}
                        setMaxMessageLength={this.setMaxMessageLength}
                        handleCollectionTabChange={this.handleCollectionTabChange}
                        openTippingCheckout={this.openTipCheckout}
                        setCommentCount={this.setCommentCount}
                        async_apply={this.state.async_apply}
                        goToCheckout={this.goToCheckout}
                        open_messages={this.state.open_messages}
                        open_coaching={this.state.open_coaching}
                        loading_page_change={this.state.loading_page_change}
                        content_list_length={this.state.content_list_length}
                        page_n={this.state.page_n}
                        setPageN={this.setPageN}
                        n_page_views={this.state.n_page_views}
                        buyNowThumbnailUrl={this.state.buyNowThumbnailUrl}
                        buyNowTitle={this.state.buyNowTitle}
                        buyNowContentType={this.state.buyNowContentType}
                        buyNowContentId={this.state.buyNowContentId}
                        setNewPlaylistModal={this.setNewPlaylistModal}
                        handleSingleViewCollection={this.handleSingleViewCollection}
                        handleConfirmationSnackbarOpen={this.handleConfirmationSnackbarOpen}
                        handleOpenCollections={this.handleOpenCollections}
                        collectionsMobileAnchorEl={this.state.collectionsMobileAnchorEl}
                        collectionsMobileOpen={this.state.collectionsMobileOpen}
                        updateCollectionOrder={this.updateCollectionOrder}
                        influencer_username={this.state.influencer_info['influencer']}
                        search_func_collection={this.openSearchContentCollection}
                        tier_filter={this.state.tier_filter}
                     /></Suspense>
                      :
                     null
                  }
               </>

            if (this.state.mobile_content) {
               let padding_bottom = '0px'
               if ((this.state.isExtraSmallDevice) && ((this.state.influencer_info['current_tier'] === -1) || (this.state.discord_active === true))) {
                  if (this.state.influencer_info['waiting_list'] === true) {
                     if (window.innerWidth >= 414) {
                        padding_bottom = '180px'
                     } else {
                        padding_bottom = '200px'
                     }
                  } else {
                     padding_bottom = '120px'
                  }
               } else if (this.state.isExtraSmallDevice) {
                  if (this.state.influencer_info['waiting_list'] === true) {
                     if (window.innerWidth >= 414) {
                        padding_bottom = '180px'
                     } else {
                        padding_bottom = '200px'
                     }
                  } else {
                     padding_bottom = '65px'
                  }
               } else if (this.state.isSmallDevice) {
                  if (this.state.influencer_info['waiting_list'] === true) {
                     if (window.innerWidth >= 414) {
                        padding_bottom = '180px'
                     } else {
                        padding_bottom = '200px'
                     }
                  } else {
                     padding_bottom = '65px'
                  }
               } else {
                  if (this.state.influencer_info['waiting_list'] === true) {
                     if (window.innerWidth >= 414) {
                        padding_bottom = '180px'
                     } else {
                        padding_bottom = '200px'
                     }
                  } else {
                     padding_bottom = '20px'
                  }
               }
               if (this.state.dashboard === true) {
                  padding_bottom = '180px'
               }
            }
         }
      }



      if (this.state.current_user) {

         main_div = (
            <>
               {
                  (this.state.is_me || this.state.current_user === this.state.influencer_info.influencer) ?
                     // Is Me
                     <Grid container sx={{ backgroundColor: 'var(--rebranding-background-color)', height: 'auto', justifyContent: 'flex-end', minHeight: this.state.deviceWidth < 500 ? 'calc(100vh - 160px)' : 'calc(100vh - 60px)' }}>
                        {

                           window.innerWidth >= 1280 && !mobile_preview ?
                              <Grid item lg={2} sx={leftBarStyle}>
                                 <Suspense fallback={<></>}>

                                    <CreatorMenu
                                       setState={this.setState}
                                       confirmationSnackbarOpen={this.state.confirmationSnackbarOpen}
                                       launched_influencer={this.state.influencer_launched}
                                       selected_tab={this.state.selected_tab}
                                       activeProductData={this.state.activeProductData}
                                       windowHeight={window.innerHeight}
                                       updateViewType={this.updateViewType}
                                       current_user_state={this.state.current_user}
                                       influencer_name={this.props.influencer_name}
                                       iconImage={this.state.current_user_icon}
                                       current_user={this.state.current_user}
                                       book_success_meeting_popup={this.setCalendlyModal}
                                       is_me={this.state.is_me}
                                       view_type={this.state.view_type}
                                       influencer_bool={this.state.influencer_bool}
                                       current_user_icon={this.state.current_user_icon}
                                       user_subscriptions={this.state.user_subscriptions}
                                       launchCopySnackbar={this.launchCopySnackbar}
                                       influencer_display_name={this.state.influencer_info['influencer_name']}
                                       influencer_username={this.state.influencer_info['influencer']}
                                       current_page={'influencer'}
                                       search_func={this.openSearchContent}
                                       search_func_collection={this.openSearchContentCollection}
                                       handleCustomCreatorLogoModalOpen={this.handleCustomCreatorLogoModalOpen}
                                       handleCustomCreatorLogoModalClose={this.handleCustomCreatorLogoModalClose}
                                       logoRectangleFile={this.state.logoRectangleFile}
                                       logoRectangleFileNew={this.state.logoRectangleFileNew}
                                       logoSquareFile={this.state.logoSquareFile}
                                       logoSquareFileNew={this.state.logoSquareFileNew}
                                       customCreatorLogoModalOpen={this.state.customCreatorLogoModalOpen}
                                       currentLogoFile={this.state.currentLogoFile}
                                       mainLogoFile={this.state.mainLogoFile}
                                       force_navbar_rerender={this.state.force_navbar_rerender}
                                       uploadingCustomCreatorLogo={this.state.uploadingCustomCreatorLogo}
                                       handlePricingModalOpen={this.handlePricingModalOpen}
                                       handlePricingModalClose={this.handlePricingModalClose}
                                       handleOpenCreatorCalendly={this.handleOpenCreatorCalendly}
                                       waitlistCreator={this.state.influencer_info['waiting_list'] === true}
                                       openExampleCreatorsPopup={this.openExampleCreatorsPopup}
                                       firstName={this.state.influencer_info['first_name']}
                                       displayName={this.state.influencer_info['influencer_name']}
                                       influencerIcon={this.state.influencer_info['icon_image_path']}
                                       windowWidth={this.state.deviceWidth}
                                       morePages={this.state.morePages}
                                       launchHelp={() => window.Intercom('boot', {
                                          hide_default_launcher: true,
                                          app_id: INTERCOM_APP_ID,
                                          api_base: "https://api-iam.intercom.io",
                                          name: this.state.current_user,
                                          email: this.state.user_email,
                                          user_hash: this.state.intercom_verify_key,
                                       })}
                                       handleProfileTabChange={this.handleProfileTabChange}
                                       stripe_customer_id2={this.state.stripe_customer_id2}



                                    />

                                 </Suspense>
                              </Grid>
                              :

                              null

                        }


                        {/* Using the portal to display pages instead of navigating away from view */}
                        {
                           (!['platform', 'dashboard', 'preview', 'home', 'subscriptions', 'digital_products', 'courses', '1v1coaching', 'community', 'messages'].includes(current_page_view)) ?
                              <PagePortal
                                 //custom creator logo modal
                                 incomeData={this.state.incomeData}
                                 current_page_view={this.props.current_page_view}
                                 activeProductData={this.state.activeProductData}
                                 launchHelp={() => {
                                    window.Intercom('boot')
                                    window.Intercom('show')
                                 }}
                                 selected_tab={this.state.selected_tab}
                                 open={this.state.customCreatorLogoModalOpen}
                                 handleProfileTabChange={this.handleProfileTabChange}
                                 handleCustomCreatorLogoModalClose={() => {
                                    this.handleCustomCreatorLogoModalClose()
                                 }}
                                 setState={this.setState}
                                 logoRectangleFile={this.state.logoRectangleFile}
                                 logoRectangleFileNew={this.state.logoRectangleFileNew}
                                 logoSquareFile={this.state.logoSquareFile}
                                 logoSquareFileNew={this.state.logoSquareFileNew}
                                 clearRectangleLogo={() => this.clearRectangleLogo()}
                                 clearSquareLogo={() => this.clearSquareLogo()}
                                 // removeSquareLogo={() => this.removeSquareLogo()}
                                 // removeRectangleLogo={() => this.removeRectangleLogo()}
                                 rerenderClearedNavbar={() => this.rerenderClearedNavbar()}
                                 setUploadingCustomCreatorLogo={(value) => this.setState({
                                    uploadingCustomCreatorLogo: value
                                 })}
                                 setMainLogoFile={(file) => this.setState({ mainLogoFile: file })}
                                 handleSuccessfulCustomLogo={() => this.handleSuccessfulCustomLogo()}
                                 handleOpenCreatorCalendly={this.handleOpenCreatorCalendly}
                                 handleCustomCreatorLogoModalOpen={this.handleCustomCreatorLogoModalOpen}
                                 openExampleCreatorsPopup={this.openExampleCreatorsPopup}
                                 current_user_state={this.state.current_user}
                                 influencer_name={this.props.influencer_name}
                                 iconImage={this.state.current_user_icon}
                                 show_search={true}
                                 current_user={this.state.current_user}
                                 user_email={this.state.user_email}
                                 intercom_verify_key={this.state.intercom_verify_key}
                                 // n_trial_days={nTrialDays}
                                 book_success_meeting_popup={this.setCalendlyModal}
                                 windowWidth={this.state.deviceWidth}
                                 is_me={this.state.is_me}
                                 view_type={this.state.view_type}
                                 updateViewType={this.updateViewType}
                                 launched_influencer={this.state.influencer_launched}
                                 mobileSearchOpen={this.state.mobileSearchOpen}
                                 handleMobileSearchClose={this.handleMobileSearchClose}
                                 handleMobileSearchOpen={this.handleMobileSearchOpen}
                                 influencer_bool={this.state.influencer_bool}
                                 current_user_icon={this.state.current_user_icon}
                                 top_bar_text={this.state.influencer_name}
                                 hidden_influencer={this.state.hidden_influencer}
                                 waiting_list_influencer={this.state.influencer_info['waiting_list']}
                                 n_user_subscriptions={this.state.n_user_subscriptions}
                                 user_subscriptions={this.state.user_subscriptions}
                                 recommended_influencers={this.state.recommended_influencers}
                                 subs_user_menu={true}
                                 influencer_id={this.state.influencer_info['id']}
                                 display_name={this.state.display_name}
                                 influencer_display_name={this.state.influencer_info['influencer_name']}
                                 influencer_username={this.state.influencer_info['influencer']}
                                 current_page={'influencer'}
                                 search_func={this.openSearchContent}
                                 search_func_collection={this.openSearchContentCollection}
                                 customCreatorLogoModalOpen={this.state.customCreatorLogoModalOpen}
                                 currentLogoFile={this.state.currentLogoFile}
                                 mainLogoFile={this.state.mainLogoFile}
                                 force_navbar_rerender={this.state.force_navbar_rerender}
                                 uploadingCustomCreatorLogo={this.state.uploadingCustomCreatorLogo}
                                 handlePricingModalOpen={this.handlePricingModalOpen}
                                 handlePricingModalClose={this.handlePricingModalClose}
                                 waitlistCreator={this.state.influencer_info['waiting_list'] === true}
                                 updatedDisplayName={this.state.updatedDisplayName}
                                 onDisplayNameUpdated={() => this.setState({ updatedDisplayName: this.state.influencerDisplayNameUpdated })}
                                 morePages={this.state.morePages}
                                 open_icon_image_edit={this.state.open_icon_image_edit}
                                 influencer_info={this.state.influencer_info}
                                 edit_mode={this.state.edit_mode}
                                 ToggleEdit={this.ToggleEdit}
                                 influencerBannerImage={this.state.banner_file}
                                 // set_edit_mode={(val) => this.setState({edit_mode: val})}
                                 OnInfluencerEditChange={this.OnInfluencerEditChange}
                                 influencerBioLength={this.state.influencerBioLength}
                                 // setInfluencerBioLength={(new_value) => {this.setState({influencerBioLength: new_value})}}
                                 editedBio={this.state.editedBio}
                                 // setEditedBio={(new_value) => {this.setState({editedBio: new_value})}}
                                 OpenSubscribePopup={this.OpenSubscribePopup}
                                 OpenWaitingListPopup={this.OpenWaitingListPopup}
                                 CloseSubscribePopup={this.CloseSubscribePopup}
                                 CloseWaitingListPopup={this.CloseWaitingListPopup}
                                 influencer_n_subscribers={this.state.influencer_n_subscribers}
                                 influencer_show_icon_image={this.state.influencer_show_icon_image}
                                 isLargeDevice={this.state.isLargeDevice}
                                 isXLargeDevice={this.state.isXLargeDevice}
                                 bannerImage={this.state.bannerImage}
                                 headerVideo={this.state.headerVideo}
                                 onVideoChange={this.onVideoChange}
                                 onBannerChange={this.onBannerChange}
                                 freeSubSubscribe={this.freeSubSubscribe}
                                 n_page_views={this.state.n_page_views}
                                 currency={this.state.currency}
                                 influencer_rating_average={this.state.influencer_rating_average}
                                 influencer_rating_count={this.state.influencer_rating_count}
                                 rating_color={this.state.rating_color}
                                 influencer_user_rating={this.state.influencer_user_rating}
                                 data_func={this.get_and_post_data_skeleton}
                                 update_ratings={this.update_ratings}
                                 waiting_list={this.state.influencer_info['waiting_list']}
                                 banner_file_path={this.state.influencer_info['banner_file_path']}
                                 influencer={this.state.influencer_name}
                                 trial_length={this.state.subscribe_popup_trial_length}
                                 discordActive={this.state.discord_active}
                                 userDiscordSetup={this.state.user_discord_setup}
                                 async_active={this.state.subscribe_popup_async_active}
                                 discordAccess={this.state.influencer_info.discord_access}
                                 uploadComplete={this.state.uploadComplete}
                                 content_count={this.state.content_count}
                                 alteredBio={this.state.alteredBio}
                                 // setAlteredBio={(new_value) => {this.setState({alteredBio: new_value})}}
                                 alteredDisplayName={this.state.alteredDisplayName}
                                 // setAlteredDisplayName={(new_value) => {this.setState({alteredDisplayName: new_value})}}
                                 //  Influencer Edit Data Props
                                 // revertChanges={this.revertChanges}
                                 // saveBannerChanges={this.saveBannerChanges}
                                 influencerDisplayName={this.state.influencer_info['influencer_name'] ? this.state.influencer_info['influencer_name'] : this.state.influencer_info['influencer']}
                                 influencerDescription={this.state.influencer_info['description']}
                                 influencerBanner={this.state.influencerBanner}
                                 influencerVideo={this.state.influencerVideo}
                                 influencerIcon={this.state.influencer_info['icon_image_path']}
                                 influencerDisplayNameUpdated={this.state.influencerDisplayNameUpdated}
                                 influencerDescriptionUpdated={this.state.influencerDescriptionUpdated}
                                 influencerIconUpdated={this.state.influencerIconUpdated}
                                 influencerBannerUpdated={this.state.influencerBannerUpdated}
                                 influencerBannerUpdatedFile={this.state.influencerBannerUpdatedFile}
                                 influencerVideoUpdated={this.state.influencerVideoUpdated}
                                 influencerVideoUpdatedFile={this.state.influencerVideoUpdatedFile}
                                 // handleDisplayNameChange={this.setState({influencerDisplayNameUpdated: event.target.value})}
                                 // handleDescriptionChange={(event) => this.setState({influencerDescriptionUpdated: event.target.value})}
                                 handleIconChange={this.handleIconChange}
                                 setCurrentBanner={this.setCurrentBanner}
                                 setCurrentVideo={this.setCurrentVideo}
                                 handleSetBannerChange={this.handleSetBannerChange}
                                 handleClearNewIcon={this.handleClearNewIcon}
                                 handleSetVideoChange={this.handleSetVideoChange}
                                 handleRemoveVideo={this.handleRemoveVideo}
                                 UpdateIconImagePush={this.UpdateIconImagePush}
                                 bannerChangesMade={this.state.bannerChangesMade}
                                 bannerChangesMadeCheck={this.bannerChangesMadeCheck}
                                 setRevertImageFalse={this.setRevertImageFalse}
                                 revertUserIcon={this.revertUserIcon}
                                 revertImage={this.state.revertImage}
                                 videoRemoved={this.state.videoRemoved}
                                 deviceWidth={this.state.deviceWidth}
                                 free_trial_eligible={this.state.free_trial_eligible}
                                 ratingsModel={this.state.ratingsModal}
                                 subpopup_tier_async_overwrite={this.state.subpopup_tier_async_overwrite}
                                 paidDMsExplainerModal={this.state.paidDMsExplainerModal}
                                 openCheckout={this.openDMCheckout}
                                 dm_active={this.state.dm_active}
                                 async_tier_access={this.state.subpopup_tier_async_overwrite !== null ? this.state.subpopup_tier_async_overwrite : this.state.subscribe_popup_async_tier_access}
                                 subscribe_popup_async_active={this.state.subscribe_popup_async_active}
                                 paidDMs_show={this.state.paidDMs_show}
                                 paidDMs_has_message={this.state.paidDMs_has_messages}
                                 isDashboard={this.props.dashboard}
                                 showChangesBanner={true}
                                 saveChanges={this.saveChanges}
                                 revertChanges={this.revertChanges}
                                 isPublished={this.state.influencer_info['waiting_list']}
                                 isMessagesActive={true}
                                 free_active={this.state.influencer_info['free_active']}
                                 bronze_active={this.state.subscribe_popup_bronze_active}
                                 silver_active={this.state.subscribe_popup_silver_active}
                                 gold_active={this.state.subscribe_popup_gold_active}
                                 subscribe_popup_async_tier_apply={this.state.subscribe_popup_async_tier_apply}
                                 subscribe_popup_bronze_monthly_active={this.state.subscribe_popup_bronze_monthly_active}
                                 subscribe_popup_silver_monthly_active={this.state.subscribe_popup_silver_monthly_active}
                                 subscribe_popup_gold_monthly_active={this.state.subscribe_popup_gold_monthly_active}
                                 subscribe_popup_bronze_annual_active={this.state.subscribe_popup_bronze_annual_active}
                                 subscribe_popup_silver_annual_active={this.state.subscribe_popup_silver_annual_active}
                                 subscribe_popup_gold_annual_active={this.state.subscribe_popup_gold_annual_active}
                                 stripe_customer_id2={this.state.stripe_customer_id2}
                              />
                              :
                              <>
                                 <Grid item xs={12} md={12} lg={mobile_preview ? 12 : 10} sx={{ boxSizing: 'border-box' }}>
                                    <DesktopHeaderCreator
                                       my_platform_page={this.state.my_platform_page}
                                       selected_tab={this.state.selected_tab}
                                       influencer_username={this.state.influencer_info['influencer']}
                                       setState={this.setState}
                                    />

                                    {/* <Box 
                                       sx={{ 
                                          display: 'flex', 
                                          flexDirection: 'row', 
                                          alignItems: 'center', 
                                          justifyContent: 'space-between', 
                                          margin: {lg: '40px 40px 0px 40px', xs: '20px 20px 0px 20px'},
                                          border: '1px solid #FCDC9E',
                                          padding: {xs: '10px', lg: '20px'},
                                          borderRadius: '10px',
                                          backgroundColor: '#FFF5EB',
                                          fontFamily: 'var(--font-family)',
                                       }}
                                    >
                                       <Typography sx={{ color: '#222222', fontSize: '16px', fontWeight: '500', textAlign: 'left', margin: '0px auto', display: 'flex', alignItems: 'center' }}>
                                          <TbAlertTriangle style={{ color: '#ED9B3C', fontSize: '20px', margin: 'auto 10px auto 0px' }}/> Your platform isn't live yet. To start earning, renew your subscription now {' '}
                                          <Typography component="span" onClick={() => {}} sx={{ color: 'var(--brand-color)', cursor: 'pointer', marginLeft: '5px', fontWeight: '500' }}>here</Typography>.
                                       </Typography>
                                    </Box> */}


                                    <>
                                       {shouldShowEditChangesBanner && (current_page_view === 'platform' || current_page_view === 'home') ? (
                                          <Suspense fallback={<></>}>
                                             <div style={{ height: '50px', width: '100%', boxSizing: 'border-box' }}>
                                                <InfluencerEditChangesBanner
                                                   setState={this.setState}
                                                   updatedDisplayName={influencerDisplayNameUpdated}
                                                   influencerDisplayName={influencer_info['influencer_name']}
                                                   isDashboard={dashboard}
                                                   windowWidth={this.state.deviceWidth}
                                                   showChangesBanner={true}
                                                   bannerChangesMade={bannerChangesMade}
                                                   saveChanges={this.saveChanges}
                                                   revertChanges={this.revertChanges}
                                                />
                                             </div>
                                          </Suspense>
                                       ) : (
                                          <>
                                          {/* removed from conditionals for now: current_page_view === 'platform' ||  */}
                                             {/* {view_type === 'creator' && (current_page_view === 'home') && !influencer_launched && this.state.deviceWidth >= 1280 && (
                                                <Suspense fallback={<></>}>
                                                   <div style={{ position: 'sticky', width: '100%', zIndex: '1300', top: '0px', left: '0px', right: '0px' }}>
                                                      <DynamicOnboardingBar
                                                         my_platform_page={this.state.my_platform_page}
                                                         setState={this.setState}
                                                         progressCount={progressCount}
                                                         setupStripe={setupStripe}
                                                         switch_onChange_handle={this.switch_onChange_handle}
                                                         current_user={current_user}
                                                         influencerDescription={influencer_info['description']}
                                                         influencerIcon={this.state.current_user_icon}
                                                         updatedPerks={updatedPerks}
                                                         windowWidth={this.state.deviceWidth}
                                                         handleProfileTabChange={this.handleProfileTabChange}
                                                         selected_tab={this.state.selected_tab}
                                                         scrollToTopOfTabs={this.scrollToTopOfTabs}
                                                      />
                                                   </div>
                                                </Suspense>
                                             )} */}
                                          </>
                                       )}
                                    </>

                                    {/* Waitlist Splash Screen */}
                                    {/*  open, handleClose, imageUrl, title, description, buttonText, smallText */}

                                    {
                                       this.state.influencer_info['waiting_list'] === true ?

                                          <SplashScreenModal
                                             open={this.state.waitlistSplashScreenOpen}
                                             handleClose={this.handleCloseSplashScreen}
                                             imageUrls={[WaitlistStepOne, WaitlistStepTwo, WaitlistStepThree]}
                                             windowWidth={this.state.deviceWidth}
                                             titles={['What is a Waitlist? 🤔', 'How Do You Build a Big Waitlist? 📢', 'What Are the Benefits? 🤑']}
                                             descriptions={[
                                                'A waitlist lets your audience sign up with their email before you launch, capturing early interest. It builds anticipation and boosts engagement, helping you kickstart your platform with a ready-made community.',
                                                'Share your waitlist link with your audience! They sign up with their email, and we’ll notify them when your platform launches, keeping them in the loop.',
                                                'A waitlist helps build anticipation, sets you up for better launch revenue, and increases your monthly recurring revenue by starting with an engaged and eager audience.']}
                                          />

                                          :
                                          null
                                    }


                                    {(this.state.my_platform_page === 'home') &&
                                       <>

                                          <MobilePreview
                                             activeTab={this.state.activeTab}
                                             LeftView={
                                                <>

                                                   {bannerMain}
                                                   {swiper_data}
                                                </>
                                             }
                                             // mobilePreviewView={
                                             //    <>
                                             //       <ThemeProvider theme={mobileTheme}>

                                             //       <div style={{position: 'sticky', top: '0px', left: '0px', height: '60px', overflow: 'hidden', right: '0px', zIndex: '1399'}}>
                                             //          {<Suspense fallback={<></>}>
                                                  
                                             //             <TopNavBar
                                             //                // current_user_state={this.state.current_user}
                                             //                influencer_bool={false}
                                             //                current_user_icon={''}
                                             //                current_user={''}
                                             //                current_user_state={''}
                                             //                top_bar_text={this.state.influencer_info['influencer']}
                                             //                hidden_influencer={this.state.hidden_influencer}
                                             //                waiting_list_influencer={this.state.influencer_info['waiting_list']}
                                             //                n_user_subscriptions={this.state.n_user_subscriptions}
                                             //                user_subscriptions={this.state.user_subscriptions}
                                             //                recommended_influencers={[]}
                                             //                subs_user_menu={true}
                                             //                is_me={false}
                                             //                windowWidth={350}
                                             //                view_type={'user'}
                                             //                show_search={true}
                                             //                influencer_id={this.state.influencer_info['id']}
                                             //                display_name={''}
                                             //                influencer_display_name={this.state.influencer_info['influencer_name']}
                                             //                influencer_username={this.state.influencer_info['influencer']}
                                             //                current_page={'influencer'}
                                             //                current_page_view={current_page_view}
                                             //                mobileSearchOpen={this.state.mobileSearchOpen}
                                             //                handleMobileSearchClose={this.handleMobileSearchClose}
                                             //                handleMobileSearchOpen={this.handleMobileSearchOpen}
                                             //                search_func={this.openSearchContent}
                                             //                search_func_collection={this.openSearchContentCollection}
                                             //                logoRectangleFile={this.state.logoRectangleFile}
                                             //                logoRectangleFileNew={this.state.logoRectangleFileNew}
                                             //                logoSquareFile={this.state.logoSquareFile}
                                             //                logoSquareFileNew={this.state.logoSquareFileNew}
                                             //                updatedDisplayName={this.state.updatedDisplayName}
                                             //                onDisplayNameUpdated={() => this.setState({ updatedDisplayName: this.state.influencerDisplayNameUpdated })}
                                             //             /></Suspense>}
                                             //             </div>
                                             //          {<InfluencerBannerMain
                                             //             open_icon_image_edit={this.state.open_icon_image_edit}
                                             //             view_type={'user'}
                                             //             influencer_info={this.state.influencer_info}
                                             //             is_me={false}
                                             //             edit_mode={this.state.edit_mode}
                                             //             windowWidth={350}
                                             //             ToggleEdit={this.ToggleEdit}
                                             //             influencerBannerImage={this.state.banner_file}
                                             //             setState={this.setState}
                                             //             OnInfluencerEditChange={this.OnInfluencerEditChange}
                                             //             influencerBioLength={this.state.influencerBioLength}
                                             //             editedBio={this.state.editedBio}
                                             //             OpenSubscribePopup={this.OpenSubscribePopup}
                                             //             OpenWaitingListPopup={this.OpenWaitingListPopup}
                                             //             mobilePreview={true}
                                             //             CloseSubscribePopup={this.CloseSubscribePopup}
                                             //             CloseWaitingListPopup={this.CloseWaitingListPopup}
                                             //             influencer_n_subscribers={this.state.influencer_n_subscribers}
                                             //             influencer_show_icon_image={this.state.influencer_show_icon_image}
                                             //             current_user={''}
                                             //             bannerImage={this.state.bannerImage}
                                             //             headerVideo={this.state.headerVideo}
                                             //             onVideoChange={this.onVideoChange}
                                             //             onBannerChange={this.onBannerChange}
                                             //             freeSubSubscribe={this.freeSubSubscribe}
                                             //             n_page_views={this.state.n_page_views}
                                             //             currency={this.state.currency}
                                             //             influencer_rating_average={this.state.influencer_rating_average}
                                             //             influencer_rating_count={this.state.influencer_rating_count}
                                             //             rating_color={this.state.rating_color}
                                             //             influencer_user_rating={this.state.influencer_user_rating}
                                             //             data_func={this.get_and_post_data_skeleton}
                                             //             update_ratings={this.update_ratings}
                                             //             waiting_list={this.state.influencer_info['waiting_list']}
                                             //             banner_file_path={this.state.influencer_info['banner_file_path']}
                                             //             influencer={this.state.influencer_name}
                                             //             trial_length={this.state.subscribe_popup_trial_length}
                                             //             discordActive={this.state.discord_active}
                                             //             userDiscordSetup={this.state.user_discord_setup}
                                             //             async_active={this.state.subscribe_popup_async_active}
                                             //             discordAccess={this.state.influencer_info.discord_access}
                                             //             uploadComplete={this.state.uploadComplete}
                                             //             content_count={this.state.content_count}
                                             //             alteredBio={this.state.alteredBio}
                                             //             alteredDisplayName={this.state.alteredDisplayName}
                                             //             influencerDisplayName={this.state.influencer_info['influencer_name'] ? this.state.influencer_info['influencer_name'] : this.state.influencer_info['influencer']}
                                             //             influencerDescription={this.state.influencer_info['description']}
                                             //             influencerBanner={this.state.influencerBanner}
                                             //             influencerVideo={this.state.influencerVideo}
                                             //             influencerIcon={this.state.influencer_info['icon_image_path']}
                                             //             influencerDisplayNameUpdated={this.state.influencerDisplayNameUpdated}
                                             //             influencerDescriptionUpdated={this.state.influencerDescriptionUpdated}
                                             //             influencerIconUpdated={this.state.influencerIconUpdated}
                                             //             influencerBannerUpdated={this.state.influencerBannerUpdated}
                                             //             influencerBannerUpdatedFile={this.state.influencerBannerUpdatedFile}
                                             //             influencerVideoUpdated={this.state.influencerVideoUpdated}
                                             //             influencerVideoUpdatedFile={this.state.influencerVideoUpdatedFile}
                                             //             handleIconChange={this.handleIconChange}
                                             //             setCurrentBanner={this.setCurrentBanner}
                                             //             setCurrentVideo={this.setCurrentVideo}
                                             //             handleSetBannerChange={this.handleSetBannerChange}
                                             //             handleClearNewIcon={this.handleClearNewIcon}
                                             //             handleSetVideoChange={this.handleSetVideoChange}
                                             //             handleRemoveVideo={this.handleRemoveVideo}
                                             //             UpdateIconImagePush={this.UpdateIconImagePush}
                                             //             bannerChangesMade={this.state.bannerChangesMade}
                                             //             bannerChangesMadeCheck={this.bannerChangesMadeCheck}
                                             //             setRevertImageFalse={this.setRevertImageFalse}
                                             //             revertUserIcon={this.revertUserIcon}
                                             //             revertImage={this.state.revertImage}
                                             //             videoRemoved={this.state.videoRemoved}
                                             //             deviceWidth={this.state.deviceWidth}
                                             //             free_trial_eligible={this.state.free_trial_eligible}
                                             //             ratingsModel={this.state.ratingsModal}
                                             //             subpopup_tier_async_overwrite={this.state.subpopup_tier_async_overwrite}
                                             //             paidDMsExplainerModal={this.state.paidDMsExplainerModal}
                                             //             openCheckout={this.openDMCheckout}
                                             //             dm_active={this.state.dm_active}
                                             //             async_tier_access={false}
                                             //             subscribe_popup_async_active={false}
                                             //             handleProfileTabChange={this.handleProfileTabChange}
                                             //             paidDMs_show={this.state.paidDMs_show}
                                             //             paidDMs_has_message={this.state.paidDMs_has_messages}
                                             //             isDashboard={this.props.dashboard}
                                             //             showChangesBanner={true}
                                             //             saveChanges={this.saveChanges}
                                             //             revertChanges={this.revertChanges}
                                             //             isPublished={this.state.influencer_info['waiting_list']}
                                             //             isMessagesActive={true}
                                             //             free_active={this.state.influencer_info['free_active']}
                                             //             bronze_active={this.state.subscribe_popup_bronze_active}
                                             //             silver_active={this.state.subscribe_popup_silver_active}
                                             //             gold_active={this.state.subscribe_popup_gold_active}
                                             //             subscribe_popup_async_tier_apply={this.state.subscribe_popup_async_tier_apply}
                                             //             subscribe_popup_bronze_monthly_active={this.state.subscribe_popup_bronze_monthly_active}
                                             //             subscribe_popup_silver_monthly_active={this.state.subscribe_popup_silver_monthly_active}
                                             //             subscribe_popup_gold_monthly_active={this.state.subscribe_popup_gold_monthly_active}
                                             //             subscribe_popup_bronze_annual_active={this.state.subscribe_popup_bronze_annual_active}
                                             //             subscribe_popup_silver_annual_active={this.state.subscribe_popup_silver_annual_active}
                                             //             subscribe_popup_gold_annual_active={this.state.subscribe_popup_gold_annual_active}
                                             //             current_tier={-1}
                                             //             influencer_bool={this.state.influencer_bool}
                                             //             hidden_influencer={this.state.hidden_influencer}
                                             //             n_user_subscriptions={this.state.n_user_subscriptions}
                                             //             user_subscriptions={this.state.user_subscriptions}
                                             //             recommended_influencers={this.state.recommended_influencers}
                                             //             mobile_content={this.state.mobile_content}
                                             //             influencer_id={this.state.influencer_info['id']}
                                             //             setCalendlyModal={this.setCalendlyModal}
                                             //             customiseMode={this.state.customiseMode}
                                             //             handleCustomiseMode={this.handleCustomiseMode}
                                             //             handleCancelCustomise={this.handleCancelCustomise}
                                             //             dashboard={this.state.dashboard}
                                             //             waiting_list_influencer={this.state.waiting_list_influencer}
                                             //             current_user_state={this.state.current_user}
                                             //             current_user_icon={this.state.current_user_icon}
                                             //             top_bar_text={this.state.influencer_name}
                                             //             subs_user_menu={true}
                                             //             show_search={true}
                                             //             display_name={this.state.display_name}
                                             //             influencer_page={true}
                                             //             mobileSearchOpen={this.state.mobileSearchOpen}
                                             //             handleMobileSearchClose={this.handleMobileSearchClose}
                                             //             handleMobileSearchOpen={this.handleMobileSearchOpen}
                                             //             onWaitingList={this.state.isWaitingList}
                                             //          />}
                                             //          {<Suspense fallback={<></>}>
                                             //             <div ref={this.tabsBarRef}
                                             //                style={{
                                             //                   position: 'relative',
                                             //                   top: this.state.isTabsFixed ? '0px' : '',
                                             //                   margin: this.state.deviceWidth >= 1280 && (this.state.selected_tab === 'sub_collections' || this.state.selected_tab === 'sub_posts' || this.state.selected_tab === 'membership' || this.state.selected_tab === 'paid_posts' || this.state.selected_tab === 'paid_collections' || this.state.selected_tab === 'collections') && current_page_view !== 'preview' && current_page_view !== 'platform' && this.state.is_me ? '50px 120px' : '',
                                             //                   boxSizing: 'border-box',
                                             //                   zIndex: this.state.isTabsFixed ? '1200' : '900',
                                             //                }}>

                                             //                <>
                                             //                   <InfluencerTabsBar
                                             //                      creator_preview={creator_preview}
                                             //                      isTabsFixed={this.state.isTabsFixed}
                                             //                      current_page_view={current_page_view}
                                             //                      mobilePreview={true}
                                             //                      my_platform_page={this.state.my_platform_page}
                                             //                      windowWidth={350}
                                             //                      setState={this.setState}
                                             //                      contentIsLoading={this.state.contentIsLoading}
                                             //                      current_user={''}
                                             //                      content_length={this.state.influencer_content_list ? this.state.influencer_content_list.length : 0}
                                             //                      selected_tab={this.state.selected_tab}
                                             //                      live_count={this.state.live_count}
                                             //                      all_count={this.state.all_count}
                                             //                      saved_count={this.state.saved_count}
                                             //                      collections_count={this.state.collections_count}
                                             //                      scheduled_count={this.state.scheduled_count}
                                             //                      creator_tabs={this.state.creator_tabs}
                                             //                      is_me={false}
                                             //                      confirmationSnackbarOpen={this.state.confirmationSnackbarOpen}
                                             //                      handleConfirmationSnackbarClose={this.handleConfirmationSnackbarClose}
                                             //                      handleConfirmationSnackbarOpen={this.handleConfirmationSnackbarOpen}
                                             //                      single_view_collection={this.state.single_view_collection}
                                             //                      handleOpenCollections={this.handleOpenCollections}
                                             //                      buyCollectionActive={this.state.buyCollectionActive}
                                             //                      buyCollectionCheckoutOpen={this.state.buyCollectionCheckoutOpen}
                                             //                      buyCollectionPriceCheckout={this.state.buyCollectionPriceCheckout}
                                             //                      buyCollectionPriceCheckoutStr={this.state.buyCollectionPriceCheckoutStr}
                                             //                      buyCollectionThumbnailUrl={this.state.buyCollectionThumbnailUrl}
                                             //                      buyCollectionTitle={this.state.buyCollectionTitle}
                                             //                      handleSingleViewCollection={this.handleSingleViewCollection}
                                             //                      influencer_info_influencer={this.state.influencer_info['influencer']}
                                             //                      current_tier={-1}
                                             //                      influencer_content_list={this.state.influencer_content_list}
                                             //                      category_filter={this.state.category_filter}
                                             //                      content_filter={this.state.content_filter}
                                             //                      sort_filter={this.state.sort_filter}
                                             //                      collection_filter={this.state.collection_filter}
                                             //                      anchorEl={this.state.anchorEl}
                                             //                      collectionsMobileAnchorEl={this.state.collectionsMobileAnchorEl}
                                             //                      collectionsMobileOpen={this.state.collectionsMobileOpen}
                                             //                      category_menu_open={this.state.category_menu_open}
                                             //                      categories={this.state.categories_filter}
                                             //                      content_types={this.state.content_types}
                                             //                      categories_rerender={this.state.categories}
                                             //                      sort_menu_open={this.state.sort_menu_open}
                                             //                      collections_menu_open={this.state.collections_menu_open}
                                             //                      content_menu_open={this.state.content_menu_open}
                                             //                      handleProfileTabChange={this.handleProfileTabChange}
                                             //                      handleCollectionTabChange={this.handleCollectionTabChange}
                                             //                      handleCopyClick={this.handleCopyClick}
                                             //                      sort_options={sort_options}
                                             //                      subscribe_popup_bronze_active={this.state.subscribe_popup_bronze_active}
                                             //                      subscribe_popup_silver_active={this.state.subscribe_popup_silver_active}
                                             //                      subscribe_popup_gold_active={this.state.subscribe_popup_gold_active}
                                             //                      subscribe_popup_async_active={this.state.subscribe_popup_async_active}
                                             //                      dashboard={this.state.dashboard}
                                             //                      view_type={'user'}
                                             //                      collection_names={this.state.collection_names}
                                             //                      collection_data={this.state.collection_data}
                                             //                      async_tier_access={false}
                                             //                      handleOpenHiddenTabModal={this.handleOpenHiddenTabModal}
                                             //                      community_is_active={this.state.community_is_active}
                                             //                      handleOpenInfoTabModal={this.handleOpenInfoTabModal}
                                             //                      handleCloseInfoTabModal={this.handleCloseInfoTabModal}
                                             //                      asyncActive={this.state.subscribe_popup_async_active}
                                             //                      hasAsyncMembers={this.state.hasAsyncMembers}
                                             //                      dm_active={this.state.dm_active}
                                             //                      subscription_popup_info_renewal_date={this.state.subscription_popup_info_renewal_date}
                                             //                      open_modal={this.state.subscribe_popup_open}
                                             //                      icon_image={this.state.subscribe_popup_icon_image}
                                             //                      influencer={this.state.influencer_info['influencer']}
                                             //                      influencer_name={this.state.subscribe_popup_influencer_name}
                                             //                      minimum_tier={this.state.subscribe_popup_minimum_tier}
                                             //                      bronze_price={this.state.subscribe_popup_bronze_price}
                                             //                      silver_price={this.state.subscribe_popup_silver_price}
                                             //                      gold_price={this.state.subscribe_popup_gold_price}
                                             //                      bronze_perks_text={this.state.subscribe_popup_bronze_perks_text}
                                             //                      silver_perks_text={this.state.subscribe_popup_silver_perks_text}
                                             //                      gold_perks_text={this.state.subscribe_popup_gold_perks_text}
                                             //                      nextStep={this.goToCheckout}
                                             //                      CloseSubscribePopup={this.CloseSubscribePopup}
                                             //                      UpgradeSubInfoPopup={this.UpgradeSubInfoPopup}
                                             //                      DowngradeSubInfoPopup={this.DowngradeSubInfoPopup}
                                             //                      free_trial_eligible={this.state.free_trial_eligible}
                                             //                      current_free_trial={this.state.subscribe_popup_current_free_trial}
                                             //                      free_active={((this.state.subscribe_popup_single_tier === true) && (this.state.subscribe_popup_initial_selected_tier === 0)) ? true : ((this.state.subscribe_popup_single_tier === true) && (this.state.subscribe_popup_initial_selected_tier !== 0)) ? false : this.state.subscribe_popup_free_active}
                                             //                      bronze_active={((this.state.subscribe_popup_single_tier === true) && (this.state.subscribe_popup_initial_selected_tier === 1)) ? true : ((this.state.subscribe_popup_single_tier === true) && (this.state.subscribe_popup_initial_selected_tier !== 1)) ? false : this.state.subscribe_popup_bronze_active}
                                             //                      silver_active={((this.state.subscribe_popup_single_tier === true) && (this.state.subscribe_popup_initial_selected_tier === 2)) ? true : ((this.state.subscribe_popup_single_tier === true) && (this.state.subscribe_popup_initial_selected_tier !== 2)) ? false : this.state.subscribe_popup_silver_active}
                                             //                      gold_active={((this.state.subscribe_popup_single_tier === true) && (this.state.subscribe_popup_initial_selected_tier === 3)) ? true : ((this.state.subscribe_popup_single_tier === true) && (this.state.subscribe_popup_initial_selected_tier !== 3)) ? false : this.state.subscribe_popup_gold_active}
                                             //                      free_name={this.state.subscribe_popup_free_name}
                                             //                      bronze_name={this.state.subscribe_popup_bronze_name}
                                             //                      silver_name={this.state.subscribe_popup_silver_name}
                                             //                      gold_name={this.state.subscribe_popup_gold_name}
                                             //                      current_duration={this.state.subscribe_popup_current_duration}
                                             //                      currency={this.state.currency}
                                             //                      bronze_annual_price={this.state.subscribe_popup_bronze_annual_price}
                                             //                      silver_annual_price={this.state.subscribe_popup_silver_annual_price}
                                             //                      gold_annual_price={this.state.subscribe_popup_gold_annual_price}
                                             //                      bronze_show_annual_reduction={this.state.subscribe_popup_bronze_show_annual_reduction}
                                             //                      silver_annual_reduction={this.state.subscribe_popup_silver_show_annual_reduction}
                                             //                      gold_annual_reduction={this.state.subscribe_popup_gold_show_annual_reduction}
                                             //                      bronze_monthly_active={this.state.subscribe_popup_bronze_monthly_active}
                                             //                      silver_monthly_active={this.state.subscribe_popup_silver_monthly_active}
                                             //                      gold_monthly_active={this.state.subscribe_popup_gold_monthly_active}
                                             //                      bronze_annual_active={this.state.subscribe_popup_bronze_annual_active}
                                             //                      silver_annual_active={this.state.subscribe_popup_silver_annual_active}
                                             //                      gold_annual_active={this.state.subscribe_popup_gold_annual_active}
                                             //                      trial_length={this.state.subscribe_popup_trial_length}
                                             //                      initial_selected_tier={this.state.subscribe_popup_initial_selected_tier}
                                             //                      influencer_icon={this.state.influencer_info['icon_image_path']}
                                             //                      influencer_banner={this.state.influencerBanner}
                                             //                      promo_code={this.state.promo_code}
                                             //                      async_price={this.state.subscribe_popup_async_price}
                                             //                      async_perks_text={this.state.subscribe_popup_async_perks_text}
                                             //                      async_active={((this.state.subscribe_popup_single_tier === true) && (this.state.subscribe_popup_initial_selected_tier === 4)) ? true : ((this.state.subscribe_popup_single_tier === true) && (this.state.subscribe_popup_initial_selected_tier !== 4)) ? false : this.state.subscribe_popup_async_active}
                                             //                      async_name={this.state.subscribe_popup_async_name}
                                             //                      async_annual_price={this.state.subscribe_popup_async_annual_price}
                                             //                      async_annual_reduction={this.state.subscribe_popup_async_show_annual_reduction}
                                             //                      async_monthly_active={this.state.subscribe_popup_async_monthly_active}
                                             //                      async_annual_active={this.state.subscribe_popup_async_annual_active}
                                             //                      subscribe_popup_single_tier={this.state.subscribe_popup_single_tier}
                                             //                      async_annual_duration={this.state.subscribe_popup_async_annual_duration}
                                             //                      async_annual_duration_type={this.state.subscribe_popup_async_annual_duration_type}
                                             //                      async_annual_rebill={this.state.subscribe_popup_async_annual_rebill}
                                             //                      paidDMs_show={this.state.paidDMs_show}
                                             //                      async_tier_hidden={this.state.subscribe_popup_async_tier_hidden}
                                             //                      async_tier_apply={this.state.subscribe_popup_async_tier_apply}
                                             //                      handleCancelCustomise={this.handleCancelCustomise}
                                             //                      openAsyncApply={this.openAsyncApply}
                                             //                      async_apply={this.state.async_apply}
                                             //                      content_list_length={this.state.content_list_length}
                                             //                      page_n={this.state.page_n}
                                             //                      setPageN={this.setPageN}
                                             //                      update_filter_state={this.update_filter_state}
                                             //                      categories_list={this.state.categories}
                                             //                      current_user_icon={this.state.current_user_icon}
                                             //                      influencer_username={this.state.influencer_info['influencer']}
                                             //                      influencer_display_name={this.state.influencer_info['influencer_name']}
                                             //                      search_func={this.openSearchContent}
                                             //                      search_func_collection={this.openSearchContentCollection}
                                             //                      buyCollectionPrice={((this.state.collection_data.length > 0) && (this.state.single_view_collection !== '')) ? this.state.collection_data[this.state.single_view_collection]?.collection_price : 0}
                                             //                      subscribe_popup_bronze_monthly_active={this.state.subscribe_popup_bronze_monthly_active}
                                             //                      subscribe_popup_silver_monthly_active={this.state.subscribe_popup_silver_monthly_active}
                                             //                      subscribe_popup_gold_monthly_active={this.state.subscribe_popup_gold_monthly_active}
                                             //                      subscribe_popup_bronze_annual_active={this.state.subscribe_popup_bronze_annual_active}
                                             //                      subscribe_popup_silver_annual_active={this.state.subscribe_popup_silver_annual_active}
                                             //                      subscribe_popup_gold_annual_active={this.state.subscribe_popup_gold_annual_active}
                                             //                      updateCollectionOrder={this.updateCollectionOrder}
                                             //                      bannerChangesMadeCheck={this.bannerChangesMadeCheck}
                                             //                      silver_access={this.state.subscription_popup_silver_access}
                                             //                      gold_access={this.state.subscription_popup_gold_access}
                                             //                   />
                                             //                </>


                                             //             </div>
                                             //          </Suspense>}

                                             //          {
                                             //             <Suspense fallback={<></>}>
                                             //                <InfluencerContent
                                             //                   handleCloseTiers={this.handleCloseTiers}
                                             //                   selectedMemberTabOverwrite={this.state.selectedMemberTabOverwrite}
                                             //                   selected_tab={this.state.selected_tab}
                                             //                   my_platform_page={this.state.my_platform_page}
                                             //                   influencer_icon={this.state.influencer_info['icon_image_path']}
                                             //                   dashboard={this.state.dashboard}
                                             //                   isPublished={this.state.influencer_launched}
                                             //                   view_type={'user'}
                                             //                   windowWidth={350}
                                             //                   contentIsLoading={this.state.contentIsLoading}
                                             //                   current_user={''}
                                             //                   current_user_icon={this.state.current_user_icon}
                                             //                   is_me={false}
                                             //                   influencer={this.state.influencer_name}
                                             //                   influencer_info={this.state.influencer_info}
                                             //                   currency={this.state.currency}
                                             //                   current_tier={-1}
                                             //                   post_id={this.state.post_id}
                                             //                   // buy collections
                                             //                   single_view_collection={this.state.single_view_collection}
                                             //                   sort_filter={this.state.sort_filter}
                                             //                   collection_filter={this.state.collection_filter}
                                             //                   category_filter={this.state.category_filter}
                                             //                   content_filter={this.state.content_filter}
                                             //                   influencer_content_list={this.state.influencer_content_list}
                                             //                   isExtraSmallDevice={this.state.isExtraSmallDevice}
                                             //                   collectionTitleHovered={this.state.collectionTitleHovered}
                                             //                   hoveredIndex={this.state.hoveredIndex}
                                             //                   setState={this.setState}
                                             //                   OpenSubscribePopup={this.OpenSubscribePopup}
                                             //                   openBuyNowCheckout={this.openBuyNowCheckout}
                                             //                   openBuyCollectionCheckout={this.openBuyCollectionCheckout}
                                             //                   buyCollectionId={this.state.buyCollectionId}
                                             //                   handleBuyNowCheckoutData={this.handleBuyNowCheckoutData}
                                             //                   handleProfileTabChange={this.handleProfileTabChange}
                                             //                   OpenWaitingListPopup={this.OpenWaitingListPopup}
                                             //                   CloseSubscribePopup={this.CloseSubscribePopup}
                                             //                   CloseWaitingListPopup={this.CloseWaitingListPopup}
                                             //                   like_button_click_post={this.like_button_click_post}
                                             //                   share_button_click={this.share_button_click}
                                             //                   bookmark_button_post={this.bookmark_button_click_post}
                                             //                   bookmark_button_click={this.bookmark_button_click}
                                             //                   pinned_post_process={this.pinned_post_process}
                                             //                   like_button_click={this.like_button_click}
                                             //                   update_filter_state={this.update_filter_state}
                                             //                   get_and_post_data_skeleton={this.get_and_post_data_skeleton}
                                             //                   handleCollectionTitleMouseLeave={this.handleCollectionTitleMouseLeave}
                                             //                   handleCollectionTitleMouseEnter={this.handleCollectionTitleMouseEnter}
                                             //                   isSmallDevice={this.state.isSmallDevice}
                                             //                   isMediumDevice={this.state.isMediumDevice}
                                             //                   isLargeDevice={this.state.isLargeDevice}
                                             //                   isXLargeDevice={this.state.isXLargeDevice}
                                             //                   subscribe_popup_bronze_active={this.state.subscribe_popup_bronze_active}
                                             //                   subscribe_popup_silver_active={this.state.subscribe_popup_silver_active}
                                             //                   subscribe_popup_gold_active={this.state.subscribe_popup_gold_active}
                                             //                   subscribe_popup_async_active={this.state.subscribe_popup_async_active}
                                             //                   subscribe_popup_bronze_name={this.state.subscribe_popup_bronze_name}
                                             //                   subscribe_popup_silver_name={this.state.subscribe_popup_silver_name}
                                             //                   subscribe_popup_gold_name={this.state.subscribe_popup_gold_name}
                                             //                   subscribe_popup_async_name={this.state.subscribe_popup_async_name}
                                             //                   force_content_rerender={this.state.force_content_rerender}
                                             //                   handleSavedContent={this.handleSavedContent}
                                             //                   handleRemoveSavedContent={this.handleRemoveSavedContent}
                                             //                   handleContentModalOpen={this.handleContentModalOpen}
                                             //                   handleContentModalClose={this.handleContentModalClose}
                                             //                   handleObserver={this.handleObserver}
                                             //                   display_name={this.state.display_name}
                                             //                   update_inf_scroll={this.state.update_inf_scroll}
                                             //                   collection_names={this.state.collection_names}
                                             //                   collection_data={this.state.collection_data}
                                             //                   width={'350px'}
                                             //                   async_tier_access={false}
                                             //                   handleRemoveVideo={this.handleRemoveVideo}
                                             //                   windowHeight={window.innerHeight}
                                             //                   expanded={this.state.expanded}
                                             //                   expandedDashboard={this.state.expandedDashboard}
                                             //                   updateViewType={this.updateViewType}
                                             //                   isSwitchOn={this.state.isSwitchOn}
                                             //                   profileLiveLoading={this.state.profileLiveLoading}
                                             //                   copyButtonClicked={this.state.copyButtonClicked}
                                             //                   progressCount={this.state.progressCount}
                                             //                   influencer_bool={this.state.influencer_bool}
                                             //                   firstName={this.state.first_name}
                                             //                   watchedSalesVideo={this.state.watchedSalesVideo}
                                             //                   setupProfile={this.state.setupProfile}
                                             //                   sharedWaitingList={this.state.sharedWaitingList}
                                             //                   oneWaitingList={this.state.oneWaitingList}
                                             //                   uploadedContent={this.state.uploadedContent}
                                             //                   uploadedPlaylistContent={this.state.uploadedPlaylistContent}
                                             //                   updatedPerks={this.state.updatedPerks}
                                             //                   setupStripe={this.state.setupStripe}
                                             //                   stripeStatus={this.state.stripeStatus}
                                             //                   missingText={this.state.missingText}
                                             //                   tierText={this.state.tierText}
                                             //                   stripeRedirectLink={this.state.stripeRedirectLink}
                                             //                   tierChangeOptions={this.state.tierChangeOptions}
                                             //                   shareWaitingListError={this.state.shareWaitingListError}
                                             //                   joinReasonAdded={this.state.joinReasonAdded}
                                             //                   profileVideoAdded={this.state.profileVideoAdded}
                                             //                   showContentConfetti={this.state.showContentConfetti}
                                             //                   openProfileWhatsThis={this.state.openProfileWhatsThis}
                                             //                   openOfferingWhatsThis={this.state.openOfferingWhatsThis}
                                             //                   openWaitingListWhatsThis={this.state.openWaitingListWhatsThis}
                                             //                   openCallWhatsThis={this.state.openCallWhatsThis}
                                             //                   openContentWhatsThis={this.state.openContentWhatsThis}
                                             //                   openStripeWhatsThis={this.state.openStripeWhatsThis}
                                             //                   openUrlWhatsThis={this.state.openUrlWhatsThis}
                                             //                   openEditUrl={this.state.openEditUrl}
                                             //                   editedUsername={this.state.editedUsername}
                                             //                   editUrlErrorMsg={this.state.editUrlErrorMsg}
                                             //                   openRefCalcWhatsThis={this.state.openRefCalcWhatsThis}
                                             //                   tiersModal={this.state.tiersModal}
                                             //                   publishModal={this.state.publishModal}
                                             //                   contentCount={this.state.content_count}
                                             //                   waitingListCount={this.state.waitingListCount}
                                             //                   waiting_list_influencer={this.state.influencer_info['waiting_list']}
                                             //                   collectionsCount={this.state.collectionsCount}
                                             //                   activeTierCount={this.state.activeTierCount}
                                             //                   snackbar={this.state.snackbar}
                                             //                   snackbarAutoHide={this.state.snackbarAutoHide}
                                             //                   snackbarSeverity={this.state.snackbarSeverity}
                                             //                   confettiModal={this.state.confettiModal}
                                             //                   whatsThisModal={this.state.whatsThisModal}
                                             //                   checkListModal={this.state.checkListModal}
                                             //                   makeInfluencerLive={this.makeInfluencerLive}
                                             //                   influencerUsername={this.state.current_user}
                                             //                   influencerIcon={this.state.influencer_info['icon_image_path']}
                                             //                   missingProfiles={this.state.missingProfiles}
                                             //                   influencerDescription={this.state.influencer_info['description']}
                                             //                   influencerEmail={this.state.user_email}
                                             //                   influencerBanner={this.state.influencerBanner}
                                             //                   influencerVideo={this.state.influencerVideo}
                                             //                   influencerIntercomKey={this.state.intercom_verify_key}
                                             //                   switch_onChange_handle={this.switch_onChange_handle}
                                             //                   submitUsernameUpdate={this.submitUsernameUpdate}
                                             //                   setTrialLength={this.setTrialLength}
                                             //                   trialLength={this.state.trialLength}
                                             //                   n_views_this_week={this.state.n_views_this_week}
                                             //                   n_views_increase={this.state.n_views_increase}
                                             //                   n_subs_this_week={this.state.n_subs_this_week}
                                             //                   n_subs_increase={this.state.n_subs_increase}
                                             //                   this_month_income={this.state.this_month_income}
                                             //                   last_month_income={this.state.last_month_income}
                                             //                   openOffering={this.state.openOffering}
                                             //                   community_is_active={this.state.community_is_active}
                                             //                   handleOpenHiddenTabModal={this.handleOpenHiddenTabModal}
                                             //                   handleOpenInfoTabModal={this.handleOpenInfoTabModal}
                                             //                   handleCloseInfoTabModal={this.handleCloseInfoTabModal}
                                             //                   updateCommunityActive={this.updateCommunityActive}
                                             //                   dm_active={this.state.dm_active}
                                             //                   openDMCheckout={this.openDMCheckout}
                                             //                   updateHasMessage={this.updateHasMessage}
                                             //                   paidDMs_show={this.state.paidDMs_show}
                                             //                   maxMessageLength={this.state.max_message_length}
                                             //                   setMaxMessageLength={this.setMaxMessageLength}
                                             //                   handleCollectionTabChange={this.handleCollectionTabChange}
                                             //                   openTippingCheckout={this.openTipCheckout}
                                             //                   setCommentCount={this.setCommentCount}
                                             //                   async_apply={this.state.async_apply}
                                             //                   goToCheckout={this.goToCheckout}
                                             //                   open_messages={this.state.open_messages}
                                             //                   open_coaching={this.state.open_coaching}
                                             //                   loading_page_change={this.state.loading_page_change}
                                             //                   content_list_length={this.state.content_list_length}
                                             //                   page_n={this.state.page_n}
                                             //                   setPageN={this.setPageN}
                                             //                   n_page_views={this.state.n_page_views}
                                             //                   buyNowThumbnailUrl={this.state.buyNowThumbnailUrl}
                                             //                   buyNowTitle={this.state.buyNowTitle}
                                             //                   buyNowContentType={this.state.buyNowContentType}
                                             //                   buyNowContentId={this.state.buyNowContentId}
                                             //                   setNewPlaylistModal={this.setNewPlaylistModal}
                                             //                   handleSingleViewCollection={this.handleSingleViewCollection}
                                             //                   handleConfirmationSnackbarOpen={this.handleConfirmationSnackbarOpen}
                                             //                   handleOpenCollections={this.handleOpenCollections}
                                             //                   collectionsMobileAnchorEl={this.state.collectionsMobileAnchorEl}
                                             //                   collectionsMobileOpen={this.state.collectionsMobileOpen}
                                             //                   updateCollectionOrder={this.updateCollectionOrder}
                                             //                   influencer_username={this.state.influencer_info['influencer']}
                                             //                   search_func_collection={this.openSearchContentCollection}
                                             //                /></Suspense>
                                             //          }
                                             //       </ThemeProvider>
                                             //    </>
                                             // }
                                             disablePreview={current_page_view === 'preview'}
                                          />
                                       </>
                                    }
                                    <Suspense fallback={<></>}><SnackbarAlert
                                       msg={this.state.errorMsgUpload}
                                       open={this.state.snackbarOpenUpload}
                                       severity={this.state.snackbarSeverityUpload}
                                       backgroundColor={'var(--brand-color)'}
                                       autoHide={4000}
                                       handleClose={() =>
                                          this.setState({
                                             snackbarOpenUpload: false
                                          })
                                       }
                                    /></Suspense>

                                    <Suspense fallback={<></>}>
                                       <NewBannerModal
                                          open={this.state.isBannerModalOpen}
                                          saveChanges={this.saveChanges}
                                          saveBannerChanges={this.saveBannerChanges}
                                          setState={this.setState}
                                          handleSetBannerChange={this.handleSetBannerChange}
                                          handlePresetBannerChange={this.handlePresetBannerChange}
                                          windowWidth={this.state.deviceWidth}
                                          influencerBannerUpdated={this.state.influencerBannerUpdated}
                                          influencerBanner={this.state.influencerBanner}
                                          influencerBannerUpdatedFile={this.state.influencerBannerUpdatedFile}
                                       /></Suspense>

                                    <Suspense fallback={<></>}>
                                       <PublishedCongratsModal
                                          publishedCongratsModal={this.state.publishedCongratsModal}
                                          handleClosePublishedCongratsModal={this.handleClosePublishedCongratsModal}
                                          displayName={this.state.influencer_info['influencer_name']}
                                          influencer_name={this.state.influencer_name}
                                       />
                                    </Suspense>


                                    <Suspense fallback={<></>}>
                                       <InitialDashboardModal
                                          new_creator_modal={this.state.new_creator_modal}
                                          openExampleCreatorsPopup={this.openExampleCreatorsPopup}
                                          handleCloseNewCreatorModal={this.handleCloseNewCreatorModal}
                                          displayName={this.state.influencer_info['influencer_name']}
                                          openGetStartedModal={this.openGetStartedModal}
                                          book_success_meeting_popup={this.setDemoModal}
                                          windowWidth={this.state.deviceWidth}
                                          handleTabChange={this.handleTabChange}
                                          handleCreateCollection={this.handleCreateCollection}
                                          handleCreateMembership={this.handleCreateMembership}
                                          handleCreateAsync={this.handleCreateAsync}
                                          handleCreateContent={this.handleCreateContent}
                                          handleCreateCommunity={this.handleCreateCommunity}
                                       />
                                    </Suspense>




                                    <Suspense fallback={<></>}>
                                       <HiddenTabModal
                                          hidden_tab_modal={this.state.hidden_tab_modal}
                                          updateCommunityActive={this.updateCommunityActive}
                                          handleOpenHiddenTabModal={this.handleOpenHiddenTabModal}
                                          handleCloseHiddenTabModal={this.handleCloseHiddenTabModal}
                                          displayName={this.state.influencer_info['influencer_name']}
                                          community_is_active={this.state.community_is_active}
                                       />
                                    </Suspense>

                                    <Suspense fallback={<></>}>
                                       <TabInfoModal
                                          tab_info_modal={this.state.tab_info_modal}
                                          tab_info_modal_type={this.state.tab_info_modal_type}
                                          tabState={this.state.tabState}
                                          handleOpenInfoTabModal={this.handleOpenInfoTabModal}
                                          handleCloseInfoTabModal={this.handleCloseInfoTabModal}
                                          displayName={this.state.influencer_info['influencer_name']}
                                          asyncActive={this.state.subscribe_popup_async_active}
                                       />
                                    </Suspense>



                                    <Suspense fallback={<></>}>
                                       <EditCollections
                                          open={this.state.editCollectionOpen}
                                          editCollectionBuyNowActive={this.state.editCollectionBuyNowActive}
                                          onClose={this.handleCloseEditCollection}
                                          currency={this.state.currency}
                                          currencySymbol={
                                             this.state.currency === 'GBP' ? '£' :
                                                this.state.currency === 'EUR' ? '€' :
                                                   this.state.currency === 'USD' ? '$' :
                                                      this.state.currency === 'AUD' ? 'AU$' :
                                                         this.state.currency === 'CAD' ? 'CA$' :
                                                            this.state.currency === 'SEK' ? '' : ''}
                                          currencySymbolPost={this.state.currency === 'SEK' ? ' kr' : ''}
                                          editCollectionPrice={this.state.editCollectionPrice}
                                          editCollectionId={this.state.editCollectionId}
                                          editCollectionPriceStr={this.state.editCollectionPriceStr}
                                          editCollectionThumbnail={this.state.editCollectionThumbnail}
                                          editCollectionLocked={this.state.editCollectionLocked}
                                          windowWidth={window.innerWidth}
                                          setState={this.setState}
                                          minBuyNowPrice={this.state.currency === 'SEK' ? 1500 : 100}
                                          editCollectionTitle={this.state.editCollectionTitle}
                                          influencer={this.state.influencer_info['influencer']}
                                          handleCollectionTabChange={this.handleCollectionTabChange}
                                          handleTabNavigation={this.handleTabNavigation}
                                          current_page_view={this.props.current_page_view}
                                          editingCourse={this.state.editingCourse}
                                          handleProfileTabChange={this.handleProfileTabChange}
                                          selected_tab={this.state.selected_tab}
                                       // collection={this.state.buyCollectionsCollection}
                                       // onUpdate={this.handleUpdateCollection}
                                       />
                                    </Suspense>
                                    <div style={{ minHeight: (this.state.influencer_info['waiting_list'] === true && this.state.is_me === false) || this.state.view_type === 'user-waitlist' || this.state.my_platform_page === 'home' ? '' : '700px' }}>

                                       {/* <div style={{ minHeight: (this.state.influencer_info['waiting_list'] === true && this.state.is_me === false) || this.state.view_type === 'waitlist-user' ? '' : '700px' }}> */}
                                       {/* <div style={{ minHeight: '700px' }}> */}
                                       {
                                          this.state.my_platform_page !== 'home' ?
                                             swiper_data
                                             :
                                             null
                                       }
                                    </div>

                                 </Grid>


                                 <Grid xs={12} sx={{ display: { xs: (showBottomJoinBanner === true || (this.state.waiting_list || this.state.influencer_info['waiting_list'] === true) || this.props.is_me) ? 'block' : 'none', lg: 'none' } }}>
                                    <Suspense fallback={<></>}>
                                       <MobileUnsubscribedButton
                                          freeSubSubscribe={this.freeSubSubscribe}
                                          is_me={this.state.is_me}
                                          subscription_popup_open={this.state.subscribe_popup_open}
                                          influencer_info={this.state.influencer_info}
                                          OpenSubscribePopup={this.OpenSubscribePopup}
                                          OpenWaitingListPopup={this.OpenWaitingListPopup}
                                          CloseSubscribePopup={this.CloseSubscribePopup}
                                          CloseWaitingListPopup={this.CloseWaitingListPopup}
                                          influencer_n_subscribers={this.state.influencer_n_subscribers}
                                          influencer_show_icon_image={this.state.influencer_show_icon_image}
                                          bronze_price={this.state.subscribe_popup_bronze_price}
                                          silver_price={this.state.subscribe_popup_silver_price}
                                          gold_price={this.state.subscribe_popup_gold_price}
                                          async_price={this.state.subscribe_popup_async_price}
                                          bronze_perks_text={this.state.subscribe_popup_bronze_perks_text}
                                          silver_perks_text={this.state.subscribe_popup_silver_perks_text}
                                          gold_perks_text={this.state.subscribe_popup_gold_perks_text}
                                          async_perks_text={this.state.subscribe_popup_async_perks_text}
                                          free_name={this.state.subscribe_popup_free_name}
                                          bronze_name={this.state.subscribe_popup_bronze_name}
                                          silver_name={this.state.subscribe_popup_silver_name}
                                          gold_name={this.state.subscribe_popup_gold_name}
                                          async_name={this.state.subscribe_popup_async_name}
                                          free_active={this.state.subscribe_popup_free_active}
                                          bronze_active={this.state.subscribe_popup_bronze_active}
                                          silver_active={this.state.subscribe_popup_silver_active}
                                          gold_active={this.state.subscribe_popup_gold_active}
                                          async_active={this.state.subscribe_popup_async_active}
                                          currency={this.state.currency}
                                          bronze_annual_price={this.state.subscribe_popup_bronze_annual_price}
                                          silver_annual_price={this.state.subscribe_popup_silver_annual_price}
                                          gold_annual_price={this.state.subscribe_popup_gold_annual_price}
                                          async_annual_price={this.state.subscribe_popup_async_annual_price}
                                          bronze_show_annual_reduction={this.state.subscribe_popup_bronze_show_annual_reduction}
                                          silver_show_annual_reduction={this.state.subscribe_popup_silver_show_annual_reduction}
                                          gold_show_annual_reduction={this.state.subscribe_popup_gold_show_annual_reduction}
                                          async_show_annual_reduction={this.state.subscribe_popup_async_show_annual_reduction}
                                          waiting_list={this.state.influencer_info['waiting_list']}
                                          influencer={this.state.influencer_name}
                                          trial_length={this.state.subscribe_popup_trial_length}
                                          discordActive={this.state.discord_active}
                                          userDiscordSetup={this.state.user_discord_setup}
                                          discordAccess={this.state.influencer_info.discord_access}
                                          bronze_monthly_active={this.state.subscribe_popup_bronze_monthly_active}
                                          silver_monthly_active={this.state.subscribe_popup_silver_monthly_active}
                                          gold_monthly_active={this.state.subscribe_popup_gold_monthly_active}
                                          async_monthly_active={this.state.subscribe_popup_async_monthly_active}
                                          bronze_annual_active={this.state.subscribe_popup_bronze_annual_active}
                                          silver_annual_active={this.state.subscribe_popup_silver_annual_active}
                                          gold_annual_active={this.state.subscribe_popup_gold_annual_active}
                                          async_annual_active={this.state.subscribe_popup_async_annual_active}
                                          profile_tab_index={this.state.selected_tab}
                                          mobileCTABannerClicked={this.state.mobileCTABannerClicked}
                                          influencer_active_in_community={this.state.influencer_info.influencer_active_in_community}
                                          free_trial_eligible={this.state.free_trial_eligible}
                                          async_tier_access={this.state.subpopup_tier_async_overwrite !== null ? this.state.subpopup_tier_async_overwrite : this.state.subscribe_popup_async_tier_access}
                                          async_annual_duration={this.state.subscribe_popup_async_annual_duration}
                                          async_annual_duration_type={this.state.subscribe_popup_async_annual_duration_type}
                                          async_annual_rebill={this.state.subscribe_popup_async_annual_rebill}
                                          async_tier_hidden={this.state.subscribe_popup_async_tier_hidden}
                                          async_tier_apply={this.state.subscribe_popup_async_tier_apply}
                                          community_is_active={this.state.community_is_active}
                                          selected_tab={this.state.selected_tab}
                                          view_type={this.state.view_type}
                                       />
                                    </Suspense>



                                 </Grid>
                              </>
                        }

                        {current_page_view === 'preview' && !isMobile && !mobile_preview && <Box
                           sx={{
                              display: 'flex',
                              position: 'fixed',
                              zIndex: 1299,
                              margin: '10px'
                           }}
                        >
                           <ViewSelector
                              currentView={view_type}
                              onChange={(value) => {
                                 this.updateViewType(value);
                                 this.setState({ loading_dashboard_data: false });
                              }}
                              userAvatar={''}
                              windowWidth={deviceWidth}
                              creatorAvatar={''}
                              launched={this.state.influencer_launched}
                           />
                        </Box>}

                        {!this.state.isAnyModalOpen && !creator_preview && !mobile_preview &&
                           <BottomTab
                              handleOpenCreatorCalendly={this.handleOpenCreatorCalendly}
                              handleCustomCreatorLogoModalOpen={this.handleCustomCreatorLogoModalOpen}
                              openExampleCreatorsPopup={this.openExampleCreatorsPopup}
                              updateViewType={this.updateViewType}
                              setState={this.setState}
                              activeProductData={this.state.activeProductData}
                              launched_influencer={this.state.influencer_launched}
                           />
                        }
                     </Grid>

                     :
                     // Not user
                     <Grid container sx={{ backgroundColor: 'var(--rebranding-background-color)', maxWidth: '100vw' }}>

                        <Grid item xs={12} lg={12} paddingBottom={
                           // So 'Powered by FW isn't hidden'
                           !this.state.mobileCTABannerClicked && !this.state.is_me && this.state.influencer_info.influencer_active_in_community ?
                              '35px' : '0'
                        }>
                           {bannerMain}
                           {
                              (this.state.influencer_info['waiting_list'] !== true) & (window.innerWidth >= 1280) ?
                                 // Desktop Inf Nav
                                 <Grid container justifyContent={'flex-end'} style={{ margin: '0px' }}>

                                    <Grid xs={2} sx={{ display: 'flex', margin: '0px' }}>
                                       {
                                          this.state.profile_tab_index === 'community' ?
                                             <p style={{ margin: '105px auto 0px 0px', fontSize: '24px', paddingLeft: window.innerWidth >= 900 ? '30px' : '16px', }}><strong>Community</strong></p>
                                             :
                                             null
                                       }

                                       {
                                          this.state.profile_tab_index === 'async' ?
                                             <p style={{ margin: '105px auto 0px 0px', fontSize: '24px', paddingLeft: window.innerWidth >= 900 ? '30px' : '16px', }}><strong>Async</strong></p>
                                             :
                                             null
                                       }

                                       {
                                          this.state.profile_tab_index === 'paidDMs' ?
                                             <p style={{ margin: '105px auto 0px 0px', fontSize: '24px', paddingLeft: window.innerWidth >= 900 ? '30px' : '16px', }}><strong>Messages</strong></p>
                                             :
                                             null
                                       }

                                       {
                                          this.state.profile_tab_index === 'dashboard' ?
                                             <p style={{ margin: '105px auto 0px 0px', fontSize: '24px', paddingLeft: window.innerWidth >= 900 ? '30px' : '16px', }}><strong>Home</strong></p>
                                             :
                                             null
                                       }

                                    </Grid>


                                 </Grid>
                                 : ''
                           }


                           {((this.state.influencer_info['waiting_list'] === true) && (this.state.view_type !== 'user-waitlist')) ?
                              <div>
                                 {swiper_data}

                              </div>
                              : ''
                           }

                           {((this.state.influencer_info['waiting_list'] !== true)) ?
                              <div>
                                 {swiper_data}
                              </div>
                              : ''
                           }

                        </Grid>
                        <Grid 
                           xs={12} 
                           sx={{ 
                              display: { 
                                 xs: ((showBottomJoinBanner === true || (this.state.waiting_list || this.state.influencer_info['waiting_list'] === true) || this.props.is_me) ? 'block' : 'none'), 
                                 lg: 'none'
                              } 
                           }}
                        >
                           <Suspense fallback={<></>}><MobileUnsubscribedButton
                              freeSubSubscribe={this.freeSubSubscribe}
                              is_me={this.state.is_me}
                              subscription_popup_open={this.state.subscribe_popup_open}
                              influencer_info={this.state.influencer_info}
                              OpenSubscribePopup={this.OpenSubscribePopup}
                              OpenWaitingListPopup={this.OpenWaitingListPopup}
                              CloseSubscribePopup={this.CloseSubscribePopup}
                              CloseWaitingListPopup={this.CloseWaitingListPopup}
                              influencer_n_subscribers={this.state.influencer_n_subscribers}
                              influencer_show_icon_image={this.state.influencer_show_icon_image}
                              bronze_price={this.state.subscribe_popup_bronze_price}
                              silver_price={this.state.subscribe_popup_silver_price}
                              gold_price={this.state.subscribe_popup_gold_price}
                              bronze_perks_text={this.state.subscribe_popup_bronze_perks_text}
                              silver_perks_text={this.state.subscribe_popup_silver_perks_text}
                              gold_perks_text={this.state.subscribe_popup_gold_perks_text}
                              free_name={this.state.subscribe_popup_free_name}
                              bronze_name={this.state.subscribe_popup_bronze_name}
                              silver_name={this.state.subscribe_popup_silver_name}
                              gold_name={this.state.subscribe_popup_gold_name}
                              free_active={this.state.subscribe_popup_free_active}
                              bronze_active={this.state.subscribe_popup_bronze_active}
                              silver_active={this.state.subscribe_popup_silver_active}
                              gold_active={this.state.subscribe_popup_gold_active}
                              currency={this.state.currency}
                              bronze_annual_price={this.state.subscribe_popup_bronze_annual_price}
                              silver_annual_price={this.state.subscribe_popup_silver_annual_price}
                              gold_annual_price={this.state.subscribe_popup_gold_annual_price}
                              bronze_show_annual_reduction={this.state.subscribe_popup_bronze_show_annual_reduction}
                              silver_show_annual_reduction={this.state.subscribe_popup_silver_show_annual_reduction}
                              gold_show_annual_reduction={this.state.subscribe_popup_gold_show_annual_reduction}
                              waiting_list={this.state.influencer_info['waiting_list']}
                              influencer={this.state.influencer_name}
                              trial_length={this.state.subscribe_popup_trial_length}
                              discordActive={this.state.discord_active}
                              userDiscordSetup={this.state.user_discord_setup}
                              discordAccess={this.state.influencer_info.discord_access}
                              bronze_monthly_active={this.state.subscribe_popup_bronze_monthly_active}
                              silver_monthly_active={this.state.subscribe_popup_silver_monthly_active}
                              gold_monthly_active={this.state.subscribe_popup_gold_monthly_active}
                              bronze_annual_active={this.state.subscribe_popup_bronze_annual_active}
                              silver_annual_active={this.state.subscribe_popup_silver_annual_active}
                              gold_annual_active={this.state.subscribe_popup_gold_annual_active}
                              profile_tab_index={this.state.selected_tab}
                              mobileCTABannerClicked={this.state.mobileCTABannerClicked}
                              influencer_active_in_community={this.state.influencer_info.influencer_active_in_community}
                              free_trial_eligible={this.state.free_trial_eligible}
                              async_price={this.state.subscribe_popup_async_price}
                              async_perks_text={this.state.subscribe_popup_async_perks_text}
                              async_name={this.state.subscribe_popup_async_name}
                              async_active={this.state.subscribe_popup_async_active}
                              async_annual_price={this.state.subscribe_popup_async_annual_price}
                              async_show_annual_reduction={this.state.subscribe_popup_async_show_annual_reduction}
                              async_monthly_active={this.state.subscribe_popup_async_monthly_active}
                              async_annual_active={this.state.subscribe_popup_async_annual_active}
                              async_tier_access={this.state.subpopup_tier_async_overwrite !== null ? this.state.subpopup_tier_async_overwrite : this.state.subscribe_popup_async_tier_access}
                              async_annual_duration={this.state.subscribe_popup_async_annual_duration}
                              async_annual_duration_type={this.state.subscribe_popup_async_annual_duration_type}
                              async_annual_rebill={this.state.subscribe_popup_async_annual_rebill}
                              async_tier_hidden={this.state.subscribe_popup_async_tier_hidden}
                              async_tier_apply={this.state.subscribe_popup_async_tier_apply}
                              community_is_active={this.state.community_is_active}
                              selected_tab={this.state.selected_tab}
                              view_type={this.state.view_type}
                           /></Suspense>
                        </Grid>
                     </Grid>
               }


            </>



         )
      } else if (this.state.current_user === '') {
         if (this.state.influencer_info['waiting_list'] === true) {
            main_div = (
               // USER NOT SIGNED IN & WAITING LIST
               <Grid container sx={{ backgroundColor: 'var(--rebranding-background-color)' }}>

                  <Grid item xs={12} lg={12}
                  >
                     {bannerMain}

                     {swiper_data}

                  </Grid>
                  <Item xs={12} sx={{ display: { xs: (showBottomJoinBanner === true || (this.state.waiting_list || this.state.influencer_info['waiting_list'] === true) || this.props.is_me) ? 'block' : 'none', lg: 'none' } }}>
                     <Suspense fallback={<></>}>
                        <MobileUnsubscribedButton
                           freeSubSubscribe={this.freeSubSubscribe}
                           is_me={this.state.is_me}
                           subscription_popup_open={this.state.subscribe_popup_open}
                           influencer_info={this.state.influencer_info}
                           OpenSubscribePopup={this.OpenSubscribePopup}
                           OpenWaitingListPopup={this.OpenWaitingListPopup}
                           CloseSubscribePopup={this.CloseSubscribePopup}
                           CloseWaitingListPopup={this.CloseWaitingListPopup}
                           influencer_n_subscribers={this.state.influencer_n_subscribers}
                           influencer_show_icon_image={this.state.influencer_show_icon_image}
                           bronze_price={this.state.subscribe_popup_bronze_price}
                           silver_price={this.state.subscribe_popup_silver_price}
                           gold_price={this.state.subscribe_popup_gold_price}
                           bronze_perks_text={this.state.subscribe_popup_bronze_perks_text}
                           silver_perks_text={this.state.subscribe_popup_silver_perks_text}
                           gold_perks_text={this.state.subscribe_popup_gold_perks_text}
                           free_name={this.state.subscribe_popup_free_name}
                           bronze_name={this.state.subscribe_popup_bronze_name}
                           silver_name={this.state.subscribe_popup_silver_name}
                           gold_name={this.state.subscribe_popup_gold_name}
                           free_active={this.state.subscribe_popup_free_active}
                           bronze_active={this.state.subscribe_popup_bronze_active}
                           silver_active={this.state.subscribe_popup_silver_active}
                           gold_active={this.state.subscribe_popup_gold_active}
                           currency={this.state.currency}
                           bronze_annual_price={this.state.subscribe_popup_bronze_annual_price}
                           silver_annual_price={this.state.subscribe_popup_silver_annual_price}
                           gold_annual_price={this.state.subscribe_popup_gold_annual_price}
                           bronze_show_annual_reduction={this.state.subscribe_popup_bronze_show_annual_reduction}
                           silver_show_annual_reduction={this.state.subscribe_popup_silver_show_annual_reduction}
                           gold_show_annual_reduction={this.state.subscribe_popup_gold_show_annual_reduction}
                           waiting_list={this.state.influencer_info['waiting_list']}
                           influencer={this.state.influencer_name}
                           trial_length={this.state.subscribe_popup_trial_length}
                           discordActive={this.state.discord_active}
                           userDiscordSetup={this.state.user_discord_setup}
                           discordAccess={this.state.influencer_info.discord_access}
                           bronze_monthly_active={this.state.subscribe_popup_bronze_monthly_active}
                           silver_monthly_active={this.state.subscribe_popup_silver_monthly_active}
                           gold_monthly_active={this.state.subscribe_popup_gold_monthly_active}
                           bronze_annual_active={this.state.subscribe_popup_bronze_annual_active}
                           silver_annual_active={this.state.subscribe_popup_silver_annual_active}
                           gold_annual_active={this.state.subscribe_popup_gold_annual_active}
                           profile_tab_index={this.state.selected_tab}
                           mobileCTABannerClicked={this.state.mobileCTABannerClicked}
                           influencer_active_in_community={this.state.influencer_info.influencer_active_in_community}
                           free_trial_eligible={this.state.free_trial_eligible}
                           async_price={this.state.subscribe_popup_async_price}
                           async_perks_text={this.state.subscribe_popup_async_perks_text}
                           async_name={this.state.subscribe_popup_async_name}
                           async_active={this.state.subscribe_popup_async_active}
                           async_annual_price={this.state.subscribe_popup_async_annual_price}
                           async_show_annual_reduction={this.state.subscribe_popup_async_show_annual_reduction}
                           async_monthly_active={this.state.subscribe_popup_async_monthly_active}
                           async_annual_active={this.state.subscribe_popup_async_annual_active}
                           async_tier_access={this.state.subpopup_tier_async_overwrite !== null ? this.state.subpopup_tier_async_overwrite : this.state.subscribe_popup_async_tier_access}
                           async_annual_duration={this.state.subscribe_popup_async_annual_duration}
                           async_annual_duration_type={this.state.subscribe_popup_async_annual_duration_type}
                           async_annual_rebill={this.state.subscribe_popup_async_annual_rebill}
                           async_tier_hidden={this.state.subscribe_popup_async_tier_hidden}
                           async_tier_apply={this.state.subscribe_popup_async_tier_apply}
                           community_is_active={this.state.community_is_active}
                           selected_tab={this.state.selected_tab}
                           view_type={this.state.view_type}
                           isLoggedout
                        /></Suspense>
                  </Item>
               </Grid>
            )
         } else {
            main_div = (
               // USER NOT SIGNED IN
               <Grid container sx={{ backgroundColor: 'var(--rebranding-background-color)' }}>


                  <Grid item xs={12} lg={12}>
                     {bannerMain}
                     {
                        window.innerWidth >= 1280 ?
                           // Desktop Inf Nav
                           <Grid container justifyContent={'flex-end'} style={{ margin: '0px' }}>
                              <Grid xs={2} sx={{ display: 'flex', margin: '0px' }}>
                                 {
                                    this.state.profile_tab_index === 'community' ?
                                       <p style={{ margin: '105px auto 0px 0px', fontSize: '24px', paddingLeft: window.innerWidth >= 900 ? '30px' : '16px', }}><strong>Community</strong></p>
                                       :
                                       null
                                 }
                              </Grid>
                           </Grid>
                           :
                           ''
                     }

                     <div
                        style={{
                           // marginTop: this.state.dashboard === true ? '0px' : (window.innerWidth >= 900 ? '60px' : '60px'),
                        }}
                     >
                        {swiper_data}
                     </div>

                  </Grid>
                  <Item xs={12} sx={{ display: { xs: (showBottomJoinBanner === true || (this.state.waiting_list || this.state.influencer_info['waiting_list'] === true) || this.props.is_me) ? 'block' : 'none', lg: 'none' } }}>
                     <Suspense fallback={<></>}>
                        <MobileUnsubscribedButton
                           freeSubSubscribe={this.freeSubSubscribe}
                           is_me={this.state.is_me}
                           subscription_popup_open={this.state.subscribe_popup_open}
                           influencer_info={this.state.influencer_info}
                           OpenSubscribePopup={this.OpenSubscribePopup}
                           OpenWaitingListPopup={this.OpenWaitingListPopup}
                           CloseSubscribePopup={this.CloseSubscribePopup}
                           CloseWaitingListPopup={this.CloseWaitingListPopup}
                           influencer_n_subscribers={this.state.influencer_n_subscribers}
                           influencer_show_icon_image={this.state.influencer_show_icon_image}
                           bronze_price={this.state.subscribe_popup_bronze_price}
                           silver_price={this.state.subscribe_popup_silver_price}
                           gold_price={this.state.subscribe_popup_gold_price}
                           bronze_perks_text={this.state.subscribe_popup_bronze_perks_text}
                           silver_perks_text={this.state.subscribe_popup_silver_perks_text}
                           gold_perks_text={this.state.subscribe_popup_gold_perks_text}
                           free_name={this.state.subscribe_popup_free_name}
                           bronze_name={this.state.subscribe_popup_bronze_name}
                           silver_name={this.state.subscribe_popup_silver_name}
                           gold_name={this.state.subscribe_popup_gold_name}
                           free_active={this.state.subscribe_popup_free_active}
                           bronze_active={this.state.subscribe_popup_bronze_active}
                           silver_active={this.state.subscribe_popup_silver_active}
                           gold_active={this.state.subscribe_popup_gold_active}
                           currency={this.state.currency}
                           bronze_annual_price={this.state.subscribe_popup_bronze_annual_price}
                           silver_annual_price={this.state.subscribe_popup_silver_annual_price}
                           gold_annual_price={this.state.subscribe_popup_gold_annual_price}
                           bronze_show_annual_reduction={this.state.subscribe_popup_bronze_show_annual_reduction}
                           silver_show_annual_reduction={this.state.subscribe_popup_silver_show_annual_reduction}
                           gold_show_annual_reduction={this.state.subscribe_popup_gold_show_annual_reduction}
                           waiting_list={this.state.influencer_info['waiting_list']}
                           influencer={this.state.influencer_name}
                           trial_length={this.state.subscribe_popup_trial_length}
                           discordActive={this.state.discord_active}
                           userDiscordSetup={this.state.user_discord_setup}
                           discordAccess={this.state.influencer_info.discord_access}
                           bronze_monthly_active={this.state.subscribe_popup_bronze_monthly_active}
                           silver_monthly_active={this.state.subscribe_popup_silver_monthly_active}
                           gold_monthly_active={this.state.subscribe_popup_gold_monthly_active}
                           bronze_annual_active={this.state.subscribe_popup_bronze_annual_active}
                           silver_annual_active={this.state.subscribe_popup_silver_annual_active}
                           gold_annual_active={this.state.subscribe_popup_gold_annual_active}
                           profile_tab_index={this.state.selected_tab}
                           mobileCTABannerClicked={this.state.mobileCTABannerClicked}
                           influencer_active_in_community={this.state.influencer_info.influencer_active_in_community}
                           free_trial_eligible={this.state.free_trial_eligible}
                           async_price={this.state.subscribe_popup_async_price}
                           async_perks_text={this.state.subscribe_popup_async_perks_text}
                           async_name={this.state.subscribe_popup_async_name}
                           async_active={this.state.subscribe_popup_async_active}
                           async_annual_price={this.state.subscribe_popup_async_annual_price}
                           async_show_annual_reduction={this.state.subscribe_popup_async_show_annual_reduction}
                           async_monthly_active={this.state.subscribe_popup_async_monthly_active}
                           async_annual_active={this.state.subscribe_popup_async_annual_active}
                           async_tier_access={this.state.subpopup_tier_async_overwrite !== null ? this.state.subpopup_tier_async_overwrite : this.state.subscribe_popup_async_tier_access}
                           async_annual_duration={this.state.subscribe_popup_async_annual_duration}
                           async_annual_duration_type={this.state.subscribe_popup_async_annual_duration_type}
                           async_annual_rebill={this.state.subscribe_popup_async_annual_rebill}
                           async_tier_hidden={this.state.subscribe_popup_async_tier_hidden}
                           async_tier_apply={this.state.subscribe_popup_async_tier_apply}
                           community_is_active={this.state.community_is_active}
                           selected_tab={this.state.selected_tab}
                           view_type={this.state.view_type}
                        /></Suspense>
                  </Item>
               </Grid>
            )
         }
      }
      let edit_banner_bar = ''
      if (((this.state.alteredBio !== this.state.influencer_info['description']) || (this.state.alteredDisplayName !== this.state.influencer_info['influencer_name'])) & (this.state.is_me === true)) {
         edit_banner_bar = (
            <>
               {/* <Fade> */}
               <Grid
                  xs={12}
                  container
                  justifyContent={'center'}
                  alignItems={'center'}
                  style={{
                     position: 'relative',
                     top: '60px',
                     width: '100%',
                     height: '50px',
                     backgroundColor: 'var(--brand-color)',
                  }}
               >
                  <Grid
                     style={{
                        margin: '0px',
                     }}
                  >
                     <span style={{ position: 'relative', top: '2px', marginRight: '20px', color: 'white', fontFamily: 'Roboto', fontSize: '18px', fontWeight: '400' }}>You've made changes, make sure you save them before leaving this window!</span>
                     <Button
                        style={{
                           backgroundColor: 'white',
                           color: 'var(--brand-color)',
                           textTransform: 'none',
                           fontFamily: 'Roboto',
                        }}
                     >
                        Save updates
                     </Button>
                     <Button

                        style={{
                           backgroundColor: 'white',
                           color: 'var(--brand-color)',
                           textTransform: 'none',
                           fontFamily: 'Roboto',
                           marginLeft: '20px',
                        }}
                     >
                        Revert changes
                     </Button>
                  </Grid>

               </Grid>
            </>
         )
      } else {
         edit_banner_bar = ''
      }
      let nav_bar = ''
      let helmet = ''
      if (this.state.dashboard === true && window.innerWidth >= 1280) {

         nav_bar = null
         // helmet = <Helmet>
         //    <title>Dashboard - WithMe</title>
         // </Helmet>


      } else if (this.state.dashboard === true) {
         nav_bar =
            <Suspense fallback={<></>}>
               <div style={{ height: '48px', width: '100%', backgroundColor: '#fff' }}></div>
               {
                  this.state.isTabsFixed === false || this.state.view_type !== 'creator' ? null :

                     <div style={{
                        height: '62px',
                        // height: '200px',
                        width: '100%', backgroundColor: '#fff'
                     }}></div>
               }

               <>
               {/* {view_type === 'creator' && (current_page_view === 'home') && !influencer_launched && this.state.deviceWidth >= 1280 && ( */}

                  {/* {
                     this.state.view_type === 'creator' && this.state.current_page_view === 'home' && this.state.influencer_launched === false && !shouldShowEditChangesBanner && (
                        <Suspense fallback={<></>}>
                           <DynamicOnboardingBar
                              setState={this.setState}
                              progressCount={this.state.progressCount}
                              setupStripe={this.state.setupStripe}
                              switch_onChange_handle={this.switch_onChange_handle}
                              current_user={this.state.current_user}
                              influencerDescription={this.state.influencer_info['description']}
                              influencerIcon={this.state.current_user_icon}
                              updatedPerks={this.state.updatedPerks}
                              windowWidth={this.state.deviceWidth}
                              handleProfileTabChange={this.handleProfileTabChange}
                              selected_tab={this.state.selected_tab}
                              scrollToTopOfTabs={this.scrollToTopOfTabs}
                           /></Suspense> 
                     )
                  } */}
               </>

               <MobileNavbar
                  current_user_state={this.state.current_user}
                  selected_tab={this.state.selected_tab}
                  my_platform_page={this.state.my_platform_page}
                  influencer_name={this.props.influencer_name}
                  iconImage={this.state.current_user_icon}
                  show_search={true}
                  setState={this.setState}
                  current_user={this.state.current_user}
                  user_email={this.state.user_email}
                  intercom_verify_key={this.state.intercom_verify_key}
                  // n_trial_days={nTrialDays}
                  book_success_meeting_popup={this.setCalendlyModal}
                  windowWidth={this.state.deviceWidth}
                  is_me={this.state.is_me}
                  creator_preview={creator_preview}
                  mobile_preview={mobile_preview} 
                  view_type={this.state.view_type}
                  updateViewType={this.updateViewType}
                  launched_influencer={this.state.influencer_launched}
                  mobileSearchOpen={this.state.mobileSearchOpen}
                  handleMobileSearchClose={this.handleMobileSearchClose}
                  handleMobileSearchOpen={this.handleMobileSearchOpen}
                  influencer_bool={this.state.influencer_bool}
                  current_user_icon={this.state.current_user_icon}
                  top_bar_text={this.state.influencer_name}
                  hidden_influencer={this.state.hidden_influencer}
                  waiting_list_influencer={this.state.influencer_info['waiting_list']}
                  n_user_subscriptions={this.state.n_user_subscriptions}
                  user_subscriptions={this.state.user_subscriptions}
                  recommended_influencers={this.state.recommended_influencers}
                  subs_user_menu={true}
                  influencer_id={this.state.influencer_info['id']}
                  display_name={this.state.display_name}
                  influencer_display_name={this.state.influencer_info['influencer_name']}
                  influencer_username={this.state.influencer_info['influencer']}
                  current_page={'influencer'}
                  search_func={this.openSearchContent}
                  search_func_collection={this.openSearchContentCollection}
                  handleCustomCreatorLogoModalOpen={this.handleCustomCreatorLogoModalOpen}
                  handleCustomCreatorLogoModalClose={this.handleCustomCreatorLogoModalClose}
                  logoRectangleFile={this.state.logoRectangleFile}
                  logoRectangleFileNew={this.state.logoRectangleFileNew}
                  logoSquareFile={this.state.logoSquareFile}
                  logoSquareFileNew={this.state.logoSquareFileNew}
                  customCreatorLogoModalOpen={this.state.customCreatorLogoModalOpen}
                  currentLogoFile={this.state.currentLogoFile}
                  mainLogoFile={this.state.mainLogoFile}
                  force_navbar_rerender={this.state.force_navbar_rerender}
                  uploadingCustomCreatorLogo={this.state.uploadingCustomCreatorLogo}
                  handlePricingModalOpen={this.handlePricingModalOpen}
                  handlePricingModalClose={this.handlePricingModalClose}
                  handleOpenCreatorCalendly={this.handleOpenCreatorCalendly}
                  waitlistCreator={this.state.influencer_info['waiting_list'] === true}
                  openExampleCreatorsPopup={this.openExampleCreatorsPopup}
                  updatedDisplayName={this.state.updatedDisplayName}
                  onDisplayNameUpdated={() => this.setState({ updatedDisplayName: this.state.influencerDisplayNameUpdated })}
               /></Suspense>
         helmet = <Helmet>
            <title>Dashboard - WithMe</title>
         </Helmet>
      } else {
         if (!creator_preview) {
            if (this.state.deviceWidth < 600) {
               nav_bar =
                  <Suspense fallback={<></>}>
                     {/* {
                        !this.state.is_me && this.state.influencer_bool === false ?
                           <Suspense fallback={<></>}>
                              <div style={{ position: 'sticky', width: '100%', zIndex: '9999', top: '60px', left: '0px', right: '0px' }}>
                                 <NonCreatorReferralBanner
                                    current_tier={this.state.influencer_info['current_tier']}
                                    current_user={this.state.current_user}
                                    influencer_bool={this.state.influencer_bool}
                                 />
                              </div>
   
                           </Suspense>
                           :
                           null
                     } */}
               <TopNavBar
                  current_user_state={this.state.current_user}
                  influencer_bool={this.state.influencer_bool}
                  current_user_icon={this.state.current_user_icon}
                  top_bar_text={this.state.influencer_name}
                  hidden_influencer={this.state.hidden_influencer}
                  waiting_list_influencer={this.state.influencer_info['waiting_list']}
                  n_user_subscriptions={this.state.n_user_subscriptions}
                  user_subscriptions={this.state.user_subscriptions}
                  recommended_influencers={this.state.recommended_influencers}
                  subs_user_menu={true}
                  is_me={this.state.is_me}
                  show_search={true}
                  influencer_id={this.state.influencer_info['id']}
                  display_name={this.state.display_name}
                  influencer_display_name={this.state.influencer_info['influencer_name']}
                  influencer_username={this.state.influencer_info['influencer']}
                  current_page={'influencer'}
                  mobileSearchOpen={this.state.mobileSearchOpen}
                  handleMobileSearchClose={this.handleMobileSearchClose}
                  handleMobileSearchOpen={this.handleMobileSearchOpen}
                  windowWidth={this.state.deviceWidth}
                  search_func={this.openSearchContent}
                  search_func_collection={this.openSearchContentCollection}
                  logoRectangleFile={this.state.logoRectangleFile}
                  logoRectangleFileNew={this.state.logoRectangleFileNew}
                  logoSquareFile={this.state.logoSquareFile}
                  logoSquareFileNew={this.state.logoSquareFileNew}
                  updatedDisplayName={this.state.updatedDisplayName}
                  onDisplayNameUpdated={() => this.setState({updatedDisplayName: this.state.influencerDisplayNameUpdated})}
               /></Suspense>

               // <div style={{marginTop: '-50px', display: 'block'}}></div>
            } else {
               nav_bar =
                  <Suspense fallback={<></>}>
                     {/* {
                        !this.state.is_me && this.state.influencer_bool === false ?
                           <Suspense fallback={<></>}>
                              <div style={{ position: 'sticky', width: '100%', zIndex: '9999', top: '60px', left: '0px', right: '0px' }}>
                                 <NonCreatorReferralBanner
                                    current_tier={this.state.influencer_info['current_tier']}
                                    current_user={this.state.current_user}
                                    influencer_bool={this.state.influencer_bool}
                                 />
                              </div>
                           </Suspense>
                           :
                           null
                     } */}
   
                     {!this.state.is_me && <TopNavBar
                        current_user_state={this.state.current_user}
                        influencer_bool={this.state.influencer_bool}
                        current_user_icon={this.state.current_user_icon}
                        top_bar_text={this.state.influencer_name}
                        hidden_influencer={this.state.hidden_influencer}
                        waiting_list_influencer={this.state.influencer_info['waiting_list']}
                        n_user_subscriptions={this.state.n_user_subscriptions}
                        user_subscriptions={this.state.user_subscriptions}
                        recommended_influencers={this.state.recommended_influencers}
                        subs_user_menu={true}
                        is_me={this.state.is_me}
                        show_search={true}
                        influencer_id={this.state.influencer_info['id']}
                        display_name={this.state.display_name}
                        influencer_display_name={this.state.influencer_info['influencer_name']}
                        influencer_username={this.state.influencer_info['influencer']}
                        current_page={'influencer'}
                        mobileSearchOpen={this.state.mobileSearchOpen}
                        handleMobileSearchClose={this.handleMobileSearchClose}
                        handleMobileSearchOpen={this.handleMobileSearchOpen}
                        windowWidth={this.state.deviceWidth}
                        search_func={this.openSearchContent}
                        search_func_collection={this.openSearchContentCollection}
                        logoRectangleFile={this.state.logoRectangleFile}
                        logoRectangleFileNew={this.state.logoRectangleFileNew}
                        logoSquareFile={this.state.logoSquareFile}
                        logoSquareFileNew={this.state.logoSquareFileNew}
                        updatedDisplayName={this.state.updatedDisplayName}
                        onDisplayNameUpdated={() => this.setState({ updatedDisplayName: this.state.influencerDisplayNameUpdated })}
                     />}
   
                  </Suspense>
            }
            if (this.state.influencer_info.influencer_name) {
               helmet = <Helmet>
                  <title>{`${this.state.influencer_info.influencer_name} - WithMe`}</title>
               </Helmet>
            }
         }
      }
      return (
         <div>
            {this.state.ratingsModal === true ?
               <Suspense fallback={<></>}>
                  <RatingsModal
                     influencer_rating_average={this.state.influencer_rating_average}
                     influencer_rating_count={this.state.influencer_rating_count}
                     rating_color={this.state.rating_color}
                     influencer_user_rating={this.state.influencer_user_rating}
                     data_func={this.get_and_post_data_skeleton}
                     update_ratings={this.update_ratings}
                     ratingsModal={this.state.ratingsModal}
                     setState={this.setState}
                     content_info={this.state.influencer_info}
                  /></Suspense> : null
            }
            {helmet}
            <div>

               {
                  this.state.contentModalOpen ?

                     <Suspense fallback={<></>}><ContentNewLives
                        contentModalOpen={this.state.contentModalOpen}
                        content_info={this.state.content_info}
                        setState={this.setState}
                        display_name={this.state.display_name}
                        handleContentModalOpen={this.handleContentModalOpen}
                        handleContentModalClose={this.handleContentModalClose}
                        current_user={this.state.current_user}
                        view_id={this.state.view_id}
                        content_loading={this.state.content_loading}
                        content_settings={this.state.content_settings}
                     /></Suspense>
                     :
                     null
               }

               <Suspense fallback={<></>}><SubscribePopup
                  openAsyncApply={this.openAsyncApply}
                  setState={this.setState}
                  subscription_popup_info_renewal_date={this.state.subscription_popup_info_renewal_date}
                  open_modal={this.state.subscribe_popup_open}
                  icon_image={this.state.subscribe_popup_icon_image}
                  influencer={this.state.subscribe_popup_influencer}
                  influencer_name={this.state.subscribe_popup_influencer_name}
                  current_tier={this.state.subscribe_popup_current_tier}
                  async_tier_access={this.state.subpopup_tier_async_overwrite !== null ? this.state.subpopup_tier_async_overwrite : this.state.subscribe_popup_async_tier_access}
                  minimum_tier={this.state.subscribe_popup_minimum_tier}
                  bronze_price={this.state.subscribe_popup_bronze_price}
                  silver_price={this.state.subscribe_popup_silver_price}
                  gold_price={this.state.subscribe_popup_gold_price}
                  bronze_perks_text={this.state.subscribe_popup_bronze_perks_text}
                  silver_perks_text={this.state.subscribe_popup_silver_perks_text}
                  gold_perks_text={this.state.subscribe_popup_gold_perks_text}
                  nextStep={this.goToCheckout}
                  CloseSubscribePopup={this.CloseSubscribePopup}
                  UpgradeSubInfoPopup={this.UpgradeSubInfoPopup}
                  DowngradeSubInfoPopup={this.DowngradeSubInfoPopup}
                  free_trial_eligible={this.state.free_trial_eligible}
                  current_free_trial={this.state.subscribe_popup_current_free_trial}
                  free_active={((this.state.subscribe_popup_single_tier === true) && (this.state.subscribe_popup_initial_selected_tier === 0)) ? true : ((this.state.subscribe_popup_single_tier === true) && (this.state.subscribe_popup_initial_selected_tier !== 0)) ? false : this.state.subscribe_popup_free_active}
                  bronze_active={((this.state.subscribe_popup_single_tier === true) && (this.state.subscribe_popup_initial_selected_tier === 1)) ? true : ((this.state.subscribe_popup_single_tier === true) && (this.state.subscribe_popup_initial_selected_tier !== 1)) ? false : this.state.subscribe_popup_bronze_active}
                  silver_active={((this.state.subscribe_popup_single_tier === true) && (this.state.subscribe_popup_initial_selected_tier === 2)) ? true : ((this.state.subscribe_popup_single_tier === true) && (this.state.subscribe_popup_initial_selected_tier !== 2)) ? false : this.state.subscribe_popup_silver_active}
                  gold_active={((this.state.subscribe_popup_single_tier === true) && (this.state.subscribe_popup_initial_selected_tier === 3)) ? true : ((this.state.subscribe_popup_single_tier === true) && (this.state.subscribe_popup_initial_selected_tier !== 3)) ? false : this.state.subscribe_popup_gold_active}
                  free_name={this.state.subscribe_popup_free_name}
                  bronze_name={this.state.subscribe_popup_bronze_name}
                  silver_name={this.state.subscribe_popup_silver_name}
                  gold_name={this.state.subscribe_popup_gold_name}
                  current_duration={this.state.subscribe_popup_current_duration}
                  currency={this.state.currency}
                  bronze_annual_price={this.state.subscribe_popup_bronze_annual_price}
                  silver_annual_price={this.state.subscribe_popup_silver_annual_price}
                  gold_annual_price={this.state.subscribe_popup_gold_annual_price}
                  bronze_show_annual_reduction={this.state.subscribe_popup_bronze_show_annual_reduction}
                  silver_annual_reduction={this.state.subscribe_popup_silver_show_annual_reduction}
                  gold_annual_reduction={this.state.subscribe_popup_gold_show_annual_reduction}
                  bronze_monthly_active={this.state.subscribe_popup_bronze_monthly_active}
                  silver_monthly_active={this.state.subscribe_popup_silver_monthly_active}
                  gold_monthly_active={this.state.subscribe_popup_gold_monthly_active}
                  bronze_annual_active={this.state.subscribe_popup_bronze_annual_active}
                  silver_annual_active={this.state.subscribe_popup_silver_annual_active}
                  gold_annual_active={this.state.subscribe_popup_gold_annual_active}
                  trial_length={this.state.subscribe_popup_trial_length}
                  initial_selected_tier={this.state.subscribe_popup_initial_selected_tier}
                  influencer_icon={this.state.influencer_info['icon_image_path']}
                  influencer_banner={this.state.influencerBanner}
                  current_user={this.state.current_user}
                  promo_code={this.state.promo_code}
                  async_price={this.state.subscribe_popup_async_price}
                  async_perks_text={this.state.subscribe_popup_async_perks_text}
                  async_active={((this.state.subscribe_popup_single_tier === true) && (this.state.subscribe_popup_initial_selected_tier === 4)) ? true : ((this.state.subscribe_popup_single_tier === true) && (this.state.subscribe_popup_initial_selected_tier !== 4)) ? false : this.state.subscribe_popup_async_active}
                  async_name={this.state.subscribe_popup_async_name}
                  async_annual_price={this.state.subscribe_popup_async_annual_price}
                  async_annual_reduction={this.state.subscribe_popup_async_show_annual_reduction}
                  async_monthly_active={this.state.subscribe_popup_async_monthly_active}
                  async_annual_active={this.state.subscribe_popup_async_annual_active}
                  subscribe_popup_single_tier={this.state.subscribe_popup_single_tier}
                  async_annual_duration={this.state.subscribe_popup_async_annual_duration}
                  async_annual_duration_type={this.state.subscribe_popup_async_annual_duration_type}
                  async_annual_rebill={this.state.subscribe_popup_async_annual_rebill}
                  async_tier_hidden={this.state.subscribe_popup_async_tier_hidden}
                  async_tier_apply={this.state.subscribe_popup_async_tier_apply}
                  async_apply={this.state.async_apply}
                  initialSubscribePopupDuration={this.state.initialSubscribePopupDuration}
                  sub_type={this.state.sub_type}
                  silver_access={this.state.subscription_popup_silver_access}
                  gold_access={this.state.subscription_popup_gold_access}
               /></Suspense>
               {
                  this.state.promo_code !== null ?
                     <Suspense fallback={<></>}> <CheckoutPopup
                        setState={this.setState}
                        subscription_popup_info_renewal_date={this.state.subscription_popup_info_renewal_date}
                        open_checkout_modal={this.state.open_checkout_modal}
                        icon_image={this.state.subscribe_popup_icon_image}
                        influencer={this.state.subscribe_popup_influencer}
                        influencer_name={this.state.subscribe_popup_influencer_name}
                        current_tier={this.state.subscribe_popup_current_tier}
                        minimum_tier={this.state.subscribe_popup_minimum_tier}
                        bronze_price={this.state.subscribe_popup_bronze_price}
                        silver_price={this.state.subscribe_popup_silver_price}
                        gold_price={this.state.subscribe_popup_gold_price}
                        bronze_perks_text={this.state.subscribe_popup_bronze_perks_text}
                        silver_perks_text={this.state.subscribe_popup_silver_perks_text}
                        gold_perks_text={this.state.subscribe_popup_gold_perks_text}
                        free_trial_eligible={this.state.free_trial_eligible}
                        current_free_trial={this.state.subscribe_popup_current_free_trial}
                        free_active={this.state.subscribe_popup_free_active}
                        bronze_active={this.state.subscribe_popup_bronze_active}
                        silver_active={this.state.subscribe_popup_silver_active}
                        gold_active={this.state.subscribe_popup_gold_active}
                        free_name={this.state.subscribe_popup_free_name}
                        bronze_name={this.state.subscribe_popup_bronze_name}
                        silver_name={this.state.subscribe_popup_silver_name}
                        gold_name={this.state.subscribe_popup_gold_name}
                        current_duration={this.state.subscribe_popup_current_duration}
                        currency={this.state.currency}
                        bronze_annual_price={this.state.subscribe_popup_bronze_annual_price}
                        silver_annual_price={this.state.subscribe_popup_silver_annual_price}
                        gold_annual_price={this.state.subscribe_popup_gold_annual_price}
                        bronze_show_annual_reduction={this.state.subscribe_popup_bronze_show_annual_reduction}
                        silver_annual_reduction={this.state.subscribe_popup_silver_show_annual_reduction}
                        gold_annual_reduction={this.state.subscribe_popup_gold_show_annual_reduction}
                        bronze_monthly_active={this.state.subscribe_popup_bronze_monthly_active}
                        silver_monthly_active={this.state.subscribe_popup_silver_monthly_active}
                        gold_monthly_active={this.state.subscribe_popup_gold_monthly_active}
                        bronze_annual_active={this.state.subscribe_popup_bronze_annual_active}
                        silver_annual_active={this.state.subscribe_popup_silver_annual_active}
                        gold_annual_active={this.state.subscribe_popup_gold_annual_active}
                        trial_length={this.state.subscribe_popup_initial_selected_tier === 4 ? 0 : this.state.free_trial_eligible === true ? this.state.subscribe_popup_trial_length : 0}
                        initial_selected_tier={this.state.subscribe_popup_initial_selected_tier}
                        initial_selected_tier_backup={this.state.subscribe_popup_initial_selected_tier_backup}
                        selected_duration={this.state.checkout_selected_duration}
                        updateSubscriptionIntent={this.updateSubscriptionIntent}
                        checkout_percent_off={this.state.checkout_percent_off}
                        edited_promo_code={this.state.edited_promo_code}
                        promo_code={this.state.promo_code}
                        influencer_banner={this.state.influencerBanner}
                        promo_error={this.state.promo_error}
                        async_price={this.state.subscribe_popup_async_price}
                        async_perks_text={this.state.subscribe_popup_async_perks_text}
                        async_active={this.state.subscribe_popup_async_active}
                        async_name={this.state.subscribe_popup_async_name}
                        async_annual_price={this.state.subscribe_popup_async_annual_price}
                        async_annual_reduction={this.state.subscribe_popup_async_show_annual_reduction}
                        async_monthly_active={this.state.subscribe_popup_async_monthly_active}
                        async_annual_active={this.state.subscribe_popup_async_annual_active}
                        async_annual_duration={this.state.subscribe_popup_async_annual_duration}
                        async_annual_duration_type={this.state.subscribe_popup_async_annual_duration_type}
                        async_annual_rebill={this.state.subscribe_popup_async_annual_rebill}
                        async_tier_hidden={this.state.subscribe_popup_async_tier_hidden}
                        connected_stripe_account_id={this.state.connected_stripe_account_id}
                     /></Suspense>
                     :
                     null
               }
               <Suspense fallback={<></>}><TermsModal
                  open={this.state.termsConditionsModal}
                  close={() => {
                     this.setState({
                        termsConditionsModal: false,
                        // subscribe_popup_open: true,
                     })
                  }}
                  selected_tab={this.state.terms_tab}
               /></Suspense>
               <Suspense fallback={<></>}><WaitingListModal
                  open_modal={this.state.waiting_list_popup_open}
                  waiting_list={this.state.influencer_info['waiting_list']}
                  influencer={this.state.influencer_info['influencer_name']}
                  influencer_username={this.state.influencer_info['influencer']}
                  CloseWaitingListPopup={this.CloseWaitingListPopup}
               /></Suspense>
               <Suspense fallback={<></>}><SubscribePopupInfo
                  page_type={this.state.subscription_popup_info_page_type}
                  current_tier={this.state.subscribe_popup_current_tier}
                  subscription_popup_info_open={this.state.subscription_popup_info_open}
                  subscription_popup_info_text_1={this.state.subscription_popup_info_text_1}
                  subscription_popup_info_text_2={this.state.subscription_popup_info_text_2}
                  subscription_popup_info_button_text={this.state.subscription_popup_info_button_text}
                  subscription_popup_info_button_click_process={this.state.subscription_popup_info_button_click_process}
                  bronze_perks_text={this.state.subscribe_popup_bronze_perks_text}
                  silver_perks_text={this.state.subscribe_popup_silver_perks_text}
                  gold_perks_text={this.state.subscribe_popup_gold_perks_text}
                  CloseSubscribePopupInfo={this.CloseSubscribePopupInfo}
                  bronze_price={this.state.subscribe_popup_bronze_price}
                  silver_price={this.state.subscribe_popup_silver_price}
                  gold_price={this.state.subscribe_popup_gold_price}
                  influencer={this.state.subscribe_popup_influencer}
                  influencer_name={this.state.subscribe_popup_influencer_name}
                  renewal_date={this.state.subscription_popup_info_renewal_date}
                  UpdateSubpopupInfoPageType={this.UpdateSubpopupInfoPageType}
                  icon_image={this.state.subscribe_popup_icon_image}
                  downgrade_tier={this.state.downgrade_tier}
                  downgrade_price_str={this.state.downgrade_price_str}
                  upgrade_tier={this.state.upgrade_tier}
                  upgrade_cost_str={this.state.upgrade_cost_str}
                  upgrade_price_str={this.state.upgrade_price_str}
                  discount={this.state.discount}
                  current_free_trial={this.state.subscribe_popup_current_free_trial}
                  page={'influencer'}
                  free_active={this.state.subscribe_popup_free_active}
                  bronze_active={this.state.subscribe_popup_bronze_active}
                  silver_active={this.state.subscribe_popup_silver_active}
                  gold_active={this.state.subscribe_popup_gold_active}
                  free_name={this.state.subscribe_popup_free_name}
                  bronze_name={this.state.subscribe_popup_bronze_name}
                  silver_name={this.state.subscribe_popup_silver_name}
                  gold_name={this.state.subscribe_popup_gold_name}
                  current_duration={this.state.subscribe_popup_current_duration}
                  currency={this.state.currency}
                  bronze_annual_price={this.state.subscribe_popup_bronze_annual_price}
                  silver_annual_price={this.state.subscribe_popup_silver_annual_price}
                  gold_annual_price={this.state.subscribe_popup_gold_annual_price}
                  bronze_show_annual_reduction={this.state.subscribe_popup_bronze_show_annual_reduction}
                  silver_annual_reduction={this.state.subscribe_popup_silver_show_annual_reduction}
                  gold_annual_reduction={this.state.subscribe_popup_gold_show_annual_reduction}
                  selected_duration={this.state.subpopup_info_selected_duration}
                  influencer_banner={this.state.influencerBanner}
                  async_perks_text={this.state.subscribe_popup_async_perks_text}
                  async_price={this.state.subscribe_popup_async_price}
                  async_active={this.state.subscribe_popup_async_active}
                  async_name={this.state.subscribe_popup_async_name}
                  async_annual_price={this.state.subscribe_popup_async_annual_price}
                  async_annual_reduction={this.state.subscribe_popup_async_show_annual_reduction}
               /></Suspense>
               {nav_bar}
               {
                  this.state.loading_dashboard_data ?

                     <Box style={modalStyle}
                        sx={{
                           display: 'flex', width: '100%', height: '100%',
                           margin: 'auto', zIndex: '9999', backgroundColor: 'transparent',
                        }}>
                        <Grid
                           container
                           spacing={0}
                           direction="column"
                           alignItems="center"
                           justifyContent="center"
                           style={{ minHeight: '90vh' }}
                        >
                           <CircularProgress sx={{
                              color: 'var(--brand-color)',
                           }} />

                        </Grid>
                     </Box>
                     :
                     <div>

                     </div>
               }

               <ThemeProvider theme={theme}>

                  <div id='main_div'>
                     {main_div}
                  </div>
                  {
                     this.state.isUploading ?
                        <Suspense fallback={<></>}><UploadProgress uploadPercent={this.state.uploadPercent} isUploading={this.state.isUploading}
                           uploadMessage={this.state.uploadMessage}
                           timeRemaining={this.state.timeRemaining}
                           uploadStep={this.state.uploadStep}
                           uploadComplete={this.state.uploadComplete}
                           uploadError={this.state.uploadError}
                           uploadErrorMsg={this.state.uploadErrorMsg}
                           resetState={() => {
                              this.setState({
                                 uploadComplete: false,
                                 uploadError: false,
                              })
                           }}
                           onClose={() => {
                              this.setState({ isUploading: false })
                           }} /></Suspense>
                        :
                        null

                  }




               </ThemeProvider>
               <Suspense fallback={<></>}><DashboardUploads
                  categories={this.reorderCategories(this.state.categories)}
                  tierTypes={this.state.tierTypes}
                  courseNames={this.state.courseNames}
                  last_5_course_names={this.state.last_5_course_names}
                  open_content_upload={this.state.open_content_upload}
                  contentType={this.state.content_type}
                  setCategories={(value) => { this.setState({ categories: value }) }}
                  setTierTypes={(value) => { this.setState({ tierTypes: value }) }}
                  setCourseNames={(value) => { this.setState({ courseNames: value }) }}
                  handleOpenCollections={this.handleOpenCollections}
                  collection_data={this.state.collection_data}
                  influencerUsername={this.state.current_user}
                  influencerEmail={this.state.user_email}
                  influencerIntercomKey={this.state.intercom_verify_key}
                  windowWidth={this.state.deviceWidth}
                  newContentSubmit={this.newContentSubmit}
                  closeUploadPopup={() => { this.setState({ open_content_upload: false }) }}
                  editCollectionThumbnail={this.state.editCollectionThumbnail}
                  editCollectionId={this.state.editCollectionId}
                  editCollectionBuyNowActive={this.state.editCollectionBuyNowActive}
                  editCollectionPriceStr={this.state.editCollectionPriceStr}
                  editCollectionPrice={this.state.editCollectionPrice}
                  isPublished={this.state.influencer_launched}
                  currency={this.state.currency}
                  currencySymbol={
                     this.state.currency === 'GBP' ? '£' :
                        this.state.currency === 'EUR' ? '€' :
                           this.state.currency === 'USD' ? '$' :
                              this.state.currency === 'AUD' ? 'AU$' :
                                 this.state.currency === 'CAD' ? 'CA$' :
                                    this.state.currency === 'NZD' ? 'NZ$' :
                                       this.state.currency === 'SEK' ? '' : ''}
                  currencySymbolPost={this.state.currency === 'SEK' ? ' kr' : ''}
                  buyNowActive={this.state.buyNowActive}
                  buyNowGuideActive={this.state.buyNowGuideActive}
                  buyNowImageActive={this.state.buyNowImageActive}
                  buyNowVideoActive={this.state.buyNowVideoActive}
                  buyNowAudioActive={this.state.buyNowAudioActive}
                  buyNowTextActive={this.state.buyNowTextActive}
                  buyNowLiveActive={this.state.buyNowLiveActive}

                  buyNowPriceCheckoutStr={this.state.buyNowPriceCheckoutStr}
                  // setBuyNowPriceCheckoutStr={(value) => {this.setState({buyNowPriceCheckoutStr: value})}}
                  buyNowPriceMinimum={this.state.buyNowPriceMinimum}
                  collections_count={this.state.collections_count}
                  all_count={this.state.all_count}
                  last_5_categories={this.state.last_5_categories}
                  selected_collection_name={this.state.single_view_collection}
                  selected_tab={this.state.selected_tab}
                  setState={this.setState}
                  resetBuyNow={() => this.resetBuyNow()}
                  product_type={this.state.product_type}
                  // loadInitialInfluencerData={this.loadInitialInfluencerData}
                  {...this.props}
               /></Suspense>
               <PopupModal
                  url="https://calendly.com/partner-success-team1/partner-success-meeting"
                  //  pageSettings={this.props.pageSettings}
                  //  utm={this.props.utm}
                  //  prefill={this.props.prefill}
                  onModalClose={() => this.setCalendlyModal(false)}
                  open={this.state.calendly_modal}
                  rootElement={document.getElementById("root")}
               />

               <PopupModal
                  url="https://calendly.com/sdr-team-9rc/fitwith-demo"
                  //  pageSettings={this.props.pageSettings}
                  //  utm={this.props.utm}
                  //  prefill={this.props.prefill}
                  onModalClose={() => this.setDemoModal(false)}
                  open={this.state.demo_modal}
                  rootElement={document.getElementById("root")}
               />

               <PopupModal
                  url="https://calendly.com/markgray/full-service-application?month=2024-01"
                  //  pageSettings={this.props.pageSettings}
                  //  utm={this.props.utm}
                  //  prefill={this.props.prefill}
                  onModalClose={() => this.setFullServiceApplicationModal(false)}
                  open={this.state.full_service_application_modal}
                  rootElement={document.getElementById("root")}
               />


               {/* Calendly Creator Menu */}
               <PopupModal
                  url={this.state.calendly_creator_menu_url}
                  onModalClose={() => this.handleCloseCreatorCalendly(false)}
                  open={this.state.calendly_creator_menu_open}
                  rootElement={document.getElementById("root")}
               />

               <Suspense fallback={<></>}>
                  <SnackbarAlert
                     msg={'WithMe URL Copied to Clipboard'}
                     open={this.state.confirmationSnackbarOpen}
                     severity={'success'}
                     backgroundColor={'var(--brand-color)'}
                     autoHide={4000}
                     handleClose={() =>
                        this.setState({
                           confirmationSnackbarOpen: false
                        })
                     }
                  /></Suspense>


               {
                  this.state.refreshing_content_data ?
                     <Modal open={this.state.refreshing_content_data}>

                        <Box
                           sx={{
                              display: 'flex', width: '100%', height: '100%',
                              margin: 'auto', zIndex: '9999',
                           }}>
                           <Grid
                              container
                              spacing={0}
                              direction="column"
                              alignItems="center"
                              justifyContent="center"
                              style={{ minHeight: '90vh' }}
                           >
                              <CircularProgress sx={{
                                 color: 'var(--brand-color)',
                              }} />
                              <p style={{
                                 color: 'var(--primary-text-color)', fontSize: 'var(--medium-text)',
                                 fontWeight: '600',
                              }}>Refreshing your content...</p>
                           </Grid>
                        </Box>
                     </Modal>
                     :
                     <div>

                     </div>
               }

            </div>
            <Suspense fallback={<></>}>
               <TextEditorModal
                  edit_mode={this.state.edit_mode}
                  influencerDescriptionUpdated={this.state.influencerDescriptionUpdated}
                  influencer_info={this.state.influencer_info}
                  influencerBioLength={this.state.influencerBioLength}
                  editedBio={this.state.editedBio}
                  setState={this.setState}
               />
            </Suspense>

            <Suspense fallback={<></>}><ShareModal
               socialModalOpen={this.state.socialModalOpen}
               pageLink={window.location.origin + `/${this.state.influencer_info['influencer']}`}
               handleSocialModalClose={() => this.setState({ socialModalOpen: false })}
               handleCopyClick={() => this.handleCopyClick()}
               facebookURL={window.location.origin + `/${this.state.influencer_info['influencer']}`}
               facebookQuote={window.location.origin + `/${this.state.influencer_info['influencer']}`}
               twitterURL={window.location.origin + `/${this.state.influencer_info['influencer']}`}
               twitterTitle={`${this.state.influencer_info['influencer']}  -Shared from WithMe`}
               twitterHashtag={['#withme']}
               whatsappURL={window.location.origin + `/${this.state.influencer_info['influencer']}`}
               whatsappTitle={`${this.state.influencer_info['influencer']}  -Shared from WithMe`}
               redditURL={window.location.origin + `/${this.state.influencer_info['influencer']}`}
               redditTitle={`Checkout my new Platform on WithMe! - ${this.state.influencer_info['influencer']}`}
            /></Suspense>

            <Suspense fallback={<></>}><SnackbarAlert
               msg={this.state.errorMsg}
               open={this.state.snackbar}
               severity={this.state.snackbarSeverity} errorMsgsnackbarSeverity snackbarAutoHide
               backgroundColor={'red'}
               autoHide={this.state.snackbarAutoHide}
               handleClose={() => {
                  this.setState({
                     snackbar: false,
                     snackbarAutoHide: 4000,
                  })
               }}
            /></Suspense>

            <Suspense fallback={<></>}><SnackbarAlert
               msg={this.state.errorMsg}
               open={this.state.snackbar}
               severity={this.state.snackbarSeverity} errorMsgsnackbarSeverity snackbarAutoHide
               backgroundColor={this.state.collectionSnackbarSeverity === 'error' ? 'red' : 'var(--brand-color)'}
               autoHide={this.state.snackbarAutoHide}
               handleClose={() => {
                  this.setState({
                     snackbar: false,
                     snackbarAutoHide: 4000,
                  })
               }}
            /></Suspense>
            <Suspense fallback={<></>}><SnackbarAlert
               msg={'You successfully updated your profile url'}
               open={this.state.usernameSnackbar}
               severity={'success'}
               backgroundColor={'var(--brand-color)'}
               autoHide={4000}
               handleClose={() => {
                  this.setState({
                     usernameSnackbar: false,
                     snackbarAutoHide: 4000,

                  })
               }}
            /></Suspense>
            <Suspense fallback={<></>}><SnackbarPublishError
               msg={this.state.publishErrorMsg}
               open={this.state.publishSnackbar}
               severity={this.state.publishSnackbarSeverity}
               // snackbarBackgroundColor={''}
               // backgroundColor={'var(--danger-color)'}
               backgroundColor={'red'}
               autoHide={this.state.publishSnackbarAutoHide}
               handleClose={() => {
                  this.setState({
                     publishSnackbar: false,
                     publishSnackbarAutoHide: 4000,
                  })
               }}
               action_text={this.state.publishActionText}
               action_process={this.state.publishActionProcess}
               waiting_list_process={() => {
                  // window.location.assign(window.location.href.split('#')[0] + '#checklist_waitlist');
                  if (window.innerWidth < 900) {
                     window.location.assign(window.location.href.split('#')[0] + '#banner_mobile');
                  } else {
                     window.location.assign(window.location.href.split('#')[0] + '#banner_desktop')
                  }
                  this.setState({ expandedDashboard: 'dashboard', publishSnackbar: false });
               }}
               sort_filter={this.state.sort_filter}
            /></Suspense>

            <Suspense fallback={<></>}>
               <PricingModal
                  pricingModal={this.state.pricingModal}
                  handlePricingModalClose={() => this.handlePricingModalClose()}
                  windowWidth={this.state.deviceWidth}
                  fullServiceBooking={() => this.setFullServiceApplicationModal(true)}
                  sectionHeader={sectionHeader}
                  mainHeader={mainHeader}
                  mainDescription={mainDescription}
                  influencer_username={this.state.influencer_info['influencer']}
               /></Suspense>


            <Suspense fallback={<></>}>
               <PaidDMsExplainer
                  open={this.state.paidDMsExplainerModal}
                  openExplainerModal={() => this.setState({ paidDMsExplainerModal: true })}
                  closeExplainerModal={() => this.setState({ paidDMsExplainerModal: false })}
                  openCheckout={this.openDMCheckout}
                  is_me={this.state.is_me}
                  windowWidth={this.state.deviceWidth}
               /></Suspense>

            {/* TODO mitch remove all the unecessary props */}
            <Suspense fallback={<></>}>
               <DMsCheckout
                  open_checkout_modal={this.state.paidDMsCheckoutModal}
                  icon_image={this.state.influencer_info['icon_image_path']}
                  influencer={this.state.subscribe_popup_influencer}
                  influencer_name={this.state.influencer_info['influencer_name']}
                  DMsCreatorCustomMessage={this.state.DMsCreatorCustomMessage}
                  paidDMsOfferingPriceMinimum={this.state.paidDMsOfferingPriceMinimum}
                  paidDMsPriceCheckout={this.state.paidDMsPriceCheckout}
                  setPaidDMsPriceCheckout={(value) => { this.setState({ paidDMsPriceCheckout: value }) }}
                  paidDMsPriceCheckoutStr={this.state.paidDMsPriceCheckoutStr}
                  setPaidDMsPriceCheckoutStr={(value) => { this.setState({ paidDMsPriceCheckoutStr: value }) }}
                  closeCheckoutPopup={() => { this.setState({ paidDMsCheckoutModal: false }) }}
                  backCheckoutPopup={() => {
                     if (this.state.paidDMsPreviouslyActive) {
                        this.setState({ paidDMsCheckoutModal: false })
                     } else {
                        this.setState({ paidDMsCheckoutModal: false, paidDMsExplainerModal: true })
                     }
                  }}
                  openExplainerModal={() => this.setState({ paidDMsExplainerModal: true })}
                  closeExplainerModal={() => this.setState({ paidDMsExplainerModal: false })}
                  open_terms={() => {
                     this.setState({
                        termsConditionsModal: true,
                        subscribe_popup_open: false,
                        terms_tab: 'subscriber'
                     })
                  }}
                  currency={this.state.currency}
                  currencyIcon={this.state.currencyIcon}
                  currencyIconPost={this.state.currencyIconPost}
                  influencer_banner={this.state.influencerBanner}
                  connected_stripe_account_id={this.state.connected_stripe_account_id}
               /></Suspense>


            <Suspense fallback={<></>}>
               <TippingCheckout
                  tippingCheckoutOpen={this.state.tippingCheckoutOpen}
                  closeTippingCheckout={() => this.setState({ tippingCheckoutOpen: false })}
                  icon_image={this.state.influencer_info['icon_image_path']}
                  influencer={this.state.subscribe_popup_influencer}
                  influencer_name={this.state.influencer_info['influencer_name']}
                  tippingPriceMinimum={this.state.tippingPriceMinimum}
                  tippingPriceCheckout={this.state.tippingPriceCheckout}
                  setTippingPriceCheckout={(value) => { this.setState({ tippingPriceCheckout: value }) }}
                  tippingPriceCheckoutStr={this.state.tippingPriceCheckoutStr}
                  setTippingPriceCheckoutStr={(value) => { this.setState({ tippingPriceCheckoutStr: value }) }}
                  open_terms={() => {
                     this.setState({
                        termsConditionsModal: true,
                        subscribe_popup_open: false,
                        terms_tab: 'subscriber'
                     })
                  }}
                  currency={this.state.currency}
                  currencyIcon={this.state.currencyIcon}
                  currencyIconPost={this.state.currencyIconPost}
                  influencer_banner={this.state.influencerBanner}
                  connected_stripe_account_id={this.state.connected_stripe_account_id}
               /></Suspense>

            <Suspense fallback={<></>}>
               <BuyNowCheckout
                  buyNowCheckoutOpen={this.state.buyNowCheckoutOpen}
                  closeBuyNowCheckout={() => this.setState({ buyNowCheckoutOpen: false })}
                  icon_image={this.state.influencer_info['icon_image_path']}
                  influencer={this.state.subscribe_popup_influencer}
                  influencer_name={this.state.influencer_info['influencer_name']}
                  open_terms={() => {
                     this.setState({
                        termsConditionsModal: true,
                        subscribe_popup_open: false,
                        terms_tab: 'subscriber'
                     })
                  }}
                  currency={this.state.currency}
                  currencyIcon={this.state.currencyIcon}
                  currencyIconPost={this.state.currencyIconPost}
                  influencer_banner={this.state.influencerBanner}
                  connected_stripe_account_id={this.state.connected_stripe_account_id}
                  buyNowCheckoutTitle={this.state.buyNowCheckoutTitle}
                  buyNowCheckoutThumbnail={this.state.buyNowCheckoutThumbnail}
                  buyNowContentType={this.state.buyNowContentType}
                  buyNowCheckoutPrice={this.state.buyNowCheckoutPrice}
                  buyNowCheckoutContentId={this.state.buyNowCheckoutContentId}
               />
            </Suspense>


            <Suspense fallback={<></>}>
               <BuyCollectionCheckout
                  buyCollectionCheckoutOpen={this.state.buyCollectionCheckoutOpen}
                  closeBuyCollectionCheckout={() => this.setState({ buyCollectionCheckoutOpen: false })}
                  icon_image={this.state.influencer_info['icon_image_path']}
                  influencer={this.state.subscribe_popup_influencer}
                  influencer_name={this.state.influencer_info['influencer_name']}
                  open_terms={() => {
                     this.setState({
                        termsConditionsModal: true,
                        subscribe_popup_open: false,
                        terms_tab: 'subscriber'
                     })
                  }}
                  currency={this.state.currency}
                  currencyIcon={this.state.currencyIcon}
                  currencyIconPost={this.state.currencyIconPost}
                  influencer_banner={this.state.influencerBanner}
                  connected_stripe_account_id={this.state.connected_stripe_account_id}
                  buyCollectionTitle={this.state.buyCollectionTitle}
                  // buyCollectionThumbnail={this.state.buyCollectionThumbnail}
                  buyCollectionPrice={this.state.buyCollectionPriceCheckout}
                  buyCollectionId={this.state.buyCollectionId}
               />
            </Suspense>




            <Suspense fallback={<></>}>
               <CreateCollection
                  newPlaylistModal={this.state.newPlaylistModal}
                  newCourseName={this.state.newCourseName}
                  setNewCourseName={this.setNewCourseName}
                  product_type={this.state.product_type}
                  current_page_view={current_page_view}
                  my_platform_page={this.state.my_platform_page}
                  courseNames={this.state.courseNames}
                  newCoursePriceActive={this.state.newCoursePriceActive}
                  setNewCoursePriceActive={this.setNewCoursePriceActive}
                  newCoursePriceStr={this.state.newCoursePriceStr}
                  setNewCoursePriceStr={this.setNewCoursePriceStr}
                  setNewPlaylistModal={this.setNewPlaylistModal}
                  setMediaSettingsModal={this.setMediaSettingsModal}
                  setNewCollectionShowMinBuyNowPriceError={this.setNewCollectionShowMinBuyNowPriceError}
                  newCollectionShowMinBuyNowPriceError={this.state.newCollectionShowMinBuyNowPriceError}
                  setNewCoursePrice={this.setNewCoursePrice}
                  newCoursePrice={this.state.newCoursePrice}
                  currency={this.state.currency}
                  currencySymbol={
                     this.state.currency === 'GBP' ? '£' :
                        this.state.currency === 'EUR' ? '€' :
                           this.state.currency === 'USD' ? '$' :
                              this.state.currency === 'AUD' ? 'AU$' :
                                 this.state.currency === 'CAD' ? 'CA$' :
                                    this.state.currency === 'NZD' ? 'NZ$' :
                                       this.state.currency === 'SEK' ? '' : ''}
                  currencySymbolPost={this.state.currency === 'SEK' ? ' kr' : ''}
                  minBuyNowPriceError={this.state.minBuyNowPriceError}
                  minBuyNowPrice={this.state.currency === 'SEK' ? 1500 : 100}
                  setDisplayEditPlaylist={this.setDisplayEditPlaylist}
                  page={'influencer'}
                  addNewPlaylist={this.addNewPlaylist}
                  setState={this.setState}
               />
            </Suspense>

            {
               window.innerWidth > 600 ?
                  // DESKTOP
                  <>
                     {
                        this.state.influencer_info['waiting_list'] ?
                           // DESKTOP - ON WAITING LIST (POSITION BOTTOM)
                           <>
                              {
                                 // DESKTOP - INFLUENCER ACCOUNT && IS_ME
                                 (this.state.is_me || this.state.current_user === this.state.influencer_info['influencer']) ?
                                    <>


                                       {
                                          window.innerWidth >= 1280 ?

                                             <div style={{ padding: '20px 0px', width: creator_preview ? '100%' : '83.5%', display: 'flex', Zindex: '10000', justifyContent: 'flex-end', margin: 'auto 0px auto auto', }}>
                                                <span style={{ margin: 'auto' }}><PoweredByFitWith clickEvent={() => window.open(window.location.origin + '/become-a-creator?passive_id=' + String(this.state.influencer_info['id']), '_blank', 'noopener,noreferrer')} /></span>
                                             </div>
                                             :
                                             <div style={{ padding: '20px 0px', width: '100%', display: 'flex', Zindex: '10000', justifyContent: 'flex-end', margin: 'auto 0px auto auto', }}>
                                                <span style={{ margin: 'auto' }}><PoweredByFitWith clickEvent={() => window.open(window.location.origin + '/become-a-creator?passive_id=' + String(this.state.influencer_info['id']), '_blank', 'noopener,noreferrer')} /></span>
                                             </div>

                                       }


                                    </>
                                    :
                                    <>

                                       <div style={{ padding: '20px 0px 20px', width: '100%', display: 'flex', Zindex: '9', position: 'relative' }}>
                                          <span style={{ margin: '100px auto auto auto' }}><PoweredByFitWith clickEvent={() => window.open(window.location.origin + '/become-a-creator?passive_id=' + String(this.state.influencer_info['id']), '_blank', 'noopener,noreferrer')} /></span>
                                       </div>
                                    </>
                              }
                           </>
                           :
                           // DESKTOP - NOT ON WAITING LIST (NORMAL PADDING)
                           <>
                              {
                                 this.state.is_me || this.state.current_user === this.state.influencer_info['influencer'] ?
                                    <>
                                       {
                                          window.innerWidth >= 1280 ?
                                             <div style={{ padding: '20px 0px', width: creator_preview ? '100%' : '83.5%', display: 'flex', Zindex: '10000', justifyContent: 'flex-end', margin: 'auto 0px auto auto' }}>
                                                <span style={{ margin: 'auto' }}><PoweredByFitWith clickEvent={() => window.open(window.location.origin + '/become-a-creator?passive_id=' + String(this.state.influencer_info['id']), '_blank', 'noopener,noreferrer')} /></span>
                                             </div>
                                             :
                                             <div style={{ padding: '20px 0px', width: '100%', display: 'flex', Zindex: '10000', justifyContent: 'flex-end', margin: 'auto 0px auto auto' }}>
                                                <span style={{ margin: 'auto' }}><PoweredByFitWith clickEvent={() => window.open(window.location.origin + '/become-a-creator?passive_id=' + String(this.state.influencer_info['id']), '_blank', 'noopener,noreferrer')} /></span>
                                             </div>
                                       }
                                    </>
                                    :
                                    // margin: 'auto 0px auto auto'
                                    <div style={{ padding: '20px 0px', width: '100%', display: 'flex', Zindex: '10000', }}>
                                       <span style={{ margin: 'auto' }}><PoweredByFitWith clickEvent={() => window.open(window.location.origin + '/become-a-creator?passive_id=' + String(this.state.influencer_info['id']), '_blank', 'noopener,noreferrer')} /></span>
                                    </div>
                              }
                           </>
                     }

                  </>
                  :
                  // MOBILE
                  <>
                     {
                        this.state.is_me ?
                           // IS MY PROFILE
                           <>
                              {
                                 this.state.influencer_launched ?
                                    // PUBLISHED (NORMAL PADDING)
                                    <div style={{ width: '100%', display: 'flex', Zindex: '10000' }}>
                                       <span style={{ margin: 'auto' }}><PoweredByFitWith clickEvent={() => window.open(window.location.origin + '/become-a-creator?passive_id=' + String(this.state.influencer_info['id']), '_blank', 'noopener,noreferrer')} /></span>
                                    </div>
                                    :
                                    // NOT PUBLISHED (NEEDS PADDING ABOVE CTA) only if on dashboard
                                    <>
                                       {
                                          this.state.selected_tab === 'dashboard' ?
                                             <div style={{ width: '100%', display: 'flex', Zindex: '10000' }}>
                                                <span style={{ margin: 'auto' }}><PoweredByFitWith clickEvent={() => window.open(window.location.origin + '/become-a-creator?passive_id=' + String(this.state.influencer_info['id']), '_blank', 'noopener,noreferrer')} /></span>
                                             </div>
                                             :
                                             <div style={{ width: '100%', display: 'flex', Zindex: '10000' }}>
                                                <span style={{ margin: 'auto' }}><PoweredByFitWith clickEvent={() => window.open(window.location.origin + '/become-a-creator?passive_id=' + String(this.state.influencer_info['id']), '_blank', 'noopener,noreferrer')} /></span>
                                             </div>
                                       }

                                    </>

                              }
                           </>
                           :
                           <>
                              {
                                 this.state.influencer_info['waiting_list'] ?
                                    <>
                                       {
                                          this.state.current_user === '' ?
                                             // MOBILE - NO USER (NEEDS BOTTOM PADDING ABOVE CTA)
                                             <div style={{ padding: '50px 0px 200px 0px', width: '100%', display: 'flex', Zindex: '10000', marginTop: '0px' }}>
                                                <span style={{ margin: 'auto' }}><PoweredByFitWith clickEvent={() => window.open(window.location.origin + '/become-a-creator?passive_id=' + String(this.state.influencer_info['id']), '_blank', 'noopener,noreferrer')} /></span>
                                             </div>
                                             :
                                             // MOBILE - IS A USER (NEEDS PADDING ABOVE EMAIL CTA)
                                             <div style={{ padding: '50px 0px 200px 0px', width: '100%', display: 'flex', Zindex: '10000' }}>
                                                <span style={{ margin: 'auto' }}><PoweredByFitWith clickEvent={() => window.open(window.location.origin + '/become-a-creator?passive_id=' + String(this.state.influencer_info['id']), '_blank', 'noopener,noreferrer')} /></span>
                                             </div>
                                       }
                                    </>
                                    :
                                    <>
                                       {
                                          this.state.current_user === '' ?
                                             // MOBILE - NO USER (NEEDS BOTTOM PADDING ABOVE CTA)
                                             <div style={{ padding: '20px 0px 120px 0px', width: '100%', display: 'flex', Zindex: '10000' }}>
                                                <span style={{ margin: 'auto', color: 'red' }}><PoweredByFitWith clickEvent={() => window.open(window.location.origin + '/become-a-creator?passive_id=' + String(this.state.influencer_info['id']), '_blank', 'noopener,noreferrer')} /></span>
                                             </div>
                                             :
                                             // MOBILE - IS A USER
                                             <>
                                                {
                                                   ((this.state.influencer_info['current_tier'] > 0) & (this.state.mobileCTABannerClicked === false) & (this.state.influencer_info['influencer_active_in_community'] === true) & (this.state.is_me === false)) ?
                                                      // MOBILE - IS SUBSCRIBED with chat mobile banner (NEEDS BOTTOM PADDING)
                                                      <div style={{ padding: '20px 0px 120px 0px', width: '100%', display: 'flex', Zindex: '10000' }}>
                                                         <span style={{ margin: 'auto' }}><PoweredByFitWith clickEvent={() => window.open(window.location.origin + '/become-a-creator?passive_id=' + String(this.state.influencer_info['id']), '_blank', 'noopener,noreferrer')} /></span>
                                                      </div>
                                                      : this.state.influencer_info['current_tier'] > 0 ?
                                                         // MOBILE - IS SUBSCRIBED (NORMAL PADDING)
                                                         <div style={{ padding: '20px 0px', width: '100%', display: 'flex', Zindex: '10000' }}>
                                                            <span style={{ margin: 'auto' }}><PoweredByFitWith clickEvent={() => window.open(window.location.origin + '/become-a-creator?passive_id=' + String(this.state.influencer_info['id']), '_blank', 'noopener,noreferrer')} /></span>
                                                         </div>
                                                         :
                                                         // MOBILE - IS NOT SUBSCRIBED (NEEDS BOTTOM PADDING ABOVE CTA)
                                                         <div style={{ padding: '20px 0px 120px 0px', width: '100%', display: 'flex', Zindex: '10000' }}>
                                                            <span style={{ margin: 'auto' }}><PoweredByFitWith clickEvent={() => window.open(window.location.origin + '/become-a-creator?passive_id=' + String(this.state.influencer_info['id']), '_blank', 'noopener,noreferrer')} /></span>
                                                         </div>
                                                }
                                             </>
                                       }
                                    </>
                              }
                           </>
                     }
                  </>
            }


            {/* Added content -> launch SnackbarSavedContent  */}
            {/* Pressing undo will -> close SnackbarSavedContent & open */}

            {

               this.state.current_user !== '' ?

                  <Suspense fallback={<></>}><SnackbarSavedContent
                     msg={'This post has been added to your saved section'}
                     open={this.state.snackbarSaved}
                     contentId={''}
                     severity={'success'}
                     backgroundColor={'var(--brand-color)'}
                     autoHide={4000}
                     selected_tab={this.state.selected_tab}
                     saved_count={this.state.saved_count}
                     undoFunc={() => {
                        this.undoSave();
                        this.handleRemoveSavedContent();
                     }}
                     viewSavedCollection={() => { this.setState({ sort_filter: 'saved' }); this.handleProfileTabChange('', this.state.is_me === true ? 'sub_posts' : 'all', 'saved'); }}
                     handleClose={() => {
                        this.setState({
                           snackbarSaved: false
                        })
                     }}
                     sort_filter={this.state.sort_filter}
                  /></Suspense>
                  :
                  null
            }

            <Suspense fallback={<></>}><CustomCreatorLogoModal
               open={this.state.customCreatorLogoModalOpen}
               handleCustomCreatorLogoModalClose={() => {
                  this.handleCustomCreatorLogoModalClose()
               }}
               setState={this.setState}
               logoRectangleFile={this.state.logoRectangleFile}
               logoRectangleFileNew={this.state.logoRectangleFileNew}
               logoSquareFile={this.state.logoSquareFile}
               logoSquareFileNew={this.state.logoSquareFileNew}
               clearRectangleLogo={() => this.clearRectangleLogo()}
               clearSquareLogo={() => this.clearSquareLogo()}
               // removeSquareLogo={() => this.removeSquareLogo()}
               // removeRectangleLogo={() => this.removeRectangleLogo()}
               rerenderClearedNavbar={() => this.rerenderClearedNavbar()}
               setUploadingCustomCreatorLogo={(value) => this.setState({
                  uploadingCustomCreatorLogo: value
               })}
               setMainLogoFile={(file) => this.setState({ mainLogoFile: file })}
               handleSuccessfulCustomLogo={() => this.handleSuccessfulCustomLogo()}
            /></Suspense>


            {/* {
               this.state.openCheckoutError ?
                  <Modal open={this.state.openCheckoutError}>

                     <Box style={modalStyle}
                           sx={{
                              display: 'flex', width: '100%', height: '100%',
                              margin: 'auto', zIndex: '9999',
                           }}>
                           <span
                              className={'backButtonStyleMediaPost'}
                              // style={this.props.content_info['content_type'] === 'txt' ? backButtonStyleTextPost : backButtonStyleMediaPost}
                              onClick={() => {this.setState({'openCheckoutError': false})}} variant="outlined">
                                       <IoClose style={{color: '#FFF'}}/>
                           </span>
                        <Grid
                           container
                           spacing={0}
                           direction="column"
                           alignItems="center"
                           justifyContent="center"
                           style={{minHeight: '90vh'}}
                        >
                           <p style={{
                              color: 'var(--primary-text-color)', fontSize: 'var(--medium-text)',
                              fontWeight: '600',
                           }}>Creator payment issue</p>
                        </Grid>
                     </Box>
                  </Modal>
                  :
                  <div>

                  </div>
            } */}

            <Suspense fallback={<></>}>
               <ErrorCheckoutModal
                  influencer_name={this.state.influencer_info['influencer_name']}
                  openCheckoutError={this.state.openCheckoutError}
                  handleCloseCheckoutError={this.handleCloseCheckoutError}
                  windowWidth={this.state.deviceWidth}
                  launchHelp={() => window.Intercom('show')}
               />
            </Suspense>


            <Suspense fallback={<></>}><SnackbarRemoveSave
               msg={'This post has been removed from your saved section'}
               open={this.state.snackbarRemoveSaved}
               severity={'success'}
               backgroundColor={'var(--brand-color)'}
               autoHide={4000}
               selected_tab={this.state.selected_tab}
               saved_count={this.state.saved_count}
               undoFunc={() => {
                  this.undoSave();
                  this.handleSavedContent();
               }}
               viewSavedCollection={() => { this.setState({ sort_filter: 'saved' }); this.handleProfileTabChange('', this.state.is_me === true ? 'sub_posts' : 'all', 'saved'); }}
               handleClose={() => {
                  this.setState({
                     snackbarRemoveSaved: false
                  })
               }}
               sort_filter={this.state.sort_filter}
            /></Suspense>
            <Suspense fallback={<></>}>
               <ExampleCreatorPopup
                  open_example_creators={this.state.open_example_creators}
                  windowWidth={this.state.deviceWidth}
                  close={() => {
                     this.setState({
                        open_example_creators: false
                     })
                  }}
               />
            </Suspense>




            <Suspense fallback={<></>}>
               <SnackbarAlert
                  msg={this.state.errorMsgUpload}
                  open={this.state.snackbarOpenUpload}
                  severity={this.state.snackbarSeverityUpload}
                  backgroundColor={'var(--brand-color)'}
                  autoHide={4000}
                  handleClose={() => {
                     this.setState({
                        snackbarOpenUpload: false
                     })
                  }}
               /></Suspense>
         </div>
      )
   }
}

export default withRouter(Influencer);
